webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiSwiper = __webpack_require__(335);
	
	var _angularUiSwiper2 = _interopRequireDefault(_angularUiSwiper);
	
	__webpack_require__(337);
	
	__webpack_require__(341);
	
	__webpack_require__(343);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(426);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(546);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(943);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _app3 = __webpack_require__(947);
	
	var _app4 = _interopRequireDefault(_app3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _common2.default, _components2.default, _angularUiSwiper2.default]).config(["$locationProvider", "$httpProvider", function ($locationProvider, $httpProvider) {
	    'ngInject';
	
	    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	
	    $locationProvider.html5Mode(true).hashPrefix('!');
	
	    $httpProvider.interceptors.push(["$q", function ($q) {
	        return {
	            'request': function request(config) {
	                try {
	                    var Token = localStorage.getItem('tourists_token');
	
	                    config.headers.authorization = 'Bearer ' + Token;
	                } catch (e) {
	                    config.headers.authorization = null;
	                }
	
	                return config;
	            },
	            'response': function response(_response) {
	                if (_response.headers('authorization-expired') === 'expired') {
	                    localStorage.removeItem('tourists_user');
	                    localStorage.removeItem('tourists_token');
	                }
	
	                return _response;
	            }
	        };
	    }]);
	}]).constant('config', {
	    baseUrl: 'http://localhost:5000',
	    frontUrl: 'https://www.emotionsaregeorgia.com'
	}).run(['$rootScope', '$state', '$window', '$location', function ($rootScope, $state, $window, $location) {
	
	    $rootScope.$on('$locationChangeStart', function (event, next, current) {
	        if ($location.path() === '/' && ($window.innerWidth <= 767 || localStorage.getItem('tourists_welcome'))) {
	            event.preventDefault();
	
	            $state.go('home');
	        }
	
	        setTimeout(function () {
	            var currentState = $state.current.name;
	            var language = localStorage.getItem('tourists_lang') || 'EN';
	
	            if (_app4.default['EN'][currentState]) {
	                $('title').html(_app4.default['EN'][currentState]);
	            } else {
	                $('title').html('Emotions Are Georgia');
	            }
	        }, 0);
	    });
	}]).component('app', _app2.default);

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navbar = __webpack_require__(427);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _user = __webpack_require__(455);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _footer = __webpack_require__(515);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _mcactionbutton = __webpack_require__(527);
	
	var _mcactionbutton2 = _interopRequireDefault(_mcactionbutton);
	
	var _loader = __webpack_require__(536);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _color = __webpack_require__(542);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _share = __webpack_require__(544);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_navbar2.default, _user2.default, _footer2.default, _mcactionbutton2.default, _loader2.default, _color2.default, _share2.default]).name;
	
	exports.default = commonModule;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navbar = __webpack_require__(428);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarModule = _angular2.default.module('navbar', [_angularUiRouter2.default]).component('navbar', _navbar2.default).name;
	
	exports.default = navbarModule;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _navbar = __webpack_require__(429);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _navbar3 = __webpack_require__(430);
	
	var _navbar4 = _interopRequireDefault(_navbar3);
	
	__webpack_require__(453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navbarComponent = {
	    bindings: {},
	    template: _navbar2.default,
	    controller: _navbar4.default
	};
	
	exports.default = navbarComponent;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n\n    <!-- Logo -->\n    <div class=\"logo\">\n        <svg ng-class=\"{rotated: $ctrl.burgerMenuRotated }\" class=\"visible-xs\" ng-click=\"$ctrl.toggleBurgerMenu()\"\n            aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"bars\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"\n            class=\"svg-inline--fa fa-bars fa-w-14 fa-2x\">\n            <path fill=\"currentColor\" d=\"M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z\"\n                class=\"\"></path>\n        </svg>\n        <img src=\"/assets/images/logo.svg\" alt=\"georgia_logo\" ng-click=\"$ctrl.clearCategories()\">\n    </div>\n\n    <!-- Burger Menu -->\n    <ul class=\"burger-menu\">\n        <li ui-sref=\"home\" ui-sref-opts=\"{reload:true}\" ng-class=\"{'active': $ctrl.$state.current.name === 'home' }\">{{$ctrl.navigations[0]}}</li>\n        <li ui-sref=\"statistics\" ui-sref-active=\"active\">{{$ctrl.navigations[1]}}</li>\n        <li ui-sref=\"about\" ui-sref-active=\"active\">{{$ctrl.navigations[2]}}</li>\n        <li><a href=\"http://georgia.travel\" target=\"_blank\">{{$ctrl.navigations[3]}}</a></li>\n    </ul>\n\n    <!-- Left Navigation ul -->\n    <ul class=\"navigation navigation-left hidden-xs\">\n        <li ui-sref=\"home\" ui-sref-active=\"active\">{{$ctrl.navigations[0]}}</li>\n        <li ui-sref=\"statistics\" ui-sref-active=\"active\">{{$ctrl.navigations[1]}}</li>\n        <li ui-sref=\"about\" ui-sref-active=\"active\">{{$ctrl.navigations[2]}}</li>\n        <li><a href=\"http://georgia.travel\" target=\"_blank\">{{$ctrl.navigations[3]}}</a></li>\n    </ul>\n\n    <!-- Languages ul -->\n    <ul class=\"languages\">\n        <li ng-class=\"{active: $ctrl.language === 'EN'}\" ng-click=\"$ctrl.changeLanguage('EN')\">\n            <svg ng-style=\"{visibility: $ctrl.language === 'EN' ? 'visible': 'hidden' }\" xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"0.125in\" height=\"0.125in\">\n                <path fill-rule=\"evenodd\" fill=\"rgb(233, 0, 76)\" d=\"M4.148,-0.000 L4.164,-0.000 C6.352,-0.000 8.125,1.773 8.125,3.961 L8.125,4.070 C8.125,6.258 6.352,8.031 4.164,8.031 L4.148,8.031 C1.961,8.031 0.187,6.258 0.187,4.070 L0.187,3.961 C0.187,1.773 1.961,-0.000 4.148,-0.000 Z\" />\n            </svg>\n            EN\n        </li>\n        <li ng-class=\"{active: $ctrl.language === 'GE'}\" ng-click=\"$ctrl.changeLanguage('GE')\">\n            <svg ng-style=\"{visibility: $ctrl.language === 'GE' ? 'visible': 'hidden' }\" xmlns=\"http://www.w3.org/2000/svg\"\n                xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"0.125in\" height=\"0.125in\">\n                <path fill-rule=\"evenodd\" fill=\"rgb(233, 0, 76)\" d=\"M4.148,-0.000 L4.164,-0.000 C6.352,-0.000 8.125,1.773 8.125,3.961 L8.125,4.070 C8.125,6.258 6.352,8.031 4.164,8.031 L4.148,8.031 C1.961,8.031 0.187,6.258 0.187,4.070 L0.187,3.961 C0.187,1.773 1.961,-0.000 4.148,-0.000 Z\" />\n            </svg>\n            GE\n        </li>\n    </ul>\n\n    <!-- Right Navigation ul -->\n    <ul class=\"navigation navigation-right hidden-xs\">\n        <li class=\"fullname\" ng-if=\"$ctrl.user\">{{$ctrl.user.fullName}}</li>\n        <li class=\"my-book\" ng-if=\"$ctrl.user\" ng-click=\"$ctrl.goToMyBook('web')\">\n            <span>\n                <svg aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"book-open\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 640 512\" class=\"svg-inline--fa fa-book-open fa-w-20 fa-2x\">\n                    <path fill=\"currentColor\" d=\"M561.9 0C549.5 0 406.5 6.5 320 56.9 233.5 6.5 90.6 0 78.1 0 35 0 0 34.3 0 76.5v313.7c0 40.7 32.5 74.3 73.9 76.4 36.8 1.9 128.8 9.5 187.7 38.7 8.2 4 17.3 6.3 26.3 6.6v.1h64v-.1c9.1-.3 18.2-2.5 26.3-6.6 59-29.2 151-36.8 187.8-38.7 41.4-2.1 73.9-35.7 73.9-76.4V76.5C640 34.3 605 0 561.9 0zm-257 449.8c0 10.6-11.8 17.5-21.9 12.5-65.3-32.4-159.9-41.2-206.6-43.6-16-.8-28.4-13.4-28.4-28.5V76.5C48 60.7 61.5 48 78.1 48c2 0 142 4.8 219.9 51.7 4.4 2.6 6.9 7.1 6.9 12.1v338zM592 390.3c0 15.1-12.4 27.7-28.4 28.5-46.7 2.4-141.2 11.2-206.5 43.6-10.1 5-22-1.9-22-12.5v-338c0-4.9 2.5-9.6 6.9-12.2C419.9 52.8 560.1 48 561.9 48c16.6 0 30.1 12.7 30.1 28.5v313.8z\"\n                        class=\"\"></path>\n                </svg>\n                {{$ctrl.myBook}}\n            </span>\n        </li>\n        <li ng-if=\"$ctrl.user\" ng-click=\"$ctrl.logout()\">\n            <span>\n                <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"sign-out\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 512 512\" class=\"svg-inline--fa fa-sign-out fa-w-16 fa-2x\">\n                    <path fill=\"currentColor\" d=\"M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z\"\n                        class=\"\"></path>\n                </svg>\n                {{$ctrl.logoutText}}\n            </span>\n        </li>\n    </ul>\n</nav>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _navbar = __webpack_require__(452);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavbarController = function () {
	    function NavbarController($scope, $state, User, Category) {
	        (0, _classCallCheck3.default)(this, NavbarController);
	
	        this.name = 'navbar';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.User = User;
	        this.Category = Category;
	
	        this.burgerMenuRotated = false;
	    }
	
	    (0, _createClass3.default)(NavbarController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // Set active language on page load
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            // Render texts
	            this.render();
	
	            // Set user if logged in
	            this.setActiveUser();
	
	            // Watch user authentication status change
	            this.watchUser();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _texts$language = _navbar2.default[this.language],
	                NAVIGATIONS = _texts$language.NAVIGATIONS,
	                MY_BOOK = _texts$language.MY_BOOK,
	                LOG_OUT = _texts$language.LOG_OUT;
	
	
	            this.navigations = NAVIGATIONS;
	            this.myBook = MY_BOOK;
	            this.logoutText = LOG_OUT;
	        }
	    }, {
	        key: 'clearCategories',
	        value: function clearCategories() {
	            this.Category.clearSelectedCategories();
	
	            this.$state.go('home', {
	                search: ''
	            });
	        }
	    }, {
	        key: 'changeLanguage',
	        value: function changeLanguage(language) {
	            this.language = language;
	
	            localStorage.setItem('tourists_lang', language);
	
	            this.render();
	        }
	    }, {
	        key: 'setActiveUser',
	        value: function setActiveUser() {
	            var _this = this;
	
	            this.User.getCurrentUser().then(function (user) {
	                _this.user = user;
	            }).catch(function () {
	                _this.user = null;
	            });
	        }
	    }, {
	        key: 'watchUser',
	        value: function watchUser() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return _this2.User.getUser();
	            }, function (newValue) {
	                _this2.user = newValue;
	            });
	        }
	    }, {
	        key: 'goToMyBook',
	        value: function goToMyBook() {
	            var bookId = localStorage.getItem('tourists_bookId');
	
	            this.$state.go('home.book.bookStep3', {
	                bookId: bookId
	            }, {
	                reload: true
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.User.logout();
	        }
	    }, {
	        key: 'toggleBurgerMenu',
	        value: function toggleBurgerMenu() {
	            this.burgerMenuRotated = !this.burgerMenuRotated;
	            $('.burger-menu').slideToggle();
	        }
	    }]);
	    return NavbarController;
	}();
	
	NavbarController.$inject = ['$scope', '$state', 'User', 'Category'];
	
	exports.default = NavbarController;

/***/ }),
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        NAVIGATIONS: ['გაზიარებული ემოციები', 'რიცხვები და ემოციები', 'კამპანიის შესახებ', 'შედი Georgia Travel-ზე'],
	        MY_BOOK: 'ჩემი წიგნი',
	        LOG_OUT: 'გამოსვლა'
	    },
	    EN: {
	        NAVIGATIONS: ['Shared Emotions', 'Figures & Feelings', 'About', 'Go to Georgia Travel'],
	        MY_BOOK: 'My book',
	        LOG_OUT: 'Log out'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(454);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./navbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "body{height:100%}@media only screen and (min-width:1500px){.hidden-custom-xl{display:none!important}.visible-custom-xl{display:block!important}.row.visible-custom-xl{display:-ms-flexbox!important;display:flex!important}.col-custom-xl{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-custom-xl-1{-ms-flex-preferred-size:8.333%;flex-basis:8.333%;max-width:8.333%}.col-custom-xl-2{-ms-flex-preferred-size:16.667%;flex-basis:16.667%;max-width:16.667%}.col-custom-xl-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-custom-xl-4{-ms-flex-preferred-size:33.333%!important;flex-basis:33.333%!important;max-width:33.333%!important}.col-custom-xl-5{-ms-flex-preferred-size:41.667%;flex-basis:41.667%;max-width:41.667%}.col-custom-xl-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-custom-xl-7{-ms-flex-preferred-size:58.333%;flex-basis:58.333%;max-width:58.333%}.col-custom-xl-8{-ms-flex-preferred-size:66.667%;flex-basis:66.667%;max-width:66.667%}.col-custom-xl-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-custom-xl-10{-ms-flex-preferred-size:83.333%;flex-basis:83.333%;max-width:83.333%}.col-custom-xl-11{-ms-flex-preferred-size:91.667%;flex-basis:91.667%;max-width:91.667%}.col-custom-xl-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-custom-xl-offset-1{margin-left:8.333%}.col-custom-xl-offset-2{margin-left:16.667%}.col-custom-xl-offset-3{margin-left:25%}.col-custom-xl-offset-4{margin-left:33.333%}.col-custom-xl-offset-5{margin-left:41.667%}.col-custom-xl-offset-6{margin-left:50%}.col-custom-xl-offset-7{margin-left:58.333%}.col-custom-xl-offset-8{margin-left:66.667%}.col-custom-xl-offset-9{margin-left:75%}.col-custom-xl-offset-10{margin-left:83.333%}.col-custom-xl-offset-11{margin-left:91.667%}}.visible-lg,.visible-md,.visible-sm,.visible-xs{display:none!important}@media (max-width:49em){.visible-xs{display:block!important}.row.visible-xs{display:-ms-flexbox!important;display:flex!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (min-width:49em) and (max-width:62em){.visible-sm{display:block!important}.row.visible-sm{display:-ms-flexbox!important;display:flex!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:62em) and (max-width:75em){.visible-md{display:block!important}.row.visible-md{display:-ms-flexbox!important;display:flex!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:75em){.visible-lg{display:block!important}.row.visible-lg{display:-ms-flexbox!important;display:flex!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (max-width:49em){.hidden-xs{display:none!important}}@media (min-width:49em) and (max-width:62em){.hidden-sm{display:none!important}}@media (min-width:62em) and (max-width:75em){.hidden-md{display:none!important}}@media (min-width:75em){.hidden-lg{display:none!important}}.navbar{border:1px solid #f7f7f7;background-color:#fff;user-select:none;height:90px}.navbar .logo{float:left;width:270px;height:100%;display:flex;cursor:pointer}@media (max-width:870px){.navbar .logo{width:165px}}.navbar .logo img{width:100px;margin-left:30px}.navbar .logo svg{color:rgba(0,0,0,.502);width:17px;margin-left:15px;transition:all .5s ease-in-out}.navbar .logo svg.rotated{transform:rotate(90deg)}.navbar .burger-menu{display:none;top:92px;left:0;position:absolute;width:100%;background-color:#fff;z-index:12;padding:20px 0;box-shadow:0 7px 14px #ddd}.navbar .burger-menu li{padding:10px 0;margin-left:15px;font-size:12px;font-family:Graphik-Regular;font-weight:700;color:rgba(0,0,0,.4)}.navbar .burger-menu li.active{color:#e43e3a}.navbar .burger-menu li a{text-decoration:none;color:inherit}.navbar .languages,.navbar .navigation{display:inline-block;margin:0;padding:0}.navbar .navigation-left li,.navbar .navigation-right li{margin-right:15px}@media (max-width:850px){.navbar .navigation-left li,.navbar .navigation-right li{margin-right:5px}}.navbar .navigation-left{float:left}.navbar .navigation-left li a{color:inherit;text-decoration:none}.navbar .languages{margin-right:25px;float:right}.navbar .navigation-right{float:right}.navbar .navigation-right svg{position:relative;top:3px;height:15px;width:15px;padding-right:2px}.navbar .navigation-right li{font-weight:bolder}.navbar .navigation-right .fullname{color:#000;cursor:text}.navbar .navigation-right .my-book{color:#6eb30f}.navbar .navigation-right .my-book:hover{color:#8be213}.navbar .languages li.active,.navbar .navigation li.active{color:#000}.navbar.geo .navigation li:not(.fullname){font-family:Georgian-Regular}.navbar .languages li,.navbar .navigation li{display:inline-block;height:100%;line-height:90px;font-size:13px;font-weight:700;font-family:Graphik-Regular;color:rgba(0,0,0,.502);cursor:pointer;padding-right:5px}.navbar .languages li:hover:not(.my-book),.navbar .navigation li:hover:not(.my-book){color:#000}.navbar .languages svg{transform:translateY(3px)}", ""]);
	
	// exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _user = __webpack_require__(456);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _book = __webpack_require__(514);
	
	var _book2 = _interopRequireDefault(_book);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userModule = _angular2.default.module('user', []).factory('User', _user2.default).factory('BookFactory', _book2.default).name;
	
	exports.default = userModule;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(457);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserFactory($http, config) {
	    var _this = this;
	
	    var baseUrl = config.baseUrl;
	
	    var User = null;
	    var Token = null;
	
	    try {
	        Token = localStorage.getItem("tourists_token");
	        User = JSON.parse(localStorage.getItem("tourists_user"));
	    } catch (e) {
	        Token = null;
	        User = null;
	    }
	
	    var login = function login() {
	        return new _promise2.default(function (resolve, reject) {
	            FB.login(function (result) {
	                if (result.authResponse) {
	                    return $http.post(baseUrl + "/api/auth/facebook", {
	                        access_token: result.authResponse.accessToken
	                    }).then(function (response) {
	                        Token = response.headers("authorization");
	                        User = response.data;
	
	                        localStorage.setItem("tourists_token", Token);
	                        localStorage.setItem("tourists_user", (0, _stringify2.default)(User));
	
	                        resolve();
	                    }).catch(function (err) {
	                        return reject(err);
	                    });
	                }
	                reject();
	                // }, { scope: 'public_profile, user_gender, user_birthday, user_hometown, user_likes, user_location' })
	            }, {
	                scope: "public_profile"
	            });
	        });
	    };
	
	    var logout = function logout() {
	        Token = null;
	        User = null;
	
	        localStorage.removeItem("tourists_token");
	        localStorage.removeItem("tourists_user");
	        localStorage.removeItem("tourists_bookId");
	    };
	
	    var isLoggedIn = function isLoggedIn() {
	        return new _promise2.default(function (resolve, reject) {
	            _this.getCurrentUser().then(function () {
	                return resolve(true);
	            }).catch(function () {
	                return reject();
	            });
	        });
	    };
	
	    var getCurrentUser = function getCurrentUser() {
	        return new _promise2.default(function (resolve, reject) {
	            if (User && Token) {
	                resolve(User);
	            } else if (Token) {
	                $http.get(baseUrl + "/api/auth/me").then(function (response) {
	                    var user = response.user;
	
	
	                    User = user;
	
	                    localStorage.setItem("tourists_user", (0, _stringify2.default)(user));
	
	                    resolve(user);
	                }).catch(function (err) {
	                    return reject(err);
	                });
	            } else {
	                resolve(null);
	            }
	        });
	    };
	
	    var getUser = function getUser() {
	        return User;
	    };
	
	    return {
	        login: login,
	        logout: logout,
	        isLoggedIn: isLoggedIn,
	        getCurrentUser: getCurrentUser,
	        getUser: getUser
	    };
	}
	
	UserFactory.$inject = ["$http", "config"];
	
	exports.default = UserFactory;

/***/ }),
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(459);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BookFactory($http, config) {
	    var baseUrl = config.baseUrl;
	
	
	    var getBook = function getBook(bookId) {
	        return $http.get(baseUrl + '/api/books/' + bookId);
	    };
	
	    var generateGuestBook = function generateGuestBook() {
	        var interests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        return new _promise2.default(function (resolve, reject) {
	            $http.post(baseUrl + '/api/guest-book', {
	                interests: interests
	            }).then(function (response) {
	                var bookId = response.data.bookId;
	
	
	                resolve({ bookId: bookId });
	            }).catch(function (err) {
	                return reject(err);
	            });
	        });
	    };
	
	    var generateFacebookBook = function generateFacebookBook() {
	        return new _promise2.default(function (resolve, reject) {
	            $http.post(baseUrl + '/api/facebook-book').then(function (response) {
	                var bookId = response.data.bookId;
	
	
	                resolve({ bookId: bookId });
	            }).catch(function (err) {
	                return reject(err);
	            });
	        });
	    };
	
	    return {
	        getBook: getBook,
	        generateFacebookBook: generateFacebookBook,
	        generateGuestBook: generateGuestBook
	    };
	}
	
	BookFactory.$inject = ['$http', 'config'];
	
	exports.default = BookFactory;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _footer = __webpack_require__(516);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _aboutFooter = __webpack_require__(523);
	
	var _aboutFooter2 = _interopRequireDefault(_aboutFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerModule = _angular2.default.module('footer', [_angularUiRouter2.default]).component('footer', _footer2.default).component('aboutFooter', _aboutFooter2.default).name;
	
	exports.default = footerModule;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footer = __webpack_require__(517);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _footer3 = __webpack_require__(518);
	
	var _footer4 = _interopRequireDefault(_footer3);
	
	__webpack_require__(519);
	
	__webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerComponent = {
	    bindings: {},
	    template: _footer2.default,
	    controller: _footer4.default
	};
	
	exports.default = footerComponent;

/***/ }),
/* 517 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"footer hidden-xs\">\n\t<div class=\"top-left-footer\">\n\t\t<div class=\"logo\" ng-click=\"$ctrl.clearCategories()\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"59\" height=\"33\" viewBox=\"0 0 59 33\">\n\t\t\t\t<image id=\"footer-logo\" width=\"59\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAhCAMAAABQtiN8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABsFBMVEUiHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8AAAAaxdiOAAAAjnRSTlMAwjL+yMCbgJ1/fp6cF/L2HPUYdad3pqV2Btw6Od0HTswCUMoBy0+7YF+9K/zoDS3mDOcslYeGlxLu+SIT7/hCIW2ubvtwBNXXQNZH0gPQsmln/bQm+usRD+pNEIuQjo0oJ2W3tbZJPtkFqyD38BUUhIUL5S5dv16+UslRON4IonmkeBvze3wJ4OLhVVdW6/wjVwAAAAFiS0dEj/UCg/kAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQNDhhV7S6FAAACGUlEQVQ4y52ViVsSURTFr0pZlgglmRuFUi4RSrlkCZIgQSqFCWmUZouV2Wr7vtN6/uZmwBlm5ozQ1/m+4d33u/e8ecy890Zq8L+qkdo6OLaRjNCBOi5QYK3IdtQLaQd26nEDdnFBPXYrv43OJhelDNDldu6hvKvJ2ai2e9HM43qwbzNqgYfTzdhfbFvb0E5JHXag00vZdrS1lqIDOOijdBe6VejvRhflfIdwWIt70MvTKsE+9HOqFz16fCRwNEgFA4HBoIQGAwOUCR4LHC/3hjDMo6twBKOcGMaQoXdi7OQpKhkPRyYi4XHi0ciYCZ7GJI8fQxxTjCcRM/UTZzBBRYkkkgmiKZy1wGnMzFqrZtN2cAbTVnYO560ogzlkGF6gqcxncxfNZGExfimby5thPped50dwGVfMYAlLsqxcFrjMVvU2Vy0TyatwxQhX4osLNl65huvG7o3if83gJkOWL41VevBmuIq0z9Yrt3D7jhYr7zZVDFJIMrTRWnkZxfSFZoBTWNvKKnfX790vRcpajm7C6Hr4AUEbPdS2jXFjPdLgKEa2tsrjjbknalvcu5pCG6U9rMBQBa88xTO1MR8kz/FCbfrRV8kqfgde6meVDl/hdRH6K3rlDd6+o4NTgV5vJzqkit7jQ/ls1vQRnzxoqWaVz+4v/KFQodtV1StfYfgWafoGNFS3SuH7j4IN/Fn4B6/8+m0D/9jAvyk9ohyPK8neAAAAAElFTkSuQmCC\"\n\t\t\t\t/>\n\t\t\t</svg>\n\t\t\t<span class=\"copyright\">\n\t\t\t\tWebsite by Windfor's\n\t\t\t</span>\n\t\t</div>\n\t\t<ul class=\"social\">\n\t\t\t<li>\n\t\t\t\t<a href=\"https://fb.com/georgiaandtravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"facebook-f\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 264 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-facebook-f fa-w-9 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#405cad\" d=\"M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://www.instagram.com/georgiatravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"instagram\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-instagram fa-w-14 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#dd3972\" d=\"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://twitter.com/GeorgiaAndTrave\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"twitter\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-twitter fa-w-16 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#4394e9\" d=\"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://www.youtube.com/user/GeorgiaAndTravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"youtube\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-youtube fa-w-18 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#dd3a0c\" d=\"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"bottom-left-footer\">\n\t\t<a ui-sref=\"privacy\">Privacy Policy</a>\n\t\t<a ui-sref=\"terms\">Terms of use</a>\n\t</div>\n</div>\n\n<div class=\"footer-mobile visible-xs\">\n\t<div class=\"top-left-footer\">\n\t\t<div class=\"logo\" ng-click=\"$ctrl.clearCategories()\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"59\" height=\"33\" viewBox=\"0 0 59 33\">\n\t\t\t\t<image id=\"footer-logo\" width=\"59\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAhCAMAAABQtiN8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABsFBMVEUiHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8AAAAaxdiOAAAAjnRSTlMAwjL+yMCbgJ1/fp6cF/L2HPUYdad3pqV2Btw6Od0HTswCUMoBy0+7YF+9K/zoDS3mDOcslYeGlxLu+SIT7/hCIW2ubvtwBNXXQNZH0gPQsmln/bQm+usRD+pNEIuQjo0oJ2W3tbZJPtkFqyD38BUUhIUL5S5dv16+UslRON4IonmkeBvze3wJ4OLhVVdW6/wjVwAAAAFiS0dEj/UCg/kAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQNDhhV7S6FAAACGUlEQVQ4y52ViVsSURTFr0pZlgglmRuFUi4RSrlkCZIgQSqFCWmUZouV2Wr7vtN6/uZmwBlm5ozQ1/m+4d33u/e8ecy890Zq8L+qkdo6OLaRjNCBOi5QYK3IdtQLaQd26nEDdnFBPXYrv43OJhelDNDldu6hvKvJ2ai2e9HM43qwbzNqgYfTzdhfbFvb0E5JHXag00vZdrS1lqIDOOijdBe6VejvRhflfIdwWIt70MvTKsE+9HOqFz16fCRwNEgFA4HBoIQGAwOUCR4LHC/3hjDMo6twBKOcGMaQoXdi7OQpKhkPRyYi4XHi0ciYCZ7GJI8fQxxTjCcRM/UTZzBBRYkkkgmiKZy1wGnMzFqrZtN2cAbTVnYO560ogzlkGF6gqcxncxfNZGExfimby5thPped50dwGVfMYAlLsqxcFrjMVvU2Vy0TyatwxQhX4osLNl65huvG7o3if83gJkOWL41VevBmuIq0z9Yrt3D7jhYr7zZVDFJIMrTRWnkZxfSFZoBTWNvKKnfX790vRcpajm7C6Hr4AUEbPdS2jXFjPdLgKEa2tsrjjbknalvcu5pCG6U9rMBQBa88xTO1MR8kz/FCbfrRV8kqfgde6meVDl/hdRH6K3rlDd6+o4NTgV5vJzqkit7jQ/ls1vQRnzxoqWaVz+4v/KFQodtV1StfYfgWafoGNFS3SuH7j4IN/Fn4B6/8+m0D/9jAvyk9ohyPK8neAAAAAElFTkSuQmCC\"\n\t\t\t\t/>\n\t\t\t</svg>\n\t\t\t<div class=\"copyright\">\n\t\t\t\t<span>\n\t\t\t\t\tWebsite by Windfor's\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t</div>\n\t\t<ul class=\"social\">\n\t\t\t<li>\n\t\t\t\t<a href=\"https://fb.com/georgiaandtravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"facebook-f\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 264 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-facebook-f fa-w-9 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#405cad\" d=\"M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://www.instagram.com/georgiatravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"instagram\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-instagram fa-w-14 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#dd3972\" d=\"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://twitter.com/GeorgiaAndTrave\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"twitter\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-twitter fa-w-16 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#4394e9\" d=\"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\t<a href=\"https://www.youtube.com/user/GeorgiaAndTravel\" target=\"_blank\">\n\t\t\t\t\t<svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"youtube\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"\n\t\t\t\t\t class=\"svg-inline--fa fa-youtube fa-w-18 fa-2x\">\n\t\t\t\t\t\t<path fill=\"#dd3a0c\" d=\"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"bottom-left-footer\">\n\t\t<div>\n\t\t\t<a ui-sref=\"privacy\">Privacy Policy</a>\n\t\t</div>\n\t\t<div>\n\t\t\t<a ui-sref=\"terms\">Terms of use</a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterController = function () {
		function FooterController($state, Category) {
			(0, _classCallCheck3.default)(this, FooterController);
	
			this.name = 'footer';
	
			this.$state = $state;
			this.Category = Category;
		}
	
		(0, _createClass3.default)(FooterController, [{
			key: 'clearCategories',
			value: function clearCategories() {
				this.Category.clearSelectedCategories();
	
				this.$state.go('home', { search: '' });
			}
		}]);
		return FooterController;
	}();
	
	FooterController.$inject = ['$state', 'Category'];
	
	exports.default = FooterController;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(520);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".footer{position:fixed;bottom:0;z-index:10;width:231px;height:53px;background:none;border-top:1px solid #ededed;padding:10px;padding-right:11px;background-color:#fff}.footer .top-left-footer{width:231px;display:flex;align-items:center;justify-content:space-between}.footer .top-left-footer .logo{position:relative;left:5px;display:flex;align-items:center;width:100px;font-size:10px;color:rgba(0,0,0,.502)}.footer .top-left-footer .logo svg{width:50px}.footer .top-left-footer .logo span{margin-left:5px}.footer .top-left-footer .social li{margin-right:15px;display:inline}.footer .top-left-footer .social li a{text-decoration:none}.footer .top-left-footer .social svg{width:12px;height:12px;cursor:pointer}.footer .bottom-left-footer{padding-top:7px;display:flex;justify-content:space-around;font-size:11px}.footer .bottom-left-footer a{color:#a1a1a1;text-decoration:none}.footer .bottom-left-footer a:hover{text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(522);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.mobile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./footer.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".footer-mobile{padding:15px}.footer-mobile .top-left-footer{width:100%}.footer-mobile .top-left-footer .logo{display:inline-block;width:calc(50% - 3px);font-size:11px;color:rgba(0,0,0,.502)}.footer-mobile .top-left-footer .logo svg{width:50px;float:left}.footer-mobile .top-left-footer .logo div{position:relative;top:3px;float:left;width:59px;font-weight:700;padding-left:5px}.footer-mobile .top-left-footer .social{position:relative;top:-15px;display:inline-block;width:calc(50% - 2px);text-align:right}.footer-mobile .top-left-footer .social svg{width:15px;height:15px}.footer-mobile .top-left-footer .social li{margin-left:7px;list-style:none;display:inline}.footer-mobile .top-left-footer .social li a{text-decoration:none}.footer-mobile .bottom-left-footer{display:inline-block;width:100%}.footer-mobile .bottom-left-footer div{text-align:center;line-height:17px}.footer-mobile .bottom-left-footer div a{text-decoration:none;font-size:11px;font-weight:700;color:#878484}", ""]);
	
	// exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _aboutFooter = __webpack_require__(524);
	
	var _aboutFooter2 = _interopRequireDefault(_aboutFooter);
	
	var _footer = __webpack_require__(518);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(525);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerComponent = {
	    bindings: {},
	    template: _aboutFooter2.default,
	    controller: _footer2.default
	};
	
	exports.default = footerComponent;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"about-footer\">\n    <div class=\"top\">\n        <div class=\"logo\" ng-click=\"$ctrl.clearCategories()\">\n            <svg class=\"windforce\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"59\" height=\"33\"\n                viewBox=\"0 0 59 33\">\n                <image id=\"footer-logo\" width=\"59\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAhCAMAAABQtiN8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABsFBMVEUiHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8iHx8AAAAaxdiOAAAAjnRSTlMAwjL+yMCbgJ1/fp6cF/L2HPUYdad3pqV2Btw6Od0HTswCUMoBy0+7YF+9K/zoDS3mDOcslYeGlxLu+SIT7/hCIW2ubvtwBNXXQNZH0gPQsmln/bQm+usRD+pNEIuQjo0oJ2W3tbZJPtkFqyD38BUUhIUL5S5dv16+UslRON4IonmkeBvze3wJ4OLhVVdW6/wjVwAAAAFiS0dEj/UCg/kAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQNDhhV7S6FAAACGUlEQVQ4y52ViVsSURTFr0pZlgglmRuFUi4RSrlkCZIgQSqFCWmUZouV2Wr7vtN6/uZmwBlm5ozQ1/m+4d33u/e8ecy890Zq8L+qkdo6OLaRjNCBOi5QYK3IdtQLaQd26nEDdnFBPXYrv43OJhelDNDldu6hvKvJ2ai2e9HM43qwbzNqgYfTzdhfbFvb0E5JHXag00vZdrS1lqIDOOijdBe6VejvRhflfIdwWIt70MvTKsE+9HOqFz16fCRwNEgFA4HBoIQGAwOUCR4LHC/3hjDMo6twBKOcGMaQoXdi7OQpKhkPRyYi4XHi0ciYCZ7GJI8fQxxTjCcRM/UTZzBBRYkkkgmiKZy1wGnMzFqrZtN2cAbTVnYO560ogzlkGF6gqcxncxfNZGExfimby5thPped50dwGVfMYAlLsqxcFrjMVvU2Vy0TyatwxQhX4osLNl65huvG7o3if83gJkOWL41VevBmuIq0z9Yrt3D7jhYr7zZVDFJIMrTRWnkZxfSFZoBTWNvKKnfX790vRcpajm7C6Hr4AUEbPdS2jXFjPdLgKEa2tsrjjbknalvcu5pCG6U9rMBQBa88xTO1MR8kz/FCbfrRV8kqfgde6meVDl/hdRH6K3rlDd6+o4NTgV5vJzqkit7jQ/ls1vQRnzxoqWaVz+4v/KFQodtV1StfYfgWafoGNFS3SuH7j4IN/Fn4B6/8+m0D/9jAvyk9ohyPK8neAAAAAElFTkSuQmCC\"\n                />\n            </svg>\n            <div class=\"copyright\">\n                Website by Windfor's\n            </div>\n        </div>\n        <div class=\"social\">\n            <ul>\n                <li>\n                    <a href=\"https://fb.com/georgiaandtravel\" target=\"_blank\">\n                        <svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"facebook-f\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 264 512\"\n                            class=\"svg-inline--fa fa-facebook-f fa-w-9 fa-2x\">\n                            <path fill=\"#405cad\" d=\"M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229\"\n                                class=\"\"></path>\n                        </svg>\n                    </a>\n                </li>\n                <li>\n                    <a href=\"https://www.instagram.com/georgiatravel\" target=\"_blank\">\n                        <svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"instagram\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"\n                            class=\"svg-inline--fa fa-instagram fa-w-14 fa-2x\">\n                            <path fill=\"#dd3972\" d=\"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z\"\n                                class=\"\"></path>\n                        </svg>\n                    </a>\n                </li>\n                <li>\n                    <a href=\"https://twitter.com/GeorgiaAndTrave\" target=\"_blank\">\n                        <svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"twitter\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n                            class=\"svg-inline--fa fa-twitter fa-w-16 fa-2x\">\n                            <path fill=\"#4394e9\" d=\"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z\"\n                                class=\"\"></path>\n                        </svg>\n                    </a>\n                </li>\n                <li>\n                    <a href=\"https://www.youtube.com/user/GeorgiaAndTravel\" target=\"_blank\">\n                        <svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"youtube\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 576 512\"\n                            class=\"svg-inline--fa fa-youtube fa-w-18 fa-2x\">\n                            <path fill=\"#dd3a0c\" d=\"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z\"\n                                class=\"\"></path>\n                        </svg>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <div class=\"bottom\">\n        <a ui-sref=\"privacy\">Privacy Policy</a>\n        <a ui-sref=\"terms\">Terms of use</a>\n    </div>\n</div>\n"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(526);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./aboutFooter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./aboutFooter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".about-footer{margin:0;padding:15px 10px 15px 15px;border-top:1px solid #c0bfbf}.about-footer .top{width:100%}.about-footer .top .logo{display:inline-block;width:125px;text-align:left;font-size:9px;color:rgba(0,0,0,.7)}.about-footer .top .logo .windforce{width:50px;height:35px}.about-footer .top .logo .copyright{position:relative;bottom:5px;display:inline-block;width:70px}.about-footer .top .social{display:inline-block;width:calc(100% - 130px);text-align:right}.about-footer .top .social ul{position:relative;top:-15px}.about-footer .top .social li{margin-right:15px;display:inline}.about-footer .top .social li:last-child{margin-right:5px}.about-footer .top .social li a{text-decoration:none}.about-footer .top .social svg{width:12px;height:12px;cursor:pointer}.about-footer .bottom{text-align:left}.about-footer .bottom a{font-size:11px;color:rgba(0,0,0,.7);text-decoration:none}.about-footer .bottom a:first-child{margin-right:10px}.about-footer .bottom a:hover{text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _mcactionbutton = __webpack_require__(528);
	
	var _mcactionbutton2 = _interopRequireDefault(_mcactionbutton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mcactionbuttonModule = _angular2.default.module('mcactionbutton', [_angularUiRouter2.default]).component('mcactionbutton', _mcactionbutton2.default).name;
	
	exports.default = mcactionbuttonModule;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mcactionbutton = __webpack_require__(529);
	
	var _mcactionbutton2 = _interopRequireDefault(_mcactionbutton);
	
	var _mcactionbutton3 = __webpack_require__(530);
	
	var _mcactionbutton4 = _interopRequireDefault(_mcactionbutton3);
	
	__webpack_require__(532);
	
	__webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mcactionbuttonComponent = {
	  bindings: {
	    'thumbs': '=',
	    'url': '=',
	    'id': '='
	  },
	  template: _mcactionbutton2.default,
	  controller: _mcactionbutton4.default
	};
	
	exports.default = mcactionbuttonComponent;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = "<!-- Action buttons -->\n<div class=\"mcactionbutton action-buttons-container hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"thumbs\">\n\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"54\" height=\"57\" viewBox=\"0 0 54 57\"\n            ng-click=\"$ctrl.saveThumb($ctrl.url)\">\n            <image data-name=\"thumb-0\" width=\"54\" height=\"57\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA5CAQAAADXGhCDAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQHJyA0PowmAAACw0lEQVRYw73YTUiUQRzH8e8zmiWVi4KlaRbRG1JaWAgJYeihoDRfDr0cAkHDgi7OoUvlrcCBjlogHSIPEVkrhC/kUVDK1G6VRpYpqQStmeLLdnh2dV+e3VV3n/lddp6Znfkw+yzDnzHqCR8JkEEeeRwki0wcbCUecPOHf3zjO1/p5z1fcFvNVz7t+AhUARcp5YDFkIEDB2nke54naMNJO4uhVwuJyUSucZMjrDVpVFPNGI9oZMr6K3GFVpBx6jKtXGXHmilvkjjDdRZ5x5LZ0eMzKCyodLpoYc+6IW8cNPCBo8EDQZgsZpCiDUPeZNNHVQRMXuENqVFTAFto5nYYTFbwlE0xoczcpy4EJk/yzOodRhUlyywwmcQLNseYAngiM4J31kCWDRQ4aArAZD41tlAA52Wp/84e2EYB1EtjBZOnKbQVO8aF1Z3V2koB5ksSIJMpi3atiDkn082dldnyl/ePoNLEztpOARSDMRPHJMkaMBcpgkNaKNhOtiBXCwWQI8jRie3Thu0VZGrDMgXp2rA0QYo2LEWQqA1LFCRowxJiXXOEjWZsTps1L5jXhs0JfmnDpgQ/tWETgnFt2JjgkzZsRDCkDRsSDGrDBo0Zg3F2aqB+kyqUm04t+3qrlgTQoQXrMM9GJ39tpxZ4BQKUi+e2Y0415T31m6JcKnIegwdTfThtpXpV5woG3GPZRuyO+eHB1AAPbaNaVJcfBtzlsy3UJLe8zRVMzVLBbMypZS6p6SAM1EcqWIgxVqO6Vx/8Ch7VTmUMaxI3N2j27QiorpSTIsZiQrmopNG/K6iUUz3k0hY11cdxXgZ2WtSNalqVUM7whqFJaimwmh+iSFWtZFPFwLqhEerYT5P1tbRRH3auzKecEg6vgRnFyWu6A08i36v2CJjnXn8XJzz3+rtJYhtxwDIuXPxglBH66WU0xG/k0/4PIbCdzAsisFMAAAAASUVORK5CYII=\"\n            />\n\n            <image ng-if=\"!$ctrl.thumbed\" class=\"thumb-outline\" data-name=\"Thumb outline\" width=\"25\" height=\"24\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABF1BMVEXuJk6AgIDuJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk4AAADzI0CPAAAAXHRSTlMAAGLZ5Msc0ebI8t0Kz9CS+44F3M7TzNY587DXwe4lFOq4JMJl/WSx9DrA+d7VlgYV6ITYrQSV4fhTAuOr+trp/gED0iGM/LMuxwnExRDivPEYyeC+w/C0v98dkHsW0tUAAAABYktHRFzq2ACXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUXCRcfFSxCkwAAAPtJREFUKM910HtXgjAcxvFntS6UkIW1LM3umVpBN6qlpVSkkJVG1/f/Php4yHUc3z92YB/2O4cBw8bG6cQkSZIAU9PazGxGJbqBuex8iiyYOZUs6sASU8hyfgVYVZ0pFNdQWt8Ylc3iFrC9szsqe+V9oFKtmVEHh0d/YNk5sR5rg06ypzg71+Oci8v4i8GoK4Pjut4wRDe3rClJy+Vw3Fa0wcw7SHL/UAH14g1WgCyPvJYipE3V0vHzgVqeunYpZVqbE6V0nl80tVjUfh1KrylN8/viRnkQvWecesN/Swrfe0LCcuB5H6z66X7RpK72LcQKuXju/+D/nxLyC8gKIhts642+AAAAAElFTkSuQmCC\"\n            />\n\n            <image ng-if=\"$ctrl.thumbed\" class=\"thumb-full\" data-name=\"Thumb full\" width=\"25\" height=\"23\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAMAAADJPRQhAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAApVBMVEXuJk6AgIDuJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk4AAADFZ5T3AAAANXRSTlMAAGzs01rgPyKmo8uBswObaQq09xB/sIAWye6vcwbw/iTelnDrzPsxHG9JAXR44SpgVw/EytembfwAAAABYktHRDZHv4jRAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUXCRcKePGmeAAAAJZJREFUKM910scSwjAMRVGZFlpoCSY0h9476P9/jTghjDF+d6c5o5VEZFYolsri0w9QhZk9l1QT4JpL6loaDmlqYP9PWu0UuGNLt5dBEObSl1IOiKJhBjySuvFkSiqZYprN2WqRCtPSBl5BWSPZbOHODkkQItkLJAcoHhL/iOQkkJyRXKKvXG9m94e+wlMp9TIOm7+OeAO8AkmAa9LC/wAAAABJRU5ErkJggg==\"\n            />\n        </svg>\n\n        <span>{{ $ctrl.thumbs }}</span>\n    </div>\n\n    <div class=\"shares\" ng-click=\"$ctrl.sharePost()\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"10\" height=\"18\" viewBox=\"0 0 10 18\">\n            <image data-name=\"share-0\" width=\"10\" height=\"18\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAQAAADIvofAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQHKCMqr8FTAAAAx0lEQVQY02XNoUpDYQCG4ec/5/AjJi/AIhaxajJpMIuiRSy2cwsTBgaDYh+IMGEXsCCCKJhtW9Xq8AYMhp/NGY5Tz/bFhxe+cApSz6q+G+04JN8Eo4E3y0rbo9v8M1RltbSno2+r+GdiN411HdVKSM+Gmek9Wp/FD3OzuOJ9CtOCAw81TLm2eZdFjTp2lfElS4O0Aym4dqgRr8gsWiIFLcca8Ryyn6qlnFCFFTUnRIF9Gy7i2d9lOBnjyR14jfcVfgm/SS+uwTdBADgVp56j4wAAAABJRU5ErkJggg==\"\n            />\n        </svg>\n        <span>{{$ctrl.shareText}}</span>\n    </div>\n</div>\n\n<div class=\"mobile-action-buttons mcactionbutton visible-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <ul>\n        <li>\n            <svg class=\"thumb-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"34\" height=\"37\"\n                ng-click=\"$ctrl.saveThumb($ctrl.url)\">\n                <image data-name=\"thumb-0\" width=\"34\" height=\"37\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA5CAQAAADXGhCDAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQHJyA0PowmAAACw0lEQVRYw73YTUiUQRzH8e8zmiWVi4KlaRbRG1JaWAgJYeihoDRfDr0cAkHDgi7OoUvlrcCBjlogHSIPEVkrhC/kUVDK1G6VRpYpqQStmeLLdnh2dV+e3VV3n/lddp6Znfkw+yzDnzHqCR8JkEEeeRwki0wcbCUecPOHf3zjO1/p5z1fcFvNVz7t+AhUARcp5YDFkIEDB2nke54naMNJO4uhVwuJyUSucZMjrDVpVFPNGI9oZMr6K3GFVpBx6jKtXGXHmilvkjjDdRZ5x5LZ0eMzKCyodLpoYc+6IW8cNPCBo8EDQZgsZpCiDUPeZNNHVQRMXuENqVFTAFto5nYYTFbwlE0xoczcpy4EJk/yzOodRhUlyywwmcQLNseYAngiM4J31kCWDRQ4aArAZD41tlAA52Wp/84e2EYB1EtjBZOnKbQVO8aF1Z3V2koB5ksSIJMpi3atiDkn082dldnyl/ePoNLEztpOARSDMRPHJMkaMBcpgkNaKNhOtiBXCwWQI8jRie3Thu0VZGrDMgXp2rA0QYo2LEWQqA1LFCRowxJiXXOEjWZsTps1L5jXhs0JfmnDpgQ/tWETgnFt2JjgkzZsRDCkDRsSDGrDBo0Zg3F2aqB+kyqUm04t+3qrlgTQoQXrMM9GJ39tpxZ4BQKUi+e2Y0415T31m6JcKnIegwdTfThtpXpV5woG3GPZRuyO+eHB1AAPbaNaVJcfBtzlsy3UJLe8zRVMzVLBbMypZS6p6SAM1EcqWIgxVqO6Vx/8Ch7VTmUMaxI3N2j27QiorpSTIsZiQrmopNG/K6iUUz3k0hY11cdxXgZ2WtSNalqVUM7whqFJaimwmh+iSFWtZFPFwLqhEerYT5P1tbRRH3auzKecEg6vgRnFyWu6A08i36v2CJjnXn8XJzz3+rtJYhtxwDIuXPxglBH66WU0xG/k0/4PIbCdzAsisFMAAAAASUVORK5CYII=\"\n                />\n\n                <image ng-if=\"!$ctrl.thumbed\" class=\"thumb-outline\" data-name=\"Thumb outline\" width=\"20\" height=\"19\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAMAAAA4a6b0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABF1BMVEXuJk6AgIDuJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk4AAADzI0CPAAAAXHRSTlMAAGLZ5Msc0ebI8t0Kz9CS+44F3M7TzNY587DXwe4lFOq4JMJl/WSx9DrA+d7VlgYV6ITYrQSV4fhTAuOr+trp/gED0iGM/LMuxwnExRDivPEYyeC+w/C0v98dkHsW0tUAAAABYktHRFzq2ACXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUXCRcfFSxCkwAAAPtJREFUKM910HtXgjAcxvFntS6UkIW1LM3umVpBN6qlpVSkkJVG1/f/Php4yHUc3z92YB/2O4cBw8bG6cQkSZIAU9PazGxGJbqBuex8iiyYOZUs6sASU8hyfgVYVZ0pFNdQWt8Ylc3iFrC9szsqe+V9oFKtmVEHh0d/YNk5sR5rg06ypzg71+Oci8v4i8GoK4Pjut4wRDe3rClJy+Vw3Fa0wcw7SHL/UAH14g1WgCyPvJYipE3V0vHzgVqeunYpZVqbE6V0nl80tVjUfh1KrylN8/viRnkQvWecesN/Swrfe0LCcuB5H6z66X7RpK72LcQKuXju/+D/nxLyC8gKIhts642+AAAAAElFTkSuQmCC\"\n                />\n\n                <image ng-if=\"$ctrl.thumbed\" class=\"thumb-full\" data-name=\"Thumb full\" width=\"20\" height=\"18\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAMAAADJPRQhAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAApVBMVEXuJk6AgIDuJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk7uJk4AAADFZ5T3AAAANXRSTlMAAGzs01rgPyKmo8uBswObaQq09xB/sIAWye6vcwbw/iTelnDrzPsxHG9JAXR44SpgVw/EytembfwAAAABYktHRDZHv4jRAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUXCRcKePGmeAAAAJZJREFUKM910scSwjAMRVGZFlpoCSY0h9476P9/jTghjDF+d6c5o5VEZFYolsri0w9QhZk9l1QT4JpL6loaDmlqYP9PWu0UuGNLt5dBEObSl1IOiKJhBjySuvFkSiqZYprN2WqRCtPSBl5BWSPZbOHODkkQItkLJAcoHhL/iOQkkJyRXKKvXG9m94e+wlMp9TIOm7+OeAO8AkmAa9LC/wAAAABJRU5ErkJggg==\"\n                />\n            </svg>\n            <span class=\"thumb-count\">{{ $ctrl.thumbs }}</span>\n        </li>\n        <li ng-click=\"$ctrl.sharePost()\">\n            <svg class=\"share-svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"7\" height=\"15\">\n                <image data-name=\"share-0\" width=\"7\" height=\"15\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAQAAADIvofAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQHKCMqr8FTAAAAx0lEQVQY02XNoUpDYQCG4ec/5/AjJi/AIhaxajJpMIuiRSy2cwsTBgaDYh+IMGEXsCCCKJhtW9Xq8AYMhp/NGY5Tz/bFhxe+cApSz6q+G+04JN8Eo4E3y0rbo9v8M1RltbSno2+r+GdiN411HdVKSM+Gmek9Wp/FD3OzuOJ9CtOCAw81TLm2eZdFjTp2lfElS4O0Aym4dqgRr8gsWiIFLcca8Ryyn6qlnFCFFTUnRIF9Gy7i2d9lOBnjyR14jfcVfgm/SS+uwTdBADgVp56j4wAAAABJRU5ErkJggg==\"\n                />\n            </svg>\n            <span class=\"share-span\">{{$ctrl.shareText}}</span>\n        </li>\n    </ul>\n</div>\n"

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(457);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _mcactionbutton = __webpack_require__(531);
	
	var _mcactionbutton2 = _interopRequireDefault(_mcactionbutton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var McactionbuttonController = function () {
	    function McactionbuttonController($scope, config, SharedMoments, Share) {
	        (0, _classCallCheck3.default)(this, McactionbuttonController);
	
	        this.name = 'mcactionbutton';
	
	        this.$scope = $scope;
	
	        this.config = config;
	        this.SharedMoments = SharedMoments;
	        this.ShareFactory = Share;
	    }
	
	    (0, _createClass3.default)(McactionbuttonController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchLanguage();
	
	            this.thumbed = this.alreadyThumbed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var SHARE = _mcactionbutton2.default[this.language].SHARE;
	
	
	            this.shareText = SHARE;
	        }
	    }, {
	        key: 'alreadyThumbed',
	        value: function alreadyThumbed() {
	            var localStorageThumbs = JSON.parse(localStorage.getItem('tourists_thumbs'));
	
	            return localStorageThumbs && localStorageThumbs.includes(this.url);
	        }
	    }, {
	        key: 'sharePost',
	        value: function sharePost() {
	            this.ShareFactory.shareObject(this.config.frontUrl + '/post?id=' + this.id);
	        }
	    }, {
	        key: 'saveThumb',
	        value: function saveThumb(url) {
	            var _this = this;
	
	            if (this.isThumbLoading) {
	                return;
	            }
	
	            this.isThumbLoading = true;
	
	            var thumbsLocalStorage = JSON.parse(localStorage.getItem('tourists_thumbs'));
	
	            // if is not alredy thumbed
	            if (!this.thumbed) {
	                this.SharedMoments.thumbPost(url, 'UP').then(function () {
	                    // Change thumb icon
	                    _this.thumbed = true;
	
	                    // Add thumbs
	                    _this.thumbs = parseInt(_this.thumbs) + 1;
	
	                    // Save to local storage
	                    if (!thumbsLocalStorage) {
	                        thumbsLocalStorage = new Array();
	                        localStorage.setItem('tourists_thumbs', (0, _stringify2.default)(thumbsLocalStorage));
	                    }
	                    thumbsLocalStorage.push(_this.url);
	                    localStorage.setItem('tourists_thumbs', (0, _stringify2.default)(thumbsLocalStorage));
	
	                    _this.isThumbLoading = false;
	                }).catch(function (err) {
	                    console.log('Error occured in method thumbPost', err);
	
	                    _this.error = err.data;
	
	                    _this.isThumbLoading = false;
	                });
	            } else {
	                // Unthumb
	                this.SharedMoments.thumbPost(url, 'DOWN').then(function () {
	                    var urlIndex = thumbsLocalStorage.indexOf(_this.url);
	                    if (urlIndex != -1) {
	                        thumbsLocalStorage.splice(urlIndex, 1);
	
	                        localStorage.setItem('tourists_thumbs', (0, _stringify2.default)(thumbsLocalStorage));
	
	                        _this.thumbed = false;
	
	                        // Subtract thumbs
	                        _this.thumbs = parseInt(_this.thumbs) - 1;
	                        _this.thumbs = _this.thumbs < 0 ? 0 : _this.thumbs;
	                    }
	
	                    _this.isThumbLoading = false;
	                }).catch(function (err) {
	                    console.log('Error occured in method thumbPost', err);
	
	                    _this.error = err.data;
	
	                    _this.isThumbLoading = false;
	                });
	            }
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this2.render();
	                }
	            });
	        }
	    }]);
	    return McactionbuttonController;
	}();
	
	McactionbuttonController.$inject = ['$scope', 'config', 'SharedMoments', 'Share'];
	
	exports.default = McactionbuttonController;

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        SHARE: 'გაზიარება'
	    },
	    EN: {
	        SHARE: 'Share'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(533);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./mcactionbutton.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./mcactionbutton.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".mcactionbutton{background-color:#fff;box-shadow:7px -7px 10px #f0f0f0;width:75px;height:171px;position:absolute;right:0;display:none;z-index:7;top:0;border-bottom-left-radius:30px;cursor:default}.mcactionbutton.geo .shares{font-family:Georgian-Black}.mcactionbutton .shares,.mcactionbutton .thumbs{text-align:center;font-size:11px;font-family:Graphik-Black;margin:10px 8px;cursor:pointer}.mcactionbutton .shares .thumb-full,.mcactionbutton .shares .thumb-outline,.mcactionbutton .thumbs .thumb-full,.mcactionbutton .thumbs .thumb-outline{transform:translate(14px,14px)}.mcactionbutton .thumbs span{color:#ee264e;user-select:none}.mcactionbutton .shares{border-top:1px solid #ccc;padding-top:15px}.mcactionbutton .shares span{color:#a6a6a6;user-select:none}.mcactionbutton .shares span,.mcactionbutton .thumbs span{display:block;margin-top:4px}", ""]);
	
	// exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(535);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./mcactionbutton.mobile.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./mcactionbutton.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".mobile-action-buttons{width:190px;position:absolute;right:0;top:-13px;height:48px;box-shadow:-7px 2px 10px #f0f0f0;border-top-left-radius:20px;border-bottom-left-radius:0;background-color:#fff;z-index:2}.mobile-action-buttons.geo .share-span{font-family:Georgian-Bold;right:10px}.mobile-action-buttons ul li{display:inline-block;width:calc(50% - 3px)}.mobile-action-buttons ul li .thumb-full,.mobile-action-buttons ul li .thumb-outline{transform:translate(7px,7px)}.mobile-action-buttons ul li .thumb-svg{margin-top:6px;margin-left:18px}.mobile-action-buttons ul li .thumb-count{position:absolute;top:20px;left:60px;font-family:Graphik-Bold;font-size:11px;color:#ee264e}.mobile-action-buttons ul li .share-svg{position:absolute;top:17px;right:75px}.mobile-action-buttons ul li .share-span{position:absolute;top:20px;right:25px;font-family:Graphik-Bold;font-size:11px;color:#a6a6a6}.mobile-action-buttons ul li:first-child{position:relative}.mobile-action-buttons ul li:first-child:after{content:\" \";height:10px;border:.03rem solid #ccc;position:absolute;right:0;top:8px;height:30px}", ""]);
	
	// exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _loader = __webpack_require__(537);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _loader3 = __webpack_require__(541);
	
	var _loader4 = _interopRequireDefault(_loader3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderModule = _angular2.default.module('loader', []).component('loader', _loader2.default).factory('Loader', _loader4.default).name;
	
	exports.default = loaderModule;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loader = __webpack_require__(538);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	__webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loaderComponent = {
	    template: _loader2.default
	};
	
	exports.default = loaderComponent;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"image-loader\">\n    <div class=\"spinner\">\n        <div class=\"cube cube0\"></div>\n        <div class=\"cube cube1\"></div>\n        <div class=\"cube cube2\"></div>\n        <div class=\"cube cube3\"></div>\n        <div class=\"cube cube4\"></div>\n        <div class=\"cube cube5\"></div>\n        <div class=\"cube cube6\"></div>\n        <div class=\"cube cube7\"></div>\n        <div class=\"cube cube8\"></div>\n        <div class=\"cube cube9\"></div>\n        <div class=\"cube cube10\"></div>\n        <div class=\"cube cube11\"></div>\n        <div class=\"cube cube12\"></div>\n        <div class=\"cube cube13\"></div>\n        <div class=\"cube cube14\"></div>\n        <div class=\"cube cube15\"></div>\n        <div class=\"cube cube16\"></div>\n        <div class=\"cube cube17\"></div>\n        <div class=\"cube cube18\"></div>\n        <div class=\"cube cube19\"></div>\n        <div class=\"cube cube20\"></div>\n        <div class=\"cube cube21\"></div>\n        <div class=\"cube cube22\"></div>\n        <div class=\"cube cube23\"></div>\n        <div class=\"cube cube24\"></div>\n    </div>\n</div>\n"

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(540);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./loader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./loader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".image-loader .spinner{position:relative;margin:25px auto 10px;width:70px;height:70px}.image-loader .cube{background-color:#e43e3a;width:10px;height:10px;position:absolute;animation:cubemove 4s infinite}@keyframes cubemove{35%{transform:scale(.005)}50%{transform:scale(1.7)}65%{transform:scale(.005)}}.image-loader .cube1{left:14px;top:0;animation-delay:.1s}.image-loader .cube2{left:28px;top:0;animation-delay:.2s}.image-loader .cube3{left:42px;top:0;animation-delay:.3s}.image-loader .cube4{left:56px;top:0;animation-delay:.4s}.image-loader .cube5{left:0;top:14px;animation-delay:.1s}.image-loader .cube6{left:14px;top:14px;animation-delay:.2s}.image-loader .cube7{left:28px;top:14px;animation-delay:.3s}.image-loader .cube8{left:42px;top:14px;animation-delay:.4s}.image-loader .cube9{left:56px;top:14px;animation-delay:.5s}.image-loader .cube10{left:0;top:28px;animation-delay:.2s}.image-loader .cube11{left:14px;top:28px;animation-delay:.3s}.image-loader .cube12{left:28px;top:28px;animation-delay:.4s}.image-loader .cube13{left:42px;top:28px;animation-delay:.5s}.image-loader .cube14{left:56px;top:28px;animation-delay:.6s}.image-loader .cube15{left:0;top:42px;animation-delay:.3s}.image-loader .cube16{left:14px;top:42px;animation-delay:.4s}.image-loader .cube17{left:28px;top:42px;animation-delay:.5s}.image-loader .cube18{left:42px;top:42px;animation-delay:.6s}.image-loader .cube19{left:56px;top:42px;animation-delay:.7s}.image-loader .cube20{left:0;top:56px;animation-delay:.4s}.image-loader .cube21{left:14px;top:56px;animation-delay:.5s}.image-loader .cube22{left:28px;top:56px;animation-delay:.6s}.image-loader .cube23{left:42px;top:56px;animation-delay:.7s}.image-loader .cube24{left:56px;top:56px;animation-delay:.8s}.image-loader .cube25{left:0;top:70px;animation-delay:.5s}", ""]);
	
	// exports


/***/ }),
/* 541 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Loader = function Loader() {
	    var loadImages = function loadImages(items, key, cb) {
	        var images = [];
	
	        if (key) {
	            images = items.map(function (item) {
	                return item[key];
	            });
	        } else {
	            images = items;
	        }
	
	        if (images.length === 0) {
	            return cb();
	        }
	
	        var i = 0;
	
	        images.forEach(function (src) {
	            var img = new Image();
	
	            var load = function load() {
	                i++;
	
	                if (i === images.length) {
	                    cb();
	                }
	            };
	
	            img.onload = load;
	            img.onerror = load;
	
	            img.src = src;
	        });
	    };
	
	    return {
	        loadImages: loadImages
	    };
	};
	
	exports.default = Loader;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _color = __webpack_require__(543);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colorModule = _angular2.default.module('color', [_angularUiRouter2.default]).factory('Color', _color2.default).name;
	
	exports.default = colorModule;

/***/ }),
/* 543 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function Color() {
	    var layoutImage = {
	        1: ['#aaadd6', '#bbbcdc', '#cfcfe5', '#ddddef'],
	        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)', '#a8e2db'],
	        3: ['#eb2f68', '#ff5186', '#ec7096', '#f1afc3'],
	        4: ['#f6c63b', '#f7da86', '#fbe4a4', '#fbe4a2'],
	        5: ['#71b560', '#9ccd90', '#bce3b2', '#c5e7bc']
	    };
	
	    var layoutLikes = {
	        1: ['#aaadd6', '#bbbcdc', '#cfcfe5', '#ddddef'],
	        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)', '#a8e2db'],
	        3: ['#eb2f68', '#ff5186', '#ec7096', '#f1afc3'],
	        4: ['#f6c63b', '#f7da86', '#fbe4a4', '#fbe4a2'],
	        5: ['#71b560', '#9ccd90', '#bce3b2', '#c5e7bc']
	    };
	
	    var layoutText = {
	        1: ['#aaadd6', '#bbbcdc', '#cfcfe5'],
	        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)'],
	        3: ['#eb2f68', '#ff5186', '#ec7096'],
	        4: ['#f6c63b', '#f7da86', '#fbe4a4'],
	        5: ['#71b560', '#9ccd90', '#bce3b2']
	    };
	
	    var bookCard1 = {
	        1: ['#ffffff', '#dbe1ee', '#dbe1ee', '#d4d8ea', '#4768a9', '#697cb7', '#8994c5', '#abb3d5', '#d1d5e9'],
	        2: ['#ececed', '#d5e2dd', '#c3dad0', '#f6f8f7', '#80bd9c', '#9ac8ae', '#b3d4c0', '#cbe1d3', '#e3efe7'],
	        3: ['#ececed', '#e5d1d3', '#e0bbbe', '#f9f6f5', '#d4666c', '#da8482', '#e1a09c', '#ebbdb7', '#f4dcd8'],
	
	        // copy of 2 & 3
	        4: ['#ececed', '#d5e2dd', '#c3dad0', '#f6f8f7', '#80bd9c', '#9ac8ae', '#b3d4c0', '#cbe1d3', '#e3efe7'],
	        5: ['#ececed', '#e5d1d3', '#e0bbbe', '#f9f6f5', '#d4666c', '#da8482', '#e1a09c', '#ebbdb7', '#f4dcd8']
	    };
	
	    var bookCard2 = {
	        1: ['#c9d2e5', '#dbe1ee', '#edf0f6', '#4768a9'],
	        2: ['#d7eae2', '#e6f2ec', '#f2f8f5', '#80bd9c'],
	        3: ['#f0d1d3', '#f4e1e3', '#f9eff1', '#d4666c'],
	
	        4: ['#d7eae2', '#e6f2ec', '#f2f8f5', '#80bd9c'],
	        5: ['#f0d1d3', '#f4e1e3', '#f9eff1', '#d4666c']
	    };
	
	    var bookCard4 = {
	        1: ['#4768a9', 'rgba(71,104,169,0.8)', 'rgba(71,104,169,0.6)', 'rgba(71,104,169,0.4)'],
	        2: ['#80bd9c', 'rgba(128,189,156,0.8)', 'rgba(128,189,156,0.6)', 'rgba(128,189,156,0.4)'],
	        3: ['#d4666c', 'rgba(212,102,108,0.8)', 'rgba(212,102,108,0.6)', 'rgba(212,102,108,0.4)'],
	        // copy of 2 & 3
	        4: ['#80bd9c', 'rgba(128,189,156,0.8)', 'rgba(128,189,156,0.6)', 'rgba(128,189,156,0.4)'],
	        5: ['#4768a9', 'rgba(71,104,169,0.8)', 'rgba(71,104,169,0.6)', 'rgba(71,104,169,0.4)']
	    };
	
	    var bookCard5 = {
	        1: ['#4768a9', '#bec7e0', '#dbe1ee'],
	        2: ['#80bd9c', '#cfe6db', '#e6f2ec'],
	        3: ['#d4666c', '#ecc7ca', '#f4e1e3'],
	        // copy of 2 & 3
	        4: ['#80bd9c', '#cfe6db', '#e6f2ec'],
	        5: ['#d4666c', '#ecc7ca', '#f4e1e3']
	    };
	
	    var getColors = function getColors(cardType, cardGroup) {
	        var layout = void 0;
	
	        switch (cardType) {
	            case 'layout image':
	                layout = layoutImage;
	                break;
	            case 'layout likes':
	                layout = layoutLikes;
	                break;
	            case 'layout text':
	                layout = layoutText;
	                break;
	            case 'book card 1':
	                layout = bookCard1;
	                break;
	            case 'book card 2':
	                layout = bookCard2;
	                break;
	            case 'book card 4':
	                layout = bookCard4;
	                break;
	            case 'book card 5':
	                layout = bookCard5;
	                break;
	            default:
	                break;
	        }
	
	        return layout[cardGroup];
	    };
	
	    return {
	        getColors: getColors
	    };
	}
	
	exports.default = Color;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _share = __webpack_require__(545);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shareModule = _angular2.default.module('share', [_angularUiRouter2.default]).factory('Share', _share2.default).name;
	
	exports.default = shareModule;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Share = function Share() {
	
	    var shareObject = function shareObject(url) {
	        FB.ui({
	            method: 'share',
	            href: url
	        }, function (response) {});
	    };
	
	    return {
	        shareObject: shareObject
	    };
	};
	
	exports.default = Share;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _home = __webpack_require__(547);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _about = __webpack_require__(903);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _welcome = __webpack_require__(910);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _statistics = __webpack_require__(917);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	var _privacy = __webpack_require__(924);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _terms = __webpack_require__(930);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _cookies = __webpack_require__(936);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_home2.default, _about2.default, _welcome2.default, _statistics2.default, _privacy2.default, _terms2.default,
	// BookMobile,
	// ContributorMobile,
	_cookies2.default]).name;
	// import BookMobile from './bookMobile/bookMobile'
	// import ContributorMobile from './contributorMobile/contributorMobile'
	exports.default = componentModule;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _home = __webpack_require__(548);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _sidebar = __webpack_require__(554);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _sharedmoments = __webpack_require__(576);
	
	var _sharedmoments2 = _interopRequireDefault(_sharedmoments);
	
	var _contributor = __webpack_require__(609);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	var _book = __webpack_require__(770);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _post = __webpack_require__(896);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeModule = _angular2.default.module('home', [_angularUiRouter2.default, _sidebar2.default, _sharedmoments2.default, _contributor2.default, _book2.default, _post2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    'ngInject';
	
	    $urlRouterProvider.otherwise('/shared-moments');
	
	    $stateProvider.state('home', {
	        url: '/shared-moments?search',
	        component: 'home'
	    });
	}]).component('home', _home2.default).name;
	
	exports.default = homeModule;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _home = __webpack_require__(549);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _home3 = __webpack_require__(550);
	
	var _home4 = _interopRequireDefault(_home3);
	
	__webpack_require__(552);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homeComponent = {
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default
	};
	
	exports.default = homeComponent;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = "<!-- View for childs -->\n<ui-view></ui-view>\n\n<cookies></cookies>\n\n<navbar></navbar>\n\n<main class=\"home container-fluid hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"sidebar\">\n        <div class=\"box\">\n            <!-- Sidebar component -->\n            <sidebar></sidebar>\n        </div>\n    </div>\n    <div class=\"content\">\n        <div class=\"row between-xs\">\n\n            <div class=\"col-sm-12 col-xs-12\">\n                <div class=\"box\">\n                    <button class=\"contributor-button\" ui-sref=\"home.contributor.step1\">\n                        {{$ctrl.areYouContributorOne}}\n                        <br/> {{$ctrl.areYouContributorTwo}}\n                    </button>\n\n                    <div class=\"check-contributor\">\n                        <p>{{$ctrl.beenInGeorgia}}</p>\n                    </div>\n\n                    <sharedMoments data=\"web\"></sharedMoments>\n                </div>\n            </div>\n        </div>\n    </div>\n</main>\n\n<!-- Mobile components -->\n<sharedMoments class=\"hidden-sm hidden-md hidden-lg hidden-xl\" data=\"mobile\"></sharedMoments>\n\n<footer class=\"hidden-xs\"></footer>\n"

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sharedmoments = __webpack_require__(551);
	
	var _sharedmoments2 = _interopRequireDefault(_sharedmoments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeController = function () {
	    function HomeController($scope) {
	        (0, _classCallCheck3.default)(this, HomeController);
	
	        this.name = 'home';
	
	        this.$scope = $scope;
	    }
	
	    (0, _createClass3.default)(HomeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _sharedmoments2.default[this.language],
	                BEEN_IN_GEORGIA = _texts$language.BEEN_IN_GEORGIA,
	                ARE_YOU_CONTRIBUTOR_ONE = _texts$language.ARE_YOU_CONTRIBUTOR_ONE,
	                ARE_YOU_CONTRIBUTOR_TWO = _texts$language.ARE_YOU_CONTRIBUTOR_TWO;
	
	
	            this.beenInGeorgia = BEEN_IN_GEORGIA;
	            this.areYouContributorOne = ARE_YOU_CONTRIBUTOR_ONE;
	            this.areYouContributorTwo = ARE_YOU_CONTRIBUTOR_TWO;
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.render();
	                }
	            });
	        }
	    }]);
	    return HomeController;
	}();
	
	HomeController.$inject = ['$scope'];
	
	exports.default = HomeController;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        MY_BOOK: 'ჩემი წიგნი',
	        LOG_OUT: 'გამოსვლა',
	        GENERATE: 'დააგენერირე',
	        PERSONAL_GUIDEBOOK: 'პერსონალიზებული გზამკვლევი',
	        BEEN_IN_GEORGIA: 'ყოფილხარ საქართველოში?',
	        ARE_YOU_CONTRIBUTOR_ONE: 'გაიგე, ხარ თუ არა',
	        ARE_YOU_CONTRIBUTOR_TWO: 'ავტორი',
	        NOT_FOUND: 'გაზიარებული ემოციები არ მოიძებნა',
	        MORE: 'ნახე მეტი'
	    },
	    EN: {
	        MY_BOOK: 'My book',
	        LOG_OUT: 'Log out',
	        GENERATE: 'Generate',
	        PERSONAL_GUIDEBOOK: 'your personal guidebook',
	        BEEN_IN_GEORGIA: 'Have you ever been in Georgia?',
	        ARE_YOU_CONTRIBUTOR_ONE: 'Find out if you are',
	        ARE_YOU_CONTRIBUTOR_TWO: 'a contributor',
	        NOT_FOUND: 'Shared Moments not found',
	        MORE: 'View more'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(553);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".home{background-color:#fcfcfc}.home .content,.home .sidebar{display:inline-block}.home .sidebar{position:fixed;float:left;width:220px}.home .content{margin-left:230px;width:calc(100% - 255px);padding-left:25px}.home .check-contributor,.home .contributor-button{float:right}.home .contributor-button{background-color:#90dc19;width:175px;height:45px;border:0;border-radius:30px;font-family:Graphik-Regular;color:#fff;font-size:13px;outline:0;box-shadow:0 3px 8px rgba(0,0,0,.21)}.home .contributor-button:hover{font-weight:700;background-color:#7fd100}.home .check-contributor{height:35px;margin-top:10px;margin-right:11px}.home .check-contributor p{margin-top:8px;font-size:12px;font-family:Graphik;color:#787878}.home .check-contributor p b{color:#000;cursor:pointer}.home.geo .check-contributor p,.home.geo .contributor-button{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sidebar = __webpack_require__(555);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _searchbox = __webpack_require__(560);
	
	var _searchbox2 = _interopRequireDefault(_searchbox);
	
	var _categories = __webpack_require__(566);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sidebarModule = _angular2.default.module('sidebar', [_angularUiRouter2.default, _searchbox2.default, _categories2.default]).component('sidebar', _sidebar2.default).name;
	
	exports.default = sidebarModule;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sidebar = __webpack_require__(556);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _sidebar3 = __webpack_require__(557);
	
	var _sidebar4 = _interopRequireDefault(_sidebar3);
	
	__webpack_require__(558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sidebarComponent = {
	  bindings: {},
	  template: _sidebar2.default,
	  controller: _sidebar4.default
	};
	
	exports.default = sidebarComponent;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidebar\">\n  <!-- Search component -->\n  <searchbox></searchbox>\n\n  <!-- Categories component -->\n  <categories></categories>\n</div>\n"

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarController = function SidebarController() {
	  (0, _classCallCheck3.default)(this, SidebarController);
	
	  this.name = 'sidebar';
	};
	
	exports.default = SidebarController;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(559);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sidebar.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sidebar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".sidebar{border-right:4px dotted #ededed;height:calc(100vh - 92px)}", ""]);
	
	// exports


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _searchbox = __webpack_require__(561);
	
	var _searchbox2 = _interopRequireDefault(_searchbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchboxModule = _angular2.default.module('searchbox', [_angularUiRouter2.default]).component('searchbox', _searchbox2.default).name;
	
	exports.default = searchboxModule;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _searchbox = __webpack_require__(562);
	
	var _searchbox2 = _interopRequireDefault(_searchbox);
	
	var _searchbox3 = __webpack_require__(563);
	
	var _searchbox4 = _interopRequireDefault(_searchbox3);
	
	__webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var searchboxComponent = {
	  bindings: {},
	  template: _searchbox2.default,
	  controller: _searchbox4.default
	};
	
	exports.default = searchboxComponent;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"searchbox\">\n    <input type=\"text\" spellcheck=\"false\" placeholder=\"Ex. ski, sea, wine\" ng-keyup=\"$event.key == 'Enter' && $ctrl.searchPosts()\" ng-model=\"$ctrl.searchWord\">\n</div>\n"

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchboxController = function () {
	    function SearchboxController($state) {
	        (0, _classCallCheck3.default)(this, SearchboxController);
	
	        this.name = 'searchbox';
	
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(SearchboxController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (this.$state.params.search) {
	                this.searchWord = this.$state.params.search;
	            }
	        }
	    }, {
	        key: 'searchPosts',
	        value: function searchPosts() {
	            sessionStorage.removeItem('tourists_categories');
	
	            this.$state.go('home', { search: this.searchWord });
	        }
	    }]);
	    return SearchboxController;
	}();
	
	SearchboxController.$inject = ['$state'];
	
	exports.default = SearchboxController;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(565);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./searchbox.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./searchbox.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".searchbox{position:relative}.searchbox input{margin-top:30px;padding-right:20px;width:calc(100% - 60px);height:25px;font-size:14px;outline:0;border:0;color:rgba(0,0,0,.502);border-bottom:1.2px solid #ededed;font-family:Graphik-Regular;font-weight:bolder;background:url(/assets/images/search.png) no-repeat 100%;background-position-y:3px}.searchbox input::-webkit-input-placeholder{position:relative;font-size:12px;font-weight:500;font-style:italic;color:rgba(0,0,0,.4)}.searchbox input::-moz-placeholder{position:relative;font-size:12px;font-weight:500;font-style:italic;color:rgba(0,0,0,.4)}.searchbox input:-ms-input-placeholder{position:relative;font-size:12px;font-weight:500;font-style:italic;color:rgba(0,0,0,.4)}.searchbox input:-moz-placeholder{position:relative;font-size:12px;font-weight:500;font-style:italic;color:rgba(0,0,0,.4)}.searchbox input:focus{color:#ea0054;transition:border-bottom-color .25s,color ease-in-out;border-bottom-color:#ea0054}", ""]);
	
	// exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _categories = __webpack_require__(567);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _categories3 = __webpack_require__(575);
	
	var _categories4 = _interopRequireDefault(_categories3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categoriesModule = _angular2.default.module('categories', [_angularUiRouter2.default]).component('categories', _categories2.default).factory('Category', _categories4.default).name;
	
	exports.default = categoriesModule;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _categories = __webpack_require__(568);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _categories3 = __webpack_require__(569);
	
	var _categories4 = _interopRequireDefault(_categories3);
	
	__webpack_require__(571);
	
	__webpack_require__(573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categoriesComponent = {
	    bindings: {
	        'type': '='
	    },
	    template: _categories2.default,
	    controller: _categories4.default
	};
	
	exports.default = categoriesComponent;

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"categories hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"sidebar-top\">\n        <ul>\n            <li ng-click=\"$ctrl.clearCategories()\" ng-class=\"{active: $ctrl.selectedCategories.length === 0}\">\n                <span>{{$ctrl.all}}</span>\n            </li>\n            <li ng-repeat=\"category in $ctrl.categories\" ng-class=\"{active: $ctrl.isActive(category)}\">\n                <span ng-click=\"$ctrl.toggleCategory(category)\">{{category}}</span>\n            </li>\n        </ul>\n    </div>\n    <div class=\"sidebar-bottom\">\n        <button class=\"clear\" ng-click=\"$ctrl.clearCategories()\" ng-show=\"$ctrl.selectedCategories.length > 0\">\n            <svg aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"times\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                viewBox=\"0 0 352 512\" class=\"svg-inline--fa fa-times fa-w-11 fa-2x\">\n                <path fill=\"currentColor\" d=\"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z\"\n                    class=\"\"></path>\n            </svg>\n            {{$ctrl.clearFilter}}\n        </button>\n    </div>\n</div>\n\n<div class=\"categories-mobile visible-xs\">\n    <button class=\"select\" ng-click=\"$ctrl.toggleDropdown()\">\n        <div>\n            <div class=\"dot active\"></div>\n            <span>{{$ctrl.chooseCategory}}</span>\n        </div>\n    </button>\n\n    <div class=\"options-background\" ng-if=\"$ctrl.dropdownActive\">\n        <div class=\"options\">\n            <p ng-click=\"$ctrl.toggleDropdown()\" class=\"return-to-cats\">\n                {{$ctrl.chooseCategory}}\n                <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"angle-down\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                    viewBox=\"0 0 256 512\" class=\"svg-inline--fa fa-angle-down fa-w-8 fa-2x\">\n                    <path fill=\"currentColor\" d=\"M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z\"\n                        class=\"\"></path>\n                </svg>\n            </p>\n            <ul class=\"option visible-xs\">\n                <li ng-click=\"$ctrl.clearCategories()\" ng-class=\"{active: $ctrl.selectedCategories.length === 0}\">\n                    <div class=\"dot\" ng-class=\"{active: $ctrl.selectedCategories.length === 0}\">\n                    </div>\n                    <span>{{$ctrl.all}}</span>\n                </li>\n                <li ng-repeat=\"category in $ctrl.categories\" ng-click=\"$ctrl.toggleCategory(category)\">\n                    <div class=\"dot\" ng-class=\"{active: $ctrl.isActive(category)}\">\n                    </div>\n                    <span>{{ category }}</span>\n                </li>\n                <li>\n                    <div class=\"clear-container\">\n                        <button class=\"clear\" ng-click=\"$ctrl.clearCategories()\" ng-show=\"$ctrl.selectedCategories.length > 0\">\n                            <svg aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"times\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n                                viewBox=\"0 0 352 512\" class=\"svg-inline--fa fa-times fa-w-11 fa-2x\">\n                                <path fill=\"currentColor\" d=\"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z\"\n                                    class=\"\"></path>\n                            </svg>\n                            {{$ctrl.clearFilter}}\n                        </button>\n                    </div>\n                </li>\n            </ul>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _categories = __webpack_require__(570);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoriesController = function () {
	    function CategoriesController($scope, $state, $stateParams, Category) {
	        (0, _classCallCheck3.default)(this, CategoriesController);
	
	        this.name = 'categories';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.Category = Category;
	
	        this.selectedCategories = [];
	        this.dropdownActive = false;
	        this.initMobileCategoriesPopup.bind(this);
	    }
	
	    (0, _createClass3.default)(CategoriesController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	            this.selectselectedCategories();
	
	            this.watchCategories();
	            this.watchLanguage();
	        }
	    }, {
	        key: 'initMobileCategoriesPopup',
	        value: function initMobileCategoriesPopup() {
	            var _this = this;
	
	            $('.options-background').mouseup(function (e) {
	                var options = $('.options');
	                // if the target of the click isn't the container nor a descendant of the container
	                if (!options.is(e.target) && options.has(e.target).length === 0) {
	                    _this.dropdownActive = false;
	                    _this.$scope.$apply();
	                }
	            });
	        }
	    }, {
	        key: 'toggleDropdown',
	        value: function toggleDropdown() {
	            var _this2 = this;
	
	            this.dropdownActive = !this.dropdownActive;
	            if (this.dropdownActive) {
	                setTimeout(function () {
	                    _this2.initMobileCategoriesPopup();
	                }, 10);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	            var langTexts = _categories2.default[this.language];
	
	            var All = langTexts.All,
	                CHOOSE_CATEGORY = langTexts.CHOOSE_CATEGORY,
	                CLEAR_FILTER = langTexts.CLEAR_FILTER;
	
	
	            this.categories = this.Category.getCategories().map(function (item) {
	                return langTexts[item];
	            });
	            this.all = All;
	            this.chooseCategory = CHOOSE_CATEGORY;
	            this.clearFilter = CLEAR_FILTER;
	        }
	    }, {
	        key: 'selectselectedCategories',
	        value: function selectselectedCategories() {
	            try {
	                var selectedCategories = JSON.parse(sessionStorage.getItem('tourists_categories'));
	
	                this.selectedCategories = selectedCategories || [];
	                this.Category.setSelectedCategories(this.selectedCategories);
	            } catch (e) {
	                this.Category.setSelectedCategories([]);
	                this.selectedCategories = [];
	            }
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(category) {
	            var langCategory = _categories2.default[this.language][category];
	
	            return this.selectedCategories.includes(langCategory);
	        }
	    }, {
	        key: 'toggleCategory',
	        value: function toggleCategory(newCategory) {
	            // this.dropdownActive = false
	
	            var category = _categories2.default[this.language][newCategory];
	
	            if (this.selectedCategories.includes(category)) {
	                this.selectedCategories = this.selectedCategories.filter(function (item) {
	                    return item !== category;
	                });
	            } else {
	                this.selectedCategories.push(category);
	            }
	
	            this.Category.setSelectedCategories(this.selectedCategories);
	
	            this.clearSearches();
	        }
	    }, {
	        key: 'clearCategories',
	        value: function clearCategories() {
	            this.dropdownActive = false;
	
	            this.Category.clearSelectedCategories();
	            this.clearSearches();
	        }
	    }, {
	        key: 'clearSearches',
	        value: function clearSearches() {
	            if (this.$stateParams.search) {
	                this.$state.go('home', {
	                    search: ''
	                });
	            }
	        }
	    }, {
	        key: 'watchCategories',
	        value: function watchCategories() {
	            var _this3 = this;
	
	            this.$scope.$watch(function () {
	                return _this3.Category.getSelectedCategories();
	            }, function (newValue) {
	                _this3.selectedCategories = newValue;
	            });
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this4 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this4.render();
	                }
	            });
	        }
	    }]);
	    return CategoriesController;
	}();
	
	CategoriesController.$inject = ['$scope', '$state', '$stateParams', 'Category'];
	
	exports.default = CategoriesController;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        All: 'ყველა',
	        'Wine Almighty': 'პირველი ღვინო',
	        'Tipsy Adventure': 'ღვინო ყველგან',
	        'Tradition of Supra': 'ქართული სუფრა',
	        'Colorful Cuisine': 'ფერადი სამზარეულო',
	        History: 'ისტორია',
	        Culture: 'კულტურა',
	        Architecture: 'არქიტექტურა',
	        Tbilisi: 'თბილისი',
	        Highlands: 'მთები',
	        'Ski Resorts': 'ზამთრის კურორტები',
	        'Black Sea': 'შავი ზღვა',
	        Nature: 'ბუნება',
	        Adventure: 'თავგადასავლები',
	        ყველა: 'All',
	        'პირველი ღვინო': 'Wine Almighty',
	        'ღვინო ყველგან': 'Tipsy Adventure',
	        'ქართული სუფრა': 'Tradition of Supra',
	        'ფერადი სამზარეულო': 'Colorful Cuisine',
	        ისტორია: 'History',
	        კულტურა: 'Culture',
	        არქიტექტურა: 'Architecture',
	        თბილისი: 'Tbilisi',
	        მთები: 'Highlands',
	        'ზამთრის კურორტები': 'Ski Resorts',
	        'შავი ზღვა': 'Black Sea',
	        ბუნება: 'Nature',
	        თავგადასავლები: 'Adventure',
	        CHOOSE_CATEGORY: 'აირჩიეთ კატეგორია',
	        CLEAR_FILTER: 'წაშლა'
	    },
	    EN: {
	        All: 'All',
	        'Wine Almighty': 'Wine Almighty',
	        'Tipsy Adventure': 'Tipsy Adventure',
	        'Tradition of Supra': 'Tradition of Supra',
	        'Colorful Cuisine': 'Colorful Cuisine',
	        History: 'History',
	        Culture: 'Culture',
	        Architecture: 'Architecture',
	        Tbilisi: 'Tbilisi',
	        Highlands: 'Highlands',
	        'Ski Resorts': 'Ski Resorts',
	        'Black Sea': 'Black Sea',
	        Nature: 'Nature',
	        Adventure: 'Adventure',
	        ყველა: 'All',
	        'პირველი ღვინო': 'Wine Almighty',
	        'ღვინო ყველგან': 'Tipsy Adventure',
	        'ქართული სუფრა': 'Tradition of Supra',
	        'ფერადი სამზარეულო': 'Colorful Cuisine',
	        ისტორია: 'History',
	        კულტურა: 'Culture',
	        არქიტექტურა: 'Architecture',
	        თბილისი: 'Tbilisi',
	        მთები: 'Highlands',
	        'ზამთრის კურორტები': 'Ski Resorts',
	        'შავი ზღვა': 'Black Sea',
	        ბუნება: 'Nature',
	        თავგადასავლები: 'Adventure',
	        CHOOSE_CATEGORY: 'Choose Category',
	        CLEAR_FILTER: 'Clear filter'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(572);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./categories.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./categories.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".categories .sidebar-top{padding-top:30px;height:calc(100vh - 292px);overflow-y:scroll}.categories .sidebar-top::-webkit-scrollbar{width:3px}.categories .sidebar-top::-webkit-scrollbar-track{background:#f2f2f2}.categories .sidebar-top::-webkit-scrollbar-thumb{background:#bbb}.categories .sidebar-top::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.categories .sidebar-top ul{list-style:none}.categories .sidebar-top ul li{user-select:none;display:flex;color:rgba(0,0,0,.502);padding-bottom:30px;font-size:12px;font-weight:700;font-family:Graphik-Regular}.categories .sidebar-top ul li span:before{content:\" \";float:left;width:12px;border-radius:50%;border:1px solid rgba(0,0,0,.502);height:12px;margin:-2px 10px 0 0}.categories .sidebar-top ul li.active,.categories .sidebar-top ul li:hover{color:#000}.categories .sidebar-top ul li.active>span:before{background:#f8c339;border-color:#f8c339}.categories .sidebar-top ul li span{cursor:pointer}.categories .sidebar-bottom{display:flex;align-items:center;justify-content:center;height:30px;padding:5px 0}.categories .sidebar-bottom .clear{position:relative;left:-15px;border:1px solid #c7cacc;padding:8px 10px;border-radius:15px;background:none;font-size:11px;font-weight:700;outline:none;color:#9b9b9b}.categories .sidebar-bottom .clear:hover{color:#333;border-color:#333}.categories .sidebar-bottom .clear:hover svg path{fill:#333}.categories .sidebar-bottom .clear svg{position:relative;top:1px;margin-right:2px;width:7px}.categories .sidebar-bottom .clear svg path{fill:#cccbcb}.categories.geo ul li{font-family:Georgian-Regular}.categories.geo ul li span:before{margin:2px 10px 0 0}", ""]);
	
	// exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(574);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./categories.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./categories.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".categories-mobile{position:relative;padding-top:20px;padding-bottom:15px;max-width:355px;width:calc(100% - 40px);font-size:14px;font-weight:700;display:table;margin:0 auto}.categories-mobile .select{position:relative;cursor:pointer;text-align:left;background-color:#ededed;border:0;height:40px;border-radius:20px;width:185px;outline:0}.categories-mobile .select>div{display:flex;align-items:center;font-size:12px}.categories-mobile .select>div span{margin-top:2.5px}.categories-mobile .dot{margin:0 10px 0 20px;width:12px;height:12px;display:inline-block;border-radius:50%;border:1px solid rgba(0,0,0,.502)}.categories-mobile .dot.active{background:#f6c63b;border-color:#f6c63b}.categories-mobile .options-background{position:fixed;top:92px;width:100vw;height:calc(100vh - 92px);left:0;background:hsla(0,0%,39%,.2);z-index:15}.categories-mobile .options{position:fixed;top:92px;left:0;width:80%;max-width:345px;height:300px;background-color:#fff;z-index:21;border-radius:3px;text-align:left}.categories-mobile .options::-webkit-scrollbar{width:3px}.categories-mobile .options::-webkit-scrollbar-track{background:#f2f2f2}.categories-mobile .options::-webkit-scrollbar-thumb{background:#bbb}.categories-mobile .options::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.categories-mobile .options .return-to-cats{height:40px;line-height:40px;padding-left:37px;border-bottom:4px dotted #ededed;display:flex;align-items:center}.categories-mobile .options .return-to-cats svg{width:11px;transform:rotate(90deg);color:#ccc;right:15px;position:absolute}.categories-mobile .options .option{margin:15px 0 20px 15px;height:224px;overflow-y:auto}.categories-mobile .options .option li{cursor:pointer;list-style:none;padding:7px 0;font-size:12px}.categories-mobile .options .option li:hover .dot{border-color:#f8d46c}.categories-mobile .options .option li:hover span{color:#787474}.categories-mobile .options .option li span{position:relative;top:-2px;color:#918e8e}.categories-mobile .options .clear-container{width:100%;text-align:center}.categories-mobile .options .clear-container .clear{border:1px solid #c7cacc;padding:8px 10px;border-radius:15px;background:none;font-size:11px;font-weight:700;outline:none;color:#9b9b9b}.categories-mobile .options .clear-container .clear svg{position:relative;top:1px;margin-right:2px;width:7px}.categories-mobile .options .clear-container .clear svg path{fill:#cccbcb}", ""]);
	
	// exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(457);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CategoryFactory() {
	    var categories = ['Wine Almighty', 'Tipsy Adventure', 'Tradition of Supra', 'Colorful Cuisine', 'History', 'Culture', 'Architecture', 'Tbilisi', 'Highlands', 'Ski Resorts', 'Black Sea', 'Nature', 'Adventure'];
	    var selectedCategories = [];
	
	    var getCategories = function getCategories() {
	        return categories;
	    };
	
	    var getSelectedCategories = function getSelectedCategories() {
	        return selectedCategories;
	    };
	
	    var setSelectedCategories = function setSelectedCategories(data) {
	        selectedCategories = JSON.parse((0, _stringify2.default)(data));
	
	        sessionStorage.setItem('tourists_categories', (0, _stringify2.default)(data));
	    };
	
	    var clearSelectedCategories = function clearSelectedCategories() {
	        sessionStorage.setItem('tourists_categories', (0, _stringify2.default)([]));
	        selectedCategories = [];
	    };
	
	    return {
	        getCategories: getCategories,
	        getSelectedCategories: getSelectedCategories,
	        setSelectedCategories: setSelectedCategories,
	        clearSelectedCategories: clearSelectedCategories
	    };
	}
	
	exports.default = CategoryFactory;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _sharedmoments = __webpack_require__(577);
	
	var _sharedmoments2 = _interopRequireDefault(_sharedmoments);
	
	var _card = __webpack_require__(584);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(592);
	
	var _card4 = _interopRequireDefault(_card3);
	
	var _card5 = __webpack_require__(600);
	
	var _card6 = _interopRequireDefault(_card5);
	
	var _sharedmoments3 = __webpack_require__(608);
	
	var _sharedmoments4 = _interopRequireDefault(_sharedmoments3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedmomentsModule = _angular2.default.module('sharedmoments', [_angularUiRouter2.default, _card2.default, _card4.default, _card6.default]).component('sharedmoments', _sharedmoments2.default).factory('SharedMoments', _sharedmoments4.default).name;
	
	exports.default = sharedmomentsModule;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _sharedmoments = __webpack_require__(578);
	
	var _sharedmoments2 = _interopRequireDefault(_sharedmoments);
	
	var _sharedmoments3 = __webpack_require__(579);
	
	var _sharedmoments4 = _interopRequireDefault(_sharedmoments3);
	
	__webpack_require__(580);
	
	__webpack_require__(582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedmomentsComponent = {
	    bindings: {
	        data: '@'
	    },
	    template: _sharedmoments2.default,
	    controller: _sharedmoments4.default
	};
	
	exports.default = sharedmomentsComponent;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sharedmoments\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n\n    <div class=\"sharedmoments-mobile visible-xs\">\n        <!--Mobile User Section-->\n        <ul class=\"user-nav visible-xs\" ng-if=\"$ctrl.user\">\n            <div class=\"left\">\n                <li class=\"fullname\" ng-if=\"$ctrl.user\">{{$ctrl.user.fullName}}</li>\n                <li class=\"my-book\" ng-if=\"$ctrl.user\" ng-click=\"$ctrl.goToMyBook()\">\n                    <span>\n                        <svg aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"book-open\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"\n                            class=\"svg-inline--fa fa-book-open fa-w-20 fa-2x\">\n                            <path fill=\"currentColor\" d=\"M561.9 0C549.5 0 406.5 6.5 320 56.9 233.5 6.5 90.6 0 78.1 0 35 0 0 34.3 0 76.5v313.7c0 40.7 32.5 74.3 73.9 76.4 36.8 1.9 128.8 9.5 187.7 38.7 8.2 4 17.3 6.3 26.3 6.6v.1h64v-.1c9.1-.3 18.2-2.5 26.3-6.6 59-29.2 151-36.8 187.8-38.7 41.4-2.1 73.9-35.7 73.9-76.4V76.5C640 34.3 605 0 561.9 0zm-257 449.8c0 10.6-11.8 17.5-21.9 12.5-65.3-32.4-159.9-41.2-206.6-43.6-16-.8-28.4-13.4-28.4-28.5V76.5C48 60.7 61.5 48 78.1 48c2 0 142 4.8 219.9 51.7 4.4 2.6 6.9 7.1 6.9 12.1v338zM592 390.3c0 15.1-12.4 27.7-28.4 28.5-46.7 2.4-141.2 11.2-206.5 43.6-10.1 5-22-1.9-22-12.5v-338c0-4.9 2.5-9.6 6.9-12.2C419.9 52.8 560.1 48 561.9 48c16.6 0 30.1 12.7 30.1 28.5v313.8z\"\n                                class=\"\"></path>\n                        </svg>\n                        {{$ctrl.myBook}}\n                    </span>\n                </li>\n            </div>\n            <div class=\"right\">\n                <li ng-if=\"$ctrl.user\">\n                    <span ng-click=\"$ctrl.logout()\">\n                        <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"sign-out\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n                            class=\"svg-inline--fa fa-sign-out fa-w-16 fa-2x\">\n                            <path fill=\"currentColor\" d=\"M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z\"\n                                class=\"\"></path>\n                        </svg>\n                        {{$ctrl.logoutText}}\n                    </span>\n                </li>\n            </div>\n        </ul>\n\n        <div class=\"row mobile-row\">\n            <div class=\"col-xs-12 center-xs\">\n                <div class=\"search-container\">\n                    <searchbox></searchbox>\n                </div>\n            </div>\n\n            <div class=\"col-xs-12 center-xs\">\n                <div class=\"categories-container\">\n                    <categories></categories>\n                </div>\n            </div>\n        </div>\n\n\n        <div class=\"row mobile-row mobile-buttons visible-xs\">\n            <!--Mobile Generate Book Section-->\n            <div class=\"generate-book col-xs-6\">\n                <p>{{$ctrl.personalGuidebook}}</p>\n                <button ui-sref=\"home.book.bookStep1\">\n                    {{$ctrl.generate}}\n                </button>\n            </div>\n\n            <!--Mobile Check Contributor Section-->\n            <div class=\"check-contributor col-xs-6\">\n                <p>{{$ctrl.beenInGeorgia}}</p>\n                <button ui-sref=\"home.contributor.step1\">\n                    {{$ctrl.areYouContributorOne}} {{$ctrl.areYouContributorTwo}}\n                </button>\n            </div>\n        </div>\n\n        <!-- Extra small Shared Components-->\n        <div class=\"mobile-posts row visible-xs\">\n\n            <div class=\"col-xs-12\">\n                <!-- <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\"> -->\n                <div ng-repeat=\"post in $ctrl.posts\">\n                    <card1 data=\"post\" ng-if=\"post.cardType === 'layout image'\"></card1>\n                    <card2 data=\"post\" ng-if=\"post.cardType === 'layout likes'\"></card2>\n                    <card3 data=\"post\" ng-if=\"post.cardType === 'layout text'\"></card3>\n                </div>\n            </div>\n            <Loader class=\"Loader\" ng-if=\"$ctrl.isLoading && $ctrl.posts.length === 0\" />\n\n            <div class=\"not-found-mobile\" ng-if=\"!$ctrl.isLoading && $ctrl.posts.length === 0\">{{$ctrl.notFound}}</div>\n            <button class=\"view-more\" ng-click=\"$ctrl.viewMorePosts()\" ng-disabled=\"$ctrl.isLoading\" ng-if=\"$ctrl.posts.length > 0 && $ctrl.postsCount !== $ctrl.posts.length\">\n                <span>{{$ctrl.more}}</span>\n                <img src=\"/assets/images/loader-spinner.gif\" alt=\"loading\" class=\"loader-spinner\" ng-if=\"$ctrl.isLoading\">\n            </button>\n        </div>\n\n        <footer class=\"visible-xs\"></footer>\n\n        <!--Mobile Recomendations Section-->\n        <!-- <div class=\"recomendations visible-xs\">\n            <h1>Recomendations from Statistics</h1>\n\n            <div class=\"cards\">\n                <div class=\"card\">\n                    <img src=\"/assets/images/khinkali.png\" alt=\"khinkali\">\n                    <span>Best khinkali in\n                        <b>Kakheti</b>\n                    </span>\n                </div>\n                <div class=\"card\">\n                    <img src=\"/assets/images/khinkali.png\" alt=\"khinkali\">\n                    <span>Best khinkali in\n                        <b>Kakheti</b>\n                    </span>\n                </div>\n                <div class=\"card\">\n                    <img src=\"/assets/images/khinkali.png\" alt=\"khinkali\">\n                    <span>Best khinkali in\n                        <b>Kakheti</b>\n                    </span>\n                </div>\n                <div class=\"card\">\n                    <img src=\"/assets/images/khinkali.png\" alt=\"khinkali\">\n                    <span>Best khinkali in\n                        <b>Kakheti</b>\n                    </span>\n                </div>\n            </div>\n        </div> -->\n\n    </div>\n\n    <div class=\"generate-book-web hidden-xs\">\n        <button ui-sref=\"home.book.bookStep1\">\n            {{$ctrl.generate}}\n        </button>\n        <p>{{$ctrl.personalGuidebook}}</p>\n    </div>\n\n    <!-- For all screens, except extra large (3 columns) and exra small -->\n    <div class=\"row cards-container hidden-custom-xl hidden-xs\">\n        <div class=\"col-md-6 col-sm-12\">\n            <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\">\n                <card1 data=\"post\" ng-if=\"$index%2 == 0 && post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"$index%2 == 0 && post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"$index%2 == 0 && post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n        <div class=\"col-md-6 col-sm-12\">\n            <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\">\n                <card1 data=\"post\" ng-if=\"$index%2 == 1 && post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"$index%2 == 1 && post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"$index%2 == 1 && post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n        <Loader class=\"Loader\" ng-if=\"$ctrl.isLoading\" />\n\n        <div class=\"not-found\" ng-if=\"!$ctrl.isLoading && $ctrl.posts.length === 0\">{{$ctrl.notFound}}</div>\n    </div>\n\n    <!-- For xl screen -->\n    <div class=\"row cards-container visible-custom-xl hidden-lg hidden-md hidden-sm hidden-xs\">\n        <div class=\"col-custom-xl-4\">\n            <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\">\n                <card1 data=\"post\" ng-if=\"$index%3 == 0 && post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"$index%3 == 0 && post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"$index%3 == 0 && post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n        <div class=\"col-custom-xl-4\">\n            <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\">\n                <card1 data=\"post\" ng-if=\"$index%3 == 1 && post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"$index%3 == 1 && post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"$index%3 == 1 && post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n        <div class=\"col-custom-xl-4\">\n            <div ng-repeat=\"post in $ctrl.posts\" ng-click=\"$ctrl.showPost($event, post.id)\">\n                <card1 data=\"post\" ng-if=\"$index%3 == 2 && post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"$index%3 == 2 && post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"$index%3 == 2 && post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n        <Loader class=\"Loader\" ng-if=\"$ctrl.isLoading\" />\n\n        <div class=\"not-found\" ng-if=\"!$ctrl.isLoading && $ctrl.posts.length === 0\">{{$ctrl.notFound}}</div>\n    </div>\n\n</div>\n"

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _sharedmoments = __webpack_require__(551);
	
	var _sharedmoments2 = _interopRequireDefault(_sharedmoments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SharedmomentsController = function () {
	    function SharedmomentsController($scope, $state, $stateParams, SharedMoments, User, Category, Loader) {
	        (0, _classCallCheck3.default)(this, SharedmomentsController);
	
	        this.name = 'sharedmoments';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.SharedMoments = SharedMoments;
	        this.User = User;
	        this.Category = Category;
	        this.Loader = Loader;
	
	        this.posts = [];
	        this.categories = Category.getCategories();
	        this.selectedCategories = [];
	        this.urls = [];
	        this.isLoading = false;
	        this.postsCount = 0;
	    }
	
	    (0, _createClass3.default)(SharedmomentsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // Set user if logged in
	            this.setActiveUser();
	
	            this.render();
	
	            // GET posts on page load
	            if (this.$stateParams.search) {
	                this.searchPosts(this.urls);
	            }
	
	            // Catch scroll event to load posts on scroll
	            this.scroll();
	
	            // Watch
	            this.watchCategories();
	            this.watchPosts();
	            this.watchLanguage();
	        }
	    }, {
	        key: 'setActiveUser',
	        value: function setActiveUser() {
	            var _this = this;
	
	            this.User.getCurrentUser().then(function (user) {
	                _this.user = user;
	            }).catch(function () {
	                _this.user = null;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _sharedmoments2.default[this.language],
	                MY_BOOK = _texts$language.MY_BOOK,
	                LOG_OUT = _texts$language.LOG_OUT,
	                GENERATE = _texts$language.GENERATE,
	                PERSONAL_GUIDEBOOK = _texts$language.PERSONAL_GUIDEBOOK,
	                BEEN_IN_GEORGIA = _texts$language.BEEN_IN_GEORGIA,
	                ARE_YOU_CONTRIBUTOR_ONE = _texts$language.ARE_YOU_CONTRIBUTOR_ONE,
	                ARE_YOU_CONTRIBUTOR_TWO = _texts$language.ARE_YOU_CONTRIBUTOR_TWO,
	                NOT_FOUND = _texts$language.NOT_FOUND,
	                MORE = _texts$language.MORE;
	
	
	            this.myBook = MY_BOOK;
	            this.logoutText = LOG_OUT;
	            this.generate = GENERATE;
	            this.personalGuidebook = PERSONAL_GUIDEBOOK;
	            this.beenInGeorgia = BEEN_IN_GEORGIA;
	            this.areYouContributorOne = ARE_YOU_CONTRIBUTOR_ONE;
	            this.areYouContributorTwo = ARE_YOU_CONTRIBUTOR_TWO;
	            this.notFound = NOT_FOUND;
	            this.more = MORE;
	        }
	    }, {
	        key: 'searchPosts',
	        value: function searchPosts(urls) {
	            var _this2 = this;
	
	            this.isLoading = true;
	
	            this.SharedMoments.searchPosts(this.$stateParams.search, urls).then(function (_ref) {
	                var data = _ref.data;
	                var count = data.count,
	                    posts = data.posts;
	
	
	                _this2.postsCount = count;
	
	                _this2.Loader.loadImages(posts, 'photoUrl', function () {
	                    _this2.isLoading = false;
	                    _this2.SharedMoments.addPosts(posts);
	
	                    if (posts.length > 0) {
	                        _this2.$scope.$apply();
	                    }
	                });
	            }).catch(function (err) {
	                console.log('Error occured in method searchPosts', err);
	
	                _this2.error = err.data;
	            });
	        }
	    }, {
	        key: 'getPosts',
	        value: function getPosts(categories, urls) {
	            var _this3 = this;
	
	            this.isLoading = true;
	
	            this.SharedMoments.getPosts(categories, urls).then(function (_ref2) {
	                var data = _ref2.data;
	                var count = data.count,
	                    posts = data.posts;
	
	
	                _this3.postsCount = count;
	
	                _this3.Loader.loadImages(posts, 'photoUrl', function () {
	                    _this3.isLoading = false;
	                    _this3.SharedMoments.addPosts(posts);
	
	                    if (posts.length > 0) {
	                        _this3.$scope.$apply();
	                    }
	                });
	            }).catch(function (err) {
	                console.log('Error occured in method getPosts', err);
	
	                _this3.error = err.data;
	            });
	        }
	    }, {
	        key: 'showPost',
	        value: function showPost(event, id) {
	            var mcactionbutton = $(event.target).closest('.mcactionbutton').get(0);
	            var readmore = $(event.target).closest('.read-more').get(0);
	            var readless = $(event.target).closest('.read-less').get(0);
	
	            if (!mcactionbutton && !readmore && !readless) {
	                this.$state.go('home.post', {
	                    id: id
	                });
	            }
	        }
	    }, {
	        key: 'scroll',
	        value: function scroll() {
	            var div = document.getElementsByClassName('cards-container');
	            var elem = angular.element(div);
	
	            var that = this;
	            var diff = 25;
	
	            elem.bind('scroll', function scrolling() {
	                if (Math.ceil(this.scrollTop + this.clientHeight) + diff >= this.scrollHeight && !that.isLoading && that.postsCount > that.posts.length) {
	                    that.isLoading = true;
	                    if (that.$stateParams.search) {
	                        that.searchPosts(that.urls);
	                    } else {
	                        that.getPosts(that.selectedCategories, that.urls);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'goToMyBook',
	        value: function goToMyBook() {
	            var bookId = localStorage.getItem('tourists_bookId');
	
	            this.$state.go('home.book.bookStep3', {
	                bookId: bookId
	            }, { reload: true });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.User.logout();
	        }
	    }, {
	        key: 'viewMorePosts',
	        value: function viewMorePosts() {
	            if (this.$stateParams.search) {
	                this.searchPosts(this.urls);
	            } else {
	                this.getPosts(this.selectedCategories, this.urls);
	            }
	        }
	    }, {
	        key: 'watchCategories',
	        value: function watchCategories() {
	            var _this4 = this;
	
	            this.$scope.$watch(function () {
	                return _this4.Category.getSelectedCategories();
	            }, function (newValue) {
	                _this4.selectedCategories = newValue;
	                _this4.urls = [];
	
	                _this4.SharedMoments.setPosts([]);
	
	                if (!_this4.$stateParams.search) {
	                    _this4.getPosts(_this4.selectedCategories, _this4.urls);
	                }
	            });
	
	            this.$scope.$watch(function () {
	                return _this4.User.getUser();
	            }, function (newValue) {
	                _this4.user = newValue;
	            });
	        }
	    }, {
	        key: 'watchPosts',
	        value: function watchPosts() {
	            var _this5 = this;
	
	            this.$scope.$watch(function () {
	                return _this5.SharedMoments.getLoadedPosts();
	            }, function (newValue) {
	                if (newValue) {
	                    _this5.posts = newValue;
	                    _this5.urls = newValue.map(function (item) {
	                        return item.url;
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this6 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this6.render();
	                }
	            });
	        }
	    }]);
	    return SharedmomentsController;
	}();
	
	SharedmomentsController.$inject = ['$scope', '$state', '$stateParams', 'SharedMoments', 'User', 'Category', 'Loader'];
	
	exports.default = SharedmomentsController;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(581);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sharedmoments.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sharedmoments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".sharedmoments{background-color:#fcfcfc}.sharedmoments h1{font-family:Graphik-Bold}@media only screen and (max-width:768px){.sharedmoments h1.shared-moments-header{font-size:26px;margin-left:34px}}.sharedmoments .generate-book-web{margin:15px 0}.sharedmoments .generate-book-web button{background-color:#90dc19;width:205px;height:45px;border:0;border-radius:30px;font-family:Graphik-Regular;color:#fff;font-size:13px;outline:0;box-shadow:0 3px 8px rgba(0,0,0,.21)}.sharedmoments .generate-book-web button:hover{font-weight:700;background-color:#7fd100}.sharedmoments .generate-book-web p{margin-left:5px;display:inline-block;font-size:12px;font-family:Graphik;color:#787878}.sharedmoments .cards-container{height:calc(100vh - 167px);top:170px;width:calc(100% + 30px);overflow-y:scroll;overflow-x:hidden;padding-top:15px}.sharedmoments .cards-container .col-sm-12>div{display:table;margin:0 auto}.sharedmoments .cards-container::-webkit-scrollbar{width:3px}.sharedmoments .cards-container::-webkit-scrollbar-track{background:#f2f2f2}.sharedmoments .cards-container::-webkit-scrollbar-thumb{background:#ff0084}.sharedmoments .cards-container::-webkit-scrollbar-thumb:hover{background:#ff002b}.sharedmoments .Loader{display:block;text-align:center;width:100%}.sharedmoments .not-found{position:relative;top:-25px;height:100%;width:100%;font-size:14px;display:flex;align-items:center;justify-content:center;color:#828080}.sharedmoments.geo h1{font-family:Georgian-Bold}.sharedmoments.geo .generate-book-web button,.sharedmoments.geo .generate-book-web p{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(583);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sharedmoments.mobile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sharedmoments.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:375px){.sharedmoments .mobile-row{margin-left:0!important}.sharedmoments .mobile-buttons{width:300px;margin-left:calc(50% - 168px)!important}}.sharedmoments .sharedmoments-mobile{height:calc(100vh - 92px);overflow-y:scroll}.sharedmoments .sharedmoments-mobile::-webkit-scrollbar{width:3px}.sharedmoments .sharedmoments-mobile::-webkit-scrollbar-track{background:#f2f2f2}.sharedmoments .sharedmoments-mobile::-webkit-scrollbar-thumb{background:#ff0084}.sharedmoments .sharedmoments-mobile::-webkit-scrollbar-thumb:hover{background:#ff002b}.sharedmoments .user-nav{padding:15px 25px}.sharedmoments .user-nav .left{display:inline-block;width:60%;text-align:left}.sharedmoments .user-nav .left li{display:inline-block}.sharedmoments .user-nav .left li:first-child{padding-right:5px}.sharedmoments .user-nav .right{width:38%;display:inline-block;text-align:right}.sharedmoments .user-nav svg{position:relative;top:3px;height:15px;width:15px;padding-right:2px}.sharedmoments .user-nav li{list-style-type:none;font-weight:bolder;font-size:13px}.sharedmoments .user-nav .fullname{color:#000;cursor:text}.sharedmoments .user-nav .my-book{color:#6eb30f}.sharedmoments .about .map{width:100%;height:auto}.sharedmoments .about .text{padding:0 25px 25px;line-height:22px;font-size:15px;color:#7d7b7b;text-align:center}.sharedmoments .about .text .title{font-size:28px;color:#ea3e4b}.sharedmoments .about .video-box{width:100%;height:auto}.sharedmoments .about .video-box video{object-fit:fill;width:100%;height:100%;max-height:100%;max-width:100%}.sharedmoments .mobile-row{margin:0;max-width:385px;margin-left:calc(50% - 192.5px)}.sharedmoments .generate-book{padding:0 0 15px 25px;text-align:center}.sharedmoments .generate-book p{margin-bottom:5px;font-size:10px;font-family:Graphik;color:#525050;text-align:center;height:30px}.sharedmoments .check-contributor button,.sharedmoments .generate-book button{background-color:#90dc19;width:130px;height:41px;border:0;border-radius:35px;font-family:Graphik-Regular;color:#fff;font-size:11px;font-weight:700}.sharedmoments .check-contributor{padding:0 0 25px 25px;text-align:center;height:35px}.sharedmoments .check-contributor p{font-size:10px;font-family:Graphik;color:#525050;margin-bottom:5px;height:30px}.sharedmoments .check-contributor p b{color:#000;cursor:pointer}.sharedmoments .mobile-posts{margin:0;border-top:4px dotted #ededed;min-height:calc(100vh - 402px)}.sharedmoments .mobile-posts .col-xs-12>div{display:table;margin:0 auto}.sharedmoments .mobile-posts .categories-container,.sharedmoments .mobile-posts .search-container{width:100%;max-width:385px}.sharedmoments .mobile-posts .view-more{position:relative;background-color:#e8edf6;width:143px;height:40px;font-size:13px;font-family:Graphik-Semibold;color:#222;border:0;border-radius:20px;outline:0;margin-top:10px;margin-left:calc(50% - 71.5px);margin-bottom:15px}.sharedmoments .mobile-posts .view-more .loader-spinner{position:absolute;top:12px;right:20px;width:15px;height:15px}.sharedmoments .mobile-posts .not-found-mobile{width:100%;margin-top:30px;margin-bottom:30px;font-size:14px;color:#828080;text-align:center}.sharedmoments .recomendations{padding:0 25px 25px}.sharedmoments .recomendations h1{font-size:26px;line-height:33px}.sharedmoments .recomendations .cards{font-size:12px}.sharedmoments .recomendations .cards .card{margin-bottom:10px;border-radius:30px;background-color:#e8edf6;width:130px;display:inline-block;padding:10px}.sharedmoments .recomendations .cards .card:nth-child(odd){margin-right:10px}.sharedmoments .recomendations .cards .card img{float:left;width:30px;margin-right:10px}.sharedmoments .recomendations .cards .card span b{font-size:13px}.sharedmoments.geo .check-contributor button,.sharedmoments.geo .check-contributor p,.sharedmoments.geo .generate-book button,.sharedmoments.geo .generate-book p{font-family:Georgian-Regular}.sharedmoments.geo .view-more{font-family:Georgian-Semibold}", ""]);
	
	// exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(585);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card1Module = _angular2.default.module('card1', [_angularUiRouter2.default]).component('card1', _card2.default).name;
	
	exports.default = card1Module;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _card = __webpack_require__(586);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(587);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(588);
	
	__webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card1Component = {
		bindings: {
			"data": '='
		},
		template: _card2.default,
		controller: _card4.default
	};
	
	exports.default = card1Component;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card1 hidden-xs\">\n\t<div class=\"top-of-card\">\n\t\t<!-- Dots grid -->\n\t\t<svg class=\"dots-grid\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"227\" height=\"227\"\n\t\t viewBox=\"0 0 227 227\">\n\t\t\t<image id=\"dots-grid-card-1\" data-name=\"Vector Smart Object\" width=\"200\" height=\"185\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\n\t\t<!-- Photo container -->\n\t\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\"></div>\n\n\t\t<!-- Date and user information -->\n\t\t<div class=\"date-user-info\">\n\t\t\t<div class=\"date-container\">\n\t\t\t\t<p>{{ $ctrl.data.date | date : \"d MMMM\" }}</p>\n\t\t\t</div>\n\t\t\t<div class=\"user-info-container\">\n\t\t\t\t<div class=\"avatar-container\">\n\t\t\t\t\t<img ng-src=\"{{$ctrl.data.owner.avatarUrl}}\" alt=\"user\">\n\t\t\t\t</div>\n\n\t\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- Layered divs -->\n\t\t<div class=\"transparent-layer\"></div>\n\n\t\t<div class=\"first\" ng-style=\"{'background-color': $ctrl.color1}\"></div>\n\t</div>\n\n\n\t<div class=\"caption\" ng-style=\"{'background-color': $ctrl.color1}\">\n\n\t\t<div class=\"icon\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\">\n\t\t\t\t<image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"25\" height=\"25\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAeFBMVEUAAAD19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vcAAABr2vVZAAAAJnRSTlMAP8b9+6URQuvwT/5QChAruMBkAjtACdZ9WePQtRVl79wcBTA60gLfb+kAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUECBoGh4cGWAAAAJhJREFUKM+N0ekSgiAUhuEPcCszTS3b05Zz/5cY5NAIcSbfnzwzcABASEV+SgpARBQqEpAUJ/BLYpJQ9AuaSIEIofTyP0mzhS1LHVnm36nylbtbsbYVc8/hpaw2tqp0pJ48TO1I025tbTPjnB0jHe0ZORAdT07nyyi43vxf64dRcC8f0569oeBgg6HwyIaYy2hi5ENgqHu9AcMCIIKECUyVAAAAAElFTkSuQmCC\"\n\t\t\t\t/>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class=\"text\">\n\t\t\t{{ $ctrl.data.caption | limitTo: $ctrl.limitForText }}\n\t\t\t<p ng-if=\"$ctrl.data.caption.length > $ctrl.limitForText\" class=\"read-more\">\n\t\t\t\t<span ng-click=\"$ctrl.readMore('web')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n\t\t\t</p>\n\n\t\t\t<p ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n\t\t\t\t<span ng-click=\"$ctrl.readLess('web')\">Less</span>\n\t\t\t</p>\n\t\t</div>\n\t</div>\n\t<div class=\"second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n\t<div class=\"third\" ng-style=\"{'background-color': $ctrl.color3}\"></div>\n\t<div class=\"fourth\" ng-style=\"{'background-color': $ctrl.color4}\"></div>\n\n\t<mcactionbutton photoUrl=\"$ctrl.data.photoUrl\" id=\"$ctrl.data.id\" thumbs=\"$ctrl.data.thumbs\" url=\"$ctrl.data.url\"></mcactionbutton>\n\n</div>\n\n\n<div class=\"card1-mobile visible-xs\">\n\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"137\" height=\"137\" viewBox=\"0 0 137 137\">\n\t\t\t<image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"137\" height=\"137\" xlink:href=\"data:img/png;base64,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\"></image>\n\t\t</svg>\n\t</div>\n\t<div class=\"date-n-user\">\n\t\t<div class=\"date\">{{ $ctrl.data.date | date : \"d MMMM\" }}</div>\n\t\t<mcactionbutton photoUrl=\"$ctrl.data.photoUrl\" id=\"$ctrl.data.id\" thumbs=\"$ctrl.data.thumbs\" url=\"$ctrl.data.url\"></mcactionbutton>\n\t\t<div class=\"user-info\">\n\t\t\t<img ng-src=\"{{ $ctrl.data.owner.avatarUrl }}\" alt=\"user\">\n\t\t\t<span>{{ $ctrl.data.owner.username }}</span>\n\t\t</div>\n\t</div>\n\t<div class=\"first\" ng-style=\"{'background-color': $ctrl.color1}\">\n\t\t<svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"comment-alt-lines\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n\t\t class=\"svg-inline--fa fa-comment-alt-lines fa-w-16 fa-2x\">\n\t\t\t<path fill=\"#fff\" d=\"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM280 240H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z\"\n\t\t\t class=\"\"></path>\n\t\t</svg>\n\t\t<p>\n\t\t\t{{ $ctrl.data.caption | limitTo: $ctrl.limitForTextMobile }}\n\t\t\t<span ng-if=\"$ctrl.data.caption.length > $ctrl.limitForTextMobile\" class=\"read-more\">\n\t\t\t\t<span ng-click=\"$ctrl.readMore('mobile')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n\t\t\t</span>\n\n\t\t\t<span ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n\t\t\t\t<span ng-click=\"$ctrl.readLess('mobile')\">Less</span>\n\t\t\t</span>\n\t\t</p>\n\t</div>\n\t<div class=\"second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n\t<div class=\"third\" ng-style=\"{'background-color': $ctrl.color3}\"></div>\n\t<div class=\"fourth\" ng-style=\"{'background-color': $ctrl.color4}\"></div>\n</div>\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card1Controller = function () {
	    function Card1Controller(Color) {
	        (0, _classCallCheck3.default)(this, Card1Controller);
	
	        this.name = 'card1';
	        this.limitDefaultValue = 260;
	        this.limitDefaultValueMobile = 200;
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Card1Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.setColor();
	
	            this.setFields();
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors(this.data.cardType, this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	        }
	    }, {
	        key: 'setFields',
	        value: function setFields() {
	            // this.data.owner.avatarUrl = this.data.owner.avatarUrl || '/assets/images/user.jpg'
	            this.limitForText = this.limitDefaultValue;
	            this.limitForTextMobile = this.limitDefaultValueMobile;
	        }
	    }, {
	        key: 'readMore',
	        value: function readMore(type) {
	            if (type === 'web') {
	                this.limitForText = this.data.caption.length;
	                this.readMoreMode = true;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.data.caption.length;
	                this.readMoreMode = true;
	            }
	        }
	    }, {
	        key: 'readLess',
	        value: function readLess(type) {
	            if (type === 'web') {
	                this.limitForText = this.limitDefaultValue;
	                this.readMoreMode = false;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.limitDefaultValueMobile;
	                this.readMoreMode = false;
	            }
	        }
	    }]);
	    return Card1Controller;
	}();
	
	Card1Controller.$inject = ['Color'];
	
	exports.default = Card1Controller;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card1.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card1{position:relative;width:372px;height:auto;padding-bottom:50px;cursor:pointer}.card1:hover .action-buttons-container{display:block;animation:action-button-animation .25s 1}@keyframes action-button-animation{0%{opacity:0}to{opacity:1}}.card1 .top-of-card{height:265px}.card1 .photo-container{position:absolute;left:0;background-color:#d1d1d1;box-shadow:-7px -7px 10px #f0f0f0;background-size:cover;width:335px;height:265px;z-index:5}.card1 .dots-grid{position:absolute;left:0;top:80px;z-index:6}.card1 .date-user-info{position:absolute;top:121px;z-index:7;left:0}.card1 .date-container{background-color:hsla(0,0%,100%,.8);width:151px;height:44px}.card1 .date-container p{font-size:11px;font-family:Graphik-Black;color:#79838d;line-height:44px;text-align:center}.card1 .user-info-container{background-color:hsla(0,0%,97%,.7);width:151px;height:95px;z-index:1;padding-top:5px}.card1 .user-info-container .avatar-container{margin-left:calc(50% - 26.5px)}.card1 .user-info-container .avatar-container img{border-radius:50%;width:53px;height:53px}.card1 .user-info-container p{font-size:12px;font-family:Graphik;color:#000;text-align:center;padding-top:8px;overflow-x:hidden}.card1 .first{position:absolute;right:0;top:100px;width:312px;height:165px;z-index:4}.card1 .caption,.card1 .first{box-shadow:7px 7px 10px #f0f0f0}.card1 .caption{position:relative;left:60px;z-index:6;padding:10px 0;color:#fff;word-wrap:break-word;min-height:120px;max-width:312px;min-width:312px;height:auto}.card1 .caption .icon{position:absolute;top:12px;padding-left:15px}.card1 .caption .text{width:calc(100% - 70px);overflow-y:auto;margin-left:55px;padding-right:15px;font-size:13px;font-family:Graphik-Regular}.card1 .caption .text p span{font-size:11px;cursor:pointer;font-family:Graphik-Bold}.card1 .second{right:0;top:245px;position:absolute;width:339px;height:143px;z-index:3}.card1 .third{right:0;top:213px;z-index:2}.card1 .fourth,.card1 .third{position:absolute;width:351px;height:137px}.card1 .fourth{right:20px;box-shadow:-8px 7px 10px #f0f0f0;opacity:.502;top:185px;z-index:1}.card1 .transparent-layer{width:372px;height:100px;right:0;z-index:6;top:165px}.card1 .transparent-layer,.card1 .user-info-shade{background-color:#f7f7f7;opacity:.22;position:absolute}.card1 .user-info-shade{width:157px;height:157px}", ""]);
	
	// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(591);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card1.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card1.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card1-mobile{overflow:auto;padding:15px 10px;max-width:350px;width:80vw}.card1-mobile .action-buttons-container{display:block}.card1-mobile .photo-container{height:160px;position:relative;box-shadow:-7px -7px 10px #f0f0f0,-7px 0 10px #f0f0f0,7px -6px 10px #f0f0f0;z-index:1}.card1-mobile .photo-container svg{width:120px;height:120px;position:absolute;bottom:0}.card1-mobile .date-n-user{position:relative;box-shadow:-7px -7px 10px #f0f0f0,-7px 0 10px #f0f0f0,7px -6px 10px #f0f0f0}.card1-mobile .date-n-user .date{background-color:#fff;height:35px;line-height:35px;font-size:11px;padding-left:10px;font-family:Graphik-Bold;color:#79838d}.card1-mobile .date-n-user .user-info{background-color:#f7f7f7;height:50px;font-size:14px;font-family:Graphik-Bold;line-height:50px;position:relative}.card1-mobile .date-n-user .user-info img{border-radius:17px;width:35px;position:absolute;top:8px;left:8px}.card1-mobile .date-n-user .user-info span{margin-left:53px}.card1-mobile .first{width:calc(100% - 60px);float:right;height:auto;min-height:99px;box-shadow:7px 7px 10px #f0f0f0}.card1-mobile .first svg{width:21px;padding:10px}.card1-mobile .first p{display:block;margin-top:-33px;width:calc(100% - 52px);padding-bottom:12px;margin-left:42px;font-size:12px;font-family:Graphik-Regular;color:#fff;word-wrap:break-word}.card1-mobile .first p>span{display:block;font-family:Graphik-Bold;margin-top:3px}.card1-mobile .fourth,.card1-mobile .second,.card1-mobile .third{float:right;width:20px;box-shadow:-6px 6px 10px #f0f0f0}.card1-mobile .second{height:79px}.card1-mobile .third{height:59px}.card1-mobile .fourth{height:39px}", ""]);
	
	// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(593);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card2Module = _angular2.default.module('card2', [_angularUiRouter2.default]).component('card2', _card2.default).name;
	
	exports.default = card2Module;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _card = __webpack_require__(594);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(595);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(596);
	
	__webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card2Component = {
		bindings: {
			'data': '='
		},
		template: _card2.default,
		controller: _card4.default
	};
	
	exports.default = card2Component;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card2 hidden-xs\">\n\n\t<div class=\"top-of-card\">\n\t\t<div class=\"like-container\" ng-style=\"{'background-color': $ctrl.color1}\">\n\t\t\t<svg class=\"around-heart\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"88\" height=\"93\"\n\t\t\t viewBox=\"0 0 88 93\">\n\t\t\t\t<image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"88\" height=\"93\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABdCAQAAACLUWkMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQIKSc/hXM2AAAERElEQVR42tXbXWjVdRzH8ffvD2vMmtto2VZjT0a2VlFIaE6nFwmCKNhFBFI3WV0Nggq6sQe6SUoQArsphIKQooueuykQpXKyHDO1WGtjRnts5VyzzbVPF2f/87An/7/z9D3nfbP/+R8Oe+233/Z/dmSYymilhWYaqeVWqqhkLS7+9hUmucIQIwzSRy/n3Hhm38+l+0HV8zBtbOFOAq8PDvM9P/ANZ918poMVlXqvXtN5ZdqY3tUuleSWWq4OdWdMTW5Uh3VHbrDVel1/ZxUbNq+P9UB2sWv0sqZygk30oZqyxd2tgRxjY13VwYzntMp1LC/YsC61ZMJt1S955UrSlB5Nl7sr5/N2pV6R//ZB+zVnxJWktz3J2q//DLm+ZD1izpWkQ1G5mzRtbV3omaW6JcOuGrq4Lc2/02x3jW3udOqqRXtacrxXMFwo4bjKVwXTwU5rZUqNHEldkTIlVM8FbrQ2LqndnUy8SB3hIwXIhaNKUiYtaiv7rG3Ldg+PJ14kTQmdZKu1bYUGWe/mYovxEdb2guVCPY+Fi4kp8YK1atWeDxcWpoSa6Ev/CDovbXKdkBjhAwXOhadiXxyAHP00WIuu01/UuNlwhB8qeC5UxbbBMfBea02kdkM4JX6i1VoToUuuHhyohiFrS8TWu98CYIe1I3LtsTm8xdoRuc0x8EZrR+Q2glPAFGXWkojNsiagoWi4cAPNAZmcy8p/LQHN1gavGgMarQ1eNQTUWRu8qguotjZ4dUtArbXBq3VBQR7Yr9xNQRH9FwYoCyi1NnhV6jRLbq9GZrdZJ1kb/PK7sF0AFSF42prg1UzANWuDV/8G/GNt8OpqsY3wTMCf1gavJgPGrA1ejQSMWhu8Gg8YtDZ4danYwAMBv1obvOp3RXQqEKDJgSaosnZEbJryAOiydkSu280XF7grtnt5ytoRue9iZ+ArmCiS/eJaNxyAu8wZa0mkLrrh8IjjM2tLpL6CEPyptSVSn0DiWnPhX/gaos7NJw5C37f2XLcPYreghyO8jt8L/ITK3e4ixEfYjfKRtWjVTsS4yecl3rQ2rdob4UIc7M7yhbVqxbr5Mu5MrNV9dBfobR573OfhYtIm2fVwzFq2bCcS3MV3BlbzMzdb+xY1x/3ufOJlyk6PG+dZa9+SDiVzl0nHrW8aTunHxQ9KLL1/eC2dbLAe1oUu86DrTV21ZD/YTbKPSWspAPM8sZi7QtquGeu5IKnD44fTXs0ac1/0/H1oj+mt+75cAG3WmAl2Tk+mOevVoDN5545oR5pcAJXqsObzyP1amT/joHZdyAt2Qk+n8dDUsuQSPafxnGJndVTZvXNDlXopR+gZvZOrB1nLdECdWcUO6KBqcoJNYt+lV9WTMXVQb2mbvE+Rpf/k+O3spI02Nniel+vnNKf4NjyozBs4Dg+fzW+ilhoqqaAi6e3LTDLJH4wyQB+99LgMd6z+ByoWJQSXjV26AAAAAElFTkSuQmCC\"\n\t\t\t\t/>\n\t\t\t\t<text fill=\"{{ $ctrl.color1 }}\" x=\"50%\" y=\"74px\" alignment-baseline=\"middle\" text-anchor=\"middle\">\n\t\t\t\t\t{{ $ctrl.data.likes }}\n\t\t\t\t</text>\n\t\t\t</svg>\n\t\t\t<svg class=\"heart\" aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"heart\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n\t\t\t class=\"svg-inline--fa fa-heart fa-w-16 fa-3x\">\n\t\t\t\t<path fill=\"{{ $ctrl.color1 }}\" d=\"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z\"\n\t\t\t\t class=\"\"></path>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class=\"share-container\" ng-style=\"{'background-color': $ctrl.color4}\">\n\t\t\t<svg class=\"dots-grid\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"100\" height=\"90\"\n\t\t\t viewBox=\"0 0 100 100\">\n\t\t\t\t<image id=\"card2-share-dots-grid\" data-name=\"Vector Smart Object\" width=\"100\" height=\"100\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t\t/>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class=\"share-icon-container\">\n\t\t\t<!-- Share icon -->\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"51\" height=\"53\" viewBox=\"0 0 51 53\">\n\t\t\t\t<image id=\"card2-share-outline\" data-name=\"Vector Smart Object\" width=\"51\" height=\"53\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA1CAQAAABG8Ru8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQMDgfZJ0lHAAACeElEQVRYw83YS2gTQRzH8e+OAY1vxFZJ7KVWiq2WYDxZL/ZQiFWhpepBPHhQqoh6UgRRFjxI7z5uqQdBzcUqaiVH8VBqS+LjUHxQsdWaIKZSkj7EeFjH2Owm6yY7i7/T7A47HybZ+c+wWh6bCLYQIkw9dQTxswyAHDkm+cgYCYZJMlfqcR0AXxnAx2666GCtRZ8fP2to+n01TZx+YmRLDaWVmM0KTtHDBrupLsgUffTyyWo2wvJn6uEtlx0isIrTvEFnidWQxQkQ5zq1DgmZpVzkOVvtmFaStFVIyDQzxP5yTBtxyz/caRZzm8OlmBD9+F1AjHGjtFsxNTxguUsIwCJiNJiZa47fLLusJCrHl0wn3S4jADs5bjSM5enjFY0KGJikXs/J2RxShMB6joJkTipCAE5IpoXtCpnGSzsM5qBCBKDbYCKKmXbQ8jWkFDMQEGxTjkBYEPKAaRE0e8A0CdcrmVWCgqAHTEBUvB07Sa1wbSMrF7+Wtz0PuhFR/RD/FZOtfhDbzAhmPGBygi8eMCnBuAfMhGfMSw+Y14KkB0xCy6/mq/LVs06QYVD1XPSUAAYUM0+MYnNHMXPXYEZ5qhBJ6COydF5VyNwAycRIKELGiBaYn5xXxFzQ5woMDHBTAfKIW0ajsDDP8M5lJM0x2SwwGTr45iIySycTZgZGifDdJWSeAzwrXC6sZoPsKv60U1Gm2cf9v28UF80RQjysEhkiVFzAzLU5zV6OVDynKc7Ran6ZrLaAPH1s4iwfHBJprtBAL/PmLq3MoVMQoYs9/3DKzvCYfu4xa+7SbRmJbSZMmI3UEfjzrTNLjs+M854Ew7zgR6nHDeYXjMmH/NKCvuMAAAAASUVORK5CYII=\"\n\t\t\t\t/>\n\t\t\t</svg>\n\n\t\t\t<svg class=\"share-arrow\" aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"share\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t viewBox=\"0 0 512 512\" class=\"svg-inline--fa fa-share fa-w-16 fa-2x\">\n\t\t\t\t<path fill=\"{{ $ctrl.color1 }}\" d=\"M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z\"\n\t\t\t\t class=\"\"></path>\n\t\t\t</svg>\n\t\t</div>\n\n\n\t\t<div class=\"share-container-layer\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n\n\t\t<!-- Date and user information -->\n\t\t<div class=\"date-user-info\">\n\t\t\t<div class=\"date-container\">\n\t\t\t\t<p>{{ $ctrl.data.date | date : \"d MMMM\" }}</p>\n\t\t\t</div>\n\t\t\t<div class=\"user-info-container\">\n\t\t\t\t<div class=\"avatar-container\">\n\t\t\t\t\t<img ng-src=\"{{$ctrl.data.owner.avatarUrl}}\" alt=\"user\">\n\t\t\t\t</div>\n\n\t\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"bottom-dots-grid\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"135\" height=\"67\">\n\t\t\t\t<defs>\n\t\t\t\t\t<style>\n\t\t\t\t\t\t.cls-1 {\n\t\t\t\t\t\t\tfilter: url(#filter);\n\t\t\t\t\t\t}\n\t\t\t\t\t</style>\n\t\t\t\t\t<filter id=\"filter\" filterUnits=\"userSpaceOnUse\">\n\t\t\t\t\t\t<feFlood result=\"flood\" flood-color=\"#ec7196\" />\n\t\t\t\t\t\t<feComposite result=\"composite\" operator=\"in\" in2=\"SourceGraphic\" />\n\t\t\t\t\t\t<feBlend result=\"blend\" in2=\"SourceGraphic\" />\n\t\t\t\t\t</filter>\n\t\t\t\t\t<image id=\"image\" width=\"67\" height=\"67\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAABDCAMAAADwFEhBAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAmVBMVEVdTyqAgIBdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTyoAAAB6ldg1AAAAMnRSTlMAAAkqMycGGzEYBykjDwstFTAgDCQhAxQrEQQiARcKHh0IFhkFMi8oExASAiUNLBofLnLLfA4AAAABYktHRDJA0kzIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUEDCsLOGLViwAAAiJJREFUWMPtmNFyqjAQhhGiDSJgAYEiWkSpKBX1/V/ubHJx9o/TaU87nhmnAxfMfLvJn5DJbjZYtiPGE4ufJyldwKknvCmwK+UT4GQsHNtyhBAzNvqEImAeE44ZA+X2mWeEjqWMIYyjeM78TPjMOFdumGeoWA8UsTFWRps5IUwYbeWOmSM9zUkSLlL4wix3XgCLZbgsgF+cPANMF2GCq/mzZzQaDRqDxn/XKFcRbl5r/VptAMs6qkvgTfVqY/MsWpU6arZsm0qK0x1zRe6KcUdxLCGfbHXENvTO2bhSgQkTeyN8g2GVe8WcEza60Z6NrWp0MBvBEAflbpn3eohjIyQkhI7yyTssgC+FhLxVvlO+6JhjKZojpcQT5gdKd4GBxVfuyePsj0HjN2ukprEsTe4+d6ekEfRmcVA1zRnQzkWOCePcNBUglRZ9oAMTDuXDzaG8N8M6vgnrRIe1MvZs/Gbt0P+tHS5s1EUKJMOZWeJsbkqci64ddsv+gqvaeh7M1SoW/QKD/+B5R1zRS7+EzPnD57H22KDxazV8N0ZbUWdGQjm5J8Q0q41zL3b9kXU2D+HiSmEMaacmd83YUaBeQUQd8WdL6tuD0UdAVJGkuDIehampbi7yK43QvJp8rLE1+xTUyYFvmZspqaNOYWFqUhUV12tz0VojCwe1USx0rbnk6zp+oP0xaAwan2h8cM/Gw/Cf7tn3uO/f47/DPf5/3OE/zB+EqiZjhF5o8AAAAABJRU5ErkJggg==\"\n\t\t\t\t\t/>\n\t\t\t\t</defs>\n\t\t\t\t<g class=\"cls-1\">\n\t\t\t\t\t<use data-name=\"Vector Smart Object copy 8\" xlink:href=\"#image\" />\n\t\t\t\t\t<use data-name=\"Vector Smart Object copy 9\" x=\"79\" xlink:href=\"#image\" />\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\"></div>\n\n\t</div>\n\n\t<div class=\"first\" ng-style=\"{'background-color': $ctrl.color1}\">\n\t\t<div class=\"caption\">\n\t\t\t<div class=\"text\">\n\t\t\t\t{{ $ctrl.data.caption | limitTo: $ctrl.limitForText }}\n\t\t\t\t<p ng-if=\"$ctrl.data.caption.length > $ctrl.limitForText\" class=\"read-more\">\n\t\t\t\t\t<span ng-click=\"$ctrl.readMore('web')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n\t\t\t\t</p>\n\n\t\t\t\t<p ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n\t\t\t\t\t<span ng-click=\"$ctrl.readLess('web')\">Less</span>\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n\t<div class=\"third\" ng-style=\"{'background-color': $ctrl.color3}\"></div>\n\n\t<mcactionbutton thumbs=\"$ctrl.data.thumbs\" id=\"$ctrl.data.id\"\n\turl=\"$ctrl.data.url\"></mcactionbutton>\n</div>\n\n<div class=\"card2-mobile visible-xs\">\n\t<div class=\"top\">\n\t\t<div class=\"left-side\">\n\t\t\t<div class=\"likes-container\" ng-style=\"{'background-color': $ctrl.color1}\">\n\t\t\t\t<svg class=\"around-heart\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"68\" height=\"73\">\n\t\t\t\t\t<image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"68\" height=\"73\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABdCAQAAACLUWkMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQIKSc/hXM2AAAERElEQVR42tXbXWjVdRzH8ffvD2vMmtto2VZjT0a2VlFIaE6nFwmCKNhFBFI3WV0Nggq6sQe6SUoQArsphIKQooueuykQpXKyHDO1WGtjRnts5VyzzbVPF2f/87An/7/z9D3nfbP/+R8Oe+233/Z/dmSYymilhWYaqeVWqqhkLS7+9hUmucIQIwzSRy/n3Hhm38+l+0HV8zBtbOFOAq8PDvM9P/ANZ918poMVlXqvXtN5ZdqY3tUuleSWWq4OdWdMTW5Uh3VHbrDVel1/ZxUbNq+P9UB2sWv0sqZygk30oZqyxd2tgRxjY13VwYzntMp1LC/YsC61ZMJt1S955UrSlB5Nl7sr5/N2pV6R//ZB+zVnxJWktz3J2q//DLm+ZD1izpWkQ1G5mzRtbV3omaW6JcOuGrq4Lc2/02x3jW3udOqqRXtacrxXMFwo4bjKVwXTwU5rZUqNHEldkTIlVM8FbrQ2LqndnUy8SB3hIwXIhaNKUiYtaiv7rG3Ldg+PJ14kTQmdZKu1bYUGWe/mYovxEdb2guVCPY+Fi4kp8YK1atWeDxcWpoSa6Ev/CDovbXKdkBjhAwXOhadiXxyAHP00WIuu01/UuNlwhB8qeC5UxbbBMfBea02kdkM4JX6i1VoToUuuHhyohiFrS8TWu98CYIe1I3LtsTm8xdoRuc0x8EZrR+Q2glPAFGXWkojNsiagoWi4cAPNAZmcy8p/LQHN1gavGgMarQ1eNQTUWRu8qguotjZ4dUtArbXBq3VBQR7Yr9xNQRH9FwYoCyi1NnhV6jRLbq9GZrdZJ1kb/PK7sF0AFSF42prg1UzANWuDV/8G/GNt8OpqsY3wTMCf1gavJgPGrA1ejQSMWhu8Gg8YtDZ4danYwAMBv1obvOp3RXQqEKDJgSaosnZEbJryAOiydkSu280XF7grtnt5ytoRue9iZ+ArmCiS/eJaNxyAu8wZa0mkLrrh8IjjM2tLpL6CEPyptSVSn0DiWnPhX/gaos7NJw5C37f2XLcPYreghyO8jt8L/ITK3e4ixEfYjfKRtWjVTsS4yecl3rQ2rdob4UIc7M7yhbVqxbr5Mu5MrNV9dBfobR573OfhYtIm2fVwzFq2bCcS3MV3BlbzMzdb+xY1x/3ufOJlyk6PG+dZa9+SDiVzl0nHrW8aTunHxQ9KLL1/eC2dbLAe1oUu86DrTV21ZD/YTbKPSWspAPM8sZi7QtquGeu5IKnD44fTXs0ac1/0/H1oj+mt+75cAG3WmAl2Tk+mOevVoDN5545oR5pcAJXqsObzyP1amT/joHZdyAt2Qk+n8dDUsuQSPafxnGJndVTZvXNDlXopR+gZvZOrB1nLdECdWcUO6KBqcoJNYt+lV9WTMXVQb2mbvE+Rpf/k+O3spI02Nniel+vnNKf4NjyozBs4Dg+fzW+ilhoqqaAi6e3LTDLJH4wyQB+99LgMd6z+ByoWJQSXjV26AAAAAElFTkSuQmCC\"\n\t\t\t\t\t/>\n\t\t\t\t\t<text fill=\"{{ $ctrl.color1 }}\" x=\"50%\" y=\"61px\" alignment-baseline=\"middle\" text-anchor=\"middle\">\n\t\t\t\t\t\t{{ $ctrl.data.likes }}\n\t\t\t\t\t</text>\n\t\t\t\t</svg>\n\t\t\t\t<svg class=\"heart\" aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"heart\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n\t\t\t\t class=\"svg-inline--fa fa-heart fa-w-16 fa-3x\">\n\t\t\t\t\t<path fill=\"{{ $ctrl.color1 }}\" d=\"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z\"\n\t\t\t\t\t class=\"\"></path>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"shares-container\" ng-style=\"{'background-color': $ctrl.color3}\">\n\t\t\t\t<div class=\"shares-inner\" ng-style=\"{'background-color': $ctrl.color2}\">\n\t\t\t\t\t<!-- Share icon -->\n\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"51\" height=\"53\" viewBox=\"0 0 51 53\">\n\t\t\t\t\t\t<image id=\"card2-share-outline\" data-name=\"Vector Smart Object\" width=\"51\" height=\"53\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA1CAQAAABG8Ru8AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQMDgfZJ0lHAAACeElEQVRYw83YS2gTQRzH8e+OAY1vxFZJ7KVWiq2WYDxZL/ZQiFWhpepBPHhQqoh6UgRRFjxI7z5uqQdBzcUqaiVH8VBqS+LjUHxQsdWaIKZSkj7EeFjH2Owm6yY7i7/T7A47HybZ+c+wWh6bCLYQIkw9dQTxswyAHDkm+cgYCYZJMlfqcR0AXxnAx2666GCtRZ8fP2to+n01TZx+YmRLDaWVmM0KTtHDBrupLsgUffTyyWo2wvJn6uEtlx0isIrTvEFnidWQxQkQ5zq1DgmZpVzkOVvtmFaStFVIyDQzxP5yTBtxyz/caRZzm8OlmBD9+F1AjHGjtFsxNTxguUsIwCJiNJiZa47fLLusJCrHl0wn3S4jADs5bjSM5enjFY0KGJikXs/J2RxShMB6joJkTipCAE5IpoXtCpnGSzsM5qBCBKDbYCKKmXbQ8jWkFDMQEGxTjkBYEPKAaRE0e8A0CdcrmVWCgqAHTEBUvB07Sa1wbSMrF7+Wtz0PuhFR/RD/FZOtfhDbzAhmPGBygi8eMCnBuAfMhGfMSw+Y14KkB0xCy6/mq/LVs06QYVD1XPSUAAYUM0+MYnNHMXPXYEZ5qhBJ6COydF5VyNwAycRIKELGiBaYn5xXxFzQ5woMDHBTAfKIW0ajsDDP8M5lJM0x2SwwGTr45iIySycTZgZGifDdJWSeAzwrXC6sZoPsKv60U1Gm2cf9v28UF80RQjysEhkiVFzAzLU5zV6OVDynKc7Ran6ZrLaAPH1s4iwfHBJprtBAL/PmLq3MoVMQoYs9/3DKzvCYfu4xa+7SbRmJbSZMmI3UEfjzrTNLjs+M854Ew7zgR6nHDeYXjMmH/NKCvuMAAAAASUVORK5CYII=\"\n\t\t\t\t\t\t/>\n\t\t\t\t\t</svg>\n\n\t\t\t\t\t<svg class=\"share-arrow\" aria-hidden=\"true\" data-prefix=\"fas\" data-icon=\"share\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t viewBox=\"0 0 512 512\" class=\"svg-inline--fa fa-share fa-w-16 fa-2x\">\n\t\t\t\t\t\t<path fill=\"{{ $ctrl.color1 }}\" d=\"M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z\"\n\t\t\t\t\t\t class=\"\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</div>\n\n\t\t\t\t<svg class=\"dots-grid\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"90\" height=\"80\"\n\t\t\t\t >\n\t\t\t\t\t<image id=\"card2-share-dots-grid\" data-name=\"Vector Smart Object\" width=\"90\" height=\"80\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t\t\t/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\"></div>\n\t</div>\n\t<div class=\"date-n-user\">\n\t\t<div class=\"date\">{{ $ctrl.data.date | date : \"d MMMM\" }}</div>\n\t\t<mcactionbutton photoUrl=\"$ctrl.data.photoUrl\" id=\"$ctrl.data.id\" thumbs=\"$ctrl.data.thumbs\" url=\"$ctrl.data.url\"></mcactionbutton>\n\t\t<div class=\"user-info\">\n\t\t\t<img ng-src=\"{{ $ctrl.data.owner.avatarUrl }}\" alt=\"user\">\n\t\t\t<span>{{ $ctrl.data.owner.username }}</span>\n\t\t</div>\n\t</div>\n\t<div class=\"first\" ng-style=\"{'background-color': $ctrl.color1}\">\n\t\t<p>\n\t\t\t{{ $ctrl.data.caption | limitTo: $ctrl.limitForTextMobile }}\n\t\t\t<span ng-if=\"$ctrl.data.caption.length > $ctrl.limitForTextMobile\" class=\"read-more\">\n\t\t\t\t<span ng-click=\"$ctrl.readMore('mobile')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n\t\t\t</span>\n\n\t\t\t<span ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n\t\t\t\t<span ng-click=\"$ctrl.readLess('mobile')\">Less</span>\n\t\t\t</span>\n\t\t</p>\n\t</div>\n\t<div class=\"second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n\t<div class=\"third\" ng-style=\"{'background-color': $ctrl.color3}\"></div>\n</div>\n"

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card2Controller = function () {
	    function Card2Controller(Colors) {
	        (0, _classCallCheck3.default)(this, Card2Controller);
	
	        this.name = 'card2';
	        this.limitDefaultValue = 160;
	        this.limitDefaultValueMobile = 250;
	        this.Color = Colors;
	    }
	
	    (0, _createClass3.default)(Card2Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.setColor();
	
	            // this.data.owner.avatarUrl = this.data.owner.avatarUrl || '/assets/images/user.jpg'
	
	            this.limitForText = this.limitDefaultValue;
	            this.limitForTextMobile = this.limitDefaultValueMobile;
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors(this.data.cardType, this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	        }
	    }, {
	        key: 'readMore',
	        value: function readMore(type) {
	            if (type === 'web') {
	                this.limitForText = this.data.caption.length;
	                this.readMoreMode = true;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.data.caption.length;
	                this.readMoreMode = true;
	            }
	        }
	    }, {
	        key: 'readLess',
	        value: function readLess(type) {
	            if (type === 'web') {
	                this.limitForText = this.limitDefaultValue;
	                this.readMoreMode = false;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.limitDefaultValueMobile;
	                this.readMoreMode = false;
	            }
	        }
	    }]);
	    return Card2Controller;
	}();
	
	Card2Controller.$inject = ['Color'];
	
	exports.default = Card2Controller;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(597);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card2.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card2{position:relative;width:396px;height:auto;padding-bottom:50px;cursor:pointer}.card2:hover .action-buttons-container{display:block;animation:action-button-animation .25s 1}@keyframes action-button-animation{0%{opacity:0}to{opacity:1}}.card2 .top-of-card{height:216px}.card2 .like-container{width:140px;height:140px;position:absolute;z-index:3;box-shadow:-7px -7px 10px #f0f0f0}.card2 .like-container .around-heart{position:relative;left:25px;z-index:1;margin-top:calc(50% - 46.5px)}.card2 .like-container .around-heart text{font-family:Graphik-Black;font-size:12px}.card2 .like-container .heart{position:relative;top:-35px;z-index:2;right:44px;width:43px}.card2 .share-icon-container{position:absolute;top:160px;left:25px;z-index:10}.card2 .share-icon-container text{font-size:9px;font-family:Graphik-Black}.card2 .share-icon-container #card2-share-arrow{transform:translate(20px,9px)}.card2 .share-icon-container .share-arrow{position:absolute;width:15px;transform:rotate(145deg);top:19px;left:18px}.card2 .share-container{opacity:.851;position:absolute;width:140px;height:95px;z-index:1;top:140px}.card2 .share-container .dots-grid{margin-left:38px;margin-top:2.5px}.card2 .date-user-info{position:absolute;top:235px;z-index:6;box-shadow:-7px 7px 10px #f0f0f0}.card2 .date-container{background-color:#fff;width:140px;height:44px}.card2 .date-container p{font-size:11px;font-family:Graphik-Black;color:#79838d;line-height:44px;text-align:center}.card2 .user-info-container{background-color:#f7f7f7;width:140px;height:85px;z-index:1;padding-top:5px}.card2 .user-info-container .avatar-container{margin-left:calc(50% - 26.5px)}.card2 .user-info-container .avatar-container img{border-radius:50%;width:53px;height:53px}.card2 .user-info-container p{font-size:12px;font-family:Graphik;color:#000;text-align:center;padding-top:8px}.card2 .share-container-layer{position:absolute;width:100px;height:95px;opacity:.8;z-index:2;top:140px;box-shadow:-7px -12px 10px #f0f0f0}.card2 .photo-container{position:absolute;left:140px;width:256px;height:216px;background-color:#646464;background:url(/assets/images/example_photo.jpg) no-repeat 50%;background-size:cover;box-shadow:3px -7px 10px #f0f0f0}.card2 .first{width:191px;min-height:180px;height:auto;top:216px;margin-left:140px;z-index:6;box-shadow:7px 7px 10px #f0f0f0}.card2 .first .caption{max-height:100%;overflow-y:auto;word-wrap:break-word;transition:height .5s}.card2 .first .caption .text{font-size:13px;font-family:Graphik-Regular;color:#fff;line-height:20px;padding:15px}.card2 .first .caption .text p span{font-size:11px;cursor:pointer;font-family:Graphik-Bold}.card2 .second{opacity:.659;width:38px;height:160px;left:331px;z-index:6}.card2 .second,.card2 .third{position:absolute;top:216px;box-shadow:7px 7px 10px #f0f0f0}.card2 .third{opacity:.349;width:27px;height:119px;left:369px;z-index:7}.card2 .bottom-dots-grid{position:absolute;top:345px;z-index:5;left:3px}", ""]);
	
	// exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(599);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card2.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card2.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card2-mobile{max-width:350px;width:80vw;overflow:auto;padding:15px 10px}.card2-mobile .top{width:100%;overflow:auto}.card2-mobile .top .photo-container{width:60%}.card2-mobile .top .left-side{float:left;width:40%}.card2-mobile .top .left-side .likes-container,.card2-mobile .top .left-side .shares-container{width:100%;height:90px}.card2-mobile .top .left-side .likes-container{position:relative;display:flex;align-items:center;justify-content:center}.card2-mobile .top .left-side .likes-container .around-heart text{font-size:11px;font-family:Graphik-Bold}.card2-mobile .top .left-side .likes-container .heart{width:40px;position:absolute;top:20px}.card2-mobile .top .left-side .shares-container{position:relative;z-index:1}.card2-mobile .top .left-side .shares-container .dots-grid{position:absolute;right:0;margin-top:5px}.card2-mobile .top .left-side .shares-container .shares-inner{position:absolute;width:78%;height:100%;z-index:2;display:flex;align-items:center;justify-content:center}.card2-mobile .top .left-side .shares-container .shares-inner .share-arrow{position:absolute;width:21px;transform:rotate(140deg);top:35px}.card2-mobile .top .left-side .shares-container .shares-inner text{font-size:11px;font-family:Graphik-Bold}.card2-mobile .top .photo-container{height:180px;float:right}.card2-mobile .date-n-user{position:relative;box-shadow:-7px -7px 10px #f0f0f0,-7px 0 10px #f0f0f0,7px -6px 10px #f0f0f0}.card2-mobile .date-n-user .date{background-color:#fff;height:35px;line-height:35px;font-size:11px;padding-left:10px;font-family:Graphik-Bold;color:#79838d}.card2-mobile .date-n-user .user-info{background-color:#f7f7f7;height:50px;font-size:14px;font-family:Graphik-Bold;line-height:50px;position:relative}.card2-mobile .date-n-user .user-info img{border-radius:17px;width:35px;position:absolute;top:8px;left:8px}.card2-mobile .date-n-user .user-info span{margin-left:53px}.card2-mobile .first,.card2-mobile .second,.card2-mobile .third{float:left}.card2-mobile .first{width:calc(100% - 40px);height:auto;min-height:120px}.card2-mobile .first p{display:block;margin-top:10px;width:calc(100% - 52px);padding-bottom:12px;margin-left:42px;font-size:12px;font-family:Graphik-Regular;color:#fff;word-wrap:break-word}.card2-mobile .first p>span{display:block;font-family:Graphik-Bold;margin-top:3px}.card2-mobile .second,.card2-mobile .third{width:20px;height:30px}.card2-mobile .second{height:100px}.card2-mobile .third{height:80px}", ""]);
	
	// exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(601);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card3Module = _angular2.default.module('card3', [_angularUiRouter2.default]).component('card3', _card2.default).name;
	
	exports.default = card3Module;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _card = __webpack_require__(602);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(603);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(604);
	
	__webpack_require__(606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card3Component = {
		bindings: {
			'data': '='
		},
		template: _card2.default,
		controller: _card4.default
	};
	
	exports.default = card3Component;

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card3 hidden-xs\">\n    <div class=\"text-container\">\n        <div class=\"caption\">\n            {{ $ctrl.data.caption | limitTo: $ctrl.limitForText }}\n            <p ng-if=\"$ctrl.data.caption.length > $ctrl.limitForText\" class=\"read-more\">\n                <span ng-click=\"$ctrl.readMore('web')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n            </p>\n\n            <p ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n                <span ng-click=\"$ctrl.readLess('web')\">Less</span>\n            </p>\n        </div>\n    </div>\n\n    <div class=\"below-text\">\n        <div class=\"left-first\" ng-style=\"{'background-color': $ctrl.color3}\"></div>\n        <div class=\"left-second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n        <div class=\"left-third\" ng-style=\"{'background-color': $ctrl.color1}\"></div>\n\n        <div class=\"photo-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"137\" height=\"137\" viewBox=\"0 0 137 137\">\n                <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"137\" height=\"137\" xlink:href=\"data:img/png;base64,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\"\n                />\n            </svg>\n        </div>\n\n        <div class=\"comment-container\" ng-style=\"{'background-color': $ctrl.color1}\">\n            <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"comment-alt-lines\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n                class=\"svg-inline--fa fa-comment-alt-lines fa-w-16 fa-2x\">\n                <path fill=\"#fff\" d=\"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM280 240H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z\"\n                    class=\"\"></path>\n            </svg>\n        </div>\n\n        <!-- Date and user information -->\n        <div class=\"date-user-info\">\n            <div class=\"date-container\">\n                <p>{{ $ctrl.data.date | date : \"d MMMM\" }}</p>\n            </div>\n            <div class=\"user-info-container\">\n                <div class=\"avatar-container\">\n                    <img ng-src=\"{{ $ctrl.data.owner.avatarUrl }}\" alt=\"user\">\n                </div>\n\n                <p>{{ $ctrl.data.owner.username }}</p>\n            </div>\n        </div>\n\n        <div class=\"bottom-center\">\n\n            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"135\" height=\"61\" viewBox=\"0 0 131 61\">\n                <defs>\n                    <image id=\"imageCard3\" width=\"61\" height=\"61\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAMAAAApvJHbAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAjVBMVEVdTyqAgIBdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTyoAAACpMIsBAAAALnRSTlMAAA4tMR4JKjIjAgUnMxAlFhQbHy8XCgEGDRUIEQsoBCEpGR0MIhMrHCQPAxogN+l0/gAAAAFiS0dELlTTEIcAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQNAxdw/E1ZAAABgUlEQVRIx+2X646CMBCFR65FLYIV0LJeEO/i+7/eDpvdmVYTN4ZkE7P0B8kHPdCm55QpOK7nA7UgFNGQaDQW4xHRMBJhAIOf5nuuA66UMqYeE6SEyEfiVydIE1LHSC54eE2pR4g0JYqQIqIpUkjqFMkDJeWMR5dJKXKi2BpXLqTMSD2aSamgiNM5zxsWujQo17lBpV4Az3uexgW82gZm69X/TP3eGeOY2Bn7eJKx+XfGtJkxJzEztkyWBpWJY2ZM9xnr1S+py2il+dl6U22ZhvWq5sTBttqsWa1XUQkVenlHHfZIB6KplZkD0p7UO6QK0PqSP35EOhGdkc5EJ6QjqTWSaBMtAupR470LUWKl/YJUkzoQbdqvjeKBQ5HdOJIA6S01KL5lBc97p5rrG693r/579bXxLa8py2vK8pqyvOaj11qf8w+g9blDZPvcsXxefvm8W8a65fthb2mY7vaW5nFved/17tV/r76rmV44l7Q107N67fczUbdasVud2qlG/gTxiigv9fq+HAAAAABJRU5ErkJggg==\"\n                    />\n                </defs>\n                <use data-name=\"Vector Smart Object\" xlink:href=\"#imageCard3\" />\n                <use data-name=\"Vector Smart Object copy 7\" x=\"71\" xlink:href=\"#imageCard3\" />\n            </svg>\n\n        </div>\n\n        <div class=\"bottom-right\" ng-style=\"{'background-color': $ctrl.color1}\"></div>\n    </div>\n\n    <mcactionbutton id=\"$ctrl.data.id\" thumbs=\"$ctrl.data.thumbs\" url=\"$ctrl.data.url\"></mcactionbutton>\n</div>\n\n<div class=\"card3-mobile visible-xs\">\n    <div class=\"text-container\">\n        {{ $ctrl.data.caption | limitTo: $ctrl.limitForTextMobile }}\n        <p ng-if=\"$ctrl.data.caption.length > $ctrl.limitForTextMobile\" class=\"read-more\">\n            <span ng-click=\"$ctrl.readMore('mobile')\" ng-if=\"!$ctrl.readMoreMode\">Read more</span>\n        </p>\n\n        <p ng-if=\"$ctrl.readMoreMode\" class=\"read-less\">\n            <span ng-click=\"$ctrl.readLess('mobile')\">Less</span>\n        </p>\n    </div>\n    <div class=\"first\" ng-style=\"{'background-color': $ctrl.color1}\"></div>\n    <div class=\"second\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n    <div class=\"date-n-user\">\n        <div class=\"date\">{{ $ctrl.data.date | date : \"d MMMM\" }}</div>\n        <mcactionbutton photoUrl=\"$ctrl.data.photoUrl\" id=\"$ctrl.data.id\" thumbs=\"$ctrl.data.thumbs\" url=\"$ctrl.data.url\"></mcactionbutton>\n        <div class=\"user-info\">\n            <img ng-src=\"{{ $ctrl.data.owner.avatarUrl }}\" alt=\"user\">\n            <span>{{ $ctrl.data.owner.username }}</span>\n        </div>\n    </div>\n    <div class=\"photo-container\">\n        <div class=\"photo\" ng-style=\"{ 'background': 'url({{ $ctrl.data.photoUrl }}) no-repeat center/cover' }\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"170\" height=\"170\">\n                <image data-name=\"card3 mobile grid\" width=\"170\" height=\"170\" xlink:href=\"data:img/png;base64,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\"\n                />\n            </svg>\n            <div class=\"transparent-layer\" ng-style=\"{'background-color': $ctrl.color2}\"></div>\n        </div>\n        <div class=\"comment-container\" ng-style=\"{'background-color': $ctrl.color2}\">\n            <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"comment-alt-lines\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"\n                class=\"svg-inline--fa fa-comment-alt-lines fa-w-16 fa-2x\">\n                <path fill=\"#fff\" d=\"M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM280 240H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z\"\n                    class=\"\"></path>\n            </svg>\n        </div>\n    </div>\n    <div class=\"card-footer\">\n        <div class=\"grid-container\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"180\" height=\"45\">\n                <defs>\n                    <image id=\"image-mobile\" width=\"45\" height=\"45\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAMAAAApvJHbAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAjVBMVEVdTyqAgIBdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTypdTyoAAACpMIsBAAAALnRSTlMAAA4tMR4JKjIjAgUnMxAlFhQbHy8XCgEGDRUIEQsoBCEpGR0MIhMrHCQPAxogN+l0/gAAAAFiS0dELlTTEIcAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBQQNAxdw/E1ZAAABgUlEQVRIx+2X646CMBCFR65FLYIV0LJeEO/i+7/eDpvdmVYTN4ZkE7P0B8kHPdCm55QpOK7nA7UgFNGQaDQW4xHRMBJhAIOf5nuuA66UMqYeE6SEyEfiVydIE1LHSC54eE2pR4g0JYqQIqIpUkjqFMkDJeWMR5dJKXKi2BpXLqTMSD2aSamgiNM5zxsWujQo17lBpV4Az3uexgW82gZm69X/TP3eGeOY2Bn7eJKx+XfGtJkxJzEztkyWBpWJY2ZM9xnr1S+py2il+dl6U22ZhvWq5sTBttqsWa1XUQkVenlHHfZIB6KplZkD0p7UO6QK0PqSP35EOhGdkc5EJ6QjqTWSaBMtAupR470LUWKl/YJUkzoQbdqvjeKBQ5HdOJIA6S01KL5lBc97p5rrG693r/579bXxLa8py2vK8pqyvOaj11qf8w+g9blDZPvcsXxefvm8W8a65fthb2mY7vaW5nFved/17tV/r76rmV44l7Q107N67fczUbdasVud2qlG/gTxiigv9fq+HAAAAABJRU5ErkJggg==\"></image>\n                </defs>\n                <use xlink:href=\"#image-mobile\"></use>\n                <use x=\"53\" xlink:href=\"#image-mobile\"></use>\n                <use x=\"105\" xlink:href=\"#image-mobile\"></use>\n                <use x=\"157\" xlink:href=\"#image-mobile\"></use>\n            </svg>\n        </div>\n        <div class=\"right-block\" ng-style=\"{'background-color': $ctrl.color1}\"></div>\n    </div>\n</div>\n"

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card3Controller = function () {
	    function Card3Controller(Colors) {
	        (0, _classCallCheck3.default)(this, Card3Controller);
	
	        this.name = 'card3';
	        this.limitDefaultValue = 200;
	        this.limitDefaultValueMobile = 150;
	        this.Color = Colors;
	    }
	
	    (0, _createClass3.default)(Card3Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.setColor();
	
	            // this.data.owner.avatarUrl = this.data.owner.avatarUrl |s| '/assets/images/user.jpg'
	
	            this.limitForText = this.limitDefaultValue;
	            this.limitForTextMobile = this.limitDefaultValueMobile;
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors(this.data.cardType, this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	        }
	    }, {
	        key: 'readMore',
	        value: function readMore(type) {
	            if (type === 'web') {
	                this.limitForText = this.data.caption.length;
	                this.readMoreMode = true;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.data.caption.length;
	                this.readMoreMode = true;
	            }
	        }
	    }, {
	        key: 'readLess',
	        value: function readLess(type) {
	            if (type === 'web') {
	                this.limitForText = this.limitDefaultValue;
	                this.readMoreMode = false;
	            } else if (type === 'mobile') {
	                this.limitForTextMobile = this.limitDefaultValueMobile;
	                this.readMoreMode = false;
	            }
	        }
	    }]);
	    return Card3Controller;
	}();
	
	Card3Controller.$inject = ['Color'];
	
	exports.default = Card3Controller;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(605);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card3.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card3{position:relative;width:386px;height:auto;padding-bottom:50px;cursor:pointer}.card3:hover .action-buttons-container{display:block;animation:action-button-animation .25s 1}@keyframes action-button-animation{0%{opacity:0}to{opacity:1}}.card3 .text-container{background-color:#f4f6f6;width:386px;height:auto;padding:1px 0;top:0;left:0;box-shadow:-7px -7px 10px #f0f0f0,-7px 0 10px #f0f0f0}.card3 .text-container .caption{font-size:13px;font-family:Graphik-Regular;line-height:23px;margin:25px;width:280px;color:#79838d;height:auto;overflow-y:auto;word-wrap:break-word}.card3 .text-container .caption p span{font-size:11px;cursor:pointer;font-family:Graphik-Bold}.card3 .below-text{clear:both;position:relative;height:210px}.card3 .below-text .left-first{opacity:.102;position:absolute;width:305px;box-shadow:-7px 4px 10px #999;height:140px}.card3 .below-text .left-second{position:absolute;width:155px;height:140px;left:32px}.card3 .below-text .left-third{position:absolute;width:198px;height:140px;left:82px}.card3 .below-text .photo-container{background-color:#d1d1d1;position:absolute;width:140px;height:140px;z-index:4;left:140px;background:url(/assets/images/example_photo.jpg) no-repeat 50%;background-size:cover}.card3 .below-text .comment-container{opacity:.58;position:absolute;left:256px;width:130px;height:140px;display:flex;z-index:5;box-shadow:8px 6px 10px #f0f0f0;align-items:center}.card3 .below-text .comment-container svg{padding-left:63px;height:42px}.card3 .below-text .date-user-info{position:absolute;top:68px;box-shadow:-7px 7px 10px #f0f0f0;height:133px;width:140px;left:0;background-color:#fff}.card3 .below-text .date-container{background-color:#fff;width:140px;height:44px}.card3 .below-text .date-container p{font-size:11px;font-family:Graphik-Black;color:#79838d;line-height:44px;text-align:center}.card3 .below-text .user-info-container{background-color:#f7f7f7;width:140px;height:85px;z-index:1;padding-top:5px}.card3 .below-text .user-info-container .avatar-container{margin-left:calc(50% - 26.5px)}.card3 .below-text .user-info-container .avatar-container img{border-radius:50%;width:53px;height:53px}.card3 .below-text .user-info-container p{font-size:12px;font-family:Graphik;color:#000;text-align:center;padding-top:8px}.card3 .below-text .bottom-right{position:absolute;width:106px;left:280px;height:60px;box-shadow:7px 7px 10px #f0f0f0;z-index:5;top:140px}.card3 .below-text .bottom-center{position:absolute;left:139px;top:140px;background:url(/assets/images/card3_grid.svg);width:140px;height:66px;display:flex;justify-content:center;align-items:center}.card3 .below-text .bottom-center svg{margin-top:7px}", ""]);
	
	// exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(607);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card3.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./card3.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card3-mobile{max-width:350px;width:80vw;padding:15px 10px}.card3-mobile .text-container{height:auto;min-height:30px;background-color:#f4f6f6;font-size:12px;font-family:Graphik-Regular;word-break:break-word;padding:15px;color:#79838d;box-shadow:-7px -7px 10px #f0f0f0,7px -7px 10px #f0f0f0,8px 49px 10px #f0f0f0,-8px 45px 10px #f0f0f0}.card3-mobile .text-container p span{font-size:11px;cursor:pointer;font-family:Graphik-Bold}.card3-mobile .first,.card3-mobile .second{height:25px;position:relative;z-index:1}.card3-mobile .date-n-user{position:relative;box-shadow:-7px -7px 10px #f0f0f0,-7px 0 10px #f0f0f0,7px -6px 10px #f0f0f0}.card3-mobile .date-n-user .date{background-color:#fff;height:35px;line-height:35px;font-size:11px;padding-left:10px;font-family:Graphik-Bold;color:#79838d}.card3-mobile .date-n-user .user-info{background-color:#f7f7f7;height:50px;font-size:14px;font-family:Graphik-Bold;line-height:50px;position:relative}.card3-mobile .date-n-user .user-info img{border-radius:17px;width:35px;position:absolute;top:8px;left:8px}.card3-mobile .date-n-user .user-info span{margin-left:53px}.card3-mobile .card-footer,.card3-mobile .photo-container{display:flex}.card3-mobile .card-footer>div,.card3-mobile .photo-container>div{display:inline-block;width:50%;height:130px}.card3-mobile .card-footer .comment-container,.card3-mobile .photo-container .comment-container{display:flex;justify-content:center;align-content:center;z-index:2;box-shadow:7px -4px 10px #f0f0f0,7px 60px 10px #f0f0f0}.card3-mobile .card-footer .comment-container svg,.card3-mobile .photo-container .comment-container svg{width:55px}.card3-mobile .card-footer .photo,.card3-mobile .photo-container .photo{box-shadow:-7px 7px 10px #f0f0f0;position:relative}.card3-mobile .card-footer .photo svg,.card3-mobile .photo-container .photo svg{margin:3px}.card3-mobile .card-footer .photo .transparent-layer,.card3-mobile .photo-container .photo .transparent-layer{position:absolute;right:0;top:0;height:100%;width:27px;opacity:.7}.card3-mobile .card-footer>div{height:50px}.card3-mobile .card-footer .grid-container svg{margin-top:3px;margin-left:2px}.card3-mobile .card-footer .right-block{z-index:3}", ""]);
	
	// exports


/***/ }),
/* 608 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function SharedMomentsFactory($http, config) {
	    var baseUrl = config.baseUrl;
	
	
	    var posts = [];
	
	    var addPosts = function addPosts(newPosts) {
	        posts = posts.concat(newPosts);
	
	        posts = posts.filter(function (obj, index, self) {
	            return self.findIndex(function (item) {
	                return item.id === obj.id;
	            }) === index;
	        });
	    };
	
	    var unshiftPost = function unshiftPost(newPost) {
	        if (posts.findIndex(function (item) {
	            return item.id === newPost.id;
	        })) {
	            posts.unshift(newPost);
	        }
	    };
	
	    var setPosts = function setPosts(newPosts) {
	        posts = newPosts;
	    };
	
	    var getLoadedPosts = function getLoadedPosts() {
	        return posts;
	    };
	
	    var getPost = function getPost(postId) {
	        return $http.get(baseUrl + '/api/posts/' + postId);
	    };
	
	    var getPosts = function getPosts() {
	        var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var urls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	        return $http.post(baseUrl + '/api/posts', {
	            categories: categories,
	            urls: urls
	        });
	    };
	
	    var searchPosts = function searchPosts(word, urls, postId) {
	        var searchWord = encodeURIComponent(word);
	
	        return $http.post(baseUrl + '/api/posts/search?text=' + searchWord, {
	            urls: urls,
	            postId: postId
	        });
	    };
	
	    var checkContributor = function checkContributor(username) {
	        return $http.get(baseUrl + '/api/posts/contributor/' + username);
	    };
	
	    var thumbPost = function thumbPost(url, type) {
	        return $http.put(baseUrl + '/api/posts/thumb', {
	            url: url,
	            type: type
	        });
	    };
	
	    var getCertificate = function getCertificate(username) {
	        return $http.get(baseUrl + '/api/certificates/' + username);
	    };
	
	    return {
	        addPosts: addPosts,
	        unshiftPost: unshiftPost,
	        setPosts: setPosts,
	        getLoadedPosts: getLoadedPosts,
	        getPost: getPost,
	        getPosts: getPosts,
	        searchPosts: searchPosts,
	        checkContributor: checkContributor,
	        thumbPost: thumbPost,
	        getCertificate: getCertificate
	    };
	}
	
	SharedMomentsFactory.$inject = ['$http', 'config'];
	
	exports.default = SharedMomentsFactory;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _contributor = __webpack_require__(610);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	var _step = __webpack_require__(615);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(624);
	
	var _step4 = _interopRequireDefault(_step3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contributorModule = _angular2.default.module('contributor', [_angularUiRouter2.default, _step2.default, _step4.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('home.contributor', {
			abstract: 'true',
			url: '/contributor',
			component: 'contributor'
		});
	}]).component('contributor', _contributor2.default).name;
	
	exports.default = contributorModule;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contributor = __webpack_require__(611);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	var _contributor3 = __webpack_require__(612);
	
	var _contributor4 = _interopRequireDefault(_contributor3);
	
	__webpack_require__(613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contributorComponent = {
	  bindings: {},
	  template: _contributor2.default,
	  controller: _contributor4.default
	};
	
	exports.default = contributorComponent;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"contributor\">\n\t<ui-view></ui-view>\n</div>"

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContributorController = function () {
	    function ContributorController($state) {
	        (0, _classCallCheck3.default)(this, ContributorController);
	
	        this.name = 'contributor';
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(ContributorController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var scope = this;
	
	            $('.contributor').mouseup(function (e) {
	                var step1 = $('.contributor .step1');
	                var mobileStep1 = $('.contributor .contributor-mobile-step1');
	                var step2 = $('.contributor .step2');
	                var mobileStep2 = $('.contributor .contributor-mobile-step2');
	
	                // if the target of the click isn't the container nor a descendant of the container
	                if (!step1.is(e.target) && step1.has(e.target).length === 0 && !mobileStep1.is(e.target) && mobileStep1.has(e.target).length === 0 && !step2.is(e.target) && step2.has(e.target).length === 0 && !mobileStep2.is(e.target) && mobileStep2.has(e.target).length === 0) {
	                    scope.goHome();
	                }
	            });
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('home');
	        }
	    }]);
	    return ContributorController;
	}();
	
	ContributorController.$inject = ['$state'];
	
	exports.default = ContributorController;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(614);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./contributor.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./contributor.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".contributor{width:100vw;height:100vh;background-color:hsla(0,0%,93%,.8);z-index:11;position:fixed}", ""]);
	
	// exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _step = __webpack_require__(616);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step1Module = _angular2.default.module('step1', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('home.contributor.step1', {
			url: '/step-1',
			component: 'step1'
		});
	}]).component('step1', _step2.default).name;
	
	exports.default = step1Module;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _step = __webpack_require__(617);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(618);
	
	var _step4 = _interopRequireDefault(_step3);
	
	__webpack_require__(620);
	
	__webpack_require__(622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step1Component = {
	    bindings: {},
	    template: _step2.default,
	    controller: _step4.default
	};
	
	exports.default = step1Component;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"step1 hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n\n    <img class=\"top-grid\" src=\"/assets/images/popup-grid-top.svg\" alt=\"top-grid\">\n    <img class=\"bottom-grid\" src=\"/assets/images/popup-grid-bottom.svg\" alt=\"bottom-grid\">\n\n    <p class=\"header\">{{$ctrl.beenInGeorgia}}</p>\n\n    <p class=\"subheader\">{{$ctrl.postsAnalyzed}}</p>\n\n    <form>\n        <div class=\"dropdown-with-input\">\n            <input type=\"text\" placeholder=\"{{$ctrl.usernamePlaceholder}}\" spellcheck=\"false\" ng-model=\"$ctrl.username\">\n        </div>\n        <button class=\"check\" ng-click=\"$ctrl.checkUsername()\" ng-disabled=\"!$ctrl.username\">{{$ctrl.check}}</button>\n    </form>\n\n    <p class=\"addional-info\" ng-if=\"!$ctrl.notFound && !$ctrl.error\">{{$ctrl.bearInMind}}</p>\n    <p class=\"error-info\" ng-if=\"$ctrl.notFound\">\n        {{$ctrl.notFoundText}}\n    </p>\n    <p class=\"error-info\" ng-if=\"$ctrl.error\">\n        {{ $ctrl.error }}\n    </p>\n\n    <p class=\"close\">\n        <span ui-sref=\"home\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\">\n                <defs>\n                    <style>\n                        .cls-1 {\n                            opacity: 0.5;\n                        }\n                    </style>\n                </defs>\n                <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" class=\"cls-1\" width=\"10\" height=\"10\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAFVBMVEWAgICRmamRmamRmamRmamRmakAAACNIiJvAAAABnRSTlMAcl0FgF8ST3WEAAAAAWJLR0QGYWa4fQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFDg4eKFQNUkUAAAAvSURBVAjXYxAyYGBWZFAJZjB1YjB1NQ4JZmAOCXU1YGAwdQlmgJIQEYgsRCVYFwARsQkr1LoXEQAAAABJRU5ErkJggg==\"\n                />\n            </svg>\n            {{$ctrl.closeText}}\n        </span>\n    </p>\n</div>\n\n<div class=\"contributor-mobile-step1 visible-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <navbar></navbar>\n    <main>\n        <p class=\"title\">\n            {{$ctrl.beenInGeorgia}}\n        </p>\n        <p class=\"subtitle\">\n            {{$ctrl.postsAnalyzed}}\n        </p>\n\n        <div class=\"username\">\n            <input type=\"text\" placeholder=\"{{$ctrl.usernamePlaceholder}}\" spellcheck=\"false\" ng-keyup=\"$event.key == 'Enter' && $ctrl.checkUsername()\"\n                ng-model=\"$ctrl.username\">\n        </div>\n        <div class=\"check\">\n            <button ng-click=\"$ctrl.checkUsername()\" ng-disabled=\"!$ctrl.username\">{{$ctrl.check}}</button>\n        </div>\n        <div class=\"error-info\" ng-if=\"$ctrl.notFound\">\n            {{$ctrl.notFoundText}}\n        </div>\n    </main>\n    <footer></footer>\n</div>\n"

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _contributor = __webpack_require__(619);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step1Controller = function () {
	    function Step1Controller($scope, $state, SharedMoments) {
	        (0, _classCallCheck3.default)(this, Step1Controller);
	
	        this.name = 'step1';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.SharedMoments = SharedMoments;
	    }
	
	    (0, _createClass3.default)(Step1Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _contributor2.default[this.language],
	                BEEN_IN_GEORGIA = _texts$language.BEEN_IN_GEORGIA,
	                POSTS_ANALYZED = _texts$language.POSTS_ANALYZED,
	                USERNAME_PLACEHOLDER = _texts$language.USERNAME_PLACEHOLDER,
	                CHECK = _texts$language.CHECK,
	                BEAR_IN_MIND = _texts$language.BEAR_IN_MIND,
	                NOT_FOUND = _texts$language.NOT_FOUND,
	                CLOSE = _texts$language.CLOSE;
	
	
	            this.beenInGeorgia = BEEN_IN_GEORGIA;
	            this.postsAnalyzed = POSTS_ANALYZED;
	            this.usernamePlaceholder = USERNAME_PLACEHOLDER;
	            this.check = CHECK;
	            this.bearInMind = BEAR_IN_MIND;
	            this.notFoundText = NOT_FOUND;
	            this.closeText = CLOSE;
	        }
	    }, {
	        key: 'checkUsername',
	        value: function checkUsername() {
	            var _this = this;
	
	            this.notFound = false;
	            this.error = null;
	
	            if (!this.username) {
	                return;
	            }
	
	            this.SharedMoments.checkContributor(this.username).then(function (response) {
	                var contributor = response.data.contributor;
	
	
	                if (contributor) {
	                    _this.$state.go('home.contributor.step2', {
	                        username: _this.username
	                    });
	                } else {
	                    _this.notFound = true;
	                }
	            }).catch(function (err) {
	                console.log('Error occured in method checkContributor', err);
	
	                _this.error = err.data;
	            });
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this2.render();
	                }
	            });
	        }
	    }]);
	    return Step1Controller;
	}();
	
	Step1Controller.$inject = ['$scope', '$state', 'SharedMoments'];
	
	exports.default = Step1Controller;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        BEEN_IN_GEORGIA: 'გიმოგზაურიათ საქართველოში?',
	        POSTS_ANALYZED: 'შეამოწმეთ, თუ გაანალიზდა თქვენი პოსტები',
	        USERNAME_PLACEHOLDER: 'ინსტაგრამის, facebook-ის ან ტვიტერის მომხმარებელი',
	        CHECK: 'შეამოწმე',
	        BEAR_IN_MIND: 'გთხოვთ გაითვალისწინოთ, რომ ჩვენ მხოლოდ ღია (public) პოსტებს ვამოწმებთ',
	        NOT_FOUND: 'თქვენი პოსტები არ მოიძებნა',
	        CLOSE: 'დახურვა',
	        SHARE: 'გაზიარება',
	        SELECTED_POSTS: 'არჩეული პოსტები',
	        APPRECIATIONS: 'მოწონება'
	    },
	    EN: {
	        BEEN_IN_GEORGIA: 'Have you been to Georgia recently?',
	        POSTS_ANALYZED: 'Check if your posts have been analyzed',
	        USERNAME_PLACEHOLDER: 'Instagram, Facebook or Twitter Username',
	        CHECK: 'Check',
	        BEAR_IN_MIND: 'Please bear in mind that we only check public posts',
	        NOT_FOUND: 'Sorry, we can\'t find anything with this username',
	        CLOSE: 'Close',
	        SHARE: 'SHARE',
	        SELECTED_POSTS: 'Selected Posts',
	        APPRECIATIONS: 'Appreciations'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(621);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".step1{border-radius:10px;background-color:#fff;width:680px;height:350px;margin-left:calc(50vw - 340px);margin-top:calc(50vh - 175px);box-shadow:8px 8px 15px #bbb;position:relative}.step1 .top-grid{position:absolute;left:15px;top:15px}.step1 .bottom-grid{position:absolute;bottom:15px;right:15px;width:100px;height:30px}.step1 .header{font-size:24px;font-family:Graphik-Bold;color:#161616;font-weight:700;text-align:center;padding-top:50px}.step1 .subheader{font-size:16px;font-family:Graphik-Semibold;color:#9199a9;text-align:center;padding-top:10px}.step1 form{margin-top:45px;display:flex;justify-content:center;align-items:center}.step1 form .dropdown-with-input{padding-left:10px;border:1px solid #ebeef4;background-color:rgba(233,0,76,0);width:382px;border-radius:191px;height:50px;display:flex;align-items:center}.step1 form .dropdown-with-input *{font-size:13px;font-family:Graphik-Regular}.step1 form .dropdown-with-input input{width:345px;border:0;height:30px;padding-left:15px;color:rgba(32,32,33,.8);outline:0;font-family:Graphik-Bold;font-style:italic}.step1 form .dropdown-with-input input::placeholder{color:rgba(145,153,169,.502);font-family:Graphik-Regular}.step1 form .check{background-color:#e9004c;width:120px;height:50px;margin-left:15px;border:0;outline:none;border-radius:60px;font-size:13px;font-family:Graphik-Semibold;color:#fff}.step1 form .check:hover{background-color:#d00044}.step1 form .check:disabled{background-color:#ffb6ce}.step1 .addional-info,.step1 .error-info{font-size:12px;font-family:Graphik-Semibold;padding:11px 85px}.step1 .addional-info{color:rgba(145,153,169,.6)}.step1 .error-info{color:#cf0000}.step1 .close{text-align:center;font-size:13px;margin-top:35px;color:#b1b3b6;font-family:Graphik-Semibold}.step1 .close:hover{color:#97999d}.step1 .close span{cursor:pointer}.step1 .close span svg{padding-right:3px}.step1.geo .header{font-family:Georgian-Bold}.step1.geo .dropdown-with-input{font-family:Georgian-Regular}.step1.geo .dropdown-with-input input::placeholder{font-family:Georgian-Regular}.step1.geo .addional-info,.step1.geo .check,.step1.geo .close,.step1.geo .error-info,.step1.geo .subheader{font-family:Georgian-Semibold}", ""]);
	
	// exports


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(623);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".contributor-mobile-step1{overflow-x:hidden;background-color:#fcfcfc;overflow-y:auto}.contributor-mobile-step1 main{padding:25px 20px;min-height:calc(100vh - 247px)}.contributor-mobile-step1 .subtitle,.contributor-mobile-step1 .title{text-align:center}.contributor-mobile-step1 .title{font-family:Graphik-Semibold;font-size:17px}.contributor-mobile-step1 .subtitle{font-family:Graphik-Regular;font-size:13px;margin-top:10px}.contributor-mobile-step1 .media{position:relative;margin-top:15px;width:100%}.contributor-mobile-step1 .media .select{position:relative;width:100%;height:20px;color:#ff0057;border-radius:30px;border:1px solid #d6d6d6;padding:20px 30px;line-height:21px;cursor:pointer;box-shadow:0 0 5px 1px #ede8ed}.contributor-mobile-step1 .media .select span:first-child{font-weight:700;text-transform:capitalize}.contributor-mobile-step1 .media .select .arrow{position:absolute;top:18px;right:30px}.contributor-mobile-step1 .media .select .arrow svg{width:12px}.contributor-mobile-step1 .media .dropdown{position:absolute;top:75px;width:calc(100% - 50px);height:75px;padding:20px 25px;border-radius:20px;z-index:10;background-color:#fff;box-shadow:0 0 5px 1px #ede8ed}.contributor-mobile-step1 .media .dropdown:before{border-color:transparent transparent #aaa}.contributor-mobile-step1 .media .dropdown:after,.contributor-mobile-step1 .media .dropdown:before{border-style:solid;border-width:6px;content:\"\";right:30px;margin:0 0 0 -100px;position:absolute;top:-12px}.contributor-mobile-step1 .media .dropdown:after{border-color:transparent transparent #fff}.contributor-mobile-step1 .media .dropdown ul{list-style:none;font-size:15px;font-weight:700;color:#c0c2c5}.contributor-mobile-step1 .media .dropdown ul li{cursor:pointer;margin-bottom:10px}.contributor-mobile-step1 .media .dropdown ul li svg{position:relative;top:-2px;width:13px;margin-right:7px}.contributor-mobile-step1 .media .dropdown ul li span{position:relative;top:-5px}.contributor-mobile-step1 .media .dropdown ul li:hover{color:#4a4949}.contributor-mobile-step1 .media .dropdown ul li:first-child svg{width:10px;margin-right:10px}.contributor-mobile-step1 .username{margin:15px 0;width:100%}.contributor-mobile-step1 .username input{width:calc(100% - 40px);border:0;height:30px;padding:15px 20px;border:1px solid #ebeef4;color:rgba(42,42,43,.8);font-weight:700;outline:0;border-radius:15px}.contributor-mobile-step1 .username input::placeholder{color:rgba(73,74,75,.502);font-family:Graphik-Regular;font-weight:400;font-size:12px}.contributor-mobile-step1 .check button{background-color:#e9004c;width:100%;height:50px;border:0;outline:none;border-radius:30px;font-size:15px;font-family:Graphik-Semibold;color:#fff}.contributor-mobile-step1 .check button:disabled{background-color:#ffb6ce}.contributor-mobile-step1 .error-info{margin-top:10px;width:100%;text-align:center;font-size:12px;font-family:Graphik-Semibold;color:red}.contributor-mobile-step1.geo .title{font-family:Georgian-SemiBold}.contributor-mobile-step1.geo .subtitle,.contributor-mobile-step1.geo .username input::placeholder{font-family:Georgian-Regular}.contributor-mobile-step1.geo .check button,.contributor-mobile-step1.geo .error-info{font-family:Georgian-Semibold}", ""]);
	
	// exports


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _step = __webpack_require__(625);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _card = __webpack_require__(584);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step2Module = _angular2.default.module('step2', [_angularUiRouter2.default, _card2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.state('home.contributor.step2', {
	    url: '/step-2?username',
	    component: 'step2'
	  });
	}]).component('step2', _step2.default).name;
	
	exports.default = step2Module;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _step = __webpack_require__(626);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(627);
	
	var _step4 = _interopRequireDefault(_step3);
	
	__webpack_require__(766);
	
	__webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step2Component = {
	    bindings: {},
	    template: _step2.default,
	    controller: _step4.default
	};
	
	exports.default = step2Component;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"step2 hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"grid-horizontal top\"></div>\n    <div class=\"grid-horizontal bottom\"></div>\n\n    <div class=\"close\" ui-sref=\"home\">\n        <svg id=\"Close\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"33\" viewBox=\"0 0 30 33\">\n            <image data-name=\"close 1\" width=\"30\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAMAAAB5ytLYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABNVBMVEXw9P6AgIDw9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P4AAAB0wDQdAAAAZXRSTlMAAAdLhbjY8/XbvotTDSyd9PmqOhKc/q4cNOLsRkHx+k4n8Pg1BdHfCnmGFG53zdUbIF1hkJG7ve/u1ra6jFheFsjPaHIMEHF9BMzZCCHtLjf2SDHd6D4Pl/2mFymZ96MzStqIUFw2AL0AAAABYktHRGYs1NklAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUYCCcRdHMjBgAAARhJREFUOMu91NdWwlAQheGJhIACEntBBYMlih2kCAp2imAvqKCg8/6v4AkICSQ545X/ZdZ3k6zMBug24BCdkgsR3YNDHq/v96kgCF0x7JfR2MjoWJ8Zn5hEU1PTRjMzi1YF5nQzv4DWBUMds6igXeGltlleQftW1ZZZQ17rmvEpXCNHmNlAfpvMbBFmW4AdpNqFPdJEIUaafYiTJgESaSRIkiYJJEH8VxMgSQoO/vDuadJk4JA0MTgiTRZypGFXdkyQE/YfnhLmjJlz/hdSLrTbueSafOu+CkUOKV21b7lcsSXydWcTbuw24fZO35b7B0vy+GTcqOeXqpm8vvVt3XvN1QPqH5+mPWSb2RCdJW0U5Wb861vVN/MHCPiu7T51uK8AAAAASUVORK5CYII=\"></image>\n            <image data-name=\"close 2\" x=\"12\" y=\"13\" width=\"7\" height=\"7\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWAgICUnrKUnrKUnrKUnrIAAADqJbCtAAAABHRSTlMA8Hd4OPcDdQAAAAFiS0dEBfhv6ccAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRgIJxF0cyMGAAAALUlEQVQI12MQYmBgUGRQMWBgdmJgdmYwMWBgMDF2BgoyuxjASbAIRBaiEqwLAJo4BS96+asEAAAAAElFTkSuQmCC\"></image>\n        </svg>\n        <span>{{$ctrl.closeText}}</span>\n    </div>\n\n    <div class=\"leaves left\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"53\" height=\"87\" viewBox=\"0 0 53 87\">\n            <image id=\"leaves-left\" data-name=\"Leaves-left\" width=\"53\" height=\"87\" xlink:href=\"data:img/png;base64,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\"\n            />\n        </svg>\n    </div>\n\n    <div class=\"certificate-center\"></div>\n    <div class=\"leaves right\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"53\" height=\"87\" viewBox=\"0 0 53 87\">\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"53\" height=\"87\" xlink:href=\"data:img/png;base64,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\"\n            />\n        </svg>\n    </div>\n\n    <div class=\"grid-vertical left\"></div>\n    <div class=\"grid-vertical right\"></div>\n\n    <div class=\"contrib-avatar-container\" ng-style=\"$ctrl.avatarStyle\"></div>\n\n    <p class=\"to\">To</p>\n    <p class=\"full-name\">{{ $ctrl.fullName }}</p>\n    <p class=\"from\">\n        From the People of Georgia\n        <br/> This document acknowledges that you have contributed to the creation of the Guidebook of Georgia\n    </p>\n    <!-- <p class=\"info\">This document acknowledges that you have contributed to the creation of the Guidebook of Georgia</p> -->\n\n    <!-- <p class=\"selected-posts\">Selected posts: {{ $ctrl.selectedPosts }}</p> -->\n    <div class=\"appreciations\">\n        <span>{{$ctrl.appreciationsText}}</span> : {{ $ctrl.appreciations }}</div>\n\n    <div class=\"contrib-date-container\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"27\" viewBox=\"0 0 25 27\">\n            <image id=\"date-share-container\" data-name=\"Vector Smart Object\" width=\"25\" height=\"27\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAbCAMAAAC+/9RaAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA0lBMVEXw9P6AgIDw9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P4AAADcjBYAAAAARHRSTlMAAARKlMjq7cyaUQcCZ+NyBRG7xxsO0twUrLkBTVbK0SswdXiusNfY9PDy1XYnLMRGT6azDMnTD7cVYuHnbUiT6+yXBn7WHqQAAAABYktHREWOs6hXAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUPCBocreR4IwAAALdJREFUKM+d0scWgjAQRuGxgNjFriA2xN57b/P+z2QIBwtkNt7lfLvkB+AFQ2FJRsSIEo3FAzx+TyRT+ElOZ1xRs/hbLu9IoYjeSmUuFfRX1ZjoKKrGxBBKPQANFNeEFiFtMAnpgEVIF3qE9ACp/pI+AQMYEmIJ39POhDQhIxgTMgGYCkFhvzATytz+04UAlvy3V2sfbFRnO9udB6Z7d2/a4fh1P52D7yWyjV6u0o1d78ZDfzobfQEdWJQtKGjDlAAAAABJRU5ErkJggg==\"\n            />\n            <image id=\"calendar\" data-name=\"Vector Smart Object\" width=\"12\" height=\"12\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAYFBMVEWAgICRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmamRmakAAADbs3zaAAAAHnRSTlMAB4trEH55bolz9fn38Pgcak1fWVBo8+4rQPImZvFqD54xAAAAAWJLR0QfBQ0QvQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFDwgZGm+qjtUAAABISURBVAjXncdHFoAgEATRRjEw0GBOoPc/pit8rK1VfUBVtW5a3fUKMGIdvaezYiBhGDHNWNaw4cEXf2AvcZQ4ccX8kUg3c+kFHaAD1rJi0HgAAAAASUVORK5CYII=\"\n            />\n        </svg>\n        <span class=\"time\">{{$ctrl.createdAt}}</span>\n    </div>\n\n    <button class=\"share\" ng-click=\"$ctrl.shareCertificate()\">\n        <span>{{$ctrl.share}}</span>\n    </button>\n\n    <div class=\"wrapper\">\n        <div class=\"row\">\n            <div class=\"col-custom-xl-4 col-md-6\" ng-repeat=\"contribution in $ctrl.posts\">\n                <card1 data=\"contribution\" ng-if=\"contribution.cardType === 'layout image'\"></card1>\n                <card2 data=\"contribution\" ng-if=\"contribution.cardType === 'layout likes'\"></card2>\n                <card3 data=\"contribution\" ng-if=\"contribution.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n    </div>\n\n</div>\n\n<div class=\"contributor-mobile-step2 visible-xs\">\n    <navbar></navbar>\n    <main>\n        <div class=\"graditute\">\n            <img src=\"/assets/images/graditute.png\" alt=\"graditute\">\n        </div>\n        <div class=\"contributor-info\">\n            <h2 class=\"to\">To</h2>\n            <h2 class=\"full-name\">{{ $ctrl.fullName }}</h2>\n            <p class=\"from\">From the People of Georgia</p>\n            <p class=\"time\">{{$ctrl.createdAt | date : \"d MMMM, y\"}}</p>\n            <p class=\"info\">This document acknowledges that you have contributed to the creation of the Guidebook of Georgia</p>\n            <div class=\"reactions\">\n                <div class=\"left\">\n                    {{$ctrl.selectedPostsText}}: {{ $ctrl.selectedPosts }}\n                </div>\n                <div class=\"right\">\n                    {{$ctrl.appreciationsText}}: {{ $ctrl.appreciations }}\n                </div>\n            </div>\n        </div>\n        <div class=\"share\" ng-click=\"$ctrl.shareCertificate()\">\n            <button>{{$ctrl.share}}</button>\n        </div>\n        <div class=\"shared-moments\">\n            <!-- <h2 class=\"title\">{{$ctrl.fullName.split(' ')[0]}}'s shared moments</h2> -->\n            <div ng-repeat=\"post in $ctrl.posts\" class=\"posts\">\n                <card1 data=\"post\" ng-if=\"post.cardType === 'layout image'\"></card1>\n                <card2 data=\"post\" ng-if=\"post.cardType === 'layout likes'\"></card2>\n                <card3 data=\"post\" ng-if=\"post.cardType === 'layout text'\"></card3>\n            </div>\n        </div>\n    </main>\n    <footer></footer>\n</div>\n"

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(628);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _contributor = __webpack_require__(619);
	
	var _contributor2 = _interopRequireDefault(_contributor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step2Controller = function () {
	    function Step2Controller($scope, $state, $stateParams, config, SharedMoments, Share) {
	        (0, _classCallCheck3.default)(this, Step2Controller);
	
	        this.name = 'step2';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	
	        this.config = config;
	        this.SharedMoments = SharedMoments;
	        this.ShareFactory = Share;
	
	        this.posts = [];
	    }
	
	    (0, _createClass3.default)(Step2Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            // Load certificate
	            this.getCertificate(this.$stateParams.username);
	
	            // watch thumbs
	            this.watchThumbs();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            if (this.language === 'GE') {
	                _moment2.default.updateLocale('en', {
	                    months: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
	                });
	            } else {
	                _moment2.default.updateLocale('en', {
	                    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	                });
	            }
	
	            var _texts$language = _contributor2.default[this.language],
	                SHARE = _texts$language.SHARE,
	                SELECTED_POSTS = _texts$language.SELECTED_POSTS,
	                APPRECIATIONS = _texts$language.APPRECIATIONS,
	                CLOSE = _texts$language.CLOSE;
	
	
	            this.share = SHARE;
	            this.appreciationsText = APPRECIATIONS;
	            this.selectedPostsText = SELECTED_POSTS;
	            this.closeText = CLOSE;
	        }
	    }, {
	        key: 'getCertificate',
	        value: function getCertificate(username) {
	            var _this = this;
	
	            this.SharedMoments.getCertificate(username).then(function (response) {
	                if (!response.data || !response.data.posts) {
	                    return _this.$state.go('home.contributor.step1');
	                }
	
	                var _response$data = response.data,
	                    fullName = _response$data.fullName,
	                    avatarUrl = _response$data.avatarUrl,
	                    createdAt = _response$data.createdAt,
	                    posts = _response$data.posts;
	
	
	                _this.username = username;
	                _this.fullName = fullName;
	                _this.avatarUrl = avatarUrl;
	                _this.createdAt = (0, _moment2.default)(createdAt).format('DD MMMM, YYYY');
	                _this.posts = posts;
	                _this.selectedPosts = posts.length;
	
	                _this.avatarStyle = {
	                    'background-image': 'url("' + (_this.avatarUrl || '/assets/images/user.jpg') + '")'
	                };
	            }).catch(function (err) {
	                console.log('Error occured in method checkContributor', err);
	
	                _this.error = err.data;
	            });
	        }
	    }, {
	        key: 'shareCertificate',
	        value: function shareCertificate() {
	            var url = this.config.frontUrl + '/shared-moments/contributor/step-2?username=' + this.username;
	
	            this.ShareFactory.shareObject(url);
	        }
	    }, {
	        key: 'watchThumbs',
	        value: function watchThumbs() {
	            var _this2 = this;
	
	            this.$scope.$watch(function () {
	                return _this2.posts.reduce(function (thumbs, item) {
	                    return thumbs + item.thumbs;
	                }, 0);
	            }, function (newValue) {
	                _this2.appreciations = newValue;
	            });
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this3 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this3.render();
	                }
	            });
	        }
	    }]);
	    return Step2Controller;
	}();
	
	Step2Controller.$inject = ['$scope', '$state', '$stateParams', 'config', 'SharedMoments', 'Share'];
	
	exports.default = Step2Controller;

/***/ }),
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 631,
		"./af.js": 631,
		"./ar": 632,
		"./ar-dz": 633,
		"./ar-dz.js": 633,
		"./ar-kw": 634,
		"./ar-kw.js": 634,
		"./ar-ly": 635,
		"./ar-ly.js": 635,
		"./ar-ma": 636,
		"./ar-ma.js": 636,
		"./ar-sa": 637,
		"./ar-sa.js": 637,
		"./ar-tn": 638,
		"./ar-tn.js": 638,
		"./ar.js": 632,
		"./az": 639,
		"./az.js": 639,
		"./be": 640,
		"./be.js": 640,
		"./bg": 641,
		"./bg.js": 641,
		"./bm": 642,
		"./bm.js": 642,
		"./bn": 643,
		"./bn-bd": 644,
		"./bn-bd.js": 644,
		"./bn.js": 643,
		"./bo": 645,
		"./bo.js": 645,
		"./br": 646,
		"./br.js": 646,
		"./bs": 647,
		"./bs.js": 647,
		"./ca": 648,
		"./ca.js": 648,
		"./cs": 649,
		"./cs.js": 649,
		"./cv": 650,
		"./cv.js": 650,
		"./cy": 651,
		"./cy.js": 651,
		"./da": 652,
		"./da.js": 652,
		"./de": 653,
		"./de-at": 654,
		"./de-at.js": 654,
		"./de-ch": 655,
		"./de-ch.js": 655,
		"./de.js": 653,
		"./dv": 656,
		"./dv.js": 656,
		"./el": 657,
		"./el.js": 657,
		"./en-au": 658,
		"./en-au.js": 658,
		"./en-ca": 659,
		"./en-ca.js": 659,
		"./en-gb": 660,
		"./en-gb.js": 660,
		"./en-ie": 661,
		"./en-ie.js": 661,
		"./en-il": 662,
		"./en-il.js": 662,
		"./en-in": 663,
		"./en-in.js": 663,
		"./en-nz": 664,
		"./en-nz.js": 664,
		"./en-sg": 665,
		"./en-sg.js": 665,
		"./eo": 666,
		"./eo.js": 666,
		"./es": 667,
		"./es-do": 668,
		"./es-do.js": 668,
		"./es-mx": 669,
		"./es-mx.js": 669,
		"./es-us": 670,
		"./es-us.js": 670,
		"./es.js": 667,
		"./et": 671,
		"./et.js": 671,
		"./eu": 672,
		"./eu.js": 672,
		"./fa": 673,
		"./fa.js": 673,
		"./fi": 674,
		"./fi.js": 674,
		"./fil": 675,
		"./fil.js": 675,
		"./fo": 676,
		"./fo.js": 676,
		"./fr": 677,
		"./fr-ca": 678,
		"./fr-ca.js": 678,
		"./fr-ch": 679,
		"./fr-ch.js": 679,
		"./fr.js": 677,
		"./fy": 680,
		"./fy.js": 680,
		"./ga": 681,
		"./ga.js": 681,
		"./gd": 682,
		"./gd.js": 682,
		"./gl": 683,
		"./gl.js": 683,
		"./gom-deva": 684,
		"./gom-deva.js": 684,
		"./gom-latn": 685,
		"./gom-latn.js": 685,
		"./gu": 686,
		"./gu.js": 686,
		"./he": 687,
		"./he.js": 687,
		"./hi": 688,
		"./hi.js": 688,
		"./hr": 689,
		"./hr.js": 689,
		"./hu": 690,
		"./hu.js": 690,
		"./hy-am": 691,
		"./hy-am.js": 691,
		"./id": 692,
		"./id.js": 692,
		"./is": 693,
		"./is.js": 693,
		"./it": 694,
		"./it-ch": 695,
		"./it-ch.js": 695,
		"./it.js": 694,
		"./ja": 696,
		"./ja.js": 696,
		"./jv": 697,
		"./jv.js": 697,
		"./ka": 698,
		"./ka.js": 698,
		"./kk": 699,
		"./kk.js": 699,
		"./km": 700,
		"./km.js": 700,
		"./kn": 701,
		"./kn.js": 701,
		"./ko": 702,
		"./ko.js": 702,
		"./ku": 703,
		"./ku.js": 703,
		"./ky": 704,
		"./ky.js": 704,
		"./lb": 705,
		"./lb.js": 705,
		"./lo": 706,
		"./lo.js": 706,
		"./lt": 707,
		"./lt.js": 707,
		"./lv": 708,
		"./lv.js": 708,
		"./me": 709,
		"./me.js": 709,
		"./mi": 710,
		"./mi.js": 710,
		"./mk": 711,
		"./mk.js": 711,
		"./ml": 712,
		"./ml.js": 712,
		"./mn": 713,
		"./mn.js": 713,
		"./mr": 714,
		"./mr.js": 714,
		"./ms": 715,
		"./ms-my": 716,
		"./ms-my.js": 716,
		"./ms.js": 715,
		"./mt": 717,
		"./mt.js": 717,
		"./my": 718,
		"./my.js": 718,
		"./nb": 719,
		"./nb.js": 719,
		"./ne": 720,
		"./ne.js": 720,
		"./nl": 721,
		"./nl-be": 722,
		"./nl-be.js": 722,
		"./nl.js": 721,
		"./nn": 723,
		"./nn.js": 723,
		"./oc-lnc": 724,
		"./oc-lnc.js": 724,
		"./pa-in": 725,
		"./pa-in.js": 725,
		"./pl": 726,
		"./pl.js": 726,
		"./pt": 727,
		"./pt-br": 728,
		"./pt-br.js": 728,
		"./pt.js": 727,
		"./ro": 729,
		"./ro.js": 729,
		"./ru": 730,
		"./ru.js": 730,
		"./sd": 731,
		"./sd.js": 731,
		"./se": 732,
		"./se.js": 732,
		"./si": 733,
		"./si.js": 733,
		"./sk": 734,
		"./sk.js": 734,
		"./sl": 735,
		"./sl.js": 735,
		"./sq": 736,
		"./sq.js": 736,
		"./sr": 737,
		"./sr-cyrl": 738,
		"./sr-cyrl.js": 738,
		"./sr.js": 737,
		"./ss": 739,
		"./ss.js": 739,
		"./sv": 740,
		"./sv.js": 740,
		"./sw": 741,
		"./sw.js": 741,
		"./ta": 742,
		"./ta.js": 742,
		"./te": 743,
		"./te.js": 743,
		"./tet": 744,
		"./tet.js": 744,
		"./tg": 745,
		"./tg.js": 745,
		"./th": 746,
		"./th.js": 746,
		"./tk": 747,
		"./tk.js": 747,
		"./tl-ph": 748,
		"./tl-ph.js": 748,
		"./tlh": 749,
		"./tlh.js": 749,
		"./tr": 750,
		"./tr.js": 750,
		"./tzl": 751,
		"./tzl.js": 751,
		"./tzm": 752,
		"./tzm-latn": 753,
		"./tzm-latn.js": 753,
		"./tzm.js": 752,
		"./ug-cn": 754,
		"./ug-cn.js": 754,
		"./uk": 755,
		"./uk.js": 755,
		"./ur": 756,
		"./ur.js": 756,
		"./uz": 757,
		"./uz-latn": 758,
		"./uz-latn.js": 758,
		"./uz.js": 757,
		"./vi": 759,
		"./vi.js": 759,
		"./x-pseudo": 760,
		"./x-pseudo.js": 760,
		"./yo": 761,
		"./yo.js": 761,
		"./zh-cn": 762,
		"./zh-cn.js": 762,
		"./zh-hk": 763,
		"./zh-hk.js": 763,
		"./zh-mo": 764,
		"./zh-mo.js": 764,
		"./zh-tw": 765,
		"./zh-tw.js": 765
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 630;


/***/ }),
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(767);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".step2{border-radius:10px;background-color:#fff;width:calc(100vw - 100px);height:calc(100vh - 80px);margin-left:calc(50vw - (100vw - 100px)/2);margin-top:calc(50vh - (100vh - 80px)/2);box-shadow:8px 8px 15px #bbb;position:relative}.step2 .grid-horizontal{position:absolute;background-image:url(/assets/images/certificate-grid.svg);width:96px;height:20px;background-size:60px 58px;left:calc(50% - 48px)}.step2 .grid-horizontal.top{top:8px}.step2 .grid-horizontal.bottom{bottom:6px}.step2 .grid-vertical{position:absolute;width:177px;background-image:url(/assets/images/certificate-grid.svg);height:90px;top:48px;background-size:60px 58px}.step2 .grid-vertical.left{left:calc((100vw - 100px)/2 - 300px)}.step2 .grid-vertical.right{right:calc((100vw - 100px)/2 - 300px)}.step2 .close{cursor:pointer;display:flex;align-items:center;float:right;margin-top:12px;margin-right:20px}.step2 .close:hover span{color:#898d97}.step2 .close span{font-size:12px;margin-left:7px;margin-top:2px;color:#a4a7af;font-family:Graphik-Semibold}.step2 .leaves{position:absolute;width:50px;height:90px;top:45px;z-index:2;background-size:50px 90px}.step2 .leaves.left{left:calc((100vw - 100px)/2 - 140px)}.step2 .leaves.right{right:calc((100vw - 100px)/2 - 140px)}.step2 .certificate-center{position:absolute;background-image:url(/assets/images/certificate-of-graditute.png);width:152px;height:69px;left:calc(50% - 152px/2);background-size:152px;top:40px}.step2 .contrib-avatar-container{width:45px;height:45px;background-color:#e9004c;background-size:cover;border-radius:25px;position:absolute;margin-left:calc(50% - 22.5px);top:140px}.step2 .full-name{font-size:14px;font-family:Graphik-Bold;color:#161616;text-align:center;width:100%;top:192px}.step2 .full-name,.step2 .to{font-weight:700;position:absolute}.step2 .to{top:110px;left:calc(50% - 14px);font-size:21px}.step2 .from{font-family:Graphik-Regular;color:#9199a9;width:290px;top:213px;left:calc(50% - 145px);line-height:13px}.step2 .from,.step2 .see-contrib{font-size:11px;position:absolute;text-align:center}.step2 .see-contrib{width:140px;height:45px;border:0;margin-left:calc(50% - 70px);top:260px;font-family:Graphik-Semibold;color:#3dba59}.step2 .appreciations,.step2 .selected-posts{position:absolute;top:282px;font-size:11px;text-align:center;font-family:Graphik-Bold;color:rgba(145,153,169,.8)}.step2 .selected-posts{left:210px}.step2 .appreciations{right:calc((100vw - 100px)/2 - 250px)}.step2 .contrib-date-container,.step2 .contrib-share-container{position:absolute;top:268px;font-size:11px;font-family:Graphik-Semibold;color:rgba(145,153,169,.8)}.step2 .contrib-date-container{left:calc((100vw - 100px)/2 - 250px)}.step2 .contrib-date-container svg{transform:translate(-6px,7px)}.step2 .contrib-date-container svg #calendar{transform:translate(6px,7px)}.step2 .contrib-date-container .time{position:relative;top:-2px;font-weight:700}.step2 .share{position:absolute;top:265px;left:calc(50% - 75px);width:150px;height:45px;border:0;border-radius:30px;background-color:#5db149;outline:none}.step2 .share:hover{background-color:#4a8d3a}.step2 .share span{font-size:13px;letter-spacing:1px;font-family:Graphik-Bold;text-transform:uppercase;color:#fff}.step2 .wrapper{position:absolute;top:320px;width:100%;height:calc((100vh - 80px) - 320px);overflow-y:auto;overflow-x:hidden}.step2 .wrapper::-webkit-scrollbar{width:3px}.step2 .wrapper::-webkit-scrollbar-track{background:#f2f2f2}.step2 .wrapper::-webkit-scrollbar-thumb{background:#ff0084}.step2 .wrapper::-webkit-scrollbar-thumb:hover{background:#ff002b}.step2 .wrapper>div{padding:10px;max-width:calc(100vw - 100px);min-width:940px}.step2 .wrapper>div>div{display:flex;justify-content:center}.step2.geo .close span,.step2.geo .contrib-share-container,.step2.geo .from .see-contrib,.step2.geo .share span{font-family:Georgian-Semibold}.step2.geo .appreciations span{font-family:Georgian-Bold}", ""]);
	
	// exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(769);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".contributor-mobile-step2{background-color:#fcfcfc;overflow-y:auto;max-height:100vh}.contributor-mobile-step2 main{padding:25px 20px;min-height:calc(100vh - 247px)}.contributor-mobile-step2 .graditute{display:flex;align-items:center;justify-content:center;width:100%;text-align:center}.contributor-mobile-step2 .graditute img{max-width:250px;width:100%}.contributor-mobile-step2 .contributor-info{text-align:center}.contributor-mobile-step2 .contributor-info .to{margin-bottom:0}.contributor-mobile-step2 .contributor-info .full-name{margin-top:10px}.contributor-mobile-step2 .contributor-info p.from,.contributor-mobile-step2 .contributor-info p.time{color:#a9a9a9}.contributor-mobile-step2 .contributor-info p.from{font-size:14px}.contributor-mobile-step2 .contributor-info p.time{margin:5px 0 15px;font-size:13px;font-weight:700;color:#a9a9a9}.contributor-mobile-step2 .contributor-info p.info{margin-bottom:15px;color:#8a91a2;font-size:15px;line-height:17px}.contributor-mobile-step2 .contributor-info .reactions{margin-bottom:10px;font-size:14px;color:#a9a9a9}.contributor-mobile-step2 .contributor-info .reactions div{display:inline-block}.contributor-mobile-step2 .contributor-info .reactions .left{text-align:left;width:53%}.contributor-mobile-step2 .contributor-info .reactions .right{text-align:right;width:45%}.contributor-mobile-step2 .share{text-align:center}.contributor-mobile-step2 .share button{width:100%;background-color:#eb3e4e;color:#fff;font-weight:700;font-size:15px;height:60px;border-radius:30px;border:none;outline:none}.contributor-mobile-step2 .shared-moments{margin:25px 5px 10px}.contributor-mobile-step2 .shared-moments .title{margin-left:5px;margin-bottom:10px}.contributor-mobile-step2 .shared-moments .posts{display:flex;align-items:center;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _book = __webpack_require__(771);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _step = __webpack_require__(776);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(785);
	
	var _step4 = _interopRequireDefault(_step3);
	
	var _step5 = __webpack_require__(793);
	
	var _step6 = _interopRequireDefault(_step5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookModule = _angular2.default.module('book', [_angularUiRouter2.default, _step2.default, _step4.default, _step6.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('home.book', {
	        abstract: 'true',
	        url: '/book',
	        component: 'book'
	    });
	}]).component('book', _book2.default).name;
	
	exports.default = bookModule;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _book = __webpack_require__(772);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _book3 = __webpack_require__(773);
	
	var _book4 = _interopRequireDefault(_book3);
	
	__webpack_require__(774);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookComponent = {
	    bindings: {},
	    template: _book2.default,
	    controller: _book4.default
	};
	
	exports.default = bookComponent;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book\">\n\t<ui-view></ui-view>\n</div>\n"

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookController = function () {
	    function BookController($state) {
	        (0, _classCallCheck3.default)(this, BookController);
	
	        this.name = 'book';
	        this.$state = $state;
	    }
	
	    (0, _createClass3.default)(BookController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var scope = this;
	
	            $('.book').mouseup(function (e) {
	                var step1 = $('.book .book-step1');
	                var step2 = $('.book .book-step2');
	                var step3 = $('.book .book-step3');
	                var mobileStep1 = $('.book .bookMobileStep1');
	                var mobileStep3 = $('.book .bookMobileStep3');
	
	                var step1Mobile = $('.book .book-step1-mobile');
	
	                // if the target of the click isn't the container nor a descendant of the container
	                if (!step1.is(e.target) && step1.has(e.target).length === 0 && !step2.is(e.target) && step2.has(e.target).length === 0 && !step3.is(e.target) && step3.has(e.target).length === 0 && !mobileStep1.is(e.target) && mobileStep1.has(e.target).length === 0 && !mobileStep3.is(e.target) && mobileStep3.has(e.target).length === 0 && !step1Mobile.is(e.target) && step1Mobile.has(e.target).length === 0) {
	                    scope.goHome();
	                }
	            });
	        }
	    }, {
	        key: 'goHome',
	        value: function goHome() {
	            this.$state.go('home');
	        }
	    }]);
	    return BookController;
	}();
	
	BookController.$inject = ['$state'];
	
	exports.default = BookController;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(775);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./book.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./book.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book{position:fixed;width:100vw;height:100vh;z-index:11;background-color:hsla(0,0%,93%,.8)}@media only screen and (max-width:768px){.book{position:fixed;min-height:100vh;width:100vw;z-index:11;overflow-y:scroll;background-color:#fff}}", ""]);
	
	// exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _step = __webpack_require__(777);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookStep1Module = _angular2.default.module('bookStep1', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('home.book.bookStep1', {
	        url: '/step-1',
	        component: 'bookStep1'
	    });
	}]).component('bookStep1', _step2.default).name;
	
	exports.default = bookStep1Module;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _step = __webpack_require__(778);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(779);
	
	var _step4 = _interopRequireDefault(_step3);
	
	__webpack_require__(781);
	
	__webpack_require__(783);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step1Component = {
	    bindings: {},
	    template: _step2.default,
	    controller: _step4.default
	};
	
	exports.default = step1Component;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-step1 hidden-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n\n    <img class=\"top-grid\" src=\"/assets/images/popup-grid-top.svg\" alt=\"top-grid\">\n    <img class=\"bottom-grid\" src=\"/assets/images/popup-grid-bottom.svg\" alt=\"bottom-grid\">\n\n    <div class=\"close\" ui-sref=\"home\">\n        <svg id=\"Close\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"33\" viewBox=\"0 0 30 33\">\n            <image data-name=\"close 1\" width=\"30\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAMAAAB5ytLYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABNVBMVEXw9P6AgIDw9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P4AAAB0wDQdAAAAZXRSTlMAAAdLhbjY8/XbvotTDSyd9PmqOhKc/q4cNOLsRkHx+k4n8Pg1BdHfCnmGFG53zdUbIF1hkJG7ve/u1ra6jFheFsjPaHIMEHF9BMzZCCHtLjf2SDHd6D4Pl/2mFymZ96MzStqIUFw2AL0AAAABYktHRGYs1NklAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUYCCcRdHMjBgAAARhJREFUOMu91NdWwlAQheGJhIACEntBBYMlih2kCAp2imAvqKCg8/6v4AkICSQ545X/ZdZ3k6zMBug24BCdkgsR3YNDHq/v96kgCF0x7JfR2MjoWJ8Zn5hEU1PTRjMzi1YF5nQzv4DWBUMds6igXeGltlleQftW1ZZZQ17rmvEpXCNHmNlAfpvMbBFmW4AdpNqFPdJEIUaafYiTJgESaSRIkiYJJEH8VxMgSQoO/vDuadJk4JA0MTgiTRZypGFXdkyQE/YfnhLmjJlz/hdSLrTbueSafOu+CkUOKV21b7lcsSXydWcTbuw24fZO35b7B0vy+GTcqOeXqpm8vvVt3XvN1QPqH5+mPWSb2RCdJW0U5Wb861vVN/MHCPiu7T51uK8AAAAASUVORK5CYII=\"\n            />\n            <image data-name=\"close 2\" x=\"12\" y=\"13\" width=\"7\" height=\"7\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWAgICUnrKUnrKUnrKUnrIAAADqJbCtAAAABHRSTlMA8Hd4OPcDdQAAAAFiS0dEBfhv6ccAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRgIJxF0cyMGAAAALUlEQVQI12MQYmBgUGRQMWBgdmJgdmYwMWBgMDF2BgoyuxjASbAIRBaiEqwLAJo4BS96+asEAAAAAElFTkSuQmCC\"\n            />\n        </svg>\n        <span>{{$ctrl.closeText}}</span>\n    </div>\n\n    <p class=\"header\">{{$ctrl.title}}</p>\n\n    <div class=\"fb-access\">\n        <a ng-click=\"$ctrl.login()\">\n            <svg aria-hidden=\"true\" data-prefix=\"fab\" data-icon=\"facebook-f\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 264 512\"\n                class=\"svg-inline--fa fa-facebook-f fa-w-9 fa-2x\">\n                <path fill=\"#fff\" d=\"M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229\"\n                    class=\"\"></path>\n            </svg>\n            <span>{{$ctrl.fbAccess}}</span>\n            <span class=\"error\"></span>\n        </a>\n    </div>\n\n    <p class=\"subheader\">{{$ctrl.subTitle}}</p>\n\n    <div class=\"questions-block\" ng-if=\"!$ctrl.testEnd\">\n        <p class=\"question\">{{ $ctrl.question }}</p>\n        <div class=\"answers\">\n            <button ng-repeat=\"ans in $ctrl.questions[$ctrl.currentQuestion].answers\" ng-click=\"$ctrl.nextQuestion(ans.id)\" ng-class=\"$ctrl.answeredId == ans.id ? 'active' : ''\">\n                {{ ans[$ctrl.language].answer }}\n            </button>\n        </div>\n    </div>\n    <div class=\"steps\">\n        <div class=\"step\" ng-repeat=\"question in $ctrl.questions\" ng-class=\"$ctrl.currentQuestion >= $index ? 'completed' : ''\">\n            <div class=\"dot\"></div>\n        </div>\n    </div>\n</div>\n\n\n<div class=\"bookMobileStep1 visible-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <navbar></navbar>\n    <div class=\"wrapper\">\n        <p class=\"header\">{{$ctrl.title}}</p>\n\n        <div class=\"icons\">\n            <svg id=\"fb_icon\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"116\" height=\"125\"\n                viewBox=\"0 0 116 125\">\n                <image width=\"116\" height=\"125\" xlink:href=\"data:img/png;base64,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\"\n                />\n                <image x=\"49\" y=\"41\" width=\"20\" height=\"47\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAvCAQAAABJPSLoAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBggKOxNoN+ZWAAAAzklEQVQ4y+2SIQ7CQBBFX0kFCRpHwgVIuAFBYVDcAQ+SBNOeAOrwCASmohdAgkJhakgQkAoMAsdgSNstbTMGQdK/Zmb/y27mZxC+zlB8iSTR0sHBxlSDNSNyZGe6gD65qhndvAgzwSYz0IBj6jpwQInSw3QyXsSCG3ACsCQxxMCedAnBzZ06LZ+wOB7zY3Qg/wdaco7rtuE8uKczsERUD660YE8HXmnphtm6Lx240cVzYQ82XnwxMewju091cKVsHz2moNnHjCqwAivwR+AbVIhCenS+lLcAAAAASUVORK5CYII=\"\n                />\n            </svg>\n\n            <svg class=\"grid-top\" width=\"117\" height=\"117\" viewBox=\"0 0 117 117\">\n                <defs>\n                    <style>\n                        .book-step1-mobile-shadows {\n                            opacity: 0.55;\n                        }\n                    </style>\n                </defs>\n                <image class=\"book-step1-mobile-shadows\" width=\"117\" height=\"117\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAB1CAMAAABH2l6OAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAWlBMVEUAAABFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKoAAADEBZCsAAAAHXRSTlMAAxIbHBcKAhAaGA0BDxkOFQQHCwwTEQkUBggFFjY1kAQAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gYICwAI3yKqtQAAA5RJREFUaN7tW9uuozgQNNhcbAwGAoET+P/vHCBtHoZqFI12NtKo6ylS+e52VEXbSiWpNlmuEIrSGldByteNaWoPqcoZWxawWp4ZnSZKJY3ZEVCn2UGlqOX2oFrUbXpQGeo2HFSTUBmjO66MMf2VehAF1qgnCsyj04bmYanQcC2UEVVeqZGo8UqVRGVXaiDKKsMPzRH1vFItUe2VehLl+MUzZ9PTtdBMFIinkl+Giqj5Sk3nMtAOORAXtEMWxAXtEIqGwrLR4N0ZDfXRKai+xczedvODqNfetn0h6mc/FXpAVOfOzeyqMMGDtx2rIeQMVTzCA59J5fMwJAw1hapTAoFAIBAI/ikkneeo4o4qOMrfUW+VsWyyVwfYeLcJUF1CqtgV8Qgb989Nbs1Qp/iwUdmydapZW0FmpEXVHassSSs3SDm9tbJeTtG7XMtE0QukchS9QCpH0Quk8nJKZc3Xd3z9+azPjhVo/zhWfTqOm15vHAfo9flJryv9AoI6WqjHlaqJqq9UtFDAeL2IWuOv9lomBhoKmeRtKywIGQo0DQIlLtE2w3xvYIZn4LAVGTwDy962Qy2rLmPNSLHHgz1MbzHlsPY+7lfec1Sf99w/SJ+/OGrJJ/YfRCAQCAQCgeBTFGVjW6hyNoPg7IrTH77KbFZhnZKv1mELo16tbfb0R+G4z/7Kr5wIj6p1RNRbhq+o27dqdUUUzRpozPiZHnyWzs35Vft3/PCJhERHWf9BjgNI7ZscRxTof5rjaIgCfu8mx0EJItPwi/edHIeLs27A5pMZQbaCzAiyFWRGkHHyzbmbx7AbqP6PYWPvkO/daniqDp9iYFJxac4F6utyYFzAEsqKobpQBiZbkVRlYDxMMZQ152EEAoFAIBAIPobPx7lmtMgrbUtGi/RpmzJaZCnbFFsY1dXzuIstf+hPDUsdvgBLssCJaBJy6LP9NouDmn1UxuiKDdkKdMUmXp0Cs41Xp8Bg48WccAp8UCgKfDCjKPCBLYgCv2WnsdmC7ziO2DRIZKx/NNfortYr9TgHRIU02NdowcC+xhwJCMKYoAImsdDRJL6tsQbmSvmRqx7tVY2o92BH5Jqno9v9PqEf5vXJHMp8zrhDOY3ZyBzKPs1m/F1BLc91HtjkqkAgEAgEAsGn+Mq98L90B/6BqPMOPOnx//m+/3feNtw4jr/4juM7b1a+8z7nO2+RVJLa//bdlbp/d2XTRP0Cxfg1ZgJGfDYAAAAASUVORK5CYII=\"\n                />\n            </svg>\n\n            <svg class=\"grid-bottom\" width=\"117\" height=\"117\" viewBox=\"0 0 117 117\">\n                <defs>\n                    <style>\n                        .book-step1-mobile-shadows {\n                            opacity: 0.55;\n                        }\n                    </style>\n                </defs>\n                <image class=\"book-step1-mobile-shadows\" width=\"117\" height=\"117\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAB1CAMAAABH2l6OAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAWlBMVEUAAABFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKoAAADEBZCsAAAAHXRSTlMAAxIbHBcKAhAaGA0BDxkOFQQHCwwTEQkUBggFFjY1kAQAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gYICwAI3yKqtQAAA5RJREFUaN7tW9uuozgQNNhcbAwGAoET+P/vHCBtHoZqFI12NtKo6ylS+e52VEXbSiWpNlmuEIrSGldByteNaWoPqcoZWxawWp4ZnSZKJY3ZEVCn2UGlqOX2oFrUbXpQGeo2HFSTUBmjO66MMf2VehAF1qgnCsyj04bmYanQcC2UEVVeqZGo8UqVRGVXaiDKKsMPzRH1vFItUe2VehLl+MUzZ9PTtdBMFIinkl+Giqj5Sk3nMtAOORAXtEMWxAXtEIqGwrLR4N0ZDfXRKai+xczedvODqNfetn0h6mc/FXpAVOfOzeyqMMGDtx2rIeQMVTzCA59J5fMwJAw1hapTAoFAIBAI/ikkneeo4o4qOMrfUW+VsWyyVwfYeLcJUF1CqtgV8Qgb989Nbs1Qp/iwUdmydapZW0FmpEXVHassSSs3SDm9tbJeTtG7XMtE0QukchS9QCpH0Quk8nJKZc3Xd3z9+azPjhVo/zhWfTqOm15vHAfo9flJryv9AoI6WqjHlaqJqq9UtFDAeL2IWuOv9lomBhoKmeRtKywIGQo0DQIlLtE2w3xvYIZn4LAVGTwDy962Qy2rLmPNSLHHgz1MbzHlsPY+7lfec1Sf99w/SJ+/OGrJJ/YfRCAQCAQCgeBTFGVjW6hyNoPg7IrTH77KbFZhnZKv1mELo16tbfb0R+G4z/7Kr5wIj6p1RNRbhq+o27dqdUUUzRpozPiZHnyWzs35Vft3/PCJhERHWf9BjgNI7ZscRxTof5rjaIgCfu8mx0EJItPwi/edHIeLs27A5pMZQbaCzAiyFWRGkHHyzbmbx7AbqP6PYWPvkO/daniqDp9iYFJxac4F6utyYFzAEsqKobpQBiZbkVRlYDxMMZQ152EEAoFAIBAIPobPx7lmtMgrbUtGi/RpmzJaZCnbFFsY1dXzuIstf+hPDUsdvgBLssCJaBJy6LP9NouDmn1UxuiKDdkKdMUmXp0Cs41Xp8Bg48WccAp8UCgKfDCjKPCBLYgCv2WnsdmC7ziO2DRIZKx/NNfortYr9TgHRIU02NdowcC+xhwJCMKYoAImsdDRJL6tsQbmSvmRqx7tVY2o92BH5Jqno9v9PqEf5vXJHMp8zrhDOY3ZyBzKPs1m/F1BLc91HtjkqkAgEAgEAsGn+Mq98L90B/6BqPMOPOnx//m+/3feNtw4jr/4juM7b1a+8z7nO2+RVJLa//bdlbp/d2XTRP0Cxfg1ZgJGfDYAAAAASUVORK5CYII=\"\n                />\n            </svg>\n        </div>\n\n        <div class=\"fb-access\">\n            <a ng-click=\"$ctrl.login()\">\n                <span>{{$ctrl.fbAccess}}</span>\n                <span class=\"error\"></span>\n            </a>\n        </div>\n\n        <p class=\"subheader\">{{$ctrl.subTitle}}</p>\n\n        <div class=\"questions-block\" ng-if=\"!$ctrl.testEnd\">\n            <p class=\"question\">{{ $ctrl.question }}</p>\n            <div class=\"answers\">\n                <button ng-repeat=\"ans in $ctrl.questions[$ctrl.currentQuestion].answers\" ng-click=\"$ctrl.nextQuestion(ans.id)\" ng-class=\"$ctrl.answeredId == ans.id ? 'active' : ''\">\n                    {{ ans[$ctrl.language].answer }}\n                </button>\n            </div>\n        </div>\n\n        <div class=\"steps\">\n            <div class=\"step\" ng-repeat=\"question in $ctrl.questions\" ng-class=\"$ctrl.currentQuestion >= $index ? 'completed' : ''\">\n                <div class=\"dot\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"footer-wrapper\">\n        <footer></footer>\n    </div>\n</div>\n"

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(457);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _book = __webpack_require__(780);
	
	var _book2 = _interopRequireDefault(_book);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step1Controller = function () {
	    function Step1Controller($scope, $state, User) {
	        (0, _classCallCheck3.default)(this, Step1Controller);
	
	        this.name = 'step1';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.User = User;
	        this.window = window;
	
	        this.currentQuestion = 0;
	
	        this.questions = [{
	            id: 0,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'ღვინო'
	                },
	                EN: {
	                    answer: 'Wine'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'ლუდი'
	                },
	                EN: {
	                    answer: 'Beer'
	                }
	            }]
	        }, {
	            id: 1,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'ღამის ცხოვრება'
	                },
	                EN: {
	                    answer: 'Nightlife'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'დღის აქტივობები'
	                },
	                EN: {
	                    answer: 'Daylife'
	                }
	            }]
	        }, {
	            id: 2,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'მთა'
	                },
	                EN: {
	                    answer: 'Mountain'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'სანაპირო'
	                },
	                EN: {
	                    answer: 'Beach'
	                }
	            }]
	        }, {
	            id: 3,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'გარე აქტივობები'
	                },
	                EN: {
	                    answer: 'Outdoor'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'შიდა აქტივობები'
	                },
	                EN: {
	                    answer: 'Indoor'
	                }
	            }]
	        }, {
	            id: 4,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'შოფინგი'
	                },
	                EN: {
	                    answer: 'Shopping'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'ლაშქრობა'
	                },
	                EN: {
	                    answer: 'Hiking'
	                }
	            }]
	        }, {
	            id: 5,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'ქალაქი'
	                },
	                EN: {
	                    answer: 'Urban'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'სოფელი'
	                },
	                EN: {
	                    answer: 'Rural'
	                }
	            }]
	        }, {
	            id: 6,
	            answers: [{
	                id: 0,
	                GE: {
	                    answer: 'ევროპა'
	                },
	                EN: {
	                    answer: 'Europe'
	                }
	            }, {
	                id: 1,
	                GE: {
	                    answer: 'აზია'
	                },
	                EN: {
	                    answer: 'Asia'
	                }
	            }]
	        }];
	
	        this.interests = [];
	    }
	
	    (0, _createClass3.default)(Step1Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.window.scrollTo(0, 0);
	
	            this.render();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _book2.default[this.language],
	                TITLE = _texts$language.TITLE,
	                SUB_TITLE = _texts$language.SUB_TITLE,
	                FB_ACCESS = _texts$language.FB_ACCESS,
	                QUESTION = _texts$language.QUESTION,
	                CLOSE = _texts$language.CLOSE;
	
	
	            this.title = TITLE;
	            this.subTitle = SUB_TITLE;
	            this.fbAccess = FB_ACCESS;
	            this.question = QUESTION;
	            this.closeText = CLOSE;
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.render();
	                }
	            });
	        }
	    }, {
	        key: 'login',
	        value: function login() {
	            var _this2 = this;
	
	            this.User.login().then(function () {
	                _this2.$state.go('home.book.bookStep2', {
	                    type: 'facebook',
	                    reload: true
	                });
	            }).catch(function () {
	                _this2.error = 'Can\'t log in app';
	
	                setTimeout(function () {
	                    _this2.$state.go('home');
	                }, 1500);
	            });
	        }
	
	        // When user clicks on answer button
	
	    }, {
	        key: 'saveAnswer',
	        value: function saveAnswer(ansId) {
	            this.answeredId = ansId;
	            this.interests.push(this.questions[this.currentQuestion].answers[ansId].EN.answer);
	        }
	
	        // on nextQuestion click
	
	    }, {
	        key: 'nextQuestion',
	        value: function nextQuestion(ansId) {
	            this.saveAnswer(ansId);
	
	            if (this.currentQuestion + 1 === this.questions.length) {
	                // this.testEnd = true
	                sessionStorage.setItem('tourists_interests', (0, _stringify2.default)(this.interests));
	
	                this.$state.go('home.book.bookStep2', {
	                    reload: true
	                });
	            } else {
	                this.answeredId = -1;
	                this.currentQuestion = this.currentQuestion + 1;
	            }
	        }
	    }]);
	    return Step1Controller;
	}();
	
	Step1Controller.$inject = ['$scope', '$state', 'User'];
	
	exports.default = Step1Controller;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        'Wine Almighty': 'პირველი ღვინო',
	        'Tipsy Adventure': 'ღვინო ყველგან',
	        'Tradition of Supra': 'ქართული სუფრა',
	        'Colorful Cuisine': 'ფერადი სამზარეულო',
	        History: 'ისტორია',
	        Culture: 'კულტურა',
	        Architecture: 'არქიტექტურა',
	        Tbilisi: 'თბილისი',
	        Highlands: 'მთები',
	        'Ski Resorts': 'ზამთრის კურორტები',
	        'Black Sea': 'შავი ზღვა',
	        Nature: 'ბუნება',
	        Adventure: 'თავგადასავლები',
	        ყველა: 'All',
	        'პირველი ღვინო': 'Wine Almighty',
	        'ღვინო ყველგან': 'Tipsy Adventure',
	        'ქართული სუფრა': 'Tradition of Supra',
	        'ფერადი სამზარეულო': 'Colorful Cuisine',
	        ისტორია: 'History',
	        კულტურა: 'Culture',
	        არქიტექტურა: 'Architecture',
	        თბილისი: 'Tbilisi',
	        მთები: 'Highlands',
	        'ზამთრის კურორტები': 'Ski Resorts',
	        'შავი ზღვა': 'Black Sea',
	        ბუნება: 'Nature',
	        თავგადასავლები: 'Adventure',
	        TITLE: 'დააგენერირე პერსონალიზებული გზამკვლევი, შენი ინტერესებით',
	        SUB_TITLE: 'ან გვიპასუხეთ რამდენიმე კითხვაზე',
	        FB_ACCESS: 'facebook-ით დაკავშირება',
	        QUESTION: 'რას ანიჭებთ უპირატესობას?',
	        CLOSE: 'დახურვა',
	        BEEN_IN_GEORGIA_ONE: 'ყოფილხარ საქართველოში? გაიგე, ხარ თუ არა',
	        BEEN_IN_GEORGIA_TWO: 'ავტორი',
	        BY_TOURISTS: '7.000.000 ტურისტი',
	        SHARE: 'გაზიარება',
	        OWNER_TEXT: '-ს გზამკვლევი',
	        SWIPE: 'გადაფურცლე',
	        CURRENT_PAGE_TEXT: 'გვერდი',
	        TOTAL_PAGE_TEXT: 'ჯამში'
	    },
	    EN: {
	        'Wine Almighty': 'Wine Almighty',
	        'Tipsy Adventure': 'Tipsy Adventure',
	        'Tradition of Supra': 'Tradition of Supra',
	        'Colorful Cuisine': 'Colorful Cuisine',
	        History: 'History',
	        Culture: 'Culture',
	        Architecture: 'Architecture',
	        Tbilisi: 'Tbilisi',
	        Highlands: 'Highlands',
	        'Ski Resorts': 'Ski Resorts',
	        'Black Sea': 'Black Sea',
	        Nature: 'Nature',
	        Adventure: 'Adventure',
	        ყველა: 'All',
	        'პირველი ღვინო': 'Wine Almighty',
	        'ღვინო ყველგან': 'Tipsy Adventure',
	        'ქართული სუფრა': 'Tradition of Supra',
	        'ფერადი სამზარეულო': 'Colorful Cuisine',
	        ისტორია: 'History',
	        კულტურა: 'Culture',
	        არქიტექტურა: 'Architecture',
	        თბილისი: 'Tbilisi',
	        მთები: 'Highlands',
	        'ზამთრის კურორტები': 'Ski Resorts',
	        'შავი ზღვა': 'Black Sea',
	        ბუნება: 'Nature',
	        თავგადასავლები: 'Adventure',
	        TITLE: 'Generate a personal guidebook based on your interests',
	        SUB_TITLE: 'or tell us a bit about yourself',
	        FB_ACCESS: 'Access with facebook',
	        QUESTION: 'What do you prefer?',
	        CLOSE: 'Close',
	        BEEN_IN_GEORGIA_ONE: 'Have you ever been in Georgia? Find out if you are',
	        BEEN_IN_GEORGIA_TWO: 'a contributor',
	        BY_TOURISTS: 'by 7.000.000 tourists',
	        SHARE: 'Share guidebook',
	        OWNER_TEXT: '\'s Guidebook',
	        SWIPE: 'Swipe',
	        CURRENT_PAGE_TEXT: 'Page',
	        TOTAL_PAGE_TEXT: 'of'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(782);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-step1{border-radius:10px;background-color:#fff;width:680px;height:375px;margin-left:calc(50vw - 340px);margin-top:calc(50vh - 187.5px);box-shadow:8px 8px 15px #bbb;position:relative}.book-step1 .top-grid{position:absolute;left:15px;top:15px}.book-step1 .bottom-grid{position:absolute;bottom:15px;right:15px;width:100px;height:30px}.book-step1 .close{cursor:pointer;display:flex;align-items:center;float:right;margin-top:12px;margin-right:20px}.book-step1 .close:hover span{color:#8d8f93}.book-step1 .close span{font-size:12px;margin-left:7px;margin-top:2px;color:#a7a9ac;font-family:Graphik-Semibold}.book-step1 .fb-access{margin-top:20px;margin-bottom:10px;display:flex;justify-content:center}.book-step1 .fb-access a{padding-left:10px;padding-right:10px;text-decoration:none;display:flex;align-items:center;justify-content:center;background-color:#5b75ae;width:189px;height:47px;margin-left:15px;border:0;border-radius:60px;font-size:13px;font-family:Graphik-Semibold;color:#fff;outline:none;cursor:pointer}.book-step1 .fb-access a:hover{background-color:#4c6292}.book-step1 .fb-access a svg{margin-right:8px;margin-top:-3px;width:9px}.book-step1 .header,.book-step1 .question{font-size:22px;font-family:Graphik-Bold;color:#161616;font-weight:700;text-align:center}.book-step1 .header{padding-top:26px;width:355px;margin-left:calc(50% - 177.5px)}.book-step1 .subheader{font-size:13px;font-family:Graphik-Semibold;color:#9199a9;text-align:center;padding-top:10px}.book-step1 .questions-block{margin-top:15px}.book-step1 .questions-block .answers{margin-top:18px;display:flex;justify-content:center}.book-step1 .questions-block .answers button{background-color:#e9ebf0;width:165px;height:43px;margin-left:15px;border:0;border-radius:60px;font-size:13px;font-family:Graphik-Semibold;color:#000;box-shadow:1px 1px 10px #f4f4f5,1px -1px 10px #f4f4f5,-1px 1px 10px #f4f4f5,-1px -1px 10px #f4f4f5;outline:0}.book-step1 .questions-block .answers button.active,.book-step1 .questions-block .answers button:hover{background-color:#e33e4a;box-shadow:1px 1px 10px #f4ccd9,1px -1px 10px #f4ccd9,-1px 1px 10px #f4ccd9,-1px -1px 10px #f4ccd9;color:#fff}.book-step1 .questions-block .next{color:#e23e4d;font-weight:700;font-family:Graphik-Bold;font-size:11px;text-align:center;margin-top:18px;cursor:pointer}.book-step1 .steps{margin-top:20px;height:20px;text-align:center}.book-step1 .steps .step{margin-right:10px;width:16px;height:16px;border-radius:50%;border:2px solid #c8c8c8;text-align:center;display:inline-block}.book-step1 .steps .step:first-child{margin-left:15px}.book-step1 .steps .step:last-child{margin-right:0}.book-step1 .steps .step.completed{border:2px solid #e9004c}.book-step1 .steps .step.completed .dot{background-color:#e9004c}.book-step1 .steps .step .dot{position:relative;top:-2px;width:6px;height:6px;border-radius:50%;display:inline-block;background-color:#c8c8c8}.book-step1.geo .header{font-size:19px}.book-step1.geo .header,.book-step1.geo .next,.book-step1.geo .question{font-family:Georgian-Bold}.book-step1.geo .answers button,.book-step1.geo .close span,.book-step1.geo .subheader{font-family:Georgian-Semibold}", ""]);
	
	// exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(784);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step1.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookMobileStep1{min-height:100vh}.bookMobileStep1 .wrapper{display:table;margin:0 auto;margin-bottom:15px}.bookMobileStep1 .wrapper .header{font-size:22px;font-family:Graphik-Bold;max-width:350px;text-align:center;margin-top:30px;padding:0 10px}.bookMobileStep1 .wrapper .icons{position:relative;margin-top:15px;height:145px}.bookMobileStep1 .wrapper .icons .grid-top{position:absolute;right:45px}.bookMobileStep1 .wrapper .icons .grid-bottom{position:absolute;left:45px;top:25px}.bookMobileStep1 .wrapper .icons #fb_icon{position:absolute;margin-left:calc(50% - 58px)}.bookMobileStep1 .wrapper .fb-access{display:flex;justify-content:center;margin-top:20px}.bookMobileStep1 .wrapper .fb-access a{display:flex;justify-content:center;align-items:center;background-color:#5b75ae;width:80vw;max-width:320px;height:47px;border-radius:24px;font-family:Graphik-Bold;font-size:13px;color:#fff}.bookMobileStep1 .wrapper .subheader{font-size:12px;font-family:Graphik-Semibold;color:#9199a9;text-align:center;padding:20px 0}.bookMobileStep1 .wrapper .questions-block{text-align:center}.bookMobileStep1 .wrapper .questions-block .question{font-size:22px;font-family:Graphik-Bold;margin:15px 0}.bookMobileStep1 .wrapper .questions-block .answers{display:table;margin:0 auto}.bookMobileStep1 .wrapper .questions-block .answers button{display:block;background-color:#e9ebf0;width:165px;height:43px;margin-left:15px;border:0;border-radius:60px;font-size:13px;font-family:Graphik-Semibold;color:#000;box-shadow:1px 1px 10px #f4f4f5,1px -1px 10px #f4f4f5,-1px 1px 10px #f4f4f5,-1px -1px 10px #f4f4f5;outline:0;margin:10px 0}.bookMobileStep1 .wrapper .questions-block .answers button:active,.bookMobileStep1 .wrapper .questions-block .answers button:hover{background-color:#e33e4a;box-shadow:1px 1px 10px #f4ccd9,1px -1px 10px #f4ccd9,-1px 1px 10px #f4ccd9,-1px -1px 10px #f4ccd9;color:#fff}.bookMobileStep1 .wrapper .steps{margin-top:10px;height:20px;text-align:center}.bookMobileStep1 .wrapper .steps .step{margin-right:10px;width:16px;height:16px;border-radius:50%;border:2px solid #c8c8c8;text-align:center;display:inline-block}.bookMobileStep1 .wrapper .steps .step:last-child{margin-right:0}.bookMobileStep1 .wrapper .steps .step.completed{border:2px solid #e9004c}.bookMobileStep1 .wrapper .steps .step.completed .dot{background-color:#e9004c}.bookMobileStep1 .wrapper .steps .step .dot{position:relative;top:-4px;width:6px;height:6px;border-radius:50%;display:inline-block;background-color:#c8c8c8}.bookMobileStep1 .footer-wrapper{margin-top:calc(100vh - 92px - 367px)}.bookMobileStep1.geo .header,.bookMobileStep1.geo .questions-block .answers button,.bookMobileStep1.geo .questions-block .question,.bookMobileStep1.geo .subheader{font-family:Georgian-Bold}.bookMobileStep1.geo .questions-block .question{font-size:19px}", ""]);
	
	// exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _step = __webpack_require__(786);
	
	var _step2 = _interopRequireDefault(_step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookStep2Module = _angular2.default.module('bookStep2', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('home.book.bookStep2', {
	        url: '/step-2?type',
	        component: 'bookStep2'
	    });
	}]).component('bookStep2', _step2.default).name;
	
	exports.default = bookStep2Module;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _step = __webpack_require__(787);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(788);
	
	var _step4 = _interopRequireDefault(_step3);
	
	__webpack_require__(789);
	
	__webpack_require__(791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step2Component = {
	    bindings: {},
	    template: _step2.default,
	    controller: _step4.default
	};
	
	exports.default = step2Component;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-step2 hidden-xs\">\n\t<img class=\"top-grid\" src=\"/assets/images/popup-grid-top.svg\" alt=\"top-grid\">\n\t<img class=\"bottom-grid\" src=\"/assets/images/popup-grid-bottom.svg\" alt=\"bottom-grid\">\n\n\t<div class=\"book-loader\">\n\t\t<svg width=\"150px\" height=\"150px\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\"\n\t\t class=\"lds-book\" style=\"background: none;\">\n\t\t\t<path d=\"M20 25L80 25L80 75L20 75Z\" fill=\"#f16c6a\" stroke=\"#ec3e3c\" stroke-width=\"1\"></path>\n\t\t\t<path d=\"M 50 25 L 75.8333 24.3056 L 75.8333 75.6944 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 65.8733 22.6456 L 65.8733 77.3544 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\"\n\t\t\t\t repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 56.0333 21.0056 L 56.0333 78.9944 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\"\n\t\t\t\t repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t</svg>\n\t</div>\n</div>\n\n<div class=\"bookMobileStep2 visible-xs\">\n\t<div class=\"book-loader\">\n\t\t<svg width=\"150px\" height=\"150px\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\"\n\t\t class=\"lds-book\" style=\"background: none;\">\n\t\t\t<path d=\"M20 25L80 25L80 75L20 75Z\" fill=\"#f16c6a\" stroke=\"#ec3e3c\" stroke-width=\"1\"></path>\n\t\t\t<path d=\"M 50 25 L 75.8333 24.3056 L 75.8333 75.6944 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 65.8733 22.6456 L 65.8733 77.3544 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\"\n\t\t\t\t repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 56.0333 21.0056 L 56.0333 78.9944 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\"\n\t\t\t stroke=\"#ec3e3c\" stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.5;0.501;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"1;1;0;0\" keyTimes=\"0;0.5;0.5001;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"-0.396s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"-0.19920000000000002s\"\n\t\t\t\t repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t\t<path d=\"M 50 25 L 20 25 L 20 75 L 50 75\" stroke-linejoin=\"round\" stroke-linecap=\"round\" fill=\"#f16c6a\" stroke=\"#ec3e3c\"\n\t\t\t stroke-width=\"1\">\n\t\t\t\t<animate attributeName=\"d\" calcMode=\"linear\" values=\"M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75\"\n\t\t\t\t keyTimes=\"0;0.499;0.5;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t\t<animate attributeName=\"opacity\" calcMode=\"linear\" values=\"0;0;1;1\" keyTimes=\"0;0.4999;0.5;1\" dur=\"1.2\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n\t\t\t</path>\n\t\t</svg>\n\t</div>\n</div>\n"

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step2Controller = function () {
	    function Step2Controller($state, BookFactory) {
	        (0, _classCallCheck3.default)(this, Step2Controller);
	
	        this.name = 'step2';
	
	        this.$state = $state;
	        this.BookFactory = BookFactory;
	    }
	
	    (0, _createClass3.default)(Step2Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.generateBook();
	        }
	    }, {
	        key: 'generateBook',
	        value: function generateBook() {
	            if (this.$state.params.type === 'facebook') {
	                this.getFacebookBook();
	            } else {
	                this.getGuestBook();
	            }
	        }
	    }, {
	        key: 'getFacebookBook',
	        value: function getFacebookBook() {
	            var _this = this;
	
	            this.BookFactory.generateFacebookBook().then(function (data) {
	                var bookId = data.bookId;
	
	
	                localStorage.setItem('tourists_bookId', bookId);
	
	                if (_this.$state.current.name === 'home.book.bookStep2') {
	                    _this.$state.go('home.book.bookStep3', {
	                        bookId: bookId
	                    }, {
	                        reload: true
	                    });
	                } else if (_this.$state.current.name === 'bookMobile.bookMobileStep2') {
	                    _this.$state.go('bookMobile.bookMobileStep3', {
	                        bookId: bookId
	                    }, {
	                        reload: true
	                    });
	                }
	            }).catch(function (err) {
	                console.log('Error occured in method getFacebookBook', err);
	
	                _this.error = err.data;
	            });
	        }
	    }, {
	        key: 'getGuestBook',
	        value: function getGuestBook() {
	            var _this2 = this;
	
	            var interests = void 0;
	
	            try {
	                interests = JSON.parse(sessionStorage.getItem('tourists_interests'));
	            } catch (e) {
	                interests = [];
	            }
	
	            this.BookFactory.generateGuestBook(interests).then(function (data) {
	                var bookId = data.bookId;
	
	
	                localStorage.setItem('tourists_bookId', bookId);
	
	                if (_this2.$state.current.name === 'home.book.bookStep2') {
	                    _this2.$state.go('home.book.bookStep3', {
	                        bookId: bookId
	                    }, {
	                        reload: true
	                    });
	                } else if (_this2.$state.current.name === 'bookMobile.bookMobileStep2') {
	                    _this2.$state.go('bookMobile.bookMobileStep3', {
	                        bookId: bookId
	                    }, {
	                        reload: true
	                    });
	                }
	            }).catch(function (err) {
	                console.log('Error occured in method getGuestBook', err);
	
	                _this2.error = err.data;
	            });
	        }
	    }]);
	    return Step2Controller;
	}();
	
	Step2Controller.$inject = ['$state', 'BookFactory'];
	
	exports.default = Step2Controller;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(790);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-step2{border-radius:10px;background-color:#fff;width:680px;height:350px;margin-left:calc(50vw - 340px);margin-top:calc(50vh - 175px);box-shadow:8px 8px 15px #bbb;position:relative}.book-step2 .top-grid{position:absolute;left:15px;top:15px}.book-step2 .bottom-grid{position:absolute;bottom:15px;right:15px;width:100px;height:30px}.book-step2 .book-loader{display:flex;justify-content:center;margin-top:35px}", ""]);
	
	// exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(792);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step2.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookMobileStep2 .book-loader{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center}", ""]);
	
	// exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _step = __webpack_require__(794);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _paginator = __webpack_require__(808);
	
	var _paginator2 = _interopRequireDefault(_paginator);
	
	var _bookcard = __webpack_require__(815);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(823);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	var _bookcard5 = __webpack_require__(831);
	
	var _bookcard6 = _interopRequireDefault(_bookcard5);
	
	var _bookcard7 = __webpack_require__(839);
	
	var _bookcard8 = _interopRequireDefault(_bookcard7);
	
	var _bookcard9 = __webpack_require__(847);
	
	var _bookcard10 = _interopRequireDefault(_bookcard9);
	
	var _card = __webpack_require__(853);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(861);
	
	var _card4 = _interopRequireDefault(_card3);
	
	var _card5 = __webpack_require__(869);
	
	var _card6 = _interopRequireDefault(_card5);
	
	var _card7 = __webpack_require__(875);
	
	var _card8 = _interopRequireDefault(_card7);
	
	var _card9 = __webpack_require__(881);
	
	var _card10 = _interopRequireDefault(_card9);
	
	var _categorycard = __webpack_require__(889);
	
	var _categorycard2 = _interopRequireDefault(_categorycard);
	
	var _paginator3 = __webpack_require__(814);
	
	var _paginator4 = _interopRequireDefault(_paginator3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookStep3Module = _angular2.default.module('bookStep3', [_angularUiRouter2.default, _paginator2.default, _bookcard2.default, _bookcard4.default, _bookcard6.default, _bookcard8.default, _bookcard10.default, _card2.default, _card4.default, _card6.default, _card8.default, _card10.default, _categorycard2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('home.book.bookStep3', {
	        url: '/step-3?bookId',
	        component: 'bookStep3'
	    });
	}]).component('bookStep3', _step2.default).factory('PaginatorFactory', _paginator4.default).name;
	
	exports.default = bookStep3Module;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _step = __webpack_require__(795);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _step3 = __webpack_require__(796);
	
	var _step4 = _interopRequireDefault(_step3);
	
	__webpack_require__(804);
	
	__webpack_require__(806);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var step3Component = {
	    bindings: {},
	    template: _step2.default,
	    controller: _step4.default
	};
	
	exports.default = step3Component;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-step3 hidden-xs\" ng-keyup=\"$ctrl.onKeyUp($event)\" tabindex=\"0\" id=\"book-step3\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"bookmark\" ng-style=\"{ 'visibility': $ctrl.bookOwnerFullName || $ctrl.fullName ? 'visible': 'hidden' }\"></div>\n    <h1 class=\"guidebook\" ng-style=\"{ 'visibility': $ctrl.bookOwnerFullName || $ctrl.fullName ? 'visible': 'hidden' }\">\n        <span class=\"name\">{{ $ctrl.bookOwnerFullName || $ctrl.fullName }}</span>\n        <span class=\"owner\">{{$ctrl.ownerText}}</span>\n    </h1>\n\n    <div class=\"close\" ui-sref=\"home\">\n        <svg id=\"Close\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"33\" viewBox=\"0 0 30 33\">\n            <image data-name=\"close 1\" width=\"30\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAMAAAB5ytLYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABNVBMVEXw9P6AgIDw9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P4AAAB0wDQdAAAAZXRSTlMAAAdLhbjY8/XbvotTDSyd9PmqOhKc/q4cNOLsRkHx+k4n8Pg1BdHfCnmGFG53zdUbIF1hkJG7ve/u1ra6jFheFsjPaHIMEHF9BMzZCCHtLjf2SDHd6D4Pl/2mFymZ96MzStqIUFw2AL0AAAABYktHRGYs1NklAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUYCCcRdHMjBgAAARhJREFUOMu91NdWwlAQheGJhIACEntBBYMlih2kCAp2imAvqKCg8/6v4AkICSQ545X/ZdZ3k6zMBug24BCdkgsR3YNDHq/v96kgCF0x7JfR2MjoWJ8Zn5hEU1PTRjMzi1YF5nQzv4DWBUMds6igXeGltlleQftW1ZZZQ17rmvEpXCNHmNlAfpvMbBFmW4AdpNqFPdJEIUaafYiTJgESaSRIkiYJJEH8VxMgSQoO/vDuadJk4JA0MTgiTRZypGFXdkyQE/YfnhLmjJlz/hdSLrTbueSafOu+CkUOKV21b7lcsSXydWcTbuw24fZO35b7B0vy+GTcqOeXqpm8vvVt3XvN1QPqH5+mPWSb2RCdJW0U5Wb861vVN/MHCPiu7T51uK8AAAAASUVORK5CYII=\"\n            />\n            <image data-name=\"close 2\" x=\"12\" y=\"13\" width=\"7\" height=\"7\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWAgICUnrKUnrKUnrKUnrIAAADqJbCtAAAABHRSTlMA8Hd4OPcDdQAAAAFiS0dEBfhv6ccAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRgIJxF0cyMGAAAALUlEQVQI12MQYmBgUGRQMWBgdmJgdmYwMWBgMDF2BgoyuxjASbAIRBaiEqwLAJo4BS96+asEAAAAAElFTkSuQmCC\"\n            />\n        </svg>\n        <span>{{$ctrl.closeText}}</span>\n    </div>\n\n    <div class=\"left-side\">\n        <ul>\n            <li ng-repeat=\"category in $ctrl.categories\" ng-class=\"{active: $ctrl.texts[$ctrl.language][$ctrl.selectedCategory] === category}\">\n                <span ng-click=\"$ctrl.selectCategory(category)\">{{category}}</span>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"posts\">\n        <!-- <div class=\"loading-wrapper\" ng-if=\"!$ctrl.bookLoaded\">\n            <loader></loader>\n        </div> -->\n\n        <div class=\"flipbook\" ng-style='{ \"display\": $ctrl.bookLoaded ? \"block\": \"none\" }'>\n            <div class=\"card-wrapper\" style=\"visibility: hidden\">dummy first</div>\n            <div class=\"card-wrapper\" ng-repeat=\"post in $ctrl.posts\" ng-init=\"$ctrl.isLast($last)\">\n                <!-- <card6 data=\"post\" ng-if=\"post.cardGroup === 4\"></card6>\n\t\t\t\t<card7 data=\"post\" ng-if=\"post.cardGroup === 5\"></card7>\n\t\t\t\t<card9 data=\"post\" ng-if=\"post.cardGroup === 3\"></card9>\n\t\t\t\t<card10 data=\"post\" ng-if=\"post.cardGroup === 2\"></card10>\n\t\t\t\t<card11 data=\"post\" ng-if=\"post.cardGroup === 1\"></card11> -->\n                <bookcard1 data=\"post\" ng-if=\"post.cardType === 'layout image' && $index % 2 !== 0\"></bookcard1>\n                <bookcard2 data=\"post\" ng-if=\"post.cardType === 'layout likes'\"></bookcard2>\n                <bookcard3 data=\"post\" ng-if=\"post.cardType === 'layout text' && $index % 2 !== 0\"></bookcard3>\n                <bookcard4 data=\"post\" ng-if=\"post.cardType === 'layout text' && $index % 2 === 0\"></bookcard4>\n                <bookcard5 data=\"post\" ng-if=\"post.cardType === 'layout image' && $index % 2 === 0\"></bookcard5>\n                <categorycard4 data=\"post\" ng-if=\"post.cardType === 'layout category'\"></categorycard4>\n            </div>\n            <div class=\"card-wrapper\" style=\"visibility: hidden\">dummy last</div>\n        </div>\n    </div>\n\n    <div class=\"right-side\">\n        <div class=\"check-contributor\">\n            <p>{{$ctrl.beenInGeorgiaOne}}\n                <b ui-sref=\"home.contributor.step1\">{{$ctrl.beenInGeorgiaTwo}}</b>\n            </p>\n        </div>\n        <p class=\"by-tourists\">{{$ctrl.byTourists}}</p>\n\n        <div class=\"page-number\">\n            {{ $ctrl.activePage }} / {{ $ctrl.pagesCount }}\n        </div>\n    </div>\n\n    <div class=\"book-footer\">\n        <paginator></paginator>\n    </div>\n</div>\n\n<div class=\"bookMobileStep3 visible-xs\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <navbar></navbar>\n\n    <p class=\"guidebook\">\n        <span ng-style=\"{ 'display': $ctrl.fullName ? 'inline': 'none' }\">\n            <span class=\"name\">{{ $ctrl.fullName }}</span>\n            <span class=\"owner\">{{$ctrl.ownerText}}</span>\n        </span>\n    </p>\n\n    <div ng-if=\"!$ctrl.bookLoaded\">\n        <loader></loader>\n    </div>\n\n    <div ng-if=\"$ctrl.bookLoaded\">\n        <div class=\"swipe-container\">\n            <swiper on-transition-end=\"$ctrl.transitionEnd\">\n                <slides>\n                    <slide ng-repeat=\"post in $ctrl.posts\">\n                        <bookcard1 data=\"post\" ng-if=\"post.cardType === 'layout image'\"></bookcard1>\n                        <bookcard2 data=\"post\" ng-if=\"post.cardType === 'layout likes'\"></bookcard2>\n                        <bookcard3 data=\"post\" ng-if=\"post.cardType === 'layout text' && $index % 2 !== 0\"></bookcard3>\n                        <bookcard4 data=\"post\" ng-if=\"post.cardType === 'layout text' && $index % 2 === 0\"></bookcard4>\n                        <categorycard4 data=\"post\" ng-if=\"post.cardType === 'layout category'\"></categorycard4>\n                    </slide>\n                </slides>\n                <div class=\"swipe-me\" ng-if=\"!$ctrl.alreadySwiped\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21.06\" height=\"26\" viewBox=\"0 0 21.06 26\">\n\n                        <defs>\n                            <style>\n                                .swipe-svg {\n                                    fill: #fff;\n                                    fill-rule: evenodd;\n                                }\n                            </style>\n                        </defs>\n                        <path data-name=\"swipe-svg\" class=\"swipe-svg\" d=\"M1708.03,517.152h2.62a0.717,0.717,0,0,0,.01.991,0.7,0.7,0,0,0,.99,0l1.19-1.2a0.716,0.716,0,0,0,0-1l-1.19-1.2a0.7,0.7,0,0,0-.99,0,0.717,0.717,0,0,0-.01.991h-2.62A0.706,0.706,0,0,0,1708.03,517.152Zm4.31,2.645h-2.61a0.717,0.717,0,0,0-.01-0.991,0.7,0.7,0,0,0-.99,0l-1.19,1.2a0.7,0.7,0,0,0,0,1l1.19,1.2a0.674,0.674,0,0,0,.49.206,0.707,0.707,0,0,0,.51-1.2h2.61A0.706,0.706,0,0,0,1712.34,519.8Zm-3.14,5.085a3.288,3.288,0,0,0-1.16.216,3.126,3.126,0,0,0-2.78-1.718,3.238,3.238,0,0,0-1.21.231,3.112,3.112,0,0,0-3.62-1.54v-5.165h0a3.048,3.048,0,0,0-3.1-2.906,3.133,3.133,0,0,0-3.12,3.138v9.568a3.212,3.212,0,0,0-2.2,2.976c-0.07,2.382.13,5.4,2.24,7.579,1.78,1.843,4.56,2.739,8.51,2.739,3.55,0,6.18-1.052,7.81-3.127a9.11,9.11,0,0,0,1.75-5.68l-0.01-3.175A3.13,3.13,0,0,0,1709.2,524.882Zm-6.44,13.706c-8.36,0-9.48-4.268-9.35-8.867a1.813,1.813,0,0,1,1.75-1.764v2.034a0.244,0.244,0,0,0,.23.286,0.239,0.239,0,0,0,.23-0.285V517.138a1.715,1.715,0,0,1,1.71-1.727,1.658,1.658,0,0,1,1.7,1.5s0,6.342-.01,7.9v0.335a0.284,0.284,0,0,0,.28.281,0.277,0.277,0,0,0,.28-0.281v-0.084a1.715,1.715,0,0,1,3.43.028v1.251a0.282,0.282,0,0,0,.28.277,0.273,0.273,0,0,0,.27-0.277v-0.072a1.612,1.612,0,0,1,1.7-1.474,1.723,1.723,0,0,1,1.72,1.727v1.266a0.265,0.265,0,1,0,.53,0v-0.1a1.612,1.612,0,0,1,1.69-1.395,1.722,1.722,0,0,1,1.71,1.727l0.01,3.173C1710.92,534.144,1709.78,538.588,1702.76,538.588Z\"\n                            transform=\"translate(-1692 -514)\" />\n                    </svg>\n                    <span>{{$ctrl.swipeText}}</span>\n                </div>\n            </swiper>\n\n        </div>\n\n        <div class=\"pages\">\n            {{ $ctrl.currentPostIndex + 1 }} / {{ $ctrl.posts.length }}\n        </div>\n\n        <button class=\"share-guidebook\" ng-click=\"$ctrl.shareGuidebook()\">{{$ctrl.shareText}}</button>\n    </div>\n\n    <footer></footer>\n</div>\n"

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray2 = __webpack_require__(797);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _book = __webpack_require__(780);
	
	var _book2 = _interopRequireDefault(_book);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step3Controller = function () {
	    function Step3Controller($scope, $rootScope, $stateParams, $timeout, config, PaginatorFactory, User, BookFactory, Category, Share) {
	        (0, _classCallCheck3.default)(this, Step3Controller);
	
	        this.name = 'step3';
	
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$stateParams = $stateParams;
	        this.$timeout = $timeout;
	        this.config = config;
	
	        this.PaginatorFactory = PaginatorFactory;
	        this.User = User;
	        this.BookFactory = BookFactory;
	        this.Category = Category;
	        this.ShareFactory = Share;
	        this.transitionEnd = this.transitionEnd.bind(this);
	
	        this.categories = [];
	        this.selectedCategory = null;
	
	        this.texts = _book2.default;
	    }
	
	    (0, _createClass3.default)(Step3Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchPagesCount();
	            this.watchActivePage();
	            this.watchLanguage();
	
	            this.getBook();
	
	            this.initializeUser();
	
	            this.bindEvents();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _book2.default[this.language],
	                CLOSE = _texts$language.CLOSE,
	                BEEN_IN_GEORGIA_ONE = _texts$language.BEEN_IN_GEORGIA_ONE,
	                BEEN_IN_GEORGIA_TWO = _texts$language.BEEN_IN_GEORGIA_TWO,
	                BY_TOURISTS = _texts$language.BY_TOURISTS,
	                OWNER_TEXT = _texts$language.OWNER_TEXT,
	                CURRENT_PAGE_TEXT = _texts$language.CURRENT_PAGE_TEXT,
	                TOTAL_PAGE_TEXT = _texts$language.TOTAL_PAGE_TEXT,
	                SWIPE = _texts$language.SWIPE,
	                SHARE = _texts$language.SHARE;
	
	
	            this.closeText = CLOSE;
	            this.beenInGeorgiaOne = BEEN_IN_GEORGIA_ONE;
	            this.beenInGeorgiaTwo = BEEN_IN_GEORGIA_TWO;
	            this.byTourists = BY_TOURISTS;
	            this.ownerText = OWNER_TEXT;
	            this.currentPageText = CURRENT_PAGE_TEXT;
	            this.totalPageText = TOTAL_PAGE_TEXT;
	            this.swipeText = SWIPE;
	            this.shareText = SHARE;
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.render();
	                }
	            });
	        }
	    }, {
	        key: 'initializeUser',
	        value: function initializeUser() {
	            var user = this.User.getUser();
	
	            if (user) {
	                try {
	                    var _user$fullName$split = user.fullName.split(' '),
	                        _user$fullName$split2 = (0, _slicedToArray3.default)(_user$fullName$split, 1),
	                        fullName = _user$fullName$split2[0];
	
	                    this.fullName = fullName;
	                } catch (e) {
	                    console.log('fullName is undefined', e);
	                }
	            }
	        }
	    }, {
	        key: 'initializeTurnjs',
	        value: function initializeTurnjs() {
	            var postsLength = this.posts.length + 1;
	            var step3Scope = this;
	
	            $('.flipbook').turn({
	                // Elevation
	                elevation: 50,
	                // Enable gradients
	                gradients: true,
	                // Duration
	                duration: 850,
	                page: 2,
	                when: {
	                    start: function start(event, pageObject) {
	                        if (pageObject.next === 1 || pageObject.next > postsLength) {
	                            event.preventDefault();
	                        }
	                    },
	                    turning: function turning(event, page) {
	                        if (page === 1 || page > postsLength) {
	                            event.preventDefault();
	                        }
	                    },
	                    turned: function turned(event, page) {
	                        if (!step3Scope.bookFlipped) {
	                            step3Scope.bookFlipped = true;
	                            return;
	                        }
	
	                        step3Scope.triggerChange(page, true);
	                    }
	                }
	            });
	
	            step3Scope.bookLoaded = true;
	        }
	    }, {
	        key: 'isLast',
	        value: function isLast(value) {
	            if (value) {
	                this.initializeTurnjs();
	            }
	        }
	    }, {
	        key: 'triggerChange',
	        value: function triggerChange(page, mustApplyScope) {
	            var activePage = Math.floor(page / 2);
	
	            this.PaginatorFactory.setActivePageNumber(activePage);
	            this.$rootScope.$broadcast('activePageChangeEvent', mustApplyScope);
	        }
	    }, {
	        key: 'getBook',
	        value: function getBook() {
	            var _this2 = this;
	
	            this.posts = [];
	            this.bookLoaded = false;
	
	            this.BookFactory.getBook(this.$stateParams.bookId).then(function (response) {
	                var _response$data = response.data,
	                    posts = _response$data.posts,
	                    categories = _response$data.categories,
	                    user = _response$data.user;
	
	
	                if (user) {
	                    var _user$fullName$split3 = user.fullName.split(' '),
	                        _user$fullName$split4 = (0, _slicedToArray3.default)(_user$fullName$split3, 1),
	                        fullName = _user$fullName$split4[0];
	
	                    _this2.bookOwnerFullName = fullName;
	                }
	
	                var _categories = (0, _slicedToArray3.default)(categories, 1),
	                    selectedCategory = _categories[0];
	
	                var prevCardCategory = '';
	
	                _this2.posts = [];
	
	                posts.forEach(function (item) {
	                    var category = item.category;
	
	
	                    if (category !== prevCardCategory) {
	                        prevCardCategory = category;
	
	                        _this2.posts.push({
	                            category: category,
	                            cardType: 'layout category'
	                        });
	                    }
	
	                    _this2.posts.push(item);
	                });
	
	                _this2.categories = categories.map(function (item) {
	                    return _book2.default[_this2.language][item];
	                });
	                _this2.selectedCategory = selectedCategory;
	
	                _this2.pagesCount = Math.ceil(_this2.posts.length / 2);
	                _this2.activePage = 1;
	                _this2.bookFlipped = false;
	                _this2.PaginatorFactory.setDataReady(true, _this2.pagesCount, _this2.activePage);
	            }).catch(function (err) {
	                console.log('Error occured in method getBook', err);
	
	                _this2.error = err.data;
	            });
	        }
	    }, {
	        key: 'transitionEnd',
	        value: function transitionEnd(ev) {
	            if (!this.alreadySwiped && ev.activeIndex > 0) {
	                this.alreadySwiped = true;
	            }
	
	            this.currentPostIndex = ev.activeIndex;
	            this.$scope.$apply();
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            var that = this;
	
	            $('#book-step3').focus();
	
	            $('.posts').on('click', '.card-wrapper', function click() {
	                var activeIndex = that.activePage * 2 - 1;
	
	                if ($(this).hasClass('even') && activeIndex > 1) {
	                    that.triggerChange(activeIndex - 1, false);
	                } else if ($(this).hasClass('odd') && activeIndex < that.posts.length - 1) {
	                    that.triggerChange(activeIndex + 3, false);
	                }
	            });
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            var activeIndex = this.activePage * 2 - 1;
	
	            if (event.key === 'ArrowLeft' && activeIndex > 1) {
	                this.triggerChange(activeIndex - 1, false);
	            } else if (event.key === 'ArrowRight' && activeIndex < this.posts.length - 1) {
	                this.triggerChange(activeIndex + 3, false);
	            }
	        }
	    }, {
	        key: 'selectCategory',
	        value: function selectCategory(newCategory) {
	            var category = _book2.default[this.language][newCategory];
	
	            if (this.selectedCategory === category) {
	                return;
	            }
	
	            this.selectedCategory = category;
	
	            var page = this.posts.findIndex(function (item) {
	                return item.category === category;
	            });
	
	            page = page % 2 === 1 ? page + 1 : page + 2;
	
	            this.triggerChange(page, false);
	        }
	    }, {
	        key: 'watchPagesCount',
	        value: function watchPagesCount() {
	            var _this3 = this;
	
	            this.$scope.$watch(function () {
	                return _this3.PaginatorFactory.getPagesCount();
	            }, function (newValue) {
	                _this3.pagesCount = newValue;
	            });
	        }
	    }, {
	        key: 'watchActivePage',
	        value: function watchActivePage() {
	            var _this4 = this;
	
	            this.$scope.$watch(function () {
	                return _this4.PaginatorFactory.getActivePageNumber();
	            }, function (newValue) {
	                _this4.activePage = newValue;
	
	                if (_this4.posts.length > 0) {
	                    var activeIndex = _this4.activePage * 2 - 1;
	
	                    try {
	                        _this4.selectedCategory = _this4.posts[activeIndex].category;
	                    } catch (e) {
	                        console.log(e);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'shareGuidebook',
	        value: function shareGuidebook() {
	            var url = this.config.frontUrl + '/shared-moments/book/step-3?bookId=' + this.$stateParams.bookId;
	
	            this.ShareFactory.shareObject(url);
	        }
	    }]);
	    return Step3Controller;
	}();
	
	Step3Controller.$inject = ['$scope', '$rootScope', '$stateParams', '$timeout', 'config', 'PaginatorFactory', 'User', 'BookFactory', 'Category', 'Share'];
	
	exports.default = Step3Controller;

/***/ }),
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(805);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step3.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-step3{min-width:1100px;width:calc(100vw - 80px);height:calc(100vh - 40px);margin-top:calc(50vh - (100vh - 40px)/2);margin-left:calc(50vw - (100vw - 80px)/2);background-color:#fff;border-radius:10px;position:relative;outline:none}.book-step3 .guidebook{font-size:23.232px;font-family:Graphik-Bold;color:#161616;font-weight:700;line-height:1.55;padding-top:30px;margin-left:53px}.book-step3 .bookmark{position:absolute;background-color:#e33d47;width:7px;height:57px;left:30px}.book-step3 .close{cursor:pointer;display:flex;align-items:center;float:right;margin-top:-60px;margin-right:35px}.book-step3 .close:hover span{color:#8d8f93}.book-step3 .close span{font-size:12px;margin-left:7px;margin-top:2px;color:#a7a9ac;font-family:Graphik-Semibold}.book-step3 .left-side{width:165px;display:inline-block;overflow-y:auto;padding-top:2px;margin-left:20px;margin-top:25px;height:calc(100% - 180px)}.book-step3 .left-side::-webkit-scrollbar{width:3px}.book-step3 .left-side::-webkit-scrollbar-track{background:#f2f2f2}.book-step3 .left-side::-webkit-scrollbar-thumb{background:#bbb}.book-step3 .left-side::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.book-step3 .left-side ul{list-style:none}.book-step3 .left-side ul li{user-select:none;display:flex;color:rgba(0,0,0,.502);padding-bottom:30px;font-size:12px;font-weight:700;font-family:Graphik-Regular}.book-step3 .left-side ul li span:before{content:\" \";float:left;width:12px;border-radius:50%;border:1px solid rgba(0,0,0,.502);height:12px;margin:-2px 10px 0 0}.book-step3 .left-side ul li.active,.book-step3 .left-side ul li:hover{color:#000}.book-step3 .left-side ul li.active>span:before{background:#f8c339;border-color:#f8c339}.book-step3 .left-side ul li span{cursor:pointer}.book-step3 .posts{width:calc((100vw - 80px) - 165px - 130px - 80px);height:calc((100vh - 40px) - 130px);top:67px;position:absolute;left:193px;z-index:2}.book-step3 .posts .page-wrapper{-ms-box-shadow:0 0 20px rgba(0,0,0,.1);-o-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1)}.book-step3 .posts .loading-wrapper{height:100%;display:flex;justify-content:center;align-items:center}.book-step3 .posts::-webkit-scrollbar{width:3px}.book-step3 .posts::-webkit-scrollbar-track{background:#f2f2f2}.book-step3 .posts::-webkit-scrollbar-thumb{background:#bbb}.book-step3 .posts::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.book-step3 .posts .flipbook{min-width:881px;width:calc((100vw - 80px) - 165px - 130px - 80px)!important;height:calc((100vh - 40px) - 130px)!important}.book-step3 .posts .card-wrapper{background:#fff;display:flex;justify-content:center;align-items:center}.book-step3 .right-side{width:130px;height:calc(100% - 120px);position:absolute;top:calc(50% - (100% - 120px)/2);right:10px}.book-step3 .right-side .check-contributor{font-size:11px;font-family:Graphik-Regular;margin-top:33px;color:#6e6e6e}.book-step3 .right-side .check-contributor b{color:#464646;cursor:pointer}.book-step3 .right-side .check-contributor b:hover{color:#000}.book-step3 .right-side .by-tourists{transform:rotate(-90deg);width:372px;font-size:34px;font-family:Graphik-Bold;color:rgba(0,0,0,.102);font-weight:700;position:absolute;left:-126px;top:210px}.book-step3 .right-side .page-number{position:absolute;bottom:0;margin-left:10px;width:100px;height:35px;border-radius:60px;border:0;background-color:#eeeeef;font-size:10px;font-family:Graphik-Bold;line-height:35px;text-align:center}.book-step3 .book-footer{position:absolute;width:100%;bottom:0;height:63px;z-index:1}.book-step3.geo .close span{font-family:Georgian-Semibold}.book-step3.geo .left-side ul li,.book-step3.geo .right-side .check-contributor{font-family:Georgian-Regular}.book-step3.geo .guidebook .owner{font-family:Georgian-Bold}", ""]);
	
	// exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(807);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step3.mobile.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./step3.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".bookMobileStep3>div{min-height:calc(100vh - 288px)}.bookMobileStep3 .swiper-slide{text-align:left!important}.bookMobileStep3 .swipe-container{position:relative}.bookMobileStep3 .swipe-container .cards{display:table;margin:0 auto}.bookMobileStep3 .swipe-container .swipe-me{position:absolute;width:100%;height:60px;background:rgba(234,0,79,.8);top:calc(50% - 30px);z-index:11;display:flex;justify-content:center;align-items:center;user-select:none}.bookMobileStep3 .swipe-container .swipe-me span{font-family:Graphik-Regular;font-size:14px;margin-left:10px;color:#fff}.bookMobileStep3 .pages{display:table;width:120px;height:45px;border-radius:60px;border:0;background-color:#eeeeef;font-size:11px;font-family:Graphik-Bold;line-height:45px;text-align:center;margin:25px auto}.bookMobileStep3 .guidebook{padding:20px 0;font-size:24px;font-family:Graphik-Bold;text-align:center}.bookMobileStep3 .share-guidebook{background-color:#ea004f;border:0;height:45px;color:#fff;font-family:Graphik-Semibold;letter-spacing:.2px;width:160px;outline:0;border-radius:80px;font-size:12px;display:table;margin:25px auto}.bookMobileStep3.geo .swipe-me span{font-family:Georgian-Regular}.bookMobileStep3.geo .guidebook .owner{font-family:Georgian-Bold}.bookMobileStep3.geo .share-guidebook{font-family:Georgian-Semibold}", ""]);
	
	// exports


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paginator = __webpack_require__(809);
	
	var _paginator2 = _interopRequireDefault(_paginator);
	
	var _paginator3 = __webpack_require__(814);
	
	var _paginator4 = _interopRequireDefault(_paginator3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginatorModule = _angular2.default.module('paginator', [_angularUiRouter2.default]).component('paginator', _paginator2.default).factory('PaginatorFactory', _paginator4.default).name;
	
	exports.default = paginatorModule;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paginator = __webpack_require__(810);
	
	var _paginator2 = _interopRequireDefault(_paginator);
	
	var _paginator3 = __webpack_require__(811);
	
	var _paginator4 = _interopRequireDefault(_paginator3);
	
	__webpack_require__(812);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginatorComponent = {
	  bindings: {},
	  template: _paginator2.default,
	  controller: _paginator4.default
	};
	
	exports.default = paginatorComponent;

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"paginator\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <!-- {{ $ctrl.activePage }} -->\n    <ul>\n        <li ng-repeat=\"page in $ctrl.pages\" ng-class=\"{ 'active' : $ctrl.activePage == page }\">\n            <span ng-click=\"$ctrl.onChangePage(page)\">{{ page }}</span>\n            <div class=\"outer\" ng-click=\"$ctrl.onChangePage(page)\">\n                <div class=\"inner\"></div>\n            </div>\n        </li>\n    </ul>\n\n    <button class=\"share-guidebook\" ng-click=\"$ctrl.shareGuidebook()\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"12\" height=\"22\" viewBox=\"0 0 12 22\">\n            <image data-name=\"share\" width=\"12\" height=\"22\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAQAAABeMbWRAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRgIJhuNvftZAAABFUlEQVQoz23Quy9scRTF8c+c8SgUcj26SUjQXDdCKRKm8x8oCYmCRndDcXP8EgW1EDQShX9AJ+IRnYjGmE4ioiEThdxEcOUoZtzxOKtc37Wz196ZeRB3O/PkzLbN8AKRskr23BqyrhD3QGZeVXGb2LgHA6HwCUA8ZdW5vmz+Czg6zbcbdhn5roCRFBCuFPWnTXCtKR388JgC4ga9LtImJtXb+X7HTyf+6az5Ynfa1WAslLIHk/m6o5uKnXMsZy6sENnw+799KGchLL5/N4K41b4OS+FPOVZpFbfa12U5zL5vK6cb7fllzUy1RoRau3psmQ5JFWSSxL0m20bD68fimSRBSVE5/ddEuIMar7JaDFaCz5rdwRttc0sOCi9rcgAAAABJRU5ErkJggg==\"\n            />\n        </svg>\n        {{$ctrl.share}}\n    </button>\n\n</div>\n"

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _book = __webpack_require__(780);
	
	var _book2 = _interopRequireDefault(_book);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaginatorController = function () {
	    function PaginatorController(config, PaginatorFactory, $scope, $stateParams, $rootScope, Share) {
	        (0, _classCallCheck3.default)(this, PaginatorController);
	
	        this.name = 'paginator';
	
	        this.config = config;
	        this.$scope = $scope;
	        this.$stateParams = $stateParams;
	        this.$rootScope = $rootScope;
	        this.PaginatorFactory = PaginatorFactory;
	        this.ShareFactory = Share;
	    }
	
	    (0, _createClass3.default)(PaginatorController, [{
	        key: 'paginationInitializer',
	        value: function paginationInitializer(activePage, pagesCount) {
	            this.activePage = activePage;
	            this.pages = [];
	            this.maxPages = pagesCount;
	            this.pagesCount = 15;
	
	            // Save maxPages in factory
	            this.PaginatorFactory.setPagesCount(this.maxPages);
	
	            // Save activePageNumber in factory
	            this.PaginatorFactory.setActivePageNumber(this.activePage);
	
	            var pagesInitialCount = this.maxPages < this.pagesCount ? this.maxPages : this.pagesCount;
	
	            for (var i = 1; i <= pagesInitialCount; i++) {
	                this.pages.push(i);
	            }
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchForDataReady();
	            this.activePageChangeListener();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var SHARE = _book2.default[this.language].SHARE;
	
	
	            this.share = SHARE;
	        }
	    }, {
	        key: 'watchForDataReady',
	        value: function watchForDataReady() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return _this.PaginatorFactory.getDataReady();
	            }, function (newValue) {
	                if (newValue === true) {
	                    _this.paginationInitializer(_this.PaginatorFactory.getActivePageNumber(), _this.PaginatorFactory.getPagesCount());
	                }
	            });
	        }
	    }, {
	        key: 'activePageChangeListener',
	        value: function activePageChangeListener() {
	            var _this2 = this;
	
	            this.$rootScope.$on('activePageChangeEvent', function (ev, mustApplyScope) {
	                var newValue = _this2.PaginatorFactory.getActivePageNumber();
	
	                _this2.onChangePage(newValue);
	
	                if (mustApplyScope) {
	                    _this2.$scope.$apply();
	                }
	            });
	        }
	    }, {
	        key: 'onChangePage',
	        value: function onChangePage(pageNumber) {
	            if (pageNumber > 0) {
	                $('.flipbook').turn('page', pageNumber * 2);
	
	                this.activePage = pageNumber;
	
	                // Save new activePage in factory
	                this.PaginatorFactory.setActivePageNumber(this.activePage);
	            }
	
	            var lastPage = this.pages[this.pages.length - 1];
	            var firstPage = this.pages[0];
	
	            if (pageNumber === 1) {
	                this.paginationInitializer(pageNumber, this.PaginatorFactory.getPagesCount());
	            }
	
	            // Next 15 pages
	            if (pageNumber >= lastPage && pageNumber < this.maxPages) {
	                var newList = [];
	
	                var newListLastElement = pageNumber + 13;
	                newListLastElement = newListLastElement > this.maxPages ? this.maxPages : newListLastElement;
	
	                for (var i = pageNumber - 1; i <= newListLastElement; i++) {
	                    newList.push(i);
	                }
	                this.pages = newList;
	            } else if (pageNumber <= firstPage && pageNumber > 1) {
	                var _newList = [];
	
	                var newListFirstElement = pageNumber - 13;
	                newListFirstElement = newListFirstElement < 1 ? 1 : newListFirstElement;
	
	                for (var _i = newListFirstElement; _i <= pageNumber + 1; _i++) {
	                    _newList.push(_i);
	                }
	
	                this.pages = _newList;
	            }
	        }
	    }, {
	        key: 'shareGuidebook',
	        value: function shareGuidebook() {
	            var url = this.config.frontUrl + '/shared-moments/book/step-3?bookId=' + this.$stateParams.bookId;
	
	            this.ShareFactory.shareObject(url);
	        }
	    }]);
	    return PaginatorController;
	}();
	
	PaginatorController.$inject = ['config', 'PaginatorFactory', '$scope', '$stateParams', '$rootScope', 'Share'];
	
	exports.default = PaginatorController;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(813);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./paginator.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./paginator.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".paginator ul{position:absolute;list-style:none;width:calc(100% - 375px);min-width:810px;left:195px;right:120px;text-align:center;height:63px;line-height:80px}.paginator ul li{display:inline-block;user-select:none}.paginator ul li:not(:last-child):after{content:\"\";width:38px;height:2px;background-color:#c8c8c8;display:inline-block;margin-bottom:7px}.paginator ul li span{position:absolute;top:-22px;font-size:11px;width:12px;height:12px;font-family:Graphik-Regular;font-weight:700;text-align:center;margin-left:4px;color:#c8c8c8}.paginator ul li .outer{width:14px;height:14px;border-radius:9px;border:2px solid #c8c8c8;display:inline-block;margin-left:0;margin-right:-5px;cursor:pointer}.paginator ul li .outer:hover{border-color:#f994b6}.paginator ul li .outer:hover .inner{background-color:#f994b6}.paginator ul li .outer .inner{width:6px;height:6px;border-radius:3px;background-color:#c8c8c8;margin-top:4px;margin-left:4px}.paginator ul li.active span{color:#e9004c}.paginator ul li.active .outer{width:16px;height:16px;margin-bottom:-1px;margin-right:-4px;border-radius:10px;border-color:#e9004c}.paginator ul li.active .outer .inner{background-color:#e9004c;margin-top:5px;margin-left:5px}.paginator ul li.active:nth-child(2n):after{margin-right:-1px}.paginator .share-guidebook{border:0;width:129px;height:30px;color:#fff;user-select:none;font-size:11px;border-radius:17px;background-color:#90dc1d;font-family:Graphik-Regular;font-weight:700;position:absolute;right:15px;bottom:15px;display:flex;align-items:center;justify-content:center}.paginator .share-guidebook:hover{background-color:#87ce1b}.paginator .share-guidebook svg{width:7px;margin-right:5px}.paginator.geo .share-guidebook{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 814 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var PaginatorFactory = function PaginatorFactory() {
	    var activePageNumber = 0;
	    var pagesCount = 0;
	    var dataReady = false;
	
	    var getActivePageNumber = function getActivePageNumber() {
	        return activePageNumber;
	    };
	
	    var setActivePageNumber = function setActivePageNumber(pageNumber) {
	        activePageNumber = pageNumber;
	    };
	
	    var getPagesCount = function getPagesCount() {
	        return pagesCount;
	    };
	
	    var setPagesCount = function setPagesCount(pgCount) {
	        pagesCount = pgCount;
	    };
	
	    var getDataReady = function getDataReady() {
	        return dataReady;
	    };
	
	    var setDataReady = function setDataReady(dtReady, pgCount, pageNumber) {
	        dataReady = dtReady;
	        pagesCount = pgCount;
	        activePageNumber = pageNumber;
	    };
	
	    return {
	        getActivePageNumber: getActivePageNumber,
	        setActivePageNumber: setActivePageNumber,
	        getPagesCount: getPagesCount,
	        setPagesCount: setPagesCount,
	        getDataReady: getDataReady,
	        setDataReady: setDataReady
	    };
	};
	
	exports.default = PaginatorFactory;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookcard = __webpack_require__(816);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard1Module = _angular2.default.module('bookcard1', [_angularUiRouter2.default]).component('bookcard1', _bookcard2.default).name;
	
	exports.default = bookcard1Module;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookcard = __webpack_require__(817);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(818);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	__webpack_require__(819);
	
	__webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard1Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _bookcard2.default,
	    controller: _bookcard4.default
	};
	
	exports.default = bookcard1Component;

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-card1\" ng-style=\"{ 'background-color': $ctrl.color1 }\">\n\t<div class=\"card-header\">\n\t\t<div class=\"left\" ng-style=\"{ 'background-color': $ctrl.color2 }\">\n\t\t\t<div class=\"overlay\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n\t\t</div>\n\t\t<div class=\"hashtag\">\n\t\t\t{{ $ctrl.data.scrapedByTag }}\n\t\t</div>\n\t\t<div class=\"right\" ng-style=\"{ 'background-color': $ctrl.color2 }\">\n\t\t\t<img src=\"/assets/images/card6-grid.svg\" alt=\"\">\n\t\t</div>\n\t</div>\n\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"240\" height=\"240\" viewBox=\"0 0 240 240\">\n\t\t\t<defs>\n\t\t\t\t<style>\n\t\t\t\t\t.card-grid {\n\t\t\t\t\t\tmix-blend-mode: overlay;\n\t\t\t\t\t}\n\t\t\t\t</style>\n\t\t\t</defs>\n\t\t\t<image data-name=\"grid\" class=\"card-grid\" width=\"240\" height=\"240\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\t\t<div class=\"avatar-container\">\n\t\t\t<div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\">\n\t\t\t</div>\n\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t</div>\n\t\t<div class=\"container-wrapper\" ng-style=\"{ 'background-color': $ctrl.color4 }\"></div>\n\n\t\t<div class=\"first\"></div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t</div>\n\t<div class=\"card-footer\">\n\t\t<div class=\"left-container\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.37 17.28\">\n\t\t\t\t<g data-name=\"Layer 2\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M8.31,17.28a.47.47,0,0,1-.17,0,.68.68,0,0,1-.49-.82L11.78.5a.67.67,0,0,1,1.3.34L9,16.78A.68.68,0,0,1,8.31,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M2.94,17.28a.52.52,0,0,1-.17,0,.67.67,0,0,1-.48-.82L6.41.5A.68.68,0,0,1,7.24,0a.67.67,0,0,1,.48.82L3.59,16.78A.67.67,0,0,1,2.94,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M14.7,6H2.2a.68.68,0,0,1-.68-.68.67.67,0,0,1,.68-.67H14.7a.67.67,0,0,1,.67.67A.68.68,0,0,1,14.7,6Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M13.17,11.9H.67A.67.67,0,0,1,0,11.23a.68.68,0,0,1,.67-.68h12.5a.68.68,0,0,1,.68.68A.67.67,0,0,1,13.17,11.9Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\n\t\t\t<div class=\"caption-small\">{{ $ctrl.data.relatedTags.toString() | limitTo: 50 }}</div>\n\t\t</div>\n\t\t<div class=\"likes-container\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.36 30.01\">\n\t\t\t\t<g>\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"background\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M28.36,15q0,7.35-3.61,11.19T14.18,30Q7.32,30,3.66,26.17T0,15Q0,7.67,3.64,3.84T14.22,0q7,0,10.55,3.81T28.36,15Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"like\" d=\"M19.61,12.25l-4.43,4.43a1.41,1.41,0,0,1-2,0L8.76,12.25a4,4,0,0,1-.22-5.44,3.91,3.91,0,0,1,5.65-.13,3.87,3.87,0,0,1,5.62.13A4,4,0,0,1,19.61,12.25Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<span class=\"count\">{{ $ctrl.data.likes }}</span>\n\t\t</div>\n\t\t<div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color5 }\">\n\t\t\t<div class=\"comment\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.28 17.29\">\n\t\t\t\t\t<g data-name=\"comment svg\">\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"background\" d=\"M16.6,16.61l-4-4H2.65a2,2,0,0,1-2-2V2.65a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2Z\" />\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M16.6,17.29a.67.67,0,0,1-.47-.2l-3.84-3.83H2.65A2.66,2.66,0,0,1,0,10.6V2.65A2.65,2.65,0,0,1,2.65,0h12a2.66,2.66,0,0,1,2.66,2.65v14a.68.68,0,0,1-.42.62A.58.58,0,0,1,16.6,17.29ZM2.65,1.35a1.3,1.3,0,0,0-1.3,1.3v8a1.31,1.31,0,0,0,1.3,1.31h9.92a.67.67,0,0,1,.48.2L15.93,15V2.65a1.31,1.31,0,0,0-1.31-1.3Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M12.07,5.55H5.21a.68.68,0,1,1,0-1.35h6.86a.68.68,0,0,1,0,1.35Z\" />\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M12.07,9.15H5.21a.67.67,0,0,1-.68-.67.68.68,0,0,1,.68-.68h6.86a.68.68,0,0,1,.67.68A.67.67,0,0,1,12.07,9.15Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"caption\">{{ $ctrl.data.caption | limitTo: 100 }}</div>\n\t\t</div>\n\t\t<div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color6 }\"></div>\n\t\t<div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color7 }\"></div>\n\t\t<div class=\"fourth\" ng-style=\"{ 'background-color': $ctrl.color8 }\"></div>\n\n\t\t<div class=\"fifth\" ng-style=\"{ 'background-color': $ctrl.color9 }\"></div>\n\t\t<div class=\"sixth\"></div>\n\t</div>\n</div>\n"

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bookcard1Controller = function () {
	    function Bookcard1Controller(Color) {
	        (0, _classCallCheck3.default)(this, Bookcard1Controller);
	
	        this.name = 'bookcard1';
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Bookcard1Controller, [{
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors('book card 1', this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	            this.color5 = colors[4];
	            this.color6 = colors[5];
	            this.color7 = colors[6];
	            this.color8 = colors[7];
	            this.color9 = colors[8];
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	            this.setColor();
	        }
	    }]);
	    return Bookcard1Controller;
	}();
	
	Bookcard1Controller.$inject = ['Color'];
	
	exports.default = Bookcard1Controller;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(820);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-card1{position:relative;margin:10px;width:400px;height:515px}.book-card1 .card-header{position:absolute}.book-card1 .card-header .left{left:0;top:0;width:25px;height:90px}.book-card1 .card-header .left .overlay{background-color:#a2e6de;height:40px;position:absolute;width:25px;top:25px}.book-card1 .card-header .hashtag{position:absolute;top:0;left:37px;height:90px;display:flex;align-items:center;font-size:50px;font-family:Nickainley-Normal;color:#475ca9}.book-card1 .card-header .right{position:absolute;top:25px;width:65px;left:285px;height:65px}.book-card1 .photo-container{position:absolute;top:90px;width:260px;height:240px;left:25px;z-index:5}.book-card1 .photo-container svg{position:absolute;left:10px;top:-5px}.book-card1 .photo-container .avatar-container{position:absolute;width:95px;height:80px;background:#fff;top:43px;left:235px;z-index:2}.book-card1 .photo-container .avatar-container .avatar{position:absolute;width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px);margin-top:12px}.book-card1 .photo-container .avatar-container p{position:absolute;bottom:7px;width:100%;font-size:12px;font-family:Myriad-Pro;font-weight:700;text-align:center;overflow:hidden}.book-card1 .photo-container .container-wrapper{position:absolute;left:260px;top:34px;width:25px;height:99px;z-index:1}.book-card1 .photo-container .first,.book-card1 .photo-container .second,.book-card1 .photo-container .third{position:absolute;width:99px;height:99px}.book-card1 .photo-container .first{background-color:#fff;opacity:.2;left:104px;top:67px;width:120px}.book-card1 .photo-container .second{background-color:#fff;opacity:.3;left:135px;top:47px;width:125px;height:100px}.book-card1 .photo-container .third{background-color:#fff;opacity:.4;left:162px;top:34px}.book-card1 .card-footer{position:absolute;top:330px}.book-card1 .card-footer .left-container{position:absolute}.book-card1 .card-footer .left-container svg{position:relative;z-index:3;margin-left:27px;margin-top:12px;width:30px}.book-card1 .card-footer .left-container svg .stroke{fill:#5fb69e}.book-card1 .card-footer .left-container .caption-small{position:absolute;z-index:2;margin:0 0 0 28px;width:127px;height:100px;background-color:#fff;font-size:11px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden;top:30px;padding:20px 0 0 5px}.book-card1 .card-footer .likes-container{position:absolute;z-index:5;left:264px;top:-79px}.book-card1 .card-footer .likes-container svg{width:40px}.book-card1 .card-footer .likes-container svg .like{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.15px}.book-card1 .card-footer .likes-container .count{position:absolute;bottom:9px;width:100%;text-align:center;font-size:8px;color:#ffff;font-family:Graphik-Bold}.book-card1 .card-footer .first{width:180px;height:170px;left:180px;position:absolute;top:-60px;z-index:4}.book-card1 .card-footer .first .comment{margin-top:65px;margin-left:11px}.book-card1 .card-footer .first .comment svg{width:20px}.book-card1 .card-footer .first .comment svg .background{fill:transparent}.book-card1 .card-footer .first .comment svg .stroke{fill:#fff}.book-card1 .card-footer .first .caption{border:15px solid transparent;border-image:url(/assets/images/border-image.png) 56 round;border-image-outset:1px;border-image-width:35px;position:absolute;height:115px;left:30px;top:84px;width:120px;background-color:#f4c33c;font-size:12px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.book-card1 .card-footer .second{z-index:3;width:60px;left:160px;position:absolute;height:130px}.book-card1 .card-footer .third{left:140px;position:absolute;width:70px;height:150px;z-index:1}.book-card1 .card-footer .fourth{left:100px;position:absolute;width:110px;height:20px;z-index:0;top:150px}.book-card1 .card-footer .fifth{top:150px;width:36px;height:20px;position:absolute;left:64px}.book-card1 .card-footer .sixth{top:150px;width:36px;height:20px;background:#fff;position:absolute;left:28px}", ""]);
	
	// exports


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(822);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard1.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard1.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.book-card1{height:410px;width:311px;margin:2px;user-select:none}.book-card1 .card-header .left{height:80px}.book-card1 .card-header .left .overlay{height:30px}.book-card1 .card-header .hashtag{font-size:42px}.book-card1 .card-header .right{top:15px;left:240px;width:55px;height:55px}.book-card1 .photo-container{top:80px;width:180px;height:160px}.book-card1 .photo-container svg{left:8px;top:8px}.book-card1 .photo-container .card-grid{width:165px;height:148px}.book-card1 .photo-container .avatar-container{left:145px;top:29px;width:95px}.book-card1 .photo-container .container-wrapper{left:180px;top:20px}.book-card1 .photo-container .first,.book-card1 .photo-container .second,.book-card1 .photo-container .third{width:60px;height:60px}.book-card1 .photo-container .first{left:30px;top:87px}.book-card1 .photo-container .second{left:57px;top:60px}.book-card1 .photo-container .third{left:80px;top:34px}.book-card1 .card-footer{top:290px}.book-card1 .card-footer .left-container .caption-small{width:95px;height:94px;left:-3px;top:-24px}.book-card1 .card-footer .left-container svg{position:absolute;top:-40px;width:25px;margin-top:0}.book-card1 .card-footer .first{width:130px;height:130px;left:140px;position:absolute;top:-70px;z-index:4}.book-card1 .card-footer .first .comment{margin-top:25px}.book-card1 .card-footer .first .caption{height:100px;left:30px;top:45px;width:70px}.book-card1 .card-footer .second{left:125px;top:-50px;height:125px}.book-card1 .card-footer .third{left:110px;height:140px;top:-50px}.book-card1 .card-footer .fourth{width:80px;height:15px;top:90px}.book-card1 .card-footer .fifth,.book-card1 .card-footer .sixth{top:90px;height:15px}.book-card1 .card-footer .sixth{left:25px;width:39px}.book-card1 .card-footer .likes-container{left:184px;top:-89px}}", ""]);
	
	// exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookcard = __webpack_require__(824);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard2Module = _angular2.default.module('bookcard2', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('bookcard2', {
	        url: '/bookcard2',
	        component: 'bookcard2'
	    });
	}]).component('bookcard2', _bookcard2.default).name;
	
	exports.default = bookcard2Module;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookcard = __webpack_require__(825);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(826);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	__webpack_require__(827);
	
	__webpack_require__(829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard2Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _bookcard2.default,
	    controller: _bookcard4.default
	};
	
	exports.default = bookcard2Component;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-card2\">\n    <div class=\"card-header\">\n        <div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n        <div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color2 }\"></div>\n        <div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n        <div class=\"right-top\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n    </div>\n    <div class=\"card-content\">\n        <div class=\"avatar-container\">\n            <div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\"></div>\n            <p>{{ $ctrl.data.owner.username }}</p>\n        </div>\n        <div class=\"caption-small\" ng-style=\"{ 'background-color': $ctrl.color3 }\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.37 17.28\">\n                <g data-name=\"Layer 2\">\n                    <g>\n                        <g>\n                            <path class=\"stroke\" d=\"M8.31,17.28a.47.47,0,0,1-.17,0,.68.68,0,0,1-.49-.82L11.78.5a.67.67,0,0,1,1.3.34L9,16.78A.68.68,0,0,1,8.31,17.28Z\"\n                            />\n                            <path class=\"stroke\" d=\"M2.94,17.28a.52.52,0,0,1-.17,0,.67.67,0,0,1-.48-.82L6.41.5A.68.68,0,0,1,7.24,0a.67.67,0,0,1,.48.82L3.59,16.78A.67.67,0,0,1,2.94,17.28Z\"\n                            />\n                            <path class=\"stroke\" d=\"M14.7,6H2.2a.68.68,0,0,1-.68-.68.67.67,0,0,1,.68-.67H14.7a.67.67,0,0,1,.67.67A.68.68,0,0,1,14.7,6Z\"\n                            />\n                            <path class=\"stroke\" d=\"M13.17,11.9H.67A.67.67,0,0,1,0,11.23a.68.68,0,0,1,.67-.68h12.5a.68.68,0,0,1,.68.68A.67.67,0,0,1,13.17,11.9Z\"\n                            />\n                        </g>\n                    </g>\n                </g>\n            </svg>\n            <p>{{ $ctrl.data.relatedTags.toString() | limitTo: 90 }}</p>\n        </div>\n\n        <div class=\"comment\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.28 17.29\">\n                <g data-name=\"comment svg\">\n                    <g>\n                        <path class=\"background\" d=\"M16.6,16.61l-4-4H2.65a2,2,0,0,1-2-2V2.65a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2Z\" />\n                        <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M16.6,17.29a.67.67,0,0,1-.47-.2l-3.84-3.83H2.65A2.66,2.66,0,0,1,0,10.6V2.65A2.65,2.65,0,0,1,2.65,0h12a2.66,2.66,0,0,1,2.66,2.65v14a.68.68,0,0,1-.42.62A.58.58,0,0,1,16.6,17.29ZM2.65,1.35a1.3,1.3,0,0,0-1.3,1.3v8a1.31,1.31,0,0,0,1.3,1.31h9.92a.67.67,0,0,1,.48.2L15.93,15V2.65a1.31,1.31,0,0,0-1.31-1.3Z\"\n                        />\n                        <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M12.07,5.55H5.21a.68.68,0,1,1,0-1.35h6.86a.68.68,0,0,1,0,1.35Z\"\n                        />\n                        <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M12.07,9.15H5.21a.67.67,0,0,1-.68-.67.68.68,0,0,1,.68-.68h6.86a.68.68,0,0,1,.67.68A.67.67,0,0,1,12.07,9.15Z\"\n                        />\n                    </g>\n                </g>\n            </svg>\n        </div>\n\n        <div class=\"caption\">{{ $ctrl.data.caption | limitTo: 120 }}</div>\n\n        <div class=\"likes-container\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.36 30.01\">\n                <g>\n                    <g>\n                        <g>\n                            <path class=\"background\" ng-style=\"{ 'fill': $ctrl.color5 }\" d=\"M28.36,15q0,7.35-3.61,11.19T14.18,30Q7.32,30,3.66,26.17T0,15Q0,7.67,3.64,3.84T14.22,0q7,0,10.55,3.81T28.36,15Z\"\n                            />\n                            <path class=\"like\" d=\"M19.61,12.25l-4.43,4.43a1.41,1.41,0,0,1-2,0L8.76,12.25a4,4,0,0,1-.22-5.44,3.91,3.91,0,0,1,5.65-.13,3.87,3.87,0,0,1,5.62.13A4,4,0,0,1,19.61,12.25Z\"\n                            />\n                        </g>\n                    </g>\n                </g>\n            </svg>\n            <span class=\"count\">{{ $ctrl.data.likes }}</span>\n        </div>\n        <div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n        <div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color2 }\"></div>\n        <div class=\"third\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n            <svg viewBox=\"0 0 190.79 194.71\">\n                <g class=\"card-lines-1\">\n                    <g data-name=\"Layer 2\">\n                        <g>\n                            <g class=\"cls-2\">\n                                <line class=\"cls-3\" y1=\"1.96\" x2=\"190.79\" y2=\"1.96\" />\n                                <line class=\"cls-3\" y1=\"6.62\" x2=\"190.79\" y2=\"6.62\" />\n                                <line class=\"cls-3\" y1=\"11.27\" x2=\"190.79\" y2=\"11.27\" />\n                                <line class=\"cls-3\" y1=\"15.92\" x2=\"190.79\" y2=\"15.92\" />\n                                <line class=\"cls-3\" y1=\"20.58\" x2=\"190.79\" y2=\"20.58\" />\n                                <line class=\"cls-3\" y1=\"25.23\" x2=\"190.79\" y2=\"25.23\" />\n                                <line class=\"cls-3\" y1=\"29.88\" x2=\"190.79\" y2=\"29.88\" />\n                                <line class=\"cls-3\" y1=\"34.54\" x2=\"190.79\" y2=\"34.54\" />\n                                <line class=\"cls-3\" y1=\"39.19\" x2=\"190.79\" y2=\"39.19\" />\n                                <line class=\"cls-3\" y1=\"43.84\" x2=\"190.79\" y2=\"43.84\" />\n                                <line class=\"cls-3\" y1=\"48.5\" x2=\"190.79\" y2=\"48.5\" />\n                                <line class=\"cls-3\" y1=\"53.15\" x2=\"190.79\" y2=\"53.15\" />\n                                <line class=\"cls-3\" y1=\"57.8\" x2=\"190.79\" y2=\"57.8\" />\n                                <line class=\"cls-3\" y1=\"62.46\" x2=\"190.79\" y2=\"62.46\" />\n                                <line class=\"cls-3\" y1=\"67.11\" x2=\"190.79\" y2=\"67.11\" />\n                                <line class=\"cls-3\" y1=\"71.76\" x2=\"190.79\" y2=\"71.76\" />\n                                <line class=\"cls-3\" y1=\"76.42\" x2=\"190.79\" y2=\"76.42\" />\n                                <line class=\"cls-3\" y1=\"81.07\" x2=\"190.79\" y2=\"81.07\" />\n                                <line class=\"cls-3\" y1=\"85.72\" x2=\"190.79\" y2=\"85.72\" />\n                                <line class=\"cls-3\" y1=\"90.38\" x2=\"190.79\" y2=\"90.38\" />\n                                <line class=\"cls-3\" y1=\"95.03\" x2=\"190.79\" y2=\"95.03\" />\n                                <line class=\"cls-3\" y1=\"99.68\" x2=\"190.79\" y2=\"99.68\" />\n                                <line class=\"cls-3\" y1=\"104.34\" x2=\"190.79\" y2=\"104.34\" />\n                                <line class=\"cls-3\" y1=\"108.99\" x2=\"190.79\" y2=\"108.99\" />\n                                <line class=\"cls-3\" y1=\"113.64\" x2=\"190.79\" y2=\"113.64\" />\n                                <line class=\"cls-3\" y1=\"118.3\" x2=\"190.79\" y2=\"118.3\" />\n                                <line class=\"cls-3\" y1=\"122.95\" x2=\"190.79\" y2=\"122.95\" />\n                                <line class=\"cls-3\" y1=\"127.6\" x2=\"190.79\" y2=\"127.6\" />\n                                <line class=\"cls-3\" y1=\"132.26\" x2=\"190.79\" y2=\"132.26\" />\n                                <line class=\"cls-3\" y1=\"136.91\" x2=\"190.79\" y2=\"136.91\" />\n                                <line class=\"cls-3\" y1=\"141.56\" x2=\"190.79\" y2=\"141.56\" />\n                                <line class=\"cls-3\" y1=\"146.21\" x2=\"190.79\" y2=\"146.21\" />\n                                <line class=\"cls-3\" y1=\"150.87\" x2=\"190.79\" y2=\"150.87\" />\n                                <line class=\"cls-3\" y1=\"155.52\" x2=\"190.79\" y2=\"155.52\" />\n                                <line class=\"cls-3\" y1=\"160.17\" x2=\"190.79\" y2=\"160.17\" />\n                                <line class=\"cls-3\" y1=\"164.83\" x2=\"190.79\" y2=\"164.83\" />\n                                <line class=\"cls-3\" y1=\"169.48\" x2=\"190.79\" y2=\"169.48\" />\n                                <line class=\"cls-3\" y1=\"174.13\" x2=\"190.79\" y2=\"174.13\" />\n                                <line class=\"cls-3\" y1=\"178.79\" x2=\"190.79\" y2=\"178.79\" />\n                                <line class=\"cls-3\" y1=\"183.44\" x2=\"190.79\" y2=\"183.44\" />\n                                <line class=\"cls-3\" y1=\"188.09\" x2=\"190.79\" y2=\"188.09\" />\n                                <line class=\"cls-3\" y1=\"192.75\" x2=\"190.79\" y2=\"192.75\" />\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </svg>\n        </div>\n\n        <div class=\"grid\" ng-style=\"{ 'background-color': $ctrl.color2 }\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54.55 54.35\">\n                <g>\n                    <g>\n                        <g>\n                            <g>\n                                <path class=\"cls-2\" d=\"M0,39.89a2,2,0,1,1,2,2A2,2,0,0,1,0,39.89Z\" />\n                                <circle class=\"cls-2\" cx=\"14.63\" cy=\"39.89\" r=\"1.98\" />\n                                <path class=\"cls-2\" d=\"M25.3,39.89a2,2,0,1,1,2,2A2,2,0,0,1,25.3,39.89Z\" />\n                                <path class=\"cls-2\" d=\"M37.94,39.89a2,2,0,1,1,2,2A2,2,0,0,1,37.94,39.89Z\" />\n                                <circle class=\"cls-2\" cx=\"52.57\" cy=\"39.89\" r=\"1.98\" />\n                                <path class=\"cls-2\" d=\"M0,14.61a2,2,0,1,1,2,2A2,2,0,0,1,0,14.61Z\" />\n                                <path class=\"cls-2\" d=\"M12.65,14.61a2,2,0,1,1,2,2A2,2,0,0,1,12.65,14.61Z\" />\n                                <path class=\"cls-2\" d=\"M25.3,14.61a2,2,0,1,1,2,2A2,2,0,0,1,25.3,14.61Z\" />\n                                <path class=\"cls-2\" d=\"M37.94,14.61a2,2,0,1,1,2,2A2,2,0,0,1,37.94,14.61Z\" />\n                                <path class=\"cls-2\" d=\"M50.59,14.61a2,2,0,1,1,2,2A2,2,0,0,1,50.59,14.61Z\" />\n                                <path class=\"cls-2\" d=\"M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z\" />\n                                <path class=\"cls-2\" d=\"M12.65,2a2,2,0,1,1,2,2A2,2,0,0,1,12.65,2Z\" />\n                                <path class=\"cls-2\" d=\"M25.3,2a2,2,0,1,1,2,2A2,2,0,0,1,25.3,2Z\" />\n                                <path class=\"cls-2\" d=\"M37.94,2a2,2,0,1,1,2,2A2,2,0,0,1,37.94,2Z\" />\n                                <path class=\"cls-2\" d=\"M50.59,2a2,2,0,1,1,2,2A2,2,0,0,1,50.59,2Z\" />\n                                <path class=\"cls-2\" d=\"M0,27.25a2,2,0,1,1,2,2A2,2,0,0,1,0,27.25Z\" />\n                                <path class=\"cls-2\" d=\"M12.65,27.25a2,2,0,1,1,2,2A2,2,0,0,1,12.65,27.25Z\" />\n                                <path class=\"cls-2\" d=\"M25.3,27.25a2,2,0,1,1,2,2A2,2,0,0,1,25.3,27.25Z\" />\n                                <path class=\"cls-2\" d=\"M37.94,27.25a2,2,0,1,1,2,2A2,2,0,0,1,37.94,27.25Z\" />\n                                <path class=\"cls-2\" d=\"M50.59,27.25a2,2,0,1,1,2,2A2,2,0,0,1,50.59,27.25Z\" />\n                                <path class=\"cls-2\" d=\"M0,52.37a2,2,0,1,1,2,2A2,2,0,0,1,0,52.37Z\" />\n                                <path class=\"cls-2\" d=\"M12.65,52.37a2,2,0,1,1,2,2A2,2,0,0,1,12.65,52.37Z\" />\n                                <path class=\"cls-2\" d=\"M25.3,52.37a2,2,0,1,1,2,2A2,2,0,0,1,25.3,52.37Z\" />\n                                <path class=\"cls-2\" d=\"M37.94,52.37a2,2,0,1,1,2,2A2,2,0,0,1,37.94,52.37Z\" />\n                                <path class=\"cls-2\" d=\"M50.59,52.37a2,2,0,1,1,2,2A2,2,0,0,1,50.59,52.37Z\" />\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </svg>\n        </div>\n        <div class=\"left\" ng-style=\"{ 'background-color': $ctrl.color4 }\"></div>\n        <div class=\"right\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n    </div>\n</div>\n"

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bookcard2Controller = function () {
	    function Bookcard2Controller(Color) {
	        (0, _classCallCheck3.default)(this, Bookcard2Controller);
	
	        this.name = 'bookcard2';
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Bookcard2Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	            this.setColor();
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors('book card 2', this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	        }
	    }]);
	    return Bookcard2Controller;
	}();
	
	Bookcard2Controller.$inject = ['Color'];
	
	exports.default = Bookcard2Controller;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(828);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-card2{margin:10px;width:400px;height:515px}.book-card2,.book-card2 .card-header{position:relative}.book-card2 .card-header .first{position:absolute;opacity:.8;width:300px;height:40px;margin:20px 0 0 30px;z-index:3}.book-card2 .card-header .second{opacity:.8;position:absolute;width:170px;height:40px;top:40px;left:30px;z-index:2}.book-card2 .card-header .third{opacity:.8;position:absolute;width:120px;height:40px;top:60px;left:30px}.book-card2 .card-header .right-top{width:95px;height:80px;position:absolute;right:70px;top:20px;opacity:.8}.book-card2 .card-content{position:relative}.book-card2 .card-content .avatar-container{top:100px;left:64px;position:absolute;width:110px;height:70px}.book-card2 .card-content .avatar-container .avatar{width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px)}.book-card2 .card-content .avatar-container p{margin-top:5px;text-align:center;font-size:12px;font-family:Myriad-Pro}.book-card2 .card-content .comment{position:absolute;top:80px;left:190px}.book-card2 .card-content .comment svg{width:20px}.book-card2 .card-content .comment svg .background{fill:transparent}.book-card2 .card-content .caption-small{position:absolute;top:178px;left:70px;width:120px;height:80px;opacity:.8}.book-card2 .card-content .caption-small svg{position:absolute;width:20px;left:-34px;top:-23px}.book-card2 .card-content .caption-small p{word-break:break-word;margin-left:-20px;font-family:Myriad-Pro;font-size:12px;max-height:100%;overflow:hidden}.book-card2 .card-content .caption{border:15px solid transparent;border-image:url(/assets/images/border-image.png) 56 round;border-image-outset:1px;border-image-width:35px;position:absolute;height:150px;right:30px;top:100px;width:130px;background-color:#f4c33c;font-size:12px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.book-card2 .card-content .likes-container{position:absolute;top:270px;left:76px;z-index:2}.book-card2 .card-content .likes-container svg{width:70px}.book-card2 .card-content .likes-container svg .background{fill:#d33c51}.book-card2 .card-content .likes-container svg .like{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.15px}.book-card2 .card-content .likes-container .count{position:absolute;bottom:13px;width:100%;text-align:center;font-size:14px;color:#ffff;font-family:Graphik-Bold}.book-card2 .card-content .first{width:125px;height:125px;position:absolute;top:281px;left:85px;z-index:1;opacity:.8}.book-card2 .card-content .second{width:125px;height:125px;position:absolute;top:301px;left:105px;z-index:1;opacity:.8}.book-card2 .card-content .third{width:200px;height:170px;top:321px;position:absolute;left:125px;z-index:1;overflow:hidden}.book-card2 .card-content .third svg .card-lines-1{isolation:isolate}.book-card2 .card-content .third svg .cls-2{opacity:.5;mix-blend-mode:overlay}.book-card2 .card-content .third svg .cls-3{fill:none;stroke:#cad2e5;stroke-miterlimit:10;stroke-width:.7px}.book-card2 .card-content .grid{top:440px;left:65px;position:absolute;width:60px;height:60px}.book-card2 .card-content .grid svg{width:40px;margin:10px}.book-card2 .card-content .grid svg .cls-2{fill:#fff}.book-card2 .card-content .left{top:500px;width:20px;height:20px;position:absolute;left:45px}.book-card2 .card-content .right{left:295px;width:50px;height:50px;position:absolute;top:460px}", ""]);
	
	// exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(830);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard2.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard2.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.book-card2{height:463px;width:364px;margin:2px;user-select:none}.book-card2 .card-header .first{margin-top:0}.book-card2 .card-header .second{top:20px}.book-card2 .card-header .third{top:40px}.book-card2 .card-header .right-top{right:34px;top:0}.book-card2 .card-content .grid{top:406px;width:40px;height:40px}.book-card2 .card-content .grid svg{width:20px}.book-card2 .card-content .left{top:445px}.book-card2 .card-content .right{left:215px;top:380px;width:40px;height:40px}.book-card2 .card-content .avatar-container{top:80px}.book-card2 .card-content .likes-container{top:240px}.book-card2 .card-content .likes-container svg{width:55px}.book-card2 .card-content .likes-container .count{font-size:11px}.book-card2 .card-content .caption-small{width:102px;height:70px;top:158px}.book-card2 .card-content .comment{left:180px;top:60px}.book-card2 .card-content .caption{height:125px;right:35px;width:100px;top:80px}.book-card2 .card-content .first{top:251px}.book-card2 .card-content .second{top:261px;left:95px}.book-card2 .card-content .third{top:271px;left:105px;width:135px;height:135px}}", ""]);
	
	// exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookcard = __webpack_require__(832);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard3Module = _angular2.default.module('bookcard3', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('bookcard3', {
	        url: '/bookcard3',
	        component: 'bookcard3'
	    });
	}]).component('bookcard3', _bookcard2.default).name;
	
	exports.default = bookcard3Module;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookcard = __webpack_require__(833);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(834);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	__webpack_require__(835);
	
	__webpack_require__(837);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard3Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _bookcard2.default,
	    controller: _bookcard4.default
	};
	
	exports.default = bookcard3Component;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-card3\">\n\t<div class=\"card-header\">\n\t\t<div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n\t\t<div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color4 }\"></div>\n\t</div>\n\n\t<div class=\"comment\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.28 17.29\">\n\t\t\t<g data-name=\"comment svg\">\n\t\t\t\t<g>\n\t\t\t\t\t<path class=\"background\" d=\"M16.6,16.61l-4-4H2.65a2,2,0,0,1-2-2V2.65a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2Z\" />\n\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M16.6,17.29a.67.67,0,0,1-.47-.2l-3.84-3.83H2.65A2.66,2.66,0,0,1,0,10.6V2.65A2.65,2.65,0,0,1,2.65,0h12a2.66,2.66,0,0,1,2.66,2.65v14a.68.68,0,0,1-.42.62A.58.58,0,0,1,16.6,17.29ZM2.65,1.35a1.3,1.3,0,0,0-1.3,1.3v8a1.31,1.31,0,0,0,1.3,1.31h9.92a.67.67,0,0,1,.48.2L15.93,15V2.65a1.31,1.31,0,0,0-1.31-1.3Z\"\n\t\t\t\t\t/>\n\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M12.07,5.55H5.21a.68.68,0,1,1,0-1.35h6.86a.68.68,0,0,1,0,1.35Z\"\n\t\t\t\t\t/>\n\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M12.07,9.15H5.21a.67.67,0,0,1-.68-.67.68.68,0,0,1,.68-.68h6.86a.68.68,0,0,1,.67.68A.67.67,0,0,1,12.07,9.15Z\"\n\t\t\t\t\t/>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</svg>\n\t</div>\n\n\t<div class=\"caption\">\n\t\t{{ $ctrl.data.caption | limitTo: 240 }}\n\t</div>\n\t<div class=\"layered-divs\">\n\t\t<div class=\"grid\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54.55 54.35\">\n\t\t\t\t<g>\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M0,39.89a2,2,0,1,1,2,2A2,2,0,0,1,0,39.89Z\" />\n\t\t\t\t\t\t\t\t<circle class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" cx=\"14.63\" cy=\"39.89\" r=\"1.98\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M25.3,39.89a2,2,0,1,1,2,2A2,2,0,0,1,25.3,39.89Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M37.94,39.89a2,2,0,1,1,2,2A2,2,0,0,1,37.94,39.89Z\" />\n\t\t\t\t\t\t\t\t<circle class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" cx=\"52.57\" cy=\"39.89\" r=\"1.98\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M0,14.61a2,2,0,1,1,2,2A2,2,0,0,1,0,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M12.65,14.61a2,2,0,1,1,2,2A2,2,0,0,1,12.65,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M25.3,14.61a2,2,0,1,1,2,2A2,2,0,0,1,25.3,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M37.94,14.61a2,2,0,1,1,2,2A2,2,0,0,1,37.94,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M50.59,14.61a2,2,0,1,1,2,2A2,2,0,0,1,50.59,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M12.65,2a2,2,0,1,1,2,2A2,2,0,0,1,12.65,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M25.3,2a2,2,0,1,1,2,2A2,2,0,0,1,25.3,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M37.94,2a2,2,0,1,1,2,2A2,2,0,0,1,37.94,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M50.59,2a2,2,0,1,1,2,2A2,2,0,0,1,50.59,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M0,27.25a2,2,0,1,1,2,2A2,2,0,0,1,0,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M12.65,27.25a2,2,0,1,1,2,2A2,2,0,0,1,12.65,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M25.3,27.25a2,2,0,1,1,2,2A2,2,0,0,1,25.3,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M37.94,27.25a2,2,0,1,1,2,2A2,2,0,0,1,37.94,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M50.59,27.25a2,2,0,1,1,2,2A2,2,0,0,1,50.59,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M0,52.37a2,2,0,1,1,2,2A2,2,0,0,1,0,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M12.65,52.37a2,2,0,1,1,2,2A2,2,0,0,1,12.65,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M25.3,52.37a2,2,0,1,1,2,2A2,2,0,0,1,25.3,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M37.94,52.37a2,2,0,1,1,2,2A2,2,0,0,1,37.94,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"cls-2\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M50.59,52.37a2,2,0,1,1,2,2A2,2,0,0,1,50.59,52.37Z\" />\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class=\"likes-container\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.36 30.01\">\n\t\t\t\t<g>\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"background\" ng-style=\"{ 'fill': $ctrl.color4 }\" d=\"M28.36,15q0,7.35-3.61,11.19T14.18,30Q7.32,30,3.66,26.17T0,15Q0,7.67,3.64,3.84T14.22,0q7,0,10.55,3.81T28.36,15Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"like\" d=\"M19.61,12.25l-4.43,4.43a1.41,1.41,0,0,1-2,0L8.76,12.25a4,4,0,0,1-.22-5.44,3.91,3.91,0,0,1,5.65-.13,3.87,3.87,0,0,1,5.62.13A4,4,0,0,1,19.61,12.25Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<span class=\"count\">{{ $ctrl.data.likes }}</span>\n\t\t</div>\n\n\t\t<div class=\"first\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t\t\t<svg viewBox=\"0 0 190.79 194.71\">\n\t\t\t\t<g class=\"card-lines-1\">\n\t\t\t\t\t<g data-name=\"Layer 2\">\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<g class=\"cls-2\">\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"1.96\" x2=\"190.79\" y2=\"1.96\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"6.62\" x2=\"190.79\" y2=\"6.62\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"11.27\" x2=\"190.79\" y2=\"11.27\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"15.92\" x2=\"190.79\" y2=\"15.92\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"20.58\" x2=\"190.79\" y2=\"20.58\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"25.23\" x2=\"190.79\" y2=\"25.23\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"29.88\" x2=\"190.79\" y2=\"29.88\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"34.54\" x2=\"190.79\" y2=\"34.54\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"39.19\" x2=\"190.79\" y2=\"39.19\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"43.84\" x2=\"190.79\" y2=\"43.84\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"48.5\" x2=\"190.79\" y2=\"48.5\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"53.15\" x2=\"190.79\" y2=\"53.15\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"57.8\" x2=\"190.79\" y2=\"57.8\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"62.46\" x2=\"190.79\" y2=\"62.46\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"67.11\" x2=\"190.79\" y2=\"67.11\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"71.76\" x2=\"190.79\" y2=\"71.76\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"76.42\" x2=\"190.79\" y2=\"76.42\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"81.07\" x2=\"190.79\" y2=\"81.07\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"85.72\" x2=\"190.79\" y2=\"85.72\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"90.38\" x2=\"190.79\" y2=\"90.38\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"95.03\" x2=\"190.79\" y2=\"95.03\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"99.68\" x2=\"190.79\" y2=\"99.68\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"104.34\" x2=\"190.79\" y2=\"104.34\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"108.99\" x2=\"190.79\" y2=\"108.99\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"113.64\" x2=\"190.79\" y2=\"113.64\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"118.3\" x2=\"190.79\" y2=\"118.3\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"122.95\" x2=\"190.79\" y2=\"122.95\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"127.6\" x2=\"190.79\" y2=\"127.6\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"132.26\" x2=\"190.79\" y2=\"132.26\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"136.91\" x2=\"190.79\" y2=\"136.91\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"141.56\" x2=\"190.79\" y2=\"141.56\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"146.21\" x2=\"190.79\" y2=\"146.21\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"150.87\" x2=\"190.79\" y2=\"150.87\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"155.52\" x2=\"190.79\" y2=\"155.52\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"160.17\" x2=\"190.79\" y2=\"160.17\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"164.83\" x2=\"190.79\" y2=\"164.83\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"169.48\" x2=\"190.79\" y2=\"169.48\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"174.13\" x2=\"190.79\" y2=\"174.13\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"178.79\" x2=\"190.79\" y2=\"178.79\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"183.44\" x2=\"190.79\" y2=\"183.44\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"188.09\" x2=\"190.79\" y2=\"188.09\" />\n\t\t\t\t\t\t\t\t<line class=\"cls-3\" y1=\"192.75\" x2=\"190.79\" y2=\"192.75\" />\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t\t<div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n\t\t<div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color2 }\"></div>\n\t\t<div class=\"fourth\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n\t\t<div class=\"fifth\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n\n\t\t<div class=\"avatar-container\">\n\t\t\t<div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\"></div>\n\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t</div>\n\n\t\t<div class=\"caption-small\" ng-style=\"{ 'background-color': $ctrl.color3 }\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.37 17.28\">\n\t\t\t\t<g data-name=\"Layer 2\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M8.31,17.28a.47.47,0,0,1-.17,0,.68.68,0,0,1-.49-.82L11.78.5a.67.67,0,0,1,1.3.34L9,16.78A.68.68,0,0,1,8.31,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M2.94,17.28a.52.52,0,0,1-.17,0,.67.67,0,0,1-.48-.82L6.41.5A.68.68,0,0,1,7.24,0a.67.67,0,0,1,.48.82L3.59,16.78A.67.67,0,0,1,2.94,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M14.7,6H2.2a.68.68,0,0,1-.68-.68.67.67,0,0,1,.68-.67H14.7a.67.67,0,0,1,.67.67A.68.68,0,0,1,14.7,6Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M13.17,11.9H.67A.67.67,0,0,1,0,11.23a.68.68,0,0,1,.67-.68h12.5a.68.68,0,0,1,.68.68A.67.67,0,0,1,13.17,11.9Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<p>{{ $ctrl.data.relatedTags.toString() | limitTo: 90 }}</p>\n\t\t</div>\n\t</div>\n\t<div class=\"right-square\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n\n</div>\n"

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bookcard3Controller = function () {
	    function Bookcard3Controller(Color) {
	        (0, _classCallCheck3.default)(this, Bookcard3Controller);
	
	        this.name = 'bookcard3';
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Bookcard3Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	            this.setColor();
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors('book card 2', 2);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	        }
	    }]);
	    return Bookcard3Controller;
	}();
	
	Bookcard3Controller.$inject = ['Color'];
	
	exports.default = Bookcard3Controller;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(836);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-card3{position:relative;margin:10px;width:400px;height:515px}.book-card3 .card-header{position:absolute;right:20px;top:20px}.book-card3 .card-header .first{width:320px;height:30px}.book-card3 .card-header .second{width:160px;height:30px;margin-left:160px}.book-card3 .comment{position:absolute;top:59px;left:39px}.book-card3 .comment svg{width:22px}.book-card3 .comment svg .background{fill:transparent}.book-card3 .caption{border:15px solid transparent;border-image:url(/assets/images/border-image.png) 56 round;border-image-outset:1px;border-image-width:35px;position:absolute;height:127px;right:50px;top:80px;width:260px;background-color:#f4c33c;font-size:12px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.book-card3 .layered-divs{position:absolute;top:260px}.book-card3 .layered-divs .grid{width:54px;margin-left:34px}.book-card3 .layered-divs .first,.book-card3 .layered-divs .fourth,.book-card3 .layered-divs .second,.book-card3 .layered-divs .third{width:130px;height:130px;position:absolute}.book-card3 .layered-divs .first{top:-3px;left:150px;z-index:4}.book-card3 .layered-divs .first svg .card-lines-1{isolation:isolate}.book-card3 .layered-divs .first svg .cls-2{opacity:.5;mix-blend-mode:overlay}.book-card3 .layered-divs .first svg .cls-3{fill:none;stroke:#cad2e5;stroke-miterlimit:10;stroke-width:.7px}.book-card3 .layered-divs .second{top:15px;left:167px;z-index:3;opacity:.8}.book-card3 .layered-divs .third{top:30px;left:190px;z-index:2;opacity:.8}.book-card3 .layered-divs .fourth{top:50px;left:225px;z-index:1}.book-card3 .layered-divs .fifth{width:25px;height:55px;position:absolute;top:180px;left:200px}.book-card3 .layered-divs .caption-small{position:relative;margin-left:30px;width:87px;height:105px;margin-top:92px}.book-card3 .layered-divs .caption-small svg{width:18px;top:-24px;position:absolute}.book-card3 .layered-divs .caption-small p{font-size:11px;font-family:Myriad-Pro;padding:3px;height:100%;overflow:hidden;word-break:break-all}.book-card3 .layered-divs .likes-container{position:absolute;z-index:2;top:72px;left:38px}.book-card3 .layered-divs .likes-container svg{width:40px}.book-card3 .layered-divs .likes-container svg .like{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.15px}.book-card3 .layered-divs .likes-container .count{position:absolute;bottom:8px;width:100%;text-align:center;font-size:9px;color:#ffff;font-family:Graphik-Bold}.book-card3 .layered-divs .avatar-container{position:absolute;bottom:10px;left:225px;width:130px}.book-card3 .layered-divs .avatar-container .avatar{width:40px;height:40px;margin-left:calc(50% - 20px);border-radius:20px;background:#000}.book-card3 .layered-divs .avatar-container p{font-size:11px;text-align:center;margin-top:6px;font-family:Myriad-Pro}.book-card3 .right-square{width:30px;height:30px;right:0;bottom:0;position:absolute}", ""]);
	
	// exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(838);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard3.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard3.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.book-card3{height:410px;width:311px;margin:2px;user-select:none}.book-card3 .card-header{top:0}.book-card3 .card-header .first{width:250px;height:25px;margin-left:70px}.book-card3 .card-header .second{height:25px}.book-card3 .caption{height:84px;right:45px;top:50px;width:180px}.book-card3 .comment{top:29px;left:36px}.book-card3 .layered-divs{top:185px}.book-card3 .layered-divs .likes-container{top:53px;left:34px}.book-card3 .layered-divs .grid{width:42px}.book-card3 .layered-divs .first,.book-card3 .layered-divs .fourth,.book-card3 .layered-divs .second,.book-card3 .layered-divs .third{width:100px;height:100px}.book-card3 .layered-divs .fourth{top:40px;left:185px}.book-card3 .layered-divs .fifth{width:20px;top:140px;left:165px}.book-card3 .layered-divs .avatar-container{bottom:43px;left:185px;top:145px;width:100px}.book-card3 .layered-divs .first{left:130px}.book-card3 .layered-divs .second{left:147px}.book-card3 .layered-divs .third{left:170px}.book-card3 .layered-divs .right-square{width:20px;height:20px}.book-card3 .layered-divs .caption-small p{height:76px}}", ""]);
	
	// exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookcard = __webpack_require__(840);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard4Module = _angular2.default.module('bookcard4', [_angularUiRouter2.default]).component('bookcard4', _bookcard2.default).name;
	
	exports.default = bookcard4Module;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookcard = __webpack_require__(841);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(842);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	__webpack_require__(843);
	
	__webpack_require__(845);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard4Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _bookcard2.default,
	    controller: _bookcard4.default
	};
	
	exports.default = bookcard4Component;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-card4\">\n\t<div class=\"card-header\">\n\t\t<div class=\"left\" ng-style=\"{ 'background-color': $ctrl.color1 }\">\n\t\t</div>\n\t\t<div class=\"hashtag\" ng-style=\"{ 'color': $ctrl.color1 }\">\n\t\t\t{{ $ctrl.data.scrapedByTag }}\n\t\t</div>\n\t\t<div class=\"right\" ng-style=\"{ 'background-color': $ctrl.color1 }\">\n\t\t</div>\n\t</div>\n\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"240\" height=\"240\" viewBox=\"0 0 240 240\">\n\t\t\t<defs>\n\t\t\t\t<style>\n\t\t\t\t\t.card-grid {\n\t\t\t\t\t\tmix-blend-mode: overlay;\n\t\t\t\t\t}\n\t\t\t\t</style>\n\t\t\t</defs>\n\t\t\t<image data-name=\"grid\" class=\"card-grid\" width=\"240\" height=\"240\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\t\t<div class=\"avatar-container\">\n\t\t\t<div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\">\n\t\t\t</div>\n\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t</div>\n\t\t<div class=\"container-wrapper\" ng-style=\"{ 'background-color': $ctrl.color4 }\"></div>\n\n\t\t<div class=\"first\"></div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t</div>\n\t<div class=\"card-footer\">\n\t\t<div class=\"right-container\">\n\t\t\t<svg class=\"hashtag\" viewBox=\"0 0 15.37 17.28\">\n\t\t\t\t<g data-name=\"Layer 2\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M8.31,17.28a.47.47,0,0,1-.17,0,.68.68,0,0,1-.49-.82L11.78.5a.67.67,0,0,1,1.3.34L9,16.78A.68.68,0,0,1,8.31,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M2.94,17.28a.52.52,0,0,1-.17,0,.67.67,0,0,1-.48-.82L6.41.5A.68.68,0,0,1,7.24,0a.67.67,0,0,1,.48.82L3.59,16.78A.67.67,0,0,1,2.94,17.28Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M14.7,6H2.2a.68.68,0,0,1-.68-.68.67.67,0,0,1,.68-.67H14.7a.67.67,0,0,1,.67.67A.68.68,0,0,1,14.7,6Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M13.17,11.9H.67A.67.67,0,0,1,0,11.23a.68.68,0,0,1,.67-.68h12.5a.68.68,0,0,1,.68.68A.67.67,0,0,1,13.17,11.9Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\n\t\t\t<div class=\"caption-small\">{{ $ctrl.data.relatedTags.toString() | limitTo: 50 }}</div>\n\n\t\t\t<svg viewBox=\"0 0 54.55 54.35\" class=\"grid\">\n\t\t\t\t<g>\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<g class=\"background\">\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M0,39.89a2,2,0,1,1,2,2A2,2,0,0,1,0,39.89Z\" />\n\t\t\t\t\t\t\t\t<circle class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" cx=\"14.63\" cy=\"39.89\" r=\"1.98\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M25.3,39.89a2,2,0,1,1,2,2A2,2,0,0,1,25.3,39.89Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M37.94,39.89a2,2,0,1,1,2,2A2,2,0,0,1,37.94,39.89Z\" />\n\t\t\t\t\t\t\t\t<circle class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" cx=\"52.57\" cy=\"39.89\" r=\"1.98\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M0,14.61a2,2,0,1,1,2,2A2,2,0,0,1,0,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M12.65,14.61a2,2,0,1,1,2,2A2,2,0,0,1,12.65,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M25.3,14.61a2,2,0,1,1,2,2A2,2,0,0,1,25.3,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M37.94,14.61a2,2,0,1,1,2,2A2,2,0,0,1,37.94,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M50.59,14.61a2,2,0,1,1,2,2A2,2,0,0,1,50.59,14.61Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M12.65,2a2,2,0,1,1,2,2A2,2,0,0,1,12.65,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M25.3,2a2,2,0,1,1,2,2A2,2,0,0,1,25.3,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M37.94,2a2,2,0,1,1,2,2A2,2,0,0,1,37.94,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M50.59,2a2,2,0,1,1,2,2A2,2,0,0,1,50.59,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M0,27.25a2,2,0,1,1,2,2A2,2,0,0,1,0,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M12.65,27.25a2,2,0,1,1,2,2A2,2,0,0,1,12.65,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M25.3,27.25a2,2,0,1,1,2,2A2,2,0,0,1,25.3,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M37.94,27.25a2,2,0,1,1,2,2A2,2,0,0,1,37.94,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M50.59,27.25a2,2,0,1,1,2,2A2,2,0,0,1,50.59,27.25Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M0,52.37a2,2,0,1,1,2,2A2,2,0,0,1,0,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M12.65,52.37a2,2,0,1,1,2,2A2,2,0,0,1,12.65,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M25.3,52.37a2,2,0,1,1,2,2A2,2,0,0,1,25.3,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M37.94,52.37a2,2,0,1,1,2,2A2,2,0,0,1,37.94,52.37Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color3 }\" d=\"M50.59,52.37a2,2,0,1,1,2,2A2,2,0,0,1,50.59,52.37Z\" />\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</div>\n\t\t<div class=\"likes-container\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.36 30.01\">\n\t\t\t\t<g>\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"background\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M28.36,15q0,7.35-3.61,11.19T14.18,30Q7.32,30,3.66,26.17T0,15Q0,7.67,3.64,3.84T14.22,0q7,0,10.55,3.81T28.36,15Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path class=\"like\" d=\"M19.61,12.25l-4.43,4.43a1.41,1.41,0,0,1-2,0L8.76,12.25a4,4,0,0,1-.22-5.44,3.91,3.91,0,0,1,5.65-.13,3.87,3.87,0,0,1,5.62.13A4,4,0,0,1,19.61,12.25Z\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<span class=\"count\">{{ $ctrl.data.likes }}</span>\n\t\t</div>\n\t\t<div class=\"first\">\n\t\t\t<div class=\"comment\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.28 17.29\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t\t<path class=\"background\" d=\"M.67,16.61l4-4h9.92a2,2,0,0,0,2-2V2.65a2,2,0,0,0-2-2h-12a2,2,0,0,0-2,2Z\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M.67,17.29a.57.57,0,0,1-.25-.06A.66.66,0,0,1,0,16.61v-14A2.65,2.65,0,0,1,2.65,0h12a2.66,2.66,0,0,1,2.66,2.65v8a2.66,2.66,0,0,1-2.66,2.66H5L1.15,17.09A.67.67,0,0,1,.67,17.29Zm2-15.94a1.3,1.3,0,0,0-1.3,1.3V15l2.88-2.88a.63.63,0,0,1,.47-.2h9.92a1.31,1.31,0,0,0,1.31-1.31V2.65a1.31,1.31,0,0,0-1.31-1.3Z\"\n\t\t\t\t\t\t\t\t ng-style=\"{ 'fill': $ctrl.color1 }\" />\n\t\t\t\t\t\t\t\t<line class=\"stroke\" x1=\"12.07\" y1=\"4.87\" x2=\"5.21\" y2=\"4.87\" ng-style=\"{ 'fill': $ctrl.color1 }\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M12.07,5.55H5.21a.68.68,0,1,1,0-1.35h6.86a.68.68,0,0,1,0,1.35Z\" ng-style=\"{ 'fill': $ctrl.color1 }\"\n\t\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t\t<line class=\"stroke\" x1=\"12.07\" y1=\"8.48\" x2=\"5.21\" y2=\"8.48\" ng-style=\"{ 'fill': $ctrl.color1 }\" />\n\t\t\t\t\t\t\t\t<path class=\"stroke\" d=\"M12.07,9.15H5.21a.67.67,0,0,1-.68-.67.68.68,0,0,1,.68-.68h6.86a.68.68,0,0,1,.67.68A.67.67,0,0,1,12.07,9.15Z\"\n\t\t\t\t\t\t\t\t ng-style=\"{ 'fill': $ctrl.color1 }\" />\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</g>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"caption\">{{ $ctrl.data.caption | limitTo: 160 }}</div>\n\t\t</div>\n\t\t<div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n\t\t<div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color2 }\"></div>\n\t\t<div class=\"fourth\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n\t\t<div class=\"fifth\" ng-style=\"{ 'background-color': $ctrl.color4 }\"></div>\n\t</div>\n</div>\n"

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bookcard4Controller = function () {
	    function Bookcard4Controller(Color) {
	        (0, _classCallCheck3.default)(this, Bookcard4Controller);
	
	        this.name = 'bookcard1';
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Bookcard4Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	            this.setColor();
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors('book card 4', this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	            this.color4 = colors[3];
	        }
	    }]);
	    return Bookcard4Controller;
	}();
	
	Bookcard4Controller.$inject = ['Color'];
	
	exports.default = Bookcard4Controller;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(844);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-card4{position:relative;margin:10px;width:400px;height:515px}.book-card4 .card-header{position:absolute}.book-card4 .card-header .left{left:0;top:0;width:30px;height:60px}.book-card4 .card-header .hashtag{position:absolute;left:30px;width:249px;text-align:right;top:0;padding-right:0;height:60px;font-size:42px;overflow:hidden;font-family:Nickainley-Normal}.book-card4 .card-header .right{position:absolute;top:0;width:65px;left:300px;height:60px}.book-card4 .photo-container{position:absolute;top:60px;width:270px;height:230px;left:30px;z-index:5}.book-card4 .photo-container svg{position:absolute;left:10px;top:5px;width:260px;height:220px}.book-card4 .photo-container .avatar-container{position:absolute;width:95px;height:80px;background:#fff;top:43px;left:235px;z-index:2}.book-card4 .photo-container .avatar-container .avatar{position:absolute;width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px);margin-top:12px}.book-card4 .photo-container .avatar-container p{position:absolute;bottom:7px;width:100%;font-size:12px;font-family:Myriad-Pro;font-weight:700;text-align:center;overflow:hidden}.book-card4 .photo-container .container-wrapper{position:absolute;left:255px;top:34px;width:25px;height:99px;z-index:1}.book-card4 .photo-container .first,.book-card4 .photo-container .second,.book-card4 .photo-container .third{position:absolute;width:99px;height:99px}.book-card4 .photo-container .first{background-color:#fff;opacity:.2;left:104px;top:67px;width:120px}.book-card4 .photo-container .second{background-color:#fff;opacity:.3;left:135px;top:47px;width:125px;height:100px}.book-card4 .photo-container .third{background-color:#fff;opacity:.4;left:162px;top:34px}.book-card4 .card-footer{position:absolute;width:400px;top:330px}.book-card4 .card-footer .right-container{position:absolute;right:0;top:-30px;width:180px}.book-card4 .card-footer .right-container svg.hashtag{position:relative;z-index:3;margin-left:0;margin-top:12px;width:20px}.book-card4 .card-footer .right-container svg.grid{width:55px;margin-top:73px;position:absolute;padding-left:8px}.book-card4 .card-footer .right-container svg.grid .background{opacity:.6}.book-card4 .card-footer .right-container .caption-small{position:absolute;z-index:2;margin:0 0 0 28px;width:125px;height:60px;background-color:#fff;font-size:11px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden;top:0;padding-top:10px}.book-card4 .card-footer .likes-container{position:absolute;z-index:5;left:280px;top:-73px}.book-card4 .card-footer .likes-container svg{width:40px}.book-card4 .card-footer .likes-container svg .like{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.15px}.book-card4 .card-footer .likes-container .count{position:absolute;bottom:9px;width:100%;text-align:center;font-size:8px;color:#ffff;font-family:Graphik-Bold}.book-card4 .card-footer .first{width:180px;height:185px;left:30px;position:absolute;top:-15px;z-index:4}.book-card4 .card-footer .first .comment{margin-top:-20px;text-align:right;margin-right:10px}.book-card4 .card-footer .first .comment svg{width:20px}.book-card4 .card-footer .first .comment svg .background{fill:transparent}.book-card4 .card-footer .first .caption{border:15px solid transparent;border-image:url(/assets/images/border-image.png) 56 round;border-image-outset:1px;border-image-width:35px;position:absolute;height:155px;left:0;top:0;width:120px;background-color:#f4c33c;font-size:12px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.book-card4 .card-footer .first .caption::-webkit-scrollbar{width:3px}.book-card4 .card-footer .first .caption::-webkit-scrollbar-track{background:#f2f2f2}.book-card4 .card-footer .first .caption::-webkit-scrollbar-thumb{background:#bbb}.book-card4 .card-footer .first .caption::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.book-card4 .card-footer .second{z-index:3;width:60px;left:180px;position:absolute;height:80px;top:90px}.book-card4 .card-footer .third{left:240px;position:absolute;width:35px;height:60px;z-index:0;top:110px}.book-card4 .card-footer .fourth{left:240px;position:absolute;width:70px;height:40px;z-index:1;top:130px}.book-card4 .card-footer .fifth{top:150px;width:75px;height:20px;position:absolute;left:270px;z-index:0}.book-card4 .card-footer .sixth{top:150px;width:36px;height:20px;background:#fff;position:absolute;left:28px}", ""]);
	
	// exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(846);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard4.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard4.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.book-card4{height:410px;width:311px;margin:2px;user-select:none}.book-card4 .card-header .left{width:25px;height:50px}.book-card4 .card-header .hashtag{left:25px;height:50px;width:200px;font-size:35px}.book-card4 .card-header .right{width:45px;left:235px;height:50px}.book-card4 .photo-container{left:25px;top:50px;width:210px;height:190px}.book-card4 .photo-container svg{left:3px;top:3px;width:204px;height:187px}.book-card4 .photo-container .container-wrapper{left:210px}.book-card4 .photo-container .avatar-container{left:180px}.book-card4 .card-footer{top:280px}.book-card4 .card-footer .likes-container{left:216px;top:-65px}.book-card4 .card-footer .likes-container svg{width:35px}.book-card4 .card-footer .right-container{right:70px;top:-28px}.book-card4 .card-footer .right-container svg.grid{display:none}.book-card4 .card-footer .right-container svg.hashtag{width:17px}.book-card4 .card-footer .right-container .caption-small{width:100px;height:74px}.book-card4 .card-footer .first{height:130px;width:145px}.book-card4 .card-footer .first .caption{height:100px;left:0;top:0;width:85px}.book-card4 .card-footer .second{width:50px;left:145px;height:80px;top:36px}.book-card4 .card-footer .third{left:195px;width:30px;height:60px;top:56px}.book-card4 .card-footer .fourth{left:195px;top:76px}.book-card4 .card-footer .fifth{top:96px;width:75px;height:20px;position:absolute;left:215px}}", ""]);
	
	// exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _bookcard = __webpack_require__(848);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard5Module = _angular2.default.module('bookcard5', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('bookcard5', {
	        url: '/bookcard5',
	        component: 'bookcard5'
	    });
	}]).component('bookcard5', _bookcard2.default).name;
	
	exports.default = bookcard5Module;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bookcard = __webpack_require__(849);
	
	var _bookcard2 = _interopRequireDefault(_bookcard);
	
	var _bookcard3 = __webpack_require__(850);
	
	var _bookcard4 = _interopRequireDefault(_bookcard3);
	
	__webpack_require__(851);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bookcard5Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _bookcard2.default,
	    controller: _bookcard4.default
	};
	
	exports.default = bookcard5Component;

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"book-card5\">\n    <div class=\"card-header\">\n        <div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n        <div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color2 }\"></div>\n        <div class=\"caption-user\" ng-style=\"{ 'background-color': $ctrl.color3 }\">\n            <div class=\"avatar-container\">\n                <div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\"></div>\n                <p>{{ $ctrl.data.owner.username }}</p>\n            </div>\n            <div class=\"caption\">\n                {{ $ctrl.data.caption }}\n            </div>\n        </div>\n        <div class=\"left-column\" ng-style=\"{ 'background-color': $ctrl.color3 }\"></div>\n    </div>\n    <div class=\"card-body\">\n        <div class=\"layers-above-photo\">\n            <div class=\"likes-container\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.36 30.01\">\n                    <g>\n                        <g>\n                            <g>\n                                <path class=\"background\" d=\"M28.36,15q0,7.35-3.61,11.19T14.18,30Q7.32,30,3.66,26.17T0,15Q0,7.67,3.64,3.84T14.22,0q7,0,10.55,3.81T28.36,15Z\"\n                                />\n                                <path class=\"like\" d=\"M19.61,12.25l-4.43,4.43a1.41,1.41,0,0,1-2,0L8.76,12.25a4,4,0,0,1-.22-5.44,3.91,3.91,0,0,1,5.65-.13,3.87,3.87,0,0,1,5.62.13A4,4,0,0,1,19.61,12.25Z\"\n                                />\n                            </g>\n                        </g>\n                    </g>\n                </svg>\n                <span class=\"count\">{{ $ctrl.data.likes }}</span>\n            </div>\n            <div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"fourth\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n        </div>\n\n        <div class=\"photo-container\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n            <div class=\"grid\"></div>\n        </div>\n\n        <div class=\"layers-below-photo\">\n            <div class=\"first\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"second\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"third\" ng-style=\"{ 'background-color': $ctrl.color1 }\"></div>\n            <div class=\"fourth\">\n                <div class=\"hashtag-svg\">\n                    <svg viewBox=\"0 0 15.37 17.28\">\n                        <g data-name=\"Layer 2\">\n                            <g>\n                                <g>\n                                    <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M8.31,17.28a.47.47,0,0,1-.17,0,.68.68,0,0,1-.49-.82L11.78.5a.67.67,0,0,1,1.3.34L9,16.78A.68.68,0,0,1,8.31,17.28Z\"\n                                    />\n                                    <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M2.94,17.28a.52.52,0,0,1-.17,0,.67.67,0,0,1-.48-.82L6.41.5A.68.68,0,0,1,7.24,0a.67.67,0,0,1,.48.82L3.59,16.78A.67.67,0,0,1,2.94,17.28Z\"\n                                    />\n                                    <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M14.7,6H2.2a.68.68,0,0,1-.68-.68.67.67,0,0,1,.68-.67H14.7a.67.67,0,0,1,.67.67A.68.68,0,0,1,14.7,6Z\"\n                                    />\n                                    <path class=\"stroke\" ng-style=\"{ 'fill': $ctrl.color1 }\" d=\"M13.17,11.9H.67A.67.67,0,0,1,0,11.23a.68.68,0,0,1,.67-.68h12.5a.68.68,0,0,1,.68.68A.67.67,0,0,1,13.17,11.9Z\"\n                                    />\n                                </g>\n                            </g>\n                        </g>\n                    </svg>\n                </div>\n                <p>{{ $ctrl.data.relatedTags.toString() | limitTo: 80 }}</p>\n            </div>\n        </div>\n\n        <div class=\"hashtag\" ng-style=\"{ 'background-color': $ctrl.color3 }\">\n            <span ng-style=\"{ 'color': $ctrl.color1 }\">{{ $ctrl.data.scrapedByTag }}</span>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bookcard5Controller = function () {
	    function Bookcard5Controller(Color) {
	        (0, _classCallCheck3.default)(this, Bookcard5Controller);
	
	        this.name = 'bookcard5';
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(Bookcard5Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	            this.setColor();
	        }
	    }, {
	        key: 'setColor',
	        value: function setColor() {
	            var colors = this.Color.getColors('book card 5', this.data.cardGroup);
	
	            this.color1 = colors[0];
	            this.color2 = colors[1];
	            this.color3 = colors[2];
	        }
	    }]);
	    return Bookcard5Controller;
	}();
	
	Bookcard5Controller.$inject = ['Color'];
	
	exports.default = Bookcard5Controller;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(852);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./bookcard5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".book-card5{margin:10px;width:400px;height:515px}.book-card5,.book-card5 .card-header{position:relative}.book-card5 .card-header .first{position:absolute;width:320px;height:40px;right:25px}.book-card5 .card-header .second{position:absolute;top:40px;right:0;width:345px;height:55px}.book-card5 .card-header .caption-user{position:absolute;top:20px;width:230px;height:250px;background:#e6f2ec;right:25px;overflow:hidden}.book-card5 .card-header .caption-user .avatar-container{margin-top:10px}.book-card5 .card-header .caption-user .avatar-container .avatar{width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px)}.book-card5 .card-header .caption-user .avatar-container p{margin-top:5px;font-family:Myriad-Pro;font-size:13px;text-align:center}.book-card5 .card-header .caption-user .caption{font-size:11px;font-family:Myriad-Pro;padding:10px;word-break:break-all}.book-card5 .card-header .left-column{position:absolute;top:40px;height:475px;width:55px;opacity:.8}.book-card5 .card-body .layers-above-photo{position:absolute;top:200px}.book-card5 .card-body .layers-above-photo .likes-container{position:absolute;left:37px;z-index:1;top:5px}.book-card5 .card-body .layers-above-photo .likes-container svg{width:35px}.book-card5 .card-body .layers-above-photo .likes-container svg .background{fill:#d33c51}.book-card5 .card-body .layers-above-photo .likes-container svg .like{stroke:#fff;fill:#d33c51}.book-card5 .card-body .layers-above-photo .likes-container .count{position:absolute;top:22px;font-size:10px;font-family:Myriad-Pro;width:100%;text-align:center;color:#fff}.book-card5 .card-body .layers-above-photo .first{opacity:.4;width:120px;height:130px;top:-25px;position:absolute}.book-card5 .card-body .layers-above-photo .second{width:118px;height:75px;opacity:.6;top:-5px;position:absolute;left:27px}.book-card5 .card-body .layers-above-photo .third{width:98px;height:55px;opacity:.8;top:15px;position:absolute;left:47px}.book-card5 .card-body .layers-above-photo .fourth{width:78px;height:35px;position:absolute;left:67px;top:35px;opacity:.8}.book-card5 .card-body .layers-below-photo{top:300px;position:absolute}.book-card5 .card-body .layers-below-photo .first{position:absolute;width:60px;height:110px;left:187px;opacity:.8}.book-card5 .card-body .layers-below-photo .second{position:absolute;width:80px;top:20px;height:110px;left:187px;opacity:.6}.book-card5 .card-body .layers-below-photo .third{position:absolute;width:100px;top:40px;height:110px;left:187px;opacity:.4}.book-card5 .card-body .layers-below-photo .fourth{position:absolute;width:160px;top:60px;height:97px;left:207px;background-color:#fff;overflow:hidden}.book-card5 .card-body .layers-below-photo .fourth .hashtag-svg{margin:5px}.book-card5 .card-body .layers-below-photo .fourth .hashtag-svg svg{width:15px}.book-card5 .card-body .layers-below-photo .fourth p{font-size:11px;font-family:Myriad-Pro;margin:5px;word-break:break-all}.book-card5 .card-body .photo-container{width:160px;height:160px;left:27px;top:270px;position:absolute;overflow:hidden}.book-card5 .card-body .photo-container .grid{background:url(/assets/images/card6-grid.svg);height:155px;width:40px;margin:3px 0 0 3px}.book-card5 .card-body .hashtag{width:205px;height:30px;bottom:8px;background-color:#e6f2ec;position:absolute;opacity:.8}.book-card5 .card-body .hashtag span{margin-left:56px;margin-top:-30px;position:absolute;font-size:40px;font-family:Nickainley-Normal}", ""]);
	
	// exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(854);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card6Module = _angular2.default.module('card6', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('card6', {
			url: '/card6',
			component: 'card6'
		});
	}]).component('card6', _card2.default).name;
	
	exports.default = card6Module;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _card = __webpack_require__(855);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(856);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(857);
	
	__webpack_require__(859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card6Component = {
	  bindings: {
	    'data': '='
	  },
	  template: _card2.default,
	  controller: _card4.default
	};
	
	exports.default = card6Component;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card6\">\n\t<div class=\"card-header\">\n\t\t<div class=\"left\">\n\t\t\t<div class=\"overlay\"></div>\n\t\t</div>\n\t\t<div class=\"hashtag\">\n\t\t\t{{ $ctrl.data.scrapedByTag }}\n\t\t</div>\n\t\t<div class=\"right\">\n\t\t\t<img src=\"/assets/images/card6-grid.svg\" alt=\"\">\n\t\t</div>\n\t</div>\n\t<div class=\"photo-container\"\n\t\tng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"240\" height=\"240\" viewBox=\"0 0 240 240\">\n\t\t\t<defs>\n\t\t\t\t<style>\n\t\t\t\t\t.card6-grid {\n\t\t\t\t\t\tmix-blend-mode: overlay;\n\t\t\t\t\t}\n\t\t\t\t</style>\n\t\t\t</defs>\n\t\t\t<image data-name=\"grid\" class=\"card6-grid\" width=\"240\" height=\"240\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\t\t<div class=\"avatar-container\">\n\t\t\t<div class=\"avatar\"\n\t\t\tng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\">\n\t\t\t</div>\n\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t</div>\n\t\t<div class=\"container-wrapper\"></div>\n\n\t\t<div class=\"first\"></div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t</div>\n\t<div class=\"card-footer\">\n\t\t<div class=\"left-container\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"34\" viewBox=\"0 0 30 34\">\n\t\t\t\t<image data-name=\"hash\" width=\"30\" height=\"34\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAsCAMAAAAgsQpJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABHVBMVEVHXKmAgIBHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKlHXKkAAAAEEw9sAAAAXXRSTlMAAAa7/YcCsJRQQg3ahegB2JbKpBxSEGFgEVEdo8vnhtmVLENv9wizvBMgI/SI65j8+6KgGSp89UokOzON4X/u0Z3CrBVaDPpoWRac0o7gZ362twQ3QEb5QfKeNHf+2ayZAAAAAWJLR0ReBNZhuwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFFgYQM9tVmO8AAAHCSURBVDjLhdR5U9RAEMbhWQhh5VK55JD7PhQQcLlPZQUF0QUV8ff9v4adRKd3hq7K/JW36kn6zWarnYtOS2vSpiltT6qV/MTOPYNEUwfQacMqdGnqhp7nNnwBLzX1Qp89ul9mDfg0mMArGw5JxWGfRuS2URu+hrGwcMWG4zChaRKmbDgts2aCwiM2nIW5+bCwDRdgUVMf9FYCuLRcnJVVeLPsz1upWFwtFXCN0pN/hHS9HG7kT3xXDjeLjltFk+0NeO8brtS08Fb41jty665Pe5L2XcX6eQ7gUNMRHKc2PIFTTWdw7kz4QWZ99OmiDp9seCnwKi5swc/wRdM13Dgb3sD1k8IG3JVZOz5dSbq04VeoXzwpbMBzONN0CifOhOkxHAWFDwJ4Wyv7P9Ruc1gv/+espxn8Vg6/509s3N3n58dPqN7/P78e4Pe/67tG8DLZ3pr26VHSnjPfekL2lr7zH3ho2DDbWwoXYcGZcFj21pB383Mwa8N8b3k4o4VjOAWTOlkKjzsbZntL4ZgWjuBotre8ay4cwXDRDsht/TbM9pZObi4cwR7oVtglX9OGnTKrQ2HSVDh6YjVpTxW2Ja0tMfwL4gGz8WlBVgsAAAAASUVORK5CYII=\"\n\t\t\t\t/>\n\t\t\t</svg>\n\n\t\t\t<div class=\"caption-small\">{{ $ctrl.data.relatedTags.toString() | limitTo: 50 }}</div>\n\t\t</div>\n\t\t<div class=\"first-top\"></div>\n\t\t<div class=\"first\">\n\t\t\t<div class=\"person-skiing\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"26\" viewBox=\"0 0 30 26\">\n\t\t\t\t\t<image data-name=\"person_skiing\" width=\"30\" height=\"26\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t\t\t/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"comment\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\">\n\t\t\t\t\t<image data-name=\"Vector Smart Object\" width=\"25\" height=\"25\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAMAAAANmfvwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAflBMVEUAAAD19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vf19vcAAADK2saLAAAAKHRSTlMAQ7n2dNKwb3zAEKfv8GSuAr0N+My/XU2+oJ1Sh2lUzQkfIHt47HL6aCzeaQAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRYGEQkEQnAcAAAAtElEQVQ4y7XT2Q6DIBRF0SsIWrVOnee5Pf//hSWSGi0CSWP3Cw+skAtGIgoYhyXOAlKFcBaqM9QipCWhNgNiQETWIoARhyBHApwA6SISGJvEk16xSZLvB0nMU9Js2ilL/zbuOCQvuh+wyH+6dFn1RVUOzFInnerRbzTD3EcWwNJDVmr69cZsu2sJ7W2/x6EldDw5jCZE58vV6KbNhwx2b4yTaOMmjXm4SWM8RBvyGw+h50u+AdJUNo40kDOxAAAAAElFTkSuQmCC\"\n\t\t\t\t\t/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"caption\">{{ $ctrl.data.caption | limitTo: 56 }}</div>\n\t\t</div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t\t<div class=\"fourth\"></div>\n\t</div>\n</div>\n"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card6Controller = function () {
		function Card6Controller($scope) {
			(0, _classCallCheck3.default)(this, Card6Controller);
	
			this.name = 'card6';
			this.$scope = $scope;
		}
	
		(0, _createClass3.default)(Card6Controller, [{
			key: '$onInit',
			value: function $onInit() {
				this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
			}
		}]);
		return Card6Controller;
	}();
	
	Card6Controller.$inject = ['$scope'];
	
	exports.default = Card6Controller;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(858);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card6{position:relative;margin:10px;width:400px;height:515px;background-color:#f0fefd}.card6 .card-header{position:absolute}.card6 .card-header .left{left:0;top:0;background-color:#c5f1ed;width:25px;height:90px}.card6 .card-header .left .overlay{background-color:#a2e6de;height:40px;position:absolute;width:25px;top:25px}.card6 .card-header .hashtag{position:absolute;top:0;left:37px;height:90px;display:flex;align-items:center;font-size:50px;font-family:Nickainley-Normal;color:#475ca9}.card6 .card-header .right{position:absolute;top:25px;width:65px;left:285px;height:65px;background-color:#c5f1ed}.card6 .card-header .right img{margin:5px}.card6 .photo-container{position:absolute;top:90px;width:260px;height:260px;left:25px;z-index:1}.card6 .photo-container svg{position:absolute;left:10px;top:10px}.card6 .photo-container .avatar-container{position:absolute;width:148px;height:80px;background:#fff;top:43px;left:227px;z-index:2}.card6 .photo-container .avatar-container .avatar{position:absolute;width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px);margin-top:12px}.card6 .photo-container .avatar-container p{position:absolute;bottom:7px;width:100%;font-size:12px;font-family:Myriad-Pro;font-weight:700;text-align:center}.card6 .photo-container .container-wrapper{position:absolute;left:260px;top:34px;width:25px;height:99px;background-color:#c8f2ee;z-index:1}.card6 .photo-container .first,.card6 .photo-container .second,.card6 .photo-container .third{position:absolute;width:99px;height:99px}.card6 .photo-container .first{background-color:#fff;opacity:.12;left:92px;top:87px}.card6 .photo-container .second{background-color:#fff;opacity:.15;left:121px;top:60px}.card6 .photo-container .third{background-color:#fff;opacity:.129;left:162px;top:34px}.card6 .card-footer{position:absolute;top:350px}.card6 .card-footer .left-container{position:absolute}.card6 .card-footer .left-container svg{margin-left:27px;margin-top:6px}.card6 .card-footer .left-container .caption-small{position:absolute;z-index:1;margin:15px 0 0 28px;width:107px;height:50px;font-size:11px;color:#475ca9;font-weight:700;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.card6 .card-footer .left-container .caption-small::-webkit-scrollbar{width:3px}.card6 .card-footer .left-container .caption-small::-webkit-scrollbar-track{background:#f2f2f2}.card6 .card-footer .left-container .caption-small::-webkit-scrollbar-thumb{background:#bbb}.card6 .card-footer .left-container .caption-small::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card6 .card-footer .first-top{background-color:#66c2ad;left:285px;position:absolute;top:-98px;height:58px;width:25px}.card6 .card-footer .first{background-color:#5fb69e;width:180px;height:190px;left:165px;position:absolute;top:-40px}.card6 .card-footer .first .person-skiing{margin-left:133px;margin-top:7px}.card6 .card-footer .first .comment{margin-top:15px;margin-left:10px}.card6 .card-footer .first .caption{position:absolute;height:55px;left:35px;top:84px;width:170px;background-color:#fff;padding:15px;font-size:12px;font-family:Myriad-Pro;word-wrap:break-word;overflow:hidden}.card6 .card-footer .first .caption::-webkit-scrollbar{width:3px}.card6 .card-footer .first .caption::-webkit-scrollbar-track{background:#f2f2f2}.card6 .card-footer .first .caption::-webkit-scrollbar-thumb{background:#bbb}.card6 .card-footer .first .caption::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card6 .card-footer .second{left:135px;position:absolute;width:30px;height:117px;background-color:#66c2ad}.card6 .card-footer .third{left:105px;position:absolute;width:30px;height:87px;background-color:#84cebf}.card6 .card-footer .fourth{left:75px;position:absolute;width:30px;height:57px;background-color:#c4e9e2}", ""]);
	
	// exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(860);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card6.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card6.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.card6{height:410px;width:311px;margin:2px;user-select:none}.card6 .card-header .left{height:80px}.card6 .card-header .left .overlay{height:30px}.card6 .card-header .hashtag{font-size:42px}.card6 .card-header .right{top:15px;left:240px;width:55px;height:55px}.card6 .photo-container{top:80px;width:180px;height:180px}.card6 .photo-container .card6-grid{width:165px;height:165px}.card6 .photo-container .avatar-container{left:145px;top:39px;width:130px}.card6 .photo-container .container-wrapper{left:180px;top:30px}.card6 .photo-container .first,.card6 .photo-container .second,.card6 .photo-container .third{width:60px;height:60px}.card6 .photo-container .first{left:30px;top:87px}.card6 .photo-container .second{left:57px;top:60px}.card6 .photo-container .third{left:80px;top:34px}.card6 .card-footer{top:260px}.card6 .card-footer .fourth,.card6 .card-footer .second,.card6 .card-footer .third{width:15px}.card6 .card-footer .fourth{left:65px}.card6 .card-footer .third{left:80px;height:90px}.card6 .card-footer .second{left:95px;height:110px}.card6 .card-footer .first{left:110px;height:170px;width:145px}.card6 .card-footer .first .caption{height:45px;width:130px;left:40px;top:66px}.card6 .card-footer .first .person-skiing{margin-left:105px;margin-top:4px}.card6 .card-footer .first-top{left:205px}.card6 .card-footer .left-container svg{width:20px;margin-left:33px}.card6 .card-footer .left-container .caption-small{width:80px;margin-top:0}}", ""]);
	
	// exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(862);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card7Module = _angular2.default.module('card7', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('card7', {
			url: '/card7',
			component: 'card7'
		});
	}]).component('card7', _card2.default).name;
	
	exports.default = card7Module;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _card = __webpack_require__(863);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(864);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(865);
	
	__webpack_require__(867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card7Component = {
	  bindings: {
	    'data': '='
	  },
	  template: _card2.default,
	  controller: _card4.default
	};
	
	exports.default = card7Component;

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card7\">\n\n\t<div class=\"top\">\n\t\t<div class=\"first\"></div>\n\t\t<svg class=\"hash\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"28\" height=\"46\" viewBox=\"0 0 28 46\">\n\t\t\t<image data-name=\"hash\" width=\"28\" height=\"46\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAA0CAMAAAA+P9EyAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEXmg1WAgIDqiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF/qiF8AAAASEbq2AAAAD3RSTlMAABGZu1VmiHfuIt0zqsy52d6qAAAAAWJLR0QQlbINLAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFFQYULs6KntwAAAFdSURBVEjHhZTtGoMgCIX9KjVL7/9uB62pjFPxZ+PxZUPOQWN0OB+Wntg1RGstwExqLfdka60lzBU6motuuIVOgijaIOfpZP0lOyUH7M9lOnK/LHIR5FY68T2jouwgdxDXx8K9eos4nsOYCve6QI7nEHuvlBQLuUpH+9xrhBzPofQscBHkeA5p7rVayJ3j/9MMcFAzwEHNBrdz5UOUfWjwGGH83WNcgrsYOOpZ+gv2Tf1+jU7cAljFWHDfoKxiELcJzS5/AU5bxUCuKKtAjsdflb8055VVDOSysgrkeA6H9pfiDmUVM3NvVsnLl3u1wLVv6Y2rV3/pDP7ZQp/KKn4T94CagfuKPVunIslJzcIktOT0ehvIYc0Ud6OZ4tR6jzdh5sCTDDm5Z2UuEpx+kg3inH6SIZfmX+BeR5Hg1JPsIafXe4fcrVX+uHKrmeSEVdJcJLm15dEQrdV8i859ACYAIv5Tr26BAAAAAElFTkSuQmCC\"\n\t\t\t/>\n\t\t</svg>\n\n\t\t<div class=\"second\">\n\t\t\t<p class=\"caption\">{{ $ctrl.data.relatedTags.toString() | limitTo: 40 }}</p>\n\t\t</div>\n\t\t<div class=\"third\"></div>\n\t\t<div class=\"fourth\"></div>\n\t\t<div class=\"fifth\"></div>\n\t\t<div class=\"sixth\"></div>\n\t</div>\n\n\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"150\" height=\"150\" viewBox=\"0 0 150 150\">\n\t\t\t<image data-name=\"Photo grid\" width=\"150\" height=\"150\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\t</div>\n\n\t<div class=\"card-footer\">\n\t\t<div class=\"background-layer\"></div>\n\t\t<div class=\"caption-container\">\n\t\t\t<p>{{ $ctrl.data.relatedTags.toString() | limitTo: 40 }}</p>\n\t\t</div>\n\t\t<div class=\"caption-footer\"></div>\n\n\t\t<div class=\"first\">\n\t\t\t<div class=\"avatar-container\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\">\n\n\t\t\t</div>\n\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t</div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t\t<div class=\"fourth\"></div>\n\n\t\t<div class=\"caption-right\">{{ $ctrl.data.caption | limitTo: 65 }}</div>\n\t</div>\n\n</div>\n"

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card7Controller = function () {
		function Card7Controller() {
			(0, _classCallCheck3.default)(this, Card7Controller);
	
			this.name = 'card7';
		}
	
		(0, _createClass3.default)(Card7Controller, [{
			key: '$onInit',
			value: function $onInit() {
				this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
			}
		}]);
		return Card7Controller;
	}();
	
	exports.default = Card7Controller;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(866);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card7{position:relative;width:400px;height:430px;margin:10px}.card7 .top .first{position:absolute;background-color:#eb8a59;width:30px;height:30px;top:40px;left:0}.card7 .top .hash{position:absolute;left:37px;top:28px}.card7 .top .second{position:absolute;background-color:hsla(20,76%,77%,.7);height:90px;width:120px;left:30px;top:70px;z-index:2}.card7 .top .second .caption{font-size:11px;padding:8px;font-family:Myriad-Pro;color:#fff;font-weight:700;height:69px;overflow-y:hidden;word-wrap:break-word}.card7 .top .second .caption::-webkit-scrollbar{width:3px}.card7 .top .second .caption::-webkit-scrollbar-track{background:#f2f2f2}.card7 .top .second .caption::-webkit-scrollbar-thumb{background:#bbb}.card7 .top .second .caption::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card7 .top .third{background-color:hsla(20,76%,77%,.7);width:130px;left:150px}.card7 .top .fourth,.card7 .top .third{position:absolute;height:70px;z-index:2}.card7 .top .fourth{background-color:hsla(20,76%,77%,.4);width:70px;left:280px;top:70px}.card7 .top .fifth{position:absolute;background-color:hsla(18,60%,64%,.7);width:30px;height:30px;left:350px;top:40px;z-index:2}.card7 .top .sixth{position:absolute;background-color:#f5cebb;width:20px;height:40px;left:380px}.card7 .photo-container{position:absolute;width:300px;height:270px;right:0;top:40px;z-index:1}.card7 .photo-container svg{opacity:.3;position:absolute;top:141px;left:-22px}.card7 .card-footer{position:absolute;width:400px;top:260px}.card7 .card-footer .background-layer{width:380px;height:134px;background-color:#f8dcce}.card7 .card-footer .caption-container{position:absolute;width:135px;height:55px;top:79px;background-color:#ea8855}.card7 .card-footer .caption-container p{font-size:10px;padding:5px;font-family:Myriad-Pro;color:#fff;font-weight:700;overflow:hidden;height:48px;word-wrap:break-word}.card7 .card-footer .caption-footer{background-color:#f2bb9e;width:135px;height:19px}.card7 .card-footer .first{position:absolute;width:100px;top:35px;height:90px;left:150px;background:#fff;border:1px solid #ccc;box-shadow:5px 5px 5px rgba(0,0,0,.1);z-index:4}.card7 .card-footer .first .avatar-container{width:40px;height:40px;border-radius:20px;margin-left:calc(50% - 20px);margin-top:15px}.card7 .card-footer .first p{position:absolute;width:100%;bottom:12px;font-size:11.5px;font-family:Myriad-Pro;color:#010101;font-weight:700;text-align:center}.card7 .card-footer .second{position:absolute;width:100px;height:82px;top:58px;left:167px;background-color:#ea8855;z-index:3}.card7 .card-footer .third{background-color:#f1b89a;position:absolute;width:100px;height:82px;top:71px;left:182px;z-index:2}.card7 .card-footer .fourth{background-color:#f5cfba;position:absolute;width:100px;height:82px;top:86px;left:197px;z-index:1}.card7 .card-footer .caption-right{position:absolute;top:50px;right:0;width:98px;height:83px;overflow-y:hidden;word-wrap:break-word;font-size:10px;font-family:Myriad Pro}", ""]);
	
	// exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(868);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card7.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card7.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.card7{height:333px;width:305px;margin:2px;user-select:none}.card7 .top .hash{left:25px;top:20px;width:20px}.card7 .top .first{width:15px;height:15px;top:45px}.card7 .top .second{height:60px;width:120px;left:15px;top:60px}.card7 .top .second .caption{font-size:10px}.card7 .top .third{height:60px;width:70px;left:135px}.card7 .top .fourth{width:50px;height:50px;right:50px;left:auto;top:60px}.card7 .top .fifth{width:30px;height:30px;right:20px;left:auto;top:30px}.card7 .top .sixth{width:20px;height:30px;left:auto;right:0}.card7 .photo-container{width:200px;height:160px;top:30px}.card7 .photo-container svg{top:90px;width:100px;height:100px}.card7 .card-footer{top:155px;width:310px}.card7 .card-footer .background-layer{width:300px}.card7 .card-footer .caption-container,.card7 .card-footer .caption-footer{width:100px}.card7 .card-footer .first,.card7 .card-footer .fourth,.card7 .card-footer .second,.card7 .card-footer .third{width:80px;height:70px}.card7 .card-footer .first{top:60px;left:120px}.card7 .card-footer .first .avatar-container{width:30px;height:30px;border-radius:15px;margin-left:calc(50% - 15px);margin-top:10px}.card7 .card-footer .first p{bottom:7px;overflow:hidden}.card7 .card-footer .second{top:70px;left:130px}.card7 .card-footer .third{top:80px;left:140px}.card7 .card-footer .fourth{top:90px;left:150px}.card7 .card-footer .caption-right{top:36px;z-index:2}}", ""]);
	
	// exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(870);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card9Module = _angular2.default.module('card9', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $stateProvider.state('card9', {
	        url: '/card9',
	        component: 'card9'
	    });
	}]).component('card9', _card2.default).name;
	
	exports.default = card9Module;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _card = __webpack_require__(871);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(872);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(873);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card9Component = {
	    bindings: {
	        'color': '=',
	        'data': '='
	    },
	    template: _card2.default,
	    controller: _card4.default
	};
	
	exports.default = card9Component;

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card9\">\n    <div class=\"header\">\n        <div class=\"top-left\">\n            <div class=\"inner\">\n                <img ng-src=\"{{$ctrl.data.owner.avatarUrl}}\" alt=\"avatar\" class=\"avatar\">\n            </div>\n            <span class=\"username\">{{ $ctrl.data.owner.username }}</span>\n        </div>\n        <div class=\"bottom-left\"></div>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"54\" height=\"60\" viewBox=\"0 0 54 60\"\n        class=\"hash\">\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"54\" height=\"60\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA8CAMAAAAaALmJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABpFBMVEUAAADvTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV0AAACbbprYAAAAinRSTlMAjffkP4X26Ek8zjHahHjIoryuD/xfCGtOHEIokdjUlaEYUv1eWxJPnszgiZQkRVFn+Apcq8AC63zhiAFprLC/wrvFG2PLk/tI/jZ7gJaYnAV08QTEpreyDPoG9W9KID4s3NCapRVWYkuZVd2MPRB5Fm1QvhPpgvCLatshMMEnA/I5qvmd2ZBBbMejlg9FAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFEQscF97smNgAAAJvSURBVEjHlZb3UxNRFIVTgAUNNRBBOgGkBASUIlEUAWM0FjqIIEWwY+9R7Mj+1Zw7Oxtyc/W+2fPbfnPOzPteZnfi8/07/kAwLwflF1iFPj1Ftm0f4+g4UMgwK5adEiDLMCtFp4yjcqAKfRWuRKeKoUgA6IQ+q0bFrmHoJKFafVaHSr20DRrUGtBplLZN+qqZDtTCbaNArfqsDZVoO0OnpK1IByqdRluRLnS6pW1MX/XQgXql7Wl91odK/wBDZ6StyFl0Bo22uRkaRmeEs3NAo6IZP39hLJOL5HFpLDvjhC5nHmMTzmzS9pYpZ3bF4yzhzK4mvc3c9+7a9ZQbujT7Rio7NwndOnpuvS0vMkUvf5yhaaCZWf3+59CZ52gBaFFfLS2jM8nQnRWgu/pslTzWGLpHaF2f+VHZMNqKbKKzJW3v66tt+gV3uG0C6IE+20Eluc3QQ2krsoXKptFWZAMdv7R9pK/W6ECr3JbQY31Gb9DykslWZB6dOaNtbuIWOinOngA91Wfr5PHMZOskvJvJc1RWXuxm5yXZTrhPEXf0yvLyWidfv3Fmbz1+Rt45s/ceZx+c2ceEp9Wnz+6NpDPpBB9Ps3yhH/Lo8euevNKBfnT6GJr9BjSt/2q9dIoehr4TSuuzUVS6OBoBGh7SZ6TWwdEg0A991U5/Btq47U9hK9JCHs0mW5EYKg0cdUtbkXp06qTtL31VQweq5rZJYStShUo0bLIVaUKllKNGaSsSRKeYo99Af/RVLR1o32Qr8heVQIQhsq0M67MKdMo5KgM6MKjRJ6WEo5C0FQnJN4Q+/kWGWaFVkJ+D8oKB/31XDwE6L85evFPFogAAAABJRU5ErkJggg==\"\n            />\n        </svg>\n        <div class=\"caption-hashtags\">{{ $ctrl.data.relatedTags.toString() | limitTo: 88 }}</div>\n    </div>\n    <div class=\"caption\">\n        <div class=\"first\">{{ $ctrl.data.caption | limitTo: 185 }}</div>\n        <div class=\"second\"></div>\n        <div class=\"third\"></div>\n        <div class=\"fourth\"></div>\n        <div class=\"fifth\"></div>\n        <div class=\"sixth\"></div>\n        <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"309\" height=\"286\" viewBox=\"0 0 309 286\">\n            <image id=\"Vector_Smart_Object\" data-name=\"Vector Smart Object\" width=\"309\" height=\"286\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAAEeCAMAAADcqnLDAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAC0FBMVEUAAADvTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV3vTV0AAADUe+/4AAAA7nRSTlMAv/M5uPU/r/ZGqPhMnvlTl/tbj/phh/xpf2945lThXdZk0W3GdcB+toWwkKWVoNBlFzEUNBM2EDcBDw0CDDoDCgQIOwUHFRE1Dgs4Ms9sdH2EjZSuteDBubFNoZiR/YhqgXF5QD1yLSt2FiYZJHcdH/dj8I6WpnznhrwhKi9nwz5ExElPqxtrIydgLFowVbOytEPy6eLY0sjCZkqARYJCgxgaHiUoQU7oopnrkuyK7VLuV19u5dxzzHqLk5ukYkcSSCIJKQbf2VzJnc29/q2cjBxo3XvTo8vOWZ8g9HDk295QVvHq2lhRXtes77suE21e1wAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRELGzrUclJqAAAQZ0lEQVR42u2d61fVZRqG390WMBR0I7AFQVFBQUERFSU5bBEV8ICoQYghpiIoKpknlDiIaJ4gO0gDYp4PlQpqpqNGpuYpMqepGW2cqaaaZqZ5/oaZPt73dq3tOOLQWs/18VqI8uO3Xeu91/Pcr7E8ZTVAJzd3FB6dn0bh2aUrCi/vbii623xQ9PD1Q+Fv74kiwBaIope9F4pAWwCKnnZ/FH6+PVD42Lqj6ObthaJrF08UT3f2QOHu1gmF9SmLCZJglL2lD4oQ6Yuin/RHESphKAbIQBThEoFikAxGESlRKIbIEBRREolisAxCESHhKAJkAIowCUXRX4aiiJYQFH2kN4pgCTLDYtCZ4SNIjIwlMWp0HIpnrCTGWONRJCQmoXAkjkWRPC4FxfjE8ShSxiWjGJvoQJGUmIAi3joGRZz1GRKjR9FPFzuSxIjhJGKGGUVRFEVRFEVRFEV5kkxweXqfmErC6fSeNtrV6T19ksvTu9Xl6d3q8vQ+KR2F8+l9dBoLPr2nTiQx2en0PuFBSRFlY05J0RSZiiJUMlBYZBqKcMlE4SHTUUTKDBReQlGYU1I0XWaiyJRnUUwTC4oMToqmyhQUfTkp8pEsFL8kRdlulEo+15lSyZwunEp6z0KRa6NUcjanks/nUSo5x56PYm7eCyjm2eeheCFvLop8+xwUfnnP009sm42imy0XxSxvTiW75KBw7/wcCqtb9n/eYkO0i0jqIF/RLkJRFEVRFEVRFEVR2pf5gRRjLQh0oLAW0MxJagGFVJMzKJNamEEjJoVFi1AsDitGsWTpMhQlRSUoli1dgqI4bDGKRUWFKEZmLEQxMWMyirQCSg8TCigDcgQuQJEcON+8KMtRvsTpWRCnZ1mcnoXwnNVQWYEiVFaiGMDpWbisQuEhNEi2iuesvDg9i+L0bAXPWUVweraa07MMWYNiqryEYrm8aErXrkM5dy39BudZylCEWV5G0T+b8t/ybPqF+VVUovCpqEIRvL4axYb1G1BUr6f8tKqCUrzKCkrxrNnlKEZk0+jdyxYavSuzUKy3eC3FeuvWlhpFURRFURRFURRFUTo6RTUbURTUlKDYNPMVFOUzN6PYkrMVxbZB21HU1lGMteFVSkWqd9Ao02t1r6Fw30GpiPVVSkVS6ygV2T5oG4qtOVtQbJ4ZjeKVmZtQlNQUoNhYU2S8hf7Y60KLmm9IEYo3hRY1dwplJ/W8x/iW0EjUb3iPsZPQSFSO0EiUp9Ci5hD5DYrZ8haKwVKPwl92ogiQN1EUyRsoAuV1FA3ibTYEUFLbuIuS2qbdlNS+vYemBxdk7kVhjdiHIrV0P4qYUor1FvofQHHQ/yCKA/4UzK4rpTnP/aX0Ru+LoDd6byYFs8P3HEIxcXcTirRdjSgSAg4bRVEURVEURVEURVE6OjlBNNHleWQSiqNHKlG88y7FAu8do1jg+IlmFHtaTqJY3XIKRUZLA4rTLadRNLTQRNipltUoTrbsQdF84jiKxmPvoah69x0UlW8cRTHpCEVYk9/PMceEgrs1QuNMZyQfRYh8gOKsnEMRKvTPXyu/RfGsnEdRIxdQRMpFFBekBsV5Xgc9LmtR7OGBtnNyFsUHPNCWL2dQfChBKLbJMVNyiPaI91eR2NdEq33FrbRRuKiVFosnVNNi8UeXaCJzVCMtFqdVO1AkNFLw56im4C+5kfaIx1/6CEVK9QQUY1tpZjOplWY245soGoyromgw7lCJURRFURRFURRFUZQnSdrHJBJon9Ck09iKuUyDWCaZ5ljM+CskrpZRJJDCYmwhZQRJZZQRxBdSRhBXlsLiKv29Vyg0MAcpNDCbL5M4QG1kZgmlCObjNPOJUMHVNalFMUWuo7jBw1sWLqHvxCX0M3k50pOHt25ytdhsHt6aLjdRzOHhrWlcLRbGw1v9eTkymoe3rnO1WK1cQzFLPjG3fOejDLW3ovjUTpNH4W30XD9ro+cayc/1ttAsXRQvnX7OGV0mV7atls9RZHC5/ya5zc+EKtuut31Gz6SNlk4P2z9F0WqnjG6+7y2T5EBn4tNdibgxLPgdNmksOsxX0H8MZgyL9HhXwuFUWKYoiqIoiqIoiqIo7UrqKcqkYvxIvPwhRVCFfUlc6Uvn+QMNdGx+pYE22PaXU9fYnXKaW9n7O1ppW1R+B8XIcppbmdhAO5lpDZQNjulLyd/lvlQ+dvlDqq666kc7bldPpRo3Hrw6wYNX7wstSH4hv0fxpexGcYsHryp48OpTHryqk69QfMaDV19JHYoLQqHOealA8Vu5hWK3fIninHyBokDeR5EvJ1D4iZuZcYOKw6b/gVZk/c/Sww7442gU86aMo7966Nsopvajtv/oegpDT9U3o7hbfxdFcz0NCs6qj0bxdD+qjnt7KP3Cx02hnrDRf6Rd15izdCnp1j9Ql9ziG3QTg6IoiqIoiqIoiqIoHZCet2lBa/k92sc6dY9yrbtHv0YRnEszbxsu0kRb41cUpDRFUpDifjEWReKqRBSxF6lrLCaSNi63fkUblwcvUtfYklzqGvv6KCUrd+5RslJ8j0r5J9zuaWxCe5l/kvso3pClKP4su1BcE7pc8UtuErvh3CRGlys+x8Nor8qrKDyFLlfMdW4Su4FiMMdpc3gYbZf8GUUvbhK7L39C0SC+xmcFrQvW9qCUtfl5Slm7vkdvY/V5ClVfm0Fvo3sUhaqJURSqxnannrCYlfQ2LuxOb+OVKHobD0TR2/j1DGq+23+emu+K3+uKYtHzzShG9qBpvVEr6IIARVEURVEURVEURVE6ILk7aYDrwjXKGs7/hbKG6WcqUUR8QxXkAd9Q0LU061sU97O+Q5Gf1QfF8izKtfpk5aP4LosyrcNZlGk1fjMQxaFv6PbJBWdowTL2LzQzFnONZsYKd+aavwqlcN9z4Nabq/t/4MCtH1f33xAaZxogPVA8J91ReMg9FJ4cuN3jqzG7c+DWQwag8OfALUD6oVgqP6AIlN4oGuR7FKfkr6bsW9rb29xMYkktrfx+HEzTlCUnacN32Xc0TbnvR1pC3HuSxisn3KWcb+SPlPONukupc9qPNE2Z8CO1gF3+jq5yTT5ZguJqMO1ip9RSLp3UTKvXSX+jm0EVRVEURVEURVEUpZ1JpiOxGU+zMCZlGAs6NJukYhZ0ijbxToJukjRxTuIONwhtZHGHG4T2OQmuFCpmsZeiCTOMxSJuI5uQbELyqAKrXxtVYIVytVi2/IQinCuwPLhabBVXi90TSr5WCiVfK4R25SK4Amsgh0thsgrFaQ6XooUqsH7icKmWa+oPt1G41JoXYv6uT+0RnlrH/YTuc/kJ3fh/+oSyUBRFURRFURRFUZT25dc8HXPy/zMd822ZTmI90iSW89TfDy6n/r6oRNGBp/7o1/koU38/PGDqT1EURVEURVEURVGUjo7P9P+93enSo7Q7UddYbJTLdqcol+1OM55Uu9OvqUmMrrU8+hBNYvUoHleTmHNrnZfL1rrc/7q1rvoJtdbRm/SA1jp6cR6ite7mA1rrFEVRFEVRFEVRFEXp6HSU2wl/eojbCWlV8HHcThj7ELcT0tTRL7cTduCbMP+BoiPdhPlIt646UDyOW1eXPcStqzT4+DhuXXU8xK2rk0mcSjWKoiiKoiiKoiiK8iSJd7BIJxHnJBL4mziJMY/hK9Iew/dw/RUJXH6U7iS4/MgRb275zkcXaqOSrE/tVJIV3kaDOf9ou44ikkuybssmFDMkA8Xncg5FpmSiOCefo8iQGSg2yW0U0RKJ4nobxU+1bVSSddhO8VOrjUqy5vveMp8IxYPXuDhsitAzucHPxMLFYZ24OGymTEPhySNvN4XCv9k88jZdbqKYwyNv02QmijAeeesvFn6ub9FzlSn0XHnkbZZ8YtJoF9ck0CyaSaeMylym5VyTTNNqZjylWObqFXrvU8pIjC2kD0JSGe1ExxeORRFXRkvScVcoGjRXuPTrIG1Nm80UHpoD/B/SEv5Uf+z0f4eiKIqiKIqiKIqitCslh+gYvb+KxL4mOlcXt9K5elErnauHV9O5+qNLdIwe1UjH6LRqB4qERjo1O6rp1JzcSEua4y99hCKlejiKsa00g5PUSrt28U3URhZXRTM4cYdKzDHZhnINj2ad4dGsEB7NOsvZWKjsQbFWjqN4lkezang066JcRHFBalCcl2dRHJe1KPZwgfw5OYuiQEJQ5MsZFB9KEIptcszkrKFBI88jk1Ac/b4SxTvv0obh+RNUHHb8RDP98/95EsXqFlooDGuhPdXTLadRNLRQkLmlZTWKk//cg6L5BP2yGk/QL6vp3XdQVH5/FMWkI5TiTV6TYxRFURRFURRFURRF6ejMCqAYq3EXxVhNu2lz7NBuSq0WZNJVfNZMCqlSSymk2h6xDsVCfxrCOVhKMzcH/KlrbF3EdhT7S2kvbF+mFcWwzAUohu+m4veJuynQSdtFgU5CwCzjzWNVr3Mx/xEpQvEmF/PvlFIU9dwk9pZzk9gQFJ14rCpHKJBxahIbItkoZvNYlVOTmL/sRBEgb6Io4iaxQHkdRbR4m6U1dJliQU0Jik0etD9Y7kGjWFtyaBF3Ww69BbV19BZsqKO3oHoH9YRV7ahC4b6DesKsddQTllpHo3fbcyhy3ZqzBcVmj3IUr3jQfGJJDWWwG2uoj05RFEVRFEVRFEVRlA5I6c8UdM39marF5lnKUIRZqACpf/YIFOXZlGj4VVSi8KmgDv3g9ZRobFhPC5bV64NRvFbhg6KygobIrNmUaIzIpu3Cly20XVhmoa6xxT/PRbHu51LzolCl+ktCJWZBvMqZxWuLIbzKOVRWoAiVlSgGiBeKcFmFwoMvvlwltMrpxWuLK3lcbYUMRRHB42rTJAtFhqxBMVVeQrFcXjTzA2loccF9BwprAaW9qR9Q2js5g9Lef2VQT1hhEaW9i8NoRnHJUuoJKykqQbFsKe1gFofRp2JYEdWCjcz4F4qJGTStl1ZAwV9CAX1MHPcp/k0OpD1kRVEURVEURVEURWlv4n81Iu4xfI/HJLLd6IzfqTMN9+R0oZZ9T2+q0cq1dUMx20bJ1+A8Sr7m2PNRzM17AcU8OwVdL+TRVZL5durV8sujATAfGw2AdbPRVZKzvGkA7OkuNADm3pkGwKxu2SZIKOvrLfQTh0hfFEM5gQvlBM7CCVw4J3AeXBwWKVEovDiBi+IytemcwGVyAjeNE7gMTuCmcgLXlxO465zABUuQmUBXPpjhlMuaiVxMP2o0fVbSWIyx0mudPonWlx2JtL6cbKX15fGJtL6cYqUkcGyiA0XSJGoBi7dS2V/c6DQWtM9sUikrNCNoMtTE0N2hiqIoiqIoiqIoitLODKNxEefT+8hYEk6n92esrk7vCYkuT+/jXJ7ex7k8vSfSHI/z6d36DAmn03ssDfY4n94nD3tQUtQHhVNS1I8r5kO5Yn6ADEQRLhEoBvEupFNSNIR3IZ2SosEyCEUEJ0UDZQCKME6K+nNSFM1JUR/pjeKXpMjyFKeSbpRKenR2SiW7ovDyplSyO6eSPXwplfS390Sxy0Zrqb3svVAE2iiV7Gmnqz79fHug8LF1R9HNm0K7rk6pZGcK7dzdOJV8yvJvwYDKetLe9ykAAAAASUVORK5CYII=\"\n            />\n        </svg>\n    </div>\n    <div class=\"photo\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\"></div>\n</div>\n"

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card9Controller = function () {
	    function Card9Controller() {
	        (0, _classCallCheck3.default)(this, Card9Controller);
	
	        this.name = 'card9';
	        this.user = {
	            avatarUrl: '/assets/images/user.jpg',
	            username: 'lesya_derkachenko'
	        };
	    }
	
	    (0, _createClass3.default)(Card9Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	        }
	    }]);
	    return Card9Controller;
	}();
	
	exports.default = Card9Controller;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(874);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card9.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card9.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card9{position:relative;width:340px;height:500px;padding:0 30px 30px;margin-top:10px}.card9 .header .top-left{width:220px;height:110px;background-color:rgba(234,85,103,.25);z-index:4}.card9 .header .top-left .inner{position:absolute;left:70px;width:100px;height:110px;background-color:rgba(234,85,103,.4);z-index:2}.card9 .header .top-left .inner .avatar{position:absolute;top:35px;left:-3px;width:40px;height:40px;border-radius:50%}.card9 .header .top-left .username{position:absolute;top:85px;left:35px;font-size:12px}.card9 .header .bottom-left{position:absolute;top:80px;z-index:3;width:300px;height:140px;background-color:rgba(234,85,103,.15)}.card9 .header .hash{position:absolute;top:30px;right:30px;width:45px;height:45px}.card9 .header .caption-hashtags{position:absolute;top:90px;right:30px;width:120px;font-size:10px;color:#ea5567;text-align:right;font-weight:700;word-wrap:break-word;overflow-y:hidden;height:77px}.card9 .header .caption-hashtags::-webkit-scrollbar{width:3px}.card9 .header .caption-hashtags::-webkit-scrollbar-track{background:#f2f2f2}.card9 .header .caption-hashtags::-webkit-scrollbar-thumb{background:#bbb}.card9 .header .caption-hashtags::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card9 .caption div{position:absolute;padding:15px;width:240px;height:70px;font-size:10px;text-align:justify}.card9 .caption svg{position:absolute;bottom:150px;right:40px;width:220px;height:200px;z-index:3}.card9 .caption .first{overflow:hidden;bottom:230px;left:0;z-index:7;background-color:#ec4a5f;padding-bottom:20px}.card9 .caption .second{bottom:220px;left:15px;z-index:6;background-color:rgba(234,85,103,.85)}.card9 .caption .third{bottom:210px;left:30px;z-index:5;background-color:rgba(234,85,103,.7)}.card9 .caption .fourth{bottom:200px;left:45px;z-index:4;background-color:rgba(234,85,103,.55)}.card9 .caption .fifth{bottom:190px;left:60px;z-index:3;background-color:rgba(234,85,103,.4)}.card9 .caption .sixth{bottom:180px;left:75px;z-index:2;background-color:rgba(234,85,103,.25)}.card9 .photo{position:absolute;bottom:30px;width:340px;height:280px}", ""]);
	
	// exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(876);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card10Module = _angular2.default.module('card10', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('card10', {
			url: '/card10',
			component: 'card10'
		});
	}]).component('card10', _card2.default).name;
	
	exports.default = card10Module;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _card = __webpack_require__(877);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(878);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(879);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card10Component = {
	  bindings: {
	    'data': '='
	  },
	  template: _card2.default,
	  controller: _card4.default
	};
	
	exports.default = card10Component;

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card10\">\n\t<div class=\"top-right\"></div>\n\n\t<div class=\"layer-1\">\n\t\t<div class=\"top-left\"></div>\n\t\t<div class=\"caption-top\">\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"34\" viewBox=\"0 0 30 34\">\n\t\t\t\t<image data-name=\"Vector Smart Object\" width=\"30\" height=\"34\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAqCAMAAAADFmLkAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABdFBMVEUAAABGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXaoAAACj9hOqAAAAenRSTlMAM+jrN0Tu4iirm8KHAYAK+mgvQHD2BojmsbzIpAPxeg/8ZDQ4TCB38wSN4Li00J70dBL+XHWww7/KuUPsOeVfoKOpwJcxQixYFYSc08Wo3JAMZh5QSCRg/RCM5MyLEQ7BYbLLJ/lRc+nw+wjZlAJ9HFM89Z94IecwaYQq0UwAAAABYktHRACIBR1IAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUWDRAdC9Z6wQAAAdZJREFUOMuFk+dTU1EQR0MCIQFCEQjSu9IC0kUpAUVRpJeEXgQpiqJiO389m5fsncjsTPbTntkzb3/v3vd8vv8rzx/Id1AQLAz5rApDkYNiKLGkSABKFcrKocKyHgGVbqGAubEKqqMKNfDYjFULdQ7qocGSGpugWaGlFdosq12SdCh0CjyxrKfQ1a3QA71mrD6IOeiHAUuKPoNBhaFhGMmejo6la1ySPM/0YxMCL7wu7J3gS3LUZMqaymVNextnBuKpmpUDqo9nak6mr9Lt6/nseG9k8FZhQeCd9YrvwR9RWIQP5mktwbKDFVi1pDWJta6wIQs3LWtLBtsKCUjuWNYu7DmIw74Zax/iDvbgwJIOk5BQ2JbtW5a1KYMNhXVoXbOsVVhxsAxL2cOjhUS6JMlxpk2cyJd96nUz6Z/oY46bLj9LWee5PohPKevi8sorsZNXWvJTX2fa2OfsfF/gRvuvQfhmveGtPPu7wrzAD8sageEhhUH4GbWsO+h3EIM+8xJ7oUf77i74ZUm/JUmnQodAu2W1yb21KDRDU6NlNcjf46BOrseM9QdqtI9WQ5UlhSRJgUKlwF/L+ie3WqZQCoGIZZVAsYMiCJuxQoVBt9CXH/DnPZjfA6yCzE9fPdJPAAAAAElFTkSuQmCC\"\n\t\t\t\t/>\n\t\t\t</svg>\n\n\t\t\t<p>{{ $ctrl.data.relatedTags.toString() | limitTo: 60 }}</p>\n\t\t</div>\n\t</div>\n\n\t<div class=\"avatar-container\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"160\" height=\"160\" viewBox=\"0 0 160 160\">\n\t\t\t<image data-name=\"avatar-grid\" width=\"160\" height=\"160\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAALsAAAC7CAMAAAAKTh9YAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAllBMVEUAAABGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXapGXaoAAACyt87wAAAAMXRSTlMAIUg+CAE0SS8MQEcbHEo3JSw7RhoLBjgTECM1CQcwBRUrEkVBAxcuLQIpDiAYIhQNCo94NgAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRYNDh5GnhSkAAACq0lEQVR42u3dSW/iQBiE4faGDQ1F2GyWhCUhgSQzSf7/rxsr0pzLBxTF0tvnEt9D0+ZASU1I0iwPZhWDsnKZMBzFsQ1N4mhoQ1U5KFwmz9IkpNL0zqxK0syF5tLCZe4W0txlZu20yoWmUhoyaene5KpUrF0oaTfBbmk7MnGZOqpcudBSykLeWHoI62ZjM8V2Z99fqHdbexzCpll70rhpj/qdz3UL3dsdbVdyf6Np3yHs2LFjx44dO3bs2LFjx44dO3bs2LFjx479l9qLynYMITzsDz50PPlaoDgd/Qsd9g8+tKqKMFD56HL1k87PLvQiXezEi/TiMs9nPdkG5bHUIJRS44qpvaRrh64s2q4sdujKru20vQs1Uhn2irZLOpyVvbrQsdSb3fc3lUeXec10tkd0E7UPYdbhcD1fLT2E/N1nwrstc1v81R7Q9hGchRt+z9xudSZhx44dO3bs2LFjx44dO3bs2LFjx44dO3bsv9Q+nP/xFdff+fEH6ce57aRCkcyHYSR93Jv1KaUd+oobrTyVPh3pQxqFKO0Ss06Svn7M/tVOOznSTophspjaQrC4RF+D3W69xYs9xvV0Men1s4odO3bs2LFjx44dO3bs2LFjx44dO3bs2LFjv729z71Hn/umPvd8fe5X+/ysYseOHTt27NixY8eOHTt27NixY8eOHTt27L/W3uN73fp8n16f7zHs8/2RP31v56d/ocPe/3nY972dt/ue4a5X7NixY8eOHTt27NixY8eOHTt27NixY8eO/X8ob5Y+t25sJxWK7c7/5F/vtr5g2DRrTxo3ecgki1+VitaVSFM7cSrZT6eOKm0Xs5SykLYjXTFVSZp16MoWtitbdOjKZu20qkNXloYkzWzlWQzKym7pcBTHNjSJo6ENVeXAHqw8S5N/YGiVE4BTm3kAAAAASUVORK5CYII=\"\n\t\t\t/>\n\t\t</svg>\n\n\t\t<div class=\"avatar\" ng-style=\"{ 'background': 'url(' + $ctrl.data.owner.avatarUrl + ') no-repeat center/cover' }\"></div>\n\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t</div>\n\n\t<div class=\"rectangle-top\"></div>\n\t<div class=\"photo-container\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t</div>\n\t<div class=\"photo-shadow\">\n\t\t<div class=\"square\"></div>\n\t</div>\n\n\t<div class=\"hashtag\">\n\t\t{{ $ctrl.data.scrapedByTag }}\n\t</div>\n\n\t<div class=\"caption-container\">\n\t\t<div class=\"top-layer\"></div>\n\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"270\" height=\"75\" viewBox=\"0 0 270 75\">\n\t\t\t<image data-name=\"caption-border\" width=\"270\" height=\"75\" xlink:href=\"data:img/png;base64,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\"\n\t\t\t/>\n\t\t</svg>\n\n\t\t<div class=\"caption-left\">{{ $ctrl.data.relatedTags.toString() | limitTo: 60 }}</div>\n\n\t\t<div class=\"caption-right\">{{ $ctrl.data.caption | limitTo: 70 }}</div>\n\t</div>\n\n\t<div class=\"rectangle-bottom\"></div>\n</div>\n"

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card10Controller = function () {
	  function Card10Controller() {
	    (0, _classCallCheck3.default)(this, Card10Controller);
	
	    this.name = 'card10';
	  }
	
	  (0, _createClass3.default)(Card10Controller, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	    }
	  }]);
	  return Card10Controller;
	}();
	
	exports.default = Card10Controller;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(880);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card10.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card10.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card10{position:relative;background-color:#f9f9ff;margin:10px;width:400px;height:500px}.card10 .top-right{position:absolute;right:0;top:0;width:40px;height:40px;background-color:#aaadd6}.card10 .layer-1{position:absolute;left:35px;top:40px;background-color:#f4f4f7;width:260px;height:375px}.card10 .layer-1 .top-left{position:absolute;left:0;top:0;width:40px;height:40px;background-color:#aaadd6}.card10 .layer-1 .caption-top{position:absolute;left:43px;height:70px;width:120px;top:40px;display:flex;font-size:10px;font-family:Myriad-Pro;color:#465daa}.card10 .layer-1 .caption-top p{margin-left:7px;width:100%;overflow-y:hidden;height:66px;word-wrap:break-word}.card10 .layer-1 .caption-top p::-webkit-scrollbar{width:3px}.card10 .layer-1 .caption-top p::-webkit-scrollbar-track{background:#f2f2f2}.card10 .layer-1 .caption-top p::-webkit-scrollbar-thumb{background:#bbb}.card10 .layer-1 .caption-top p::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card10 .avatar-container svg{position:absolute;right:40px;top:40px;z-index:2}.card10 .avatar-container .avatar,.card10 .avatar-container p{position:absolute;right:40px}.card10 .avatar-container .avatar{right:100px;top:80px;width:40px;height:40px;border-radius:20px}.card10 .avatar-container p{font-size:11px;font-family:Myriad-Pro;top:129px;right:73px;width:94px;text-align:center;font-weight:700}.card10 .rectangle-top{position:absolute;left:0;width:75px;height:40px;top:150px;background-color:#aaadd6}.card10 .photo-container{position:absolute;left:75px;width:285px;top:150px;height:200px;z-index:1}.card10 .photo-shadow{position:absolute;right:0;width:285px;top:175px;height:210px;background-color:#aaadd6;z-index:0}.card10 .photo-shadow .square{width:40px;height:40px;background:#cfcfe5;bottom:0;position:absolute;left:-40px}.card10 .caption-container{position:absolute;background-color:#cfcfe5;left:75px;width:285px;top:385px;height:90px}.card10 .caption-container .top-layer{position:absolute;width:200px;height:30px;background-color:#c7c8e0}.card10 .caption-container svg{position:absolute;top:14px;right:-76px}.card10 .caption-container .caption-left{top:30px;position:absolute;font-size:10px;width:110px;height:45px;margin:3px;word-wrap:break-word;overflow-y:hidden}.card10 .caption-container .caption-left::-webkit-scrollbar{width:3px}.card10 .caption-container .caption-left::-webkit-scrollbar-track{background:#f2f2f2}.card10 .caption-container .caption-left::-webkit-scrollbar-thumb{background:#bbb}.card10 .caption-container .caption-left::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card10 .caption-container .caption-right{position:absolute;font-size:10px;top:24px;right:-20px;width:165px;max-height:55px;min-height:55px;color:#515ea2;display:flex;align-items:center;word-break:break-all;overflow:hidden}.card10 .caption-container .caption-right::-webkit-scrollbar{width:3px}.card10 .caption-container .caption-right::-webkit-scrollbar-track{background:#f2f2f2}.card10 .caption-container .caption-right::-webkit-scrollbar-thumb{background:#bbb}.card10 .caption-container .caption-right::-webkit-scrollbar-thumb:hover{background:#8a8a8a}.card10 .hashtag{position:absolute;right:53px;bottom:117px;color:#000;font-family:Nickainley-Normal;font-size:42px;z-index:1;user-select:none}.card10 .rectangle-bottom{position:absolute;width:75px;height:25px;background-color:#aaadd6;bottom:0}", ""]);
	
	// exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _card = __webpack_require__(882);
	
	var _card2 = _interopRequireDefault(_card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card11Module = _angular2.default.module('card11', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		"ngInject";
	
		$stateProvider.state('card11', {
			url: '/card11',
			component: 'card11'
		});
	}]).component('card11', _card2.default).name;
	
	exports.default = card11Module;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _card = __webpack_require__(883);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _card3 = __webpack_require__(884);
	
	var _card4 = _interopRequireDefault(_card3);
	
	__webpack_require__(885);
	
	__webpack_require__(887);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var card11Component = {
	  bindings: {
	    'data': '='
	  },
	  template: _card2.default,
	  controller: _card4.default
	};
	
	exports.default = card11Component;

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"card11\">\n\t<div class=\"header\">\n\t\t<div class=\"top-left\">\n\t\t\t<div class=\"right\"></div>\n\t\t</div>\n\n\t\t<div class=\"top-right\">\n\t\t\t<div class=\"top-left\"></div>\n\t\t\t<div class=\"top-right\"></div>\n\n\t\t\t<div class=\"center-grid\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"36\" height=\"36\" viewBox=\"0 0 36 36\">\n\t\t\t\t\t<image data-name=\"Vector Smart Object\" width=\"36\" height=\"36\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAMAAAC7faEHAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAXVBMVEUAAABFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKpFXKoAAACuqEMzAAAAHnRSTlMAIDIXHRocMyowLC4YERYTFQIjHisoDxQfMRkbEi/URJ1iAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFEQsoC3HHN2AAAADOSURBVDjL3ZTLDoQgDEURwaIoMgriY/j/35xkbp24ZKXJ3NXpghIOTUUla/GNkhrQyAagpQLUshKSDIqWOoAlC+ioBRiSojcDCmdGgDceMBoHGEwv/iavMpiI9VbEemeaAQ1VAE3T1XMA/DyHq2cXFxQpsvAxsvAhJsAS3dN2bs+6nfO87YBDHoB9O+d5W4vnWYc3Hwps1QW2mgJf9Q766WffnsOyjt2yjtqyDmfZfLJHsWeVPTfO3GbP3KbO/IE+q6effXtK92mp58J9/wHhCgorjVbROgAAAABJRU5ErkJggg==\"\n\t\t\t\t\t/>\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<div class=\"bottom-right\"></div>\n\t\t</div>\n\n\t\t<div class=\"bottom-left\">\n\t\t\t<div class=\"left\">\n\t\t\t\t\n\t\t\t\t<div class=\"avatar\" ng-style=\"{ 'background': 'url({{ $ctrl.data.owner.avatarUrl }}) no-repeat center/cover' }\"></div>\n\t\t\t\t<p>{{ $ctrl.data.owner.username }}</p>\n\t\t\t</div>\n\n\t\t\t<div class=\"right\"></div>\n\t\t</div>\n\n\t\t<div class=\"bottom-right\">\n\t\t\t<div class=\"top\"></div>\n\t\t\t<div class=\"right\"></div>\n\t\t\t<div class=\"hashtag\">{{ $ctrl.data.scrapedByTag }}</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"caption\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"77\" height=\"49\" viewBox=\"0 0 77 49\">\n\t\t\t<image data-name=\"Vector Smart Object\" width=\"65\" height=\"37\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAAxCAMAAACoN9Q4AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB3VBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHyAAAADZrelWAAAAnXRSTlMALnGp4C0DOXq02ked5PQGUKXtuCOP6MAplYM4sP6IQLdMLLFRMrkWC478GQ+WP+NL5wJ8/ap0ChTEPRXH+rNdDCfc700E0+J5JNBgyWjUAbWTDhHZ93gFh0O7SM8Xf74NEOXBNQef1jTsHG9KE62EniHwNtukYVSyHk/GjIqQzFgg5kbpga93e+tEXlmaZMgJ+TA78/W/bMOLSYA8HU/fcAAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRELJTB1YqAJAAACjUlEQVRIx43W+VsSURTG8SkRExAQNdsQ08pEsEiEFiOM3DPMsixbpEXbaMFsX620fc/W+7/Wk8U5c5j3yvn583yHuTN3uIahnyVLS2ylRhFjL1tW7tACp6tCKeW2L5ryeCt9f2QVFtU1y9XfqV2stWKlb0GuQmL1Gr/6N3X6VqD+P1RrrUVDo6JZp2ut38Bkk5XY2BxkRLXgVijsZ9BmRVptvKU24djmiEmWFIotbVETUe2o5Wk2QxUrIPFGtahZmK3bpNwuyY4OM9iZ2JW0jnXuNsuUa0+XvF63SfT0Nhlg+sxL1j8QL3xEe7mIDHrg+vdVcLnPmy4k9iEmovuH8cM8cJDJkUOHrcwo/2FHcMuwH2XSYf1RGGPk2HFNzDjB5MlxS5I5ReR0SBc7w7ZK4qy1mWBPSBvrmiTZEbc252jHnb+gixkX2eqiBWFv9iVtLJsi6QTGSeSyNmZcIXkVmdo8CV7TxkK5vPRlgZmiC1bqf1qMZC8yLjJl2lj6eh66M8CMu2mnp7W1VrrsNDI3yIT1N8pu4iYyt8gMaGN2H8nbwCRHyLhzbCLyAxhgO5TDXDmZOwrMXXnde0jeJ/MAmRpZe4gkW8R+ZB6J2HAUSdraGT8yj0VtDMEZMk+QeSpv9BmSs2TakEnIWhWSc2SGkHkuYukUkgFCL5B5KWqdCEaTeVONjF/+B75CspvMa2Qm5bKFkXxTxLs7UfS7+5bMO2QGRex9EMmGvPF8QOajqH1C8DOd2qeQ+SI/IDEk58l8ReabXLZ2JEfJTCPzXdZ6kPSScSAjv9QtCLJTexYaeX7wIshO7T+QmZE3WockO7X/RGZW1uaRZKf2emTmRMzuRvIXIR8yAVErRTBIZ7jf+VIu0Os+lkgAAAAASUVORK5CYII=\"\n\t\t\t/>\n\t\t</svg>\n\n\t\t<p class=\"text\">{{ $ctrl.data.caption | limitTo: 180 }}</p>\n\t</div>\n\t<div class=\"photo\" ng-style=\"{ 'background': 'url(' + $ctrl.data.photoUrl + ') no-repeat center/cover' }\">\n\t</div>\n\t<div class=\"card-footer\">\n\t\t<div class=\"first\"></div>\n\t\t<div class=\"second\"></div>\n\t\t<div class=\"third\"></div>\n\t\t<div class=\"fourth\"></div>\n\t\t<div class=\"fifth\"></div>\n\t\t<div class=\"sixth\"></div>\n\n\t\t<div class=\"hashtags-list\">\n\t\t\t<p>{{ $ctrl.data.relatedTags.toString() | limitTo: 42 }}</p>\n\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"37\" viewBox=\"0 0 30 37\">\n\t\t\t\t<image data-name=\"Vector Smart Object\" width=\"30\" height=\"37\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAqCAMAAAADFmLkAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABd1BMVEWhyUGAgIChyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUGhyUEAAAAh2xhaAAAAe3RSTlMAADPo6zdE7uIoq5vChwGACvpoL0Bw9gaI5rG8yKQD8XoP/GQ0OEwgd/MEjeC4tNCe9HQS/lx1sMO/yrlD7DnlX6CjqcCXMUIsWBWEnNPFqNyQDGYeUEgkYP0QjOTMixEOwWGyyyf5UXPp8PsI2ZQCfRxTPPWfeCHnMGlXLwEUAAAAAWJLR0R80bYgXwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+IFEQsmERIm45QAAAHgSURBVDjLhZNnV1NBEEBXEggECKBAUHrvASki2Agq0qSXRMFesSuKev+8814yeyLMOZlPc3fueTO7+9a5/6MkEi31UBYrr7gQxBnJxaHSQxVUW1YiCjUKtXVw0bIuAfW+oYDZsQEakwpNcNlZ1hVo9tACrZbV1g4dCp1d0G1ZPTJJr0KfQL9lDcDgkMIwjDjLGoWUhzEYt6zkVZhQmJyC6ULr2kwurssks/l8Zk7gRpjFwxO8SZG4FVi3i1l3wo7z4+kgFuSAWtL5uCvVe7n0/mLh8A+ksKSwLLDijD2uQiShsAYPnWWtw4aHTdiyrG0Za0dhVxruWda+FA4UMpB9ZFmP4dBDGo6cZR1B2sMhPLGsp1nIKBxI933L2pPCrsIOdG1b1hZsetiAdVdgPVvO5EImeZ5PMy/kz34ZZvPhI3Kvitx03evAelPsh3gbWO/eH4chdvZYQx71h3ya+lg4/Sf4rPmXGHx17vwev8m3vyssCvywrGmYmlSYgJOkZf2EMd89BaPOskZgWPOhQfhlWacySZ8WegV6LKtb7q1TCx3Q3mZZrfJ6/FjNcj3Osn5Dk64nG6HBsipkkjJdrxf4Y1l/5VZrdb0GognLqoYqv14JcWd2LI/5hq40Gik5Y/0D8vbPSSzKruwAAAAASUVORK5CYII=\"\n\t\t\t\t/>\n\t\t\t</svg>\n\t\t</div>\n\t</div>\n\n</div>\n"

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card11Controller = function () {
	  function Card11Controller() {
	    (0, _classCallCheck3.default)(this, Card11Controller);
	
	    this.name = 'card11';
	  }
	
	  (0, _createClass3.default)(Card11Controller, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg';
	    }
	  }]);
	  return Card11Controller;
	}();
	
	exports.default = Card11Controller;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(886);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card11.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card11.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".card11{position:relative;width:400px;height:500px;margin:5px}.card11 .header{margin-left:15px;position:relative}.card11 .header .top-left{position:absolute;left:0;right:0;background-color:#eaf4d3;width:220px;height:80px}.card11 .header .top-left .right{background-color:#dbecb5;height:40px;width:120px;position:absolute;right:0}.card11 .header .bottom-left{position:absolute;left:0;top:80px;width:220px}.card11 .header .bottom-left .left{width:110px;height:85px;background-color:#ebede8;position:absolute}.card11 .header .bottom-left .left .avatar{width:36px;height:36px;background:#ccc;margin-left:calc(50% - 18px);margin-top:13px;border-radius:18px}.card11 .header .bottom-left .left p{font-family:Graphik-Regular;font-size:10.5px;text-align:center;bottom:10px;position:absolute;width:100%}.card11 .header .bottom-left .right{position:absolute;right:-3px;top:37px;width:70px;height:33px;background:#caddaa}.card11 .header .bottom-right{top:80px;position:absolute;left:220px}.card11 .header .bottom-right .top{background:#9cc063;top:2px;width:41px;height:35px;position:absolute;left:2px}.card11 .header .bottom-right .right{position:absolute;left:90px;width:60px;top:5px;height:32px;background-color:#eaf4d3}.card11 .header .bottom-right .hashtag{position:absolute;top:36px;font-family:Nickainley-Normal;font-size:37px;right:-145px;user-select:none}.card11 .header .top-right{position:absolute;left:220px}.card11 .header .top-right .top-left{height:40px;width:44px;background-color:#eaf4d3}.card11 .header .top-right .top-right{position:absolute;left:90px;width:60px;height:40px;background-color:#eaf4d3}.card11 .header .top-right .center-grid{position:absolute;left:48px;top:44px}.card11 .header .top-right .bottom-right{position:absolute;top:40px;left:90px;width:60px;height:45px;background-color:#ddecbd}.card11 .caption{position:absolute;width:400px;height:145px;z-index:2;top:223px;background-color:hsla(76,57%,61%,.7)}.card11 .caption .text{margin:30px;font-family:Myriad-Pro;font-size:12px;color:#020202;overflow:hidden;max-height:calc(100% - 60px)}.card11 .caption svg{position:absolute;top:-17px;left:25px}.card11 .photo{margin-left:15px;width:370px;position:absolute;height:260px;top:165px}.card11 .card-footer{position:absolute;top:425px;left:15px;width:370px;height:75px}.card11 .card-footer .first{position:absolute;width:90px;top:0;height:75px;background-color:#a1c941;left:0}.card11 .card-footer .second{position:absolute;height:75px;width:20px;left:90px;background-color:#aed15a}.card11 .card-footer .third{position:absolute;height:75px;width:20px;left:110px;background-color:#b9d76f}.card11 .card-footer .fourth{position:absolute;height:75px;width:20px;left:130px;background-color:#c3dd84}.card11 .card-footer .fifth{position:absolute;height:75px;width:20px;left:150px;background-color:#daeab1}.card11 .card-footer .sixth{position:absolute;height:75px;width:20px;left:170px;background-color:#f1f8e2}.card11 .card-footer .hashtags-list{position:absolute;right:0;height:75px;width:180px}.card11 .card-footer .hashtags-list svg{display:flex;align-items:center;height:75px;position:absolute;right:0}.card11 .card-footer .hashtags-list p{overflow:hidden;position:absolute;width:calc(100% - 38px);margin-top:10px;height:63px;align-items:center;justify-content:center;text-align:right;font-family:Myriad-Pro;font-size:11px;font-weight:600;color:#a1c941;word-wrap:break-word}", ""]);
	
	// exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(888);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card11.mobile.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./card11.mobile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "@media (max-width:440px){.card11{width:301px;height:400px;user-select:none}.card11 .header{margin-left:0}.card11 .header .top-left{width:170px;height:60px}.card11 .header .top-left .right{height:30px}.card11 .header .top-right{left:170px}.card11 .header .top-right .top-left{height:30px;width:34px}.card11 .header .top-right .top-right{width:40px;height:30px}.card11 .header .top-right .center-grid{left:53px;top:29px}.card11 .header .top-right .center-grid svg{width:27px}.card11 .header .top-right .bottom-right{top:30px;left:90px;width:40px;height:31px}.card11 .header .bottom-left{top:60px}.card11 .header .bottom-left .left{width:100px;height:70px}.card11 .header .bottom-left .left .avatar{margin-top:7px}.card11 .header .bottom-left .left p{overflow:hidden}.card11 .header .bottom-left .right{right:48px;top:26px;width:55px;height:26px}.card11 .header .bottom-right{left:170px;top:56px}.card11 .header .bottom-right .top{height:28px}.card11 .header .bottom-right .right{width:40px;height:26px}.card11 .header .bottom-right .hashtag{top:33px;font-size:30px;right:-130px}.card11 .photo{margin-left:0;width:300px;height:200px;top:130px}.card11 .caption{width:300px;height:130px;top:160px}.card11 .caption svg{width:30px}.card11 .card-footer{top:330px;width:300px;height:60px;left:0}.card11 .card-footer .hashtag-lists p{width:calc(100% - 50px);margin-left:17px;height:50px}.card11 .card-footer .fifth,.card11 .card-footer .first,.card11 .card-footer .fourth,.card11 .card-footer .hashtag-lists svg,.card11 .card-footer .second,.card11 .card-footer .sixth,.card11 .card-footer .third{height:60px}.card11 .card-footer .first{width:80px}.card11 .card-footer .fifth,.card11 .card-footer .fourth,.card11 .card-footer .second,.card11 .card-footer .sixth,.card11 .card-footer .third{width:15px}.card11 .card-footer .second{left:80px}.card11 .card-footer .third{left:95px}.card11 .card-footer .fourth{left:110px}.card11 .card-footer .fifth{left:125px}.card11 .card-footer .sixth{left:140px}}", ""]);
	
	// exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _categorycard = __webpack_require__(890);
	
	var _categorycard2 = _interopRequireDefault(_categorycard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categorycard4Module = _angular2.default.module('categorycard4', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('categorycard4', {
	        url: '/categorycard4',
	        component: 'categorycard4'
	    });
	}]).component('categorycard4', _categorycard2.default).name;
	
	exports.default = categorycard4Module;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _categorycard = __webpack_require__(891);
	
	var _categorycard2 = _interopRequireDefault(_categorycard);
	
	var _categorycard3 = __webpack_require__(892);
	
	var _categorycard4 = _interopRequireDefault(_categorycard3);
	
	__webpack_require__(894);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categorycard4Component = {
	    bindings: {
	        'data': '='
	    },
	    template: _categorycard2.default,
	    controller: _categorycard4.default
	};
	
	exports.default = categorycard4Component;

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"category-card4\">\n    <div class=\"card-header\">\n        <div class=\"top-left\"></div>\n        <div class=\"top-right\"></div>\n\n        <div class=\"bottom\">\n            <div class=\"grid\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54.55 54.35\">\n                    <g>\n                        <g>\n                            <g>\n                                <g class=\"category-cls-1\">\n                                    <path class=\"category-cls-2\" d=\"M0,39.89a2,2,0,1,1,2,2A2,2,0,0,1,0,39.89Z\" />\n                                    <circle class=\"category-cls-2\" cx=\"14.63\" cy=\"39.89\" r=\"1.98\" />\n                                    <path class=\"category-cls-2\" d=\"M25.3,39.89a2,2,0,1,1,2,2A2,2,0,0,1,25.3,39.89Z\" />\n                                    <path class=\"category-cls-2\" d=\"M37.94,39.89a2,2,0,1,1,2,2A2,2,0,0,1,37.94,39.89Z\" />\n                                    <circle class=\"category-cls-2\" cx=\"52.57\" cy=\"39.89\" r=\"1.98\" />\n                                    <path class=\"category-cls-2\" d=\"M0,14.61a2,2,0,1,1,2,2A2,2,0,0,1,0,14.61Z\" />\n                                    <path class=\"category-cls-2\" d=\"M12.65,14.61a2,2,0,1,1,2,2A2,2,0,0,1,12.65,14.61Z\" />\n                                    <path class=\"category-cls-2\" d=\"M25.3,14.61a2,2,0,1,1,2,2A2,2,0,0,1,25.3,14.61Z\" />\n                                    <path class=\"category-cls-2\" d=\"M37.94,14.61a2,2,0,1,1,2,2A2,2,0,0,1,37.94,14.61Z\" />\n                                    <path class=\"category-cls-2\" d=\"M50.59,14.61a2,2,0,1,1,2,2A2,2,0,0,1,50.59,14.61Z\" />\n                                    <path class=\"category-cls-2\" d=\"M0,2A2,2,0,1,1,2,4,2,2,0,0,1,0,2Z\" />\n                                    <path class=\"category-cls-2\" d=\"M12.65,2a2,2,0,1,1,2,2A2,2,0,0,1,12.65,2Z\" />\n                                    <path class=\"category-cls-2\" d=\"M25.3,2a2,2,0,1,1,2,2A2,2,0,0,1,25.3,2Z\" />\n                                    <path class=\"category-cls-2\" d=\"M37.94,2a2,2,0,1,1,2,2A2,2,0,0,1,37.94,2Z\" />\n                                    <path class=\"category-cls-2\" d=\"M50.59,2a2,2,0,1,1,2,2A2,2,0,0,1,50.59,2Z\" />\n                                    <path class=\"category-cls-2\" d=\"M0,27.25a2,2,0,1,1,2,2A2,2,0,0,1,0,27.25Z\" />\n                                    <path class=\"category-cls-2\" d=\"M12.65,27.25a2,2,0,1,1,2,2A2,2,0,0,1,12.65,27.25Z\" />\n                                    <path class=\"category-cls-2\" d=\"M25.3,27.25a2,2,0,1,1,2,2A2,2,0,0,1,25.3,27.25Z\" />\n                                    <path class=\"category-cls-2\" d=\"M37.94,27.25a2,2,0,1,1,2,2A2,2,0,0,1,37.94,27.25Z\" />\n                                    <path class=\"category-cls-2\" d=\"M50.59,27.25a2,2,0,1,1,2,2A2,2,0,0,1,50.59,27.25Z\" />\n                                    <path class=\"category-cls-2\" d=\"M0,52.37a2,2,0,1,1,2,2A2,2,0,0,1,0,52.37Z\" />\n                                    <path class=\"category-cls-2\" d=\"M12.65,52.37a2,2,0,1,1,2,2A2,2,0,0,1,12.65,52.37Z\" />\n                                    <path class=\"category-cls-2\" d=\"M25.3,52.37a2,2,0,1,1,2,2A2,2,0,0,1,25.3,52.37Z\" />\n                                    <path class=\"category-cls-2\" d=\"M37.94,52.37a2,2,0,1,1,2,2A2,2,0,0,1,37.94,52.37Z\" />\n                                    <path class=\"category-cls-2\" d=\"M50.59,52.37a2,2,0,1,1,2,2A2,2,0,0,1,50.59,52.37Z\" />\n                                </g>\n                            </g>\n                        </g>\n                    </g>\n                </svg>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"card-content\">\n        <h2>{{ $ctrl.title }}</h2>\n        <p>{{ $ctrl.description }}</p>\n    </div>\n\n    <div class=\"card-footer\">\n        <div class=\"left\"></div>\n        <div class=\"right\"></div>\n    </div>\n</div>\n"

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _categorycard = __webpack_require__(893);
	
	var _categorycard2 = _interopRequireDefault(_categorycard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Categorycard4Controller = function () {
	    function Categorycard4Controller() {
	        (0, _classCallCheck3.default)(this, Categorycard4Controller);
	
	        this.name = 'categorycard4';
	    }
	
	    (0, _createClass3.default)(Categorycard4Controller, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.title = this.data.category;
	            this.description = _categorycard2.default[this.title];
	        }
	    }]);
	    return Categorycard4Controller;
	}();
	
	exports.default = Categorycard4Controller;

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    'Wine Almighty': 'It’s official: Georgia is the cradle of wine. It was here that the wild vine was first domesticated and its fruit used to make the now famous drink. And of course we have proof! In 2016, grape seeds and winemaking equipment were found by archeologists among the remains dating from 6000 BC  in the settlement in Imiri, Kvemo Kartli. Today there are only two (yes, two) techniques of winemaking in the world  -  the European method and the Kakhetian-Georgian one.',
	    'Tipsy Adventure': 'Each region of Georgia has its own, unique variety of wine. Scratch that - practically every village has its own grape variety and a wine named after it. It will come as no surprise at all that the cellar used to be the most important part of a Georgian household. It was a cool, windowless place, perfect for storing wine-making equipment and qvevris ( (special vessels used to make and store wine).',
	    'Tradition of Supra': 'In the realm of Georgian traditions, one of the most important is that of the supra, which means ‘feast’.  A Georgian host is always ready to invite a guest into his or her house. That guest might be a total stranger, but a rule is a rule – a supra must be prepared and every guest should feel like they’re visiting long-lost relatives. The supra is led by the tamada - the toastmaster - whose words are law.  It’s quite tricky to be a good tamada; you have to be creative with the toasts without breaking the very specific order. You must get all the guests drunk, while staying (relatively) sober yourself. Don’t be surprised when, at the end of an epic feast, the host apologizes for not giving you a better welcome. You’ll have to promise to return so they can do better next time.',
	    'Colorful Cuisine': 'Georgian dishes differ a lot depending on the region they come from. The jewel of Imeretian cuisine is khachapuri. This dish is made in almost every region of Georgia, but they say that the Imeretian version, made with fresh Imeretian cheese and bread dough, is the one that rules them all. If you’re eating the spiciest food ever, then most probably you are in Samegrelo, famous for its fiery food. Meat, meat and more meat is the order of the day in Kakheti. In the mountains the most common dish is khinkali (meat dumpling). With slight variations it is arguably the most popular Georgian dish in general.',
	    History: 'Is Georgia part of Eastern or Western civilization? That is a question many visitors ask. The answer is not that simple. Thanks to its geographical location, Georgia, has been a natural mix of these two very different cultures. In 1991 archaeologists came across a sensational discovery in Dmanisi – the jaw of an ancient human. Just nine years later they followed it up with two human skulls. It was later established that the owners of these bones, now called Zezva and Mzia, lived here 1.7 to 1.8 million years ago. That makes them the oldest Europeans. So, can you imagine, how many interesting facts and stories does history of Georgia unite?',
	    Culture: 'The Georgian, Svan, Megrelian and Laz languages make up the Kartvelian language family. That means they originated from one common language. Scientists have failed to connect the Kartvelian group to any other language group in the world. Just imagine, no other language known to mankind, dead or alive exhibits any similarity to Kartvelian Languages. Georgians are very proud of their unique alphabet. It is used only by Georgians and each symbol corresponds to one sound and one sound only. It now consists of 33 letters. And for those who want cultural adventures, we have museums, theatres and galleries where you can get to know Georgian culture a little better.',
	    Tbilisi: 'The legend of Tbilisi goes like this: King Vakhtang was out hunting when his falcon chased a pheasant and they both got lost. The King discovered the two birds in a natural spring – but they were cooked because the water bubbling out of the ground was hot. Those hot sulphur springs inspired the King to build a city here. In the past century, Tbilisi developed into the cultural, political and social center of Georgia and even the region. Tbilisi is a city of variety.',
	    Architecture: 'Today Tbilisi’s historic district can be comfortably seen on foot. There are picturesque narrow streets and small houses with colorful wooden balconies nestled together. The place where the King found the birds is now called Abanotubani, which means ‘bath district’. You are highly recommended to visit one of those bathhouses. The smell of the natural sulphuric waters might scare you off at first, but you’ll come out looking and feeling 10 years younger.',
	    Highlands: 'The first thing people associate Georgia with is mountains. And that’s fair enough, since each and every road leads to a mountain eventually. Georgia’s mountain resorts are unique - Khevsureti, Tusheti, Kazbegi, Svaneti. Climate, water, temperature – you have everything you need for health, relaxation and for adventures.',
	    'Ski Resorts': 'We have part of the Caucasus Mountain range in Georgia - how much better can it get?  Snow, temperatures, slopes – all the ingredients for a perfect skiing experience.  The history of Winter Sports in Georgia dates back to the 1930s, when the first ever ski tournament was held in Bakuriani in 1934. Snowboarding is quite a young sport here, but freestylers and free riders enjoy our mountains just as much as skiers.',
	    'Black Sea': 'The season here starts in May and lasts till October. The sea is especially warm and calm in the autumn and our ‘Indian summer’ attracts many tourists. There are various resorts on the Georgian coast of the Black sea - Batumi, Anaklia, Ureki, Shekvetili, Kobuleti, Tsikhisdziri, Chakvi, Makhinjauri, Gonio, Kvariati. All of them have totally different climate conditions and attract visitors with different interests.',
	    Nature: 'It’s fascinating how diverse the Georgian landscape can be. Even from the highest snowy mountains you can get to a warm, sunny beach by car in a couple of hours. Georgia’s protected areas and national parks make up 600 000 ha of the country’s territory.  That’s roughly 8 % of the whole country, so if you’re into hiking and eco-tourism, what more could you ask for?!',
	    Adventure: 'Georgia is a small country with big travel opportunities. There are so many hiking routes, that it’s very difficult to choose the best one. The thing to remember is: every way is the right way. And It’s not just the beauty of the mountains and breathtaking views that make our country so special - but the people that live here. Everywhere you go, even in the most remote places (and trust us, there are villages here consisting of just one family) you will come across traditional Georgian hospitality.'
	};
	
	exports.default = json;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./categorycard4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./categorycard4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".category-card4{position:relative;margin:10px;width:400px;height:515px;border:1px solid #fff}.category-card4 .card-header{position:relative;margin-top:20px}.category-card4 .card-header .top-left{position:absolute;margin-left:20px;width:220px;height:35px;background-color:#e7b5b9}.category-card4 .card-header .top-right{position:absolute;right:20px;width:35px;height:35px;background-color:#e7b5b9}.category-card4 .card-header .bottom{position:absolute;width:320px;height:80px;background-color:#f3dcde;top:50px}.category-card4 .card-header .bottom .grid{position:absolute;right:0;width:80px;height:80px;background-color:#e7b5b9}.category-card4 .card-header .bottom .grid svg{margin:11px;width:60px}.category-card4 .card-header .bottom .grid svg .category-cls-1{opacity:.9}.category-card4 .card-header .bottom .grid svg .category-cls-2{fill:#fff}.category-card4 .card-content{margin-top:200px;padding:0 38px;font-family:Myriad-Pro;text-align:right}.category-card4 .card-content h2{font-size:35px}.category-card4 .card-content p{margin-top:30px;font-size:12px}.category-card4 .card-footer{position:absolute;bottom:55px}.category-card4 .card-footer .left{position:absolute;margin-left:20px;width:280px;height:35px;background-color:#e7b5b9}.category-card4 .card-footer .right{position:absolute;left:345px;width:35px;height:35px;background-color:#e7b5b9}", ""]);
	
	// exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _post = __webpack_require__(897);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostModule = _angular2.default.module('post', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('post', {
	        url: '/post?id',
	        component: 'post',
	        redirectTo: 'home.post'
	    }).state('home.post', {
	        url: '/:id',
	        component: 'post'
	    });
	}]).component('post', _post2.default).name;
	
	exports.default = PostModule;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _post = __webpack_require__(898);
	
	var _post2 = _interopRequireDefault(_post);
	
	var _post3 = __webpack_require__(899);
	
	var _post4 = _interopRequireDefault(_post3);
	
	__webpack_require__(901);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postComponent = {
	    bindings: {},
	    template: _post2.default,
	    controller: _post4.default
	};
	
	exports.default = postComponent;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"post\" id=\"post\" ng-class=\"{geo: $ctrl.language === 'GE'}\"\n    ng-click=\"$ctrl.onClick($event)\"\n    ng-keyup=\"$ctrl.onKeyUp($event)\" tabindex=\"0\">\n    <div class=\"popup\">\n        <div class=\"close\" ui-sref=\"home\">\n            <svg id=\"Close\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"30\" height=\"33\" viewBox=\"0 0 30 33\">\n                <image data-name=\"close 1\" width=\"30\" height=\"33\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAmCAMAAAB5ytLYAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABNVBMVEXw9P6AgIDw9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P7w9P4AAAB0wDQdAAAAZXRSTlMAAAdLhbjY8/XbvotTDSyd9PmqOhKc/q4cNOLsRkHx+k4n8Pg1BdHfCnmGFG53zdUbIF1hkJG7ve/u1ra6jFheFsjPaHIMEHF9BMzZCCHtLjf2SDHd6D4Pl/2mFymZ96MzStqIUFw2AL0AAAABYktHRGYs1NklAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4gUYCCcRdHMjBgAAARhJREFUOMu91NdWwlAQheGJhIACEntBBYMlih2kCAp2imAvqKCg8/6v4AkICSQ545X/ZdZ3k6zMBug24BCdkgsR3YNDHq/v96kgCF0x7JfR2MjoWJ8Zn5hEU1PTRjMzi1YF5nQzv4DWBUMds6igXeGltlleQftW1ZZZQ17rmvEpXCNHmNlAfpvMbBFmW4AdpNqFPdJEIUaafYiTJgESaSRIkiYJJEH8VxMgSQoO/vDuadJk4JA0MTgiTRZypGFXdkyQE/YfnhLmjJlz/hdSLrTbueSafOu+CkUOKV21b7lcsSXydWcTbuw24fZO35b7B0vy+GTcqOeXqpm8vvVt3XvN1QPqH5+mPWSb2RCdJW0U5Wb861vVN/MHCPiu7T51uK8AAAAASUVORK5CYII=\"\n                />\n                <image data-name=\"close 2\" x=\"12\" y=\"13\" width=\"7\" height=\"7\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEWAgICUnrKUnrKUnrKUnrIAAADqJbCtAAAABHRSTlMA8Hd4OPcDdQAAAAFiS0dEBfhv6ccAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfiBRgIJxF0cyMGAAAALUlEQVQI12MQYmBgUGRQMWBgdmJgdmYwMWBgMDF2BgoyuxjASbAIRBaiEqwLAJo4BS96+asEAAAAAElFTkSuQmCC\"\n                />\n            </svg>\n            <span>{{$ctrl.CLOSE}}</span>\n        </div>\n        <Loader class=\"loader\" ng-if=\"!$ctrl.activePost\" />\n        <div class=\"content\" ng-if=\"$ctrl.activePost\">\n            <div class=\"left\">\n                <div class=\"date\">\n                    <span>{{ $ctrl.activePost.date | date : \"d MMMM\" }}</span>\n                </div>\n                <div class=\"personal\">\n                    <img ng-src=\"{{$ctrl.activePost.owner.avatarUrl}}\" alt=\"avatar\">\n                    <p class=\"full-name\">\n                        <span>{{$ctrl.activePost.owner.fullName}}</span>\n                    </p>\n                </div>\n                <div class=\"caption\">\n                    {{$ctrl.activePost.caption}}\n                </div>\n            </div>\n            <div class=\"right\">\n                <div class=\"card\">\n                    <div class=\"layer photo\" ng-style=\"$ctrl.photoStyle\"></div>\n                    <div class=\"layer light\" ng-style=\"{'background-color': $ctrl.colors[2]}\"></div>\n                    <div class=\"layer normal\" ng-style=\"{'background-color': $ctrl.colors[1]}\"></div>\n                    <div class=\"layer dark\" ng-style=\"{'background-color': $ctrl.colors[0]}\"></div>\n                    <div class=\"layer dots\"></div>\n                    <mcactionbutton photoUrl=\"$ctrl.activePost.photoUrl\" id=\"$ctrl.activePost.id\" thumbs=\"$ctrl.activePost.thumbs\" url=\"$ctrl.activePost.url\"></mcactionbutton>\n                </div>\n            </div>\n        </div>\n        <div class=\"controls\">\n            <span class=\"arrow-left\" ng-click=\"$ctrl.prevPost()\">\n                <svg aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"angle-left\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\"\n                    class=\"svg-inline--fa fa-angle-left fa-w-6 fa-2x\">\n                    <path d=\"M4.2 247.5L151 99.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17L69.3 256l118.5 119.7c4.7 4.7 4.7 12.3 0 17L168 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 264.5c-4.7-4.7-4.7-12.3 0-17z\"></path>\n                </svg>\n            </span>\n            <span class=\"arrow-right\" ng-click=\"$ctrl.nextPost()\">\n                <svg aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"angle-right\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\"\n                    class=\"svg-inline--fa fa-angle-right fa-w-6 fa-3x\">\n                    <path d=\"M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z\"></path>\n                </svg>\n            </span>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _post = __webpack_require__(900);
	
	var _post2 = _interopRequireDefault(_post);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostController = function () {
	    function PostController($scope, $state, $stateParams, SharedMoments, Category, Color) {
	        (0, _classCallCheck3.default)(this, PostController);
	
	        this.name = 'post';
	
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	
	        this.SharedMoments = SharedMoments;
	        this.Category = Category;
	        this.Color = Color;
	    }
	
	    (0, _createClass3.default)(PostController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.postId = this.$stateParams.id;
	
	            this.posts = this.SharedMoments.getLoadedPosts();
	            this.selectedCategories = this.Category.getSelectedCategories();
	            this.search = this.$stateParams.search;
	
	            this.render();
	
	            this.bindEvents();
	
	            this.setActivePost();
	
	            this.watchLanguage();
	
	            this.watchPosts();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var CLOSE = _post2.default[this.language].CLOSE;
	
	
	            this.CLOSE = CLOSE;
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            $('#post').focus();
	        }
	    }, {
	        key: 'setActivePost',
	        value: function setActivePost() {
	            var _this = this;
	
	            this.activePost = this.posts.find(function (item, index) {
	                if (item.id === _this.postId) {
	                    _this.activeIndex = index;
	
	                    return item;
	                }
	            });
	
	            if (this.activePost) {
	                this.photoStyle = {
	                    'background-image': 'url("' + this.activePost.photoUrl + '")'
	                };
	
	                this.colors = this.Color.getColors(this.activePost.cardType, this.activePost.cardGroup);
	            } else {
	                this.getPost();
	            }
	        }
	    }, {
	        key: 'loadPosts',
	        value: function loadPosts() {
	            if (this.isLoading || this.postsCount && this.postsCount === this.posts.length) {
	                this.isLoading = false;
	
	                return;
	            }
	
	            this.isLoading = true;
	
	            if (this.search) {
	                this.searchPosts();
	            } else {
	                this.getPosts();
	            }
	        }
	    }, {
	        key: 'getPost',
	        value: function getPost() {
	            var _this2 = this;
	
	            if (this.isLoading) {
	                return;
	            }
	
	            this.isLoading = true;
	
	            this.SharedMoments.getPost(this.$stateParams.id).then(function (_ref) {
	                var data = _ref.data;
	
	                _this2.SharedMoments.unshiftPost(data);
	
	                _this2.isLoading = false;
	            }).catch(function (err) {
	                console.log('Error occured in method getPost', err);
	
	                _this2.error = err.data;
	            });
	        }
	    }, {
	        key: 'getPosts',
	        value: function getPosts() {
	            var _this3 = this;
	
	            this.SharedMoments.getPosts(this.selectedCategories, this.urls).then(function (_ref2) {
	                var data = _ref2.data;
	                var count = data.count,
	                    posts = data.posts;
	
	
	                _this3.postsCount = count;
	
	                _this3.SharedMoments.addPosts(posts);
	                _this3.isLoading = false;
	
	                _this3.activeIndex += 1;
	
	                var activePost = _this3.posts[_this3.activeIndex];
	
	                if (activePost && activePost.id !== _this3.search) {
	                    _this3.$state.go('home.post', {
	                        id: activePost.id
	                    }, {
	                        notify: false
	                    });
	                }
	            }).catch(function (err) {
	                console.log('Error occured in method getPosts', err);
	
	                _this3.error = err.data;
	            });
	        }
	    }, {
	        key: 'searchPosts',
	        value: function searchPosts() {
	            var _this4 = this;
	
	            this.SharedMoments.searchPosts(this.search, this.urls, this.$stateParams.id).then(function (_ref3) {
	                var data = _ref3.data;
	                var count = data.count,
	                    posts = data.posts;
	
	
	                _this4.postsCount = count;
	
	                _this4.SharedMoments.addPosts(posts);
	                _this4.isLoading = false;
	
	                _this4.activeIndex += 1;
	
	                var activePost = _this4.posts[_this4.activeIndex];
	
	                if (activePost && activePost.id !== _this4.search) {
	                    _this4.$state.go('home.post', {
	                        id: activePost.id
	                    }, {
	                        notify: false
	                    });
	                }
	            }).catch(function (err) {
	                console.log('Error occured in method searchPosts', err);
	
	                _this4.error = err.data;
	            });
	        }
	    }, {
	        key: 'prevPost',
	        value: function prevPost() {
	            if (this.activeIndex === 0) {
	                return;
	            }
	
	            this.activeIndex -= 1;
	
	            this.activePost = this.posts[this.activeIndex];
	
	            this.$state.go('home.post', {
	                id: this.activePost.id
	            }, {
	                notify: false
	            });
	        }
	    }, {
	        key: 'nextPost',
	        value: function nextPost() {
	            if (this.activeIndex < this.posts.length - 1) {
	                this.activeIndex++;
	            }
	
	            if (this.activeIndex < this.posts.length) {
	                this.activePost = this.posts[this.activeIndex];
	
	                this.$state.go('home.post', {
	                    id: this.activePost.id
	                }, {
	                    notify: false
	                });
	            }
	
	            if (this.activeIndex >= this.posts.length - 1) {
	                this.loadPosts();
	            }
	        }
	    }, {
	        key: 'onClick',
	        value: function onClick(event) {
	            if (event.target.id === 'post') {
	                this.$state.go('home');
	            }
	        }
	    }, {
	        key: 'onKeyUp',
	        value: function onKeyUp(event) {
	            if (event.key === 'Escape') {
	                this.$state.go('home');
	                return;
	            }
	
	            if (event.key === 'ArrowLeft') {
	                this.prevPost();
	            } else if (event.key === 'ArrowRight') {
	                this.nextPost();
	            }
	        }
	    }, {
	        key: 'watchPosts',
	        value: function watchPosts() {
	            var _this5 = this;
	
	            this.$scope.$watch(function () {
	                return _this5.SharedMoments.getLoadedPosts();
	            }, function (newValue) {
	                if (newValue) {
	                    _this5.posts = newValue;
	                    _this5.urls = newValue.map(function (item) {
	                        return item.url;
	                    });
	
	                    _this5.setActivePost();
	                }
	            });
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this6 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this6.render();
	                }
	            });
	        }
	    }]);
	    return PostController;
	}();
	
	PostController.$inject = ['$scope', '$state', '$stateParams', 'SharedMoments', 'Category', 'Color'];
	
	exports.default = PostController;

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        CLOSE: 'დახურვა'
	    },
	    EN: {
	        CLOSE: 'Close'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(902);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./post.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./post.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".post{position:fixed;width:calc(100vw - 100px);height:calc(100vh - 60px);padding:30px 50px;z-index:11;outline:none;background-color:hsla(0,0%,93%,.8)}.post .loader{position:absolute;top:calc(50vh - 90px);left:calc(50vw - 80px)}@media only screen and (max-width:1023px){.post{display:none}}.post .action-buttons-container{position:absolute;top:55px;display:block}.post .popup{position:relative;padding:20px;width:calc(100vw - 140px);height:calc(100vh - 100px);border-radius:10px;background-color:#fff;box-shadow:8px 8px 15px #bbb}@media only screen and (max-width:768px){.post .popup{width:calc(100vw - 40px);height:calc(100vh - 40px)}}.post .popup .close{position:absolute;right:20px;display:flex;align-items:center;cursor:pointer}.post .popup .close:hover span{color:#16181c}.post .popup .close span{font-size:12px;margin-left:7px;margin-top:2px;color:#8c93a5;font-family:Graphik-Semibold}.post .popup .content{position:relative;top:35px;left:12px;margin:0 30px;height:calc(100% - 40px);width:calc(100% - 84px)}@media (min-width:1024px){.post .popup .content .left{width:320px}.post .popup .content .right{width:500px}}@media (min-width:1280px){.post .popup .content .left{margin-left:50px}.post .popup .content .right{margin-right:50px}}@media (min-width:1440px){.post .popup .content .left{margin-left:100px;width:400px}.post .popup .content .right{margin-right:100px;width:600px}}.post .popup .content .left,.post .popup .content .right{display:inline-block;height:100%}.post .popup .content .left{position:absolute;top:0;left:0}.post .popup .content .left .date{font-size:15px;width:230px;padding:20px 15px;color:#7e8891;text-align:center;font-family:Graphik-Bold}.post .popup .content .left .personal{margin-bottom:30px;padding:20px 15px;width:230px;text-align:center;background-color:#f7f7f7}.post .popup .content .left .personal img{margin-bottom:10px;width:70px;height:70px;border-radius:50%}.post .popup .content .left .personal .full-name{font-family:Graphik-Bold;font-size:15px}.post .popup .content .left .caption{height:calc(100% - 300px);overflow-y:auto;font-family:Graphik;font-size:15px;color:#000;word-wrap:break-word;overflow-x:hidden}.post .popup .content .left .caption::-webkit-scrollbar{width:3px}.post .popup .content .left .caption::-webkit-scrollbar-track{background:#f2f2f2}.post .popup .content .left .caption::-webkit-scrollbar-thumb{background:#ff0084}.post .popup .content .left .caption::-webkit-scrollbar-thumb:hover{background:#ff002b}.post .popup .content .right{position:absolute;top:0;right:0}.post .popup .content .right .card{width:100%;height:100%}.post .popup .content .right .card .layer{position:absolute;background-size:cover}.post .popup .content .right .card .photo{top:55px;right:30px;z-index:4}.post .popup .content .right .card .light{top:130px;right:75px;z-index:1}.post .popup .content .right .card .normal{top:150px;right:45px;z-index:2}.post .popup .content .right .card .dark{top:180px;right:0;z-index:3}.post .popup .content .right .card .dots{background-image:url(/assets/images/dots.png);background-size:cover;z-index:5}@media (min-width:1024px){.post .popup .content .right .card .layer{width:350px;height:330px}.post .popup .content .right .card .photo{width:420px;height:380px}.post .popup .content .right .card .dark{width:365px}.post .popup .content .right .card .dots{top:275px;right:197px;width:250px;height:250px}}@media (min-width:1440px){.post .popup .content .right .card .layer{width:380px;height:330px}.post .popup .content .right .card .photo{width:500px;height:380px}.post .popup .content .right .card .light{top:150px;left:100px}.post .popup .content .right .card .normal{top:175px;left:140px}.post .popup .content .right .card .dark{width:419px;height:360px}.post .popup .content .right .card .dots{top:290px;right:250px;width:280px;height:250px}}.post .popup .controls .arrow-left,.post .popup .controls .arrow-right{cursor:pointer}.post .popup .controls .arrow-left:hover path,.post .popup .controls .arrow-right:hover path{fill:#a4b2d6}.post .popup .controls .arrow-left{position:absolute;top:calc((100% - 40px) / 2);left:5px}.post .popup .controls .arrow-right{position:absolute;top:calc((100% - 40px) / 2);right:5px}.post .popup .controls svg{width:40px;height:40px}.post .popup .controls svg path{fill:#d9dfee}", ""]);
	
	// exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _about = __webpack_require__(904);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aboutModule = _angular2.default.module('about', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('about', {
	        url: '/about',
	        component: 'about'
	    });
	}]).component('about', _about2.default).name;
	
	exports.default = aboutModule;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _about = __webpack_require__(905);
	
	var _about2 = _interopRequireDefault(_about);
	
	var _about3 = __webpack_require__(906);
	
	var _about4 = _interopRequireDefault(_about3);
	
	__webpack_require__(908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var aboutComponent = {
	  bindings: {},
	  template: _about2.default,
	  controller: _about4.default
	};
	
	exports.default = aboutComponent;

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n<cookies></cookies>\n<div class=\"about\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"content\">\n        <div class=\"texts\">\n            <div class=\"row center-xs\">\n                <div class=\"col-md-8\">\n                    <h3 class=\"title\">\n                        {{$ctrl.title}}\n                    </h3>\n                </div>\n            </div>\n            <div class=\"row center-xs\">\n                <div class=\"col-md-8\">\n                    {{$ctrl.descriptions[0]}}\n                </div>\n            </div>\n            <div class=\"row center-xs\">\n                <div class=\"col-md-12 video-row\">\n                    <iframe src=\"https://www.youtube.com/embed/TUxEKhlq_ks?rel=0&amp;controls=0&amp;showinfo=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\"\n                        allowfullscreen></iframe>\n                </div>\n            </div>\n            <div class=\"row center-xs\">\n                <div class=\"col-md-8\">\n                    {{$ctrl.descriptions[1]}}\n                    <br>\n                    <br> {{$ctrl.descriptions[2]}}\n                    <br>\n                    <br> {{$ctrl.descriptions[3]}}\n                </div>\n            </div>\n        </div>\n        <about-footer/>\n    </div>\n</div>\n"

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _about = __webpack_require__(907);
	
	var _about2 = _interopRequireDefault(_about);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutController = function () {
	    function AboutController($scope) {
	        (0, _classCallCheck3.default)(this, AboutController);
	
	        this.name = 'about';
	
	        this.$scope = $scope;
	    }
	
	    (0, _createClass3.default)(AboutController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _about2.default[this.language],
	                TITLE = _texts$language.TITLE,
	                DESCRIPTIONS = _texts$language.DESCRIPTIONS;
	
	
	            this.title = TITLE;
	            this.descriptions = DESCRIPTIONS;
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.render();
	                }
	            });
	        }
	    }]);
	    return AboutController;
	}();
	
	AboutController.$inject = ['$scope'];
	
	exports.default = AboutController;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        TITLE: 'კამპანიის შესახებ',
	        DESCRIPTIONS: ['საქართველო - ქვეყანა, რომელიც ცნობილია სტუმართმოყვარეობით. ქართველებს გვიყვარს ჩვენი ქვეყნის სტუმრებისთვის გაზიარება, მათ კი თავიანთი ემოციების გაზიარება სოციალურ ქსელებში, ფოტოებისა და ისტორიების სახით. ეს არის გულწრფელი და პირდაპირი შეფასებები, დაწერილი არა პროფესიონალების, არამედ ჩვეულებრივი მოგზაურების მიერ - ტურისტების, მსოფლიოს სხვადასხვა კუთხიდან, რომლებიც ჩვენს ქვეყანას ესტუმრნენ.', 'ჩვენ შევაგროვეთ 7 მილიონზე მეტი ტურისტის მიერ გაზიარებული ეს ძვირფასი  მონაცემები. დავახარისხეთ და გავაანალიზეთ ხელოვნური ინტელექტის საშუალებით, რომელსაც ასევე ემოციების ამოცნობა ვასწავლეთ და საბოლოოდ ყველაზე ამაღელვებელი შთაბეჭდილებები შევარჩიეთ.', 'შედეგად, შევქმენით საქართველოს პირველი ციფრული გზამკვლევი, რომელიც ხელოვნური ინტელექტის კომპლექსური ხელსაწყოებით შერჩეულ, ადამიანურ ემოციებს ეფუძნება. ყველაფერი, რაც ჩვენს ქვეყანაზე უცხოელებმა უნდა იცოდნენ, მოყოლილია სოციალურ მედიაში გაზიარებული რეალური ისტორიებით, რომლებიც მოგზაურებმა თავად გამოსცადეს და აღმოაჩინეს -  ცნობილი ქართული სტუმართმოყვარეობა, უძველესი კულტურა, უნიკალური ადგილები, მრავალფეროვანი სამზარეულო და სხვა.', 'ვებ პლატფორმის მთავარი ფუნქცია პერსონალიზებული გზამკვლევის გენერირებაა. მას შემდეგ, რაც ვებ გვერდს მისცემთ წვდომას თქვენს facebook-ის პროფილზე,ან უპასუხებთ რამდენიმე მარტივ კითხვას, ვებ გვერდი გააანალიზებს თქვენს მონაცემებს და დააგენერირებს თქვენს ინტერესებზე მორგებულ საქართველოს გზამკვლევს.']
	    },
	    EN: {
	        TITLE: 'About the project',
	        DESCRIPTIONS: ['Georgia is famous for its hospitality. We love sharing our country with our guests and they, in return, enjoy sharing photos and stories of their journey with friends and family members.These are straightforward, heartfelt and uncensored“ reviews”, written not by professional travel writers, but by regular tourists - travelers from all around the world who’ ve actually visited our country.', 'We’ve collected this valuable data, accumulated in 2017 by more than 7 000 000 visitors, sorted and analyzed it with help of Artificial Intelligence based tools to detect the most genuine human emotions shared on social media and as the result we have created a one of a kind guidebook of Georgia, fully generated by tourists.', 'This is the first ever guidebook that features human emotions that are selected and chosen by complex Artificial Intelligence tools. Everything you need to know about our country is told through stories shared on social media by travelers who’ve experienced Georgia’s famous hospitality, embraced its ancient culture, and discovered its unique places and diverse cuisine independently.', 'The main feature of the web-platform is the option to GENERATE YOUR OWN GUIDEBOOK of Georgia. After you give the website an access to your Facebook information or simply answering some quick questions, the website analyzes your data and generates an custom guidebook shaped according to your interests.']
	    }
	};
	
	exports.default = json;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(909);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./about.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./about.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".about{background-color:#fcfcfc}.about .title{margin-top:20px;margin-bottom:20px;color:#ea3e4a}.about.geo .content{font-family:Georgian-Regular}.about .content{height:calc(100vh - 92px);overflow-y:auto;background-color:#fcfcfc;text-align:center;font-size:13px;font-weight:300;font-family:Graphik-Regular;overflow-x:hidden}.about .content::-webkit-scrollbar{width:3px}.about .content::-webkit-scrollbar-track{background:#f2f2f2}.about .content::-webkit-scrollbar-thumb{background:#ff0084}.about .content::-webkit-scrollbar-thumb:hover{background:#ff002b}.about .content .texts{min-height:calc(100% - 120px);margin-bottom:50px}.about .content .texts .row{margin-left:25px;margin-right:25px}.about .content .texts .video-row{margin-top:20px;margin-bottom:20px}@media (min-width:425px){.about .content .texts .video-row iframe{width:400px;height:225px}}@media (min-width:768px){.about .content .texts .video-row iframe{width:500px;height:315px}}@media (min-width:1024px){.about .content .texts .video-row iframe{width:800px;height:450px}}@media (min-width:1440px){.about .content .texts .video-row iframe{width:1000px;height:563px}}@media (min-width:2560px){.about .content .texts .video-row iframe{width:2000px;height:1126px}}", ""]);
	
	// exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _welcome = __webpack_require__(911);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var welcomeModule = _angular2.default.module('welcome', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('welcome', {
	        url: '/',
	        component: 'welcome'
	    });
	}]).component('welcome', _welcome2.default).name;
	
	exports.default = welcomeModule;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _welcome = __webpack_require__(912);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	var _welcome3 = __webpack_require__(913);
	
	var _welcome4 = _interopRequireDefault(_welcome3);
	
	__webpack_require__(915);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var welcomeComponent = {
	    bindings: {},
	    template: _welcome2.default,
	    controller: _welcome4.default
	};
	
	exports.default = welcomeComponent;

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"welcome\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"video-box\">\n        <video id=\"welcomeVideo\" autoplay muted>\n            <source src=\"https://s3-eu-west-1.amazonaws.com/tourists/videoplayback.mp4\" type=\"video/mp4\" />\n        </video>\n    </div>\n    <div class=\"blur-box\"></div>\n    <div class=\"rectangle\">\n        <div class=\"line\" id=\"videoLine\"></div>\n        <p class=\"slide-text\">\n            <span>{{$ctrl.skipDescription}}</span>\n        </p>\n        <div class=\"skip\">\n            <div ui-sref=\"home\">\n                {{$ctrl.skip}}\n            </div>\n        </div>\n        <div class=\"language\">\n            <div class=\"en\" ng-class=\"{active: $ctrl.language === 'EN'}\" ng-click=\"$ctrl.changeLanguage('EN')\">EN</div>\n            <div class=\"ge\" ng-class=\"{active: $ctrl.language === 'GE'}\" ng-click=\"$ctrl.changeLanguage('GE')\">GE</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _welcome = __webpack_require__(914);
	
	var _welcome2 = _interopRequireDefault(_welcome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WelcomeController = function () {
	    function WelcomeController($state, $timeout) {
	        (0, _classCallCheck3.default)(this, WelcomeController);
	
	        this.name = 'Welcome';
	
	        this.$state = $state;
	        this.$timeout = $timeout;
	    }
	
	    (0, _createClass3.default)(WelcomeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // Set active language on page load
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            this.render();
	
	            // Track welcome video events
	            var welcomeVideo = document.getElementById('welcomeVideo');
	
	            this.setVideoDuration(welcomeVideo);
	
	            welcomeVideo.ontimeupdate = this.timeupdate;
	            welcomeVideo.onended = this.videoEnded.bind(this);
	
	            localStorage.setItem('tourists_welcome', true);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _texts$language = _welcome2.default[this.language],
	                SKIP = _texts$language.SKIP,
	                SKIP_DESCRIPTION = _texts$language.SKIP_DESCRIPTION;
	
	
	            this.skip = SKIP;
	            this.skipDescription = SKIP_DESCRIPTION;
	        }
	    }, {
	        key: 'setVideoDuration',
	        value: function setVideoDuration(video) {
	            var that = this;
	
	            var videoInterval = setInterval(function () {
	                if (video.readyState > 0) {
	                    that.videoDuration = video.duration % 60;
	                    clearInterval(videoInterval);
	                }
	            }, 200);
	        }
	    }, {
	        key: 'timeupdate',
	        value: function timeupdate() {
	            var width = this.currentTime / this.duration * 100;
	            var videoLine = document.getElementById('videoLine');
	
	            if (videoLine) {
	                videoLine.style.width = width + '%';
	            }
	        }
	    }, {
	        key: 'videoEnded',
	        value: function videoEnded() {
	            var _this = this;
	
	            this.$timeout(function () {
	                _this.$state.go('home');
	            }, 800);
	        }
	    }, {
	        key: 'changeLanguage',
	        value: function changeLanguage(language) {
	            this.language = language;
	
	            localStorage.setItem('tourists_lang', language);
	
	            this.render();
	        }
	    }]);
	    return WelcomeController;
	}();
	
	WelcomeController.$inject = ['$state', '$timeout'];
	
	exports.default = WelcomeController;

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        SKIP: 'გამოტოვება',
	        SKIP_DESCRIPTION: 'გასაგრძელებლად დააჭირეთ გამოტოვებას'
	    },
	    EN: {
	        SKIP: 'Skip video',
	        SKIP_DESCRIPTION: 'Click skip to continue'
	    }
	};
	
	exports.default = json;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(916);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./welcome.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./welcome.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".welcome{font-family:Graphik-Regular;background-color:#edecee;height:100vh}.welcome.geo{font-family:Georgian-Regular}.welcome .video-box{width:100%;height:85%}.welcome .video-box video{width:100%;height:100%;max-height:100%;max-width:100%}.welcome .rectangle{position:absolute;bottom:0;padding-top:15px;padding-bottom:15px;width:100%;height:15%;background-color:#0e0e0f;z-index:13}.welcome .rectangle .line{position:relative;top:-15px;height:2px;width:0;background-color:#fff}.welcome .rectangle .slide-text{margin-top:7px;text-align:center}.welcome .rectangle .slide-text span{font-size:10.5px;color:hsla(0,0%,100%,.2);line-height:3.572;text-align:left;z-index:17}.welcome .rectangle .skip{text-align:center}.welcome .rectangle .skip div{cursor:pointer;text-align:center;width:70px;border:1px solid #2c3133;border-radius:20px;font-size:10px;font-weight:700;padding:10px;color:#fff;display:inline-block;line-height:11px}.welcome .rectangle .language{position:absolute;top:0;right:0;color:#fff;width:150px;font-size:10px;padding-top:42px;user-select:none;font-family:Graphik-Semibold}.welcome .rectangle .language .en,.welcome .rectangle .language .ge{width:35px;height:35px;padding:5px;cursor:pointer;text-align:center;display:inline-block;line-height:35px}.welcome .rectangle .language div.active{background-color:#fff;color:#000;font-weight:700}@media (max-width:576px){.welcome .rectangle .language{width:100px}}", ""]);
	
	// exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _statistics = __webpack_require__(918);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statisticsModule = _angular2.default.module('statistics', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	    'ngInject';
	
	    $stateProvider.state('statistics', {
	        url: '/statistics',
	        component: 'statistics'
	    });
	}]).component('statistics', _statistics2.default).name;
	
	exports.default = statisticsModule;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _statistics = __webpack_require__(919);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	var _statistics3 = __webpack_require__(920);
	
	var _statistics4 = _interopRequireDefault(_statistics3);
	
	__webpack_require__(922);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statisticsComponent = {
	    bindings: {},
	    template: _statistics2.default,
	    controller: _statistics4.default
	};
	
	exports.default = statisticsComponent;

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n<cookies></cookies>\n<div class=\"statistics\" id=\"statistics\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"parallax-text\" id=\"parallax-text\">\n        <div class=\"inner\" ng-style=\"{display: $ctrl.activeIndex === 0 ? 'block': 'none'}\">\n            <div class=\"column\">\n                <h1 class=\"title\">{{$ctrl.titles[0]}}</h1>\n                <div class=\"policy\">\n                    {{$ctrl.policies[0]}}\n                    <br/>{{$ctrl.policies[1]}}\n                </div>\n            </div>\n        </div>\n\n        <div class=\"inner\" ng-style=\"{display: $ctrl.activeIndex === 1 ? 'block': 'none'}\">\n            <div class=\"column\">\n                <h1 class=\"title\">{{$ctrl.titles[1]}}</h1>\n                <div class=\"policy\">\n                    {{$ctrl.policies[0]}}\n                    <br/>{{$ctrl.policies[1]}}\n                </div>\n            </div>\n        </div>\n\n        <div class=\"inner\" ng-style=\"{display: $ctrl.activeIndex === 2 ? 'block': 'none'}\">\n            <div class=\"column\">\n                <h1 class=\"title\">{{$ctrl.titles[2]}}</h1>\n                <div class=\"policy\">\n                    {{$ctrl.policies[0]}}\n                    <br/>{{$ctrl.policies[1]}}\n                </div>\n            </div>\n        </div>\n\n        <div class=\"inner\" ng-style=\"{display: $ctrl.activeIndex === 3 ? 'block': 'none'}\">\n            <div class=\"column\">\n                <h1 class=\"title\">{{$ctrl.titles[3]}}</h1>\n                <div class=\"policy\">\n                    {{$ctrl.policies[0]}}\n                    <br/>{{$ctrl.policies[1]}}\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"parallax-window\">\n        <img src=\"/assets/images/statistics/1.png\" alt=\"1\" class=\"parallax-slider\" id=\"slide-0\">\n        <img src=\"/assets/images/statistics/2.png\" alt=\"2\" class=\"parallax-slider\" id=\"slide-1\">\n        <img src=\"/assets/images/statistics/3.png\" alt=\"3\" class=\"parallax-slider\" id=\"slide-2\">\n        <img src=\"/assets/images/statistics/4.png\" alt=\"4\" class=\"parallax-slider\" id=\"slide-3\">\n    </div>\n    <div class=\"actions\">\n        <button data-balloon=\"size: 3x\" data-balloon-pos=\"up\" class=\"up\" ng-click=\"$ctrl.scrollUp()\" ng-style=\"{'visibility': $ctrl.activeIndex !== 0 ? 'visible' : 'hidden' }\">\n            <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"angle-up\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 512\"\n                class=\"svg-inline--fa fa-angle-up fa-w-8 fa-3x\">\n                <path fill=\"currentColor\" d=\"M136.5 185.1l116 117.8c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L128 224.7 27.6 326.9c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17l116-117.8c4.7-4.6 12.3-4.6 17 .1z\"\n                    class=\"\"></path>\n            </svg>\n        </button>\n\n        <button data-balloon=\"size: 3x\" data-balloon-pos=\"up\" class=\"down\" ng-click=\"$ctrl.scrollDown()\" ng-style=\"{'visibility': $ctrl.activeIndex !== 3 ? 'visible' : 'hidden' }\">\n            <svg aria-hidden=\"true\" data-prefix=\"fal\" data-icon=\"angle-down\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 512\"\n                class=\"svg-inline--fa fa-angle-down fa-w-8 fa-3x\">\n                <path fill=\"currentColor\" d=\"M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z\"\n                    class=\"\"></path>\n            </svg>\n        </button>\n    </div>\n</div>\n\n<!-- <footer></footer> -->\n"

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _statistics = __webpack_require__(921);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticsController = function () {
	    function StatisticsController($scope, $timeout) {
	        (0, _classCallCheck3.default)(this, StatisticsController);
	
	        this.name = 'Statistics';
	
	        this.$scope = $scope;
	        this.timeout = $timeout;
	
	        this.activeIndex = 0;
	        this.isScrolling = false;
	        this.colors = ['#ea5967', '#475cab', '#f4b460', '#63c19d'];
	    }
	
	    (0, _createClass3.default)(StatisticsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.render();
	
	            this.bindScroll();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _statistics2.default[this.language],
	                TITLES = _texts$language.TITLES,
	                POLICIES = _texts$language.POLICIES;
	
	
	            this.titles = TITLES;
	            this.policies = POLICIES;
	        }
	    }, {
	        key: 'bindScroll',
	        value: function bindScroll() {
	            var _this = this;
	
	            angular.element(document.getElementById('statistics')).bind('mousewheel DOMMouseScroll', function (e) {
	                if (_this.isScrolling) {
	                    return;
	                }
	
	                if (e.originalEvent.wheelDelta < 0) {
	                    _this.scrollDown();
	                } else {
	                    _this.scrollUp();
	                }
	            });
	        }
	    }, {
	        key: 'scrollUp',
	        value: function scrollUp() {
	            var _this2 = this;
	
	            var height = $('#slide-' + this.activeIndex).height();
	            var index = this.activeIndex;
	
	            if (index === 0) {
	                this.isScrolling = false;
	                return;
	            }
	
	            if (this.isScrolling) {
	                return;
	            }
	
	            this.isScrolling = true;
	            this.activeIndex--;
	
	            if (this.scrollTimeout) {
	                this.timeout.cancel(this.scrollTimeout);
	            }
	
	            var activeTag = $('#slide-' + index);
	            var nextTag = $('#slide-' + (index - 1));
	            var textTag = $('#parallax-text');
	
	            activeTag.css({
	                'z-index': 10
	            });
	            nextTag.css({
	                'z-index': 11
	            });
	
	            activeTag.animate({
	                top: '+=' + height + 'px'
	            }, 1000);
	
	            nextTag.animate({
	                top: '+=' + height + 'px'
	            }, 700);
	
	            textTag.css({
	                'background-color': this.colors[index - 1]
	            }, 1000);
	
	            this.scrollTimeout = this.timeout(function () {
	                _this2.isScrolling = false;
	            }, 1000);
	        }
	    }, {
	        key: 'scrollDown',
	        value: function scrollDown() {
	            var _this3 = this;
	
	            var height = $('#slide-' + this.activeIndex).height();
	            var index = this.activeIndex;
	
	            if (index >= 3) {
	                this.isScrolling = false;
	                return;
	            }
	
	            if (this.isScrolling) {
	                return;
	            }
	
	            this.isScrolling = true;
	            this.activeIndex++;
	
	            if (this.scrollTimeout) {
	                this.timeout.cancel(this.scrollTimeout);
	            }
	
	            var activeTag = $('#slide-' + index);
	            var nextTag = $('#slide-' + (index + 1));
	            var textTag = $('#parallax-text');
	
	            activeTag.css({
	                'z-index': 10
	            });
	            nextTag.css({
	                'z-index': 11
	            });
	
	            activeTag.animate({
	                top: '-=' + height + 'px'
	            }, 1000);
	
	            nextTag.animate({
	                top: '-=' + height + 'px'
	            }, 700);
	
	            textTag.css({
	                'background-color': this.colors[index + 1]
	            }, 1000);
	
	            this.scrollTimeout = this.timeout(function () {
	                _this3.isScrolling = false;
	            }, 1000);
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this4 = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this4.render();
	                }
	            });
	        }
	    }]);
	    return StatisticsController;
	}();
	
	StatisticsController.$inject = ['$scope', '$timeout'];
	
	exports.default = StatisticsController;

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        TITLES: ['ტოპ 5 ღვინო, რომელმაც დაიპყრო ტურისტების გულები', 'ტოპ 5 ქართული კერძი, რომელიც ყველაზე ხშირად დაიდო ინსტაგრამზე', 'ტოპ 5 ყველაზე ხშირად დათაგული შენობა თბილისში', 'ტოპ 7 ყველაზე ხშირად მონახულებული ლოკაცია თვეების მიხედვით'],
	        POLICIES: ['მონაცემები გენერირებულია 7 მილიონი ტურისტის მიერ სოციალურ მედიებში გაზიარებული პოსტებიდან.', 'გულწრფელი, ადამიანური ემოციები ხელოვნური ინტელექტის დახმარებითაა გაანალიზებული.']
	    },
	    EN: {
	        TITLES: ['Top 5 wines that captivated tourist\'s hearts and made them post on social media', 'Top 5 most instagramed Georgian dishes', 'Top 5 most frequently tagged buildings in Tbilisi', 'Top 7 most checked in locations by month'],
	        POLICIES: ['This data is generated from social media posts shared by 7 million tourists.', 'Genuine human emotions were selected and analyzed by artificial intelligence.']
	    }
	};
	
	exports.default = json;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(923);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./statistics.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./statistics.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".statistics{position:relative;height:calc(100vh - 92px);width:100%;overflow-y:hidden}.statistics .parallax-text{position:fixed;top:92px;height:calc(100vh - 92px);width:calc(100% - 600px);background-color:#ea5967;transition:background-color 1s linear}.statistics .parallax-text .inner{width:100%;height:100%}.statistics .parallax-text .inner .column{position:absolute;right:25%;display:inline-block;height:100%;width:250px}.statistics .parallax-text .inner .column .title{margin-top:130px;margin-bottom:15px;font-family:Graphik-bold}.statistics .parallax-text .inner .column small{font-weight:700;color:#fff}.statistics .parallax-text .inner .column .policy{position:absolute;bottom:80px;font-size:11px;color:#fff;font-family:Graphik-Regular}.statistics .parallax-window{margin-left:calc(100% - 600px);height:calc(100vh - 92px);width:600px}.statistics .parallax-window .parallax-slider{position:absolute;height:calc(100vh - 92px);width:600px}.statistics .parallax-window :first-child{top:0}.statistics .parallax-window :nth-child(2),.statistics .parallax-window :nth-child(3),.statistics .parallax-window :nth-child(4){top:calc(100vh - 92px)}.statistics .actions{position:fixed;bottom:100px;right:50px;width:45px;z-index:12}.statistics .actions button{background-color:#fff;border:none;border-radius:50%;width:45px;height:45px;outline:none}.statistics .actions svg{color:#a5a5a5;width:18px}.statistics .actions .down{margin-top:10px}.statistics .actions .down svg{position:relative;top:3px}.statistics.geo .parallax-text .inner .column .title{font-family:Georgian-Bold;font-size:28px}.statistics.geo .parallax-text .inner .column .policy{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _privacy = __webpack_require__(925);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyModule = _angular2.default.module('privacy', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $stateProvider.state('privacy', {
	        url: '/privacy-policy',
	        component: 'privacy'
	    });
	}]).component('privacy', _privacy2.default).name;
	
	exports.default = privacyModule;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _privacy = __webpack_require__(926);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _privacy3 = __webpack_require__(927);
	
	var _privacy4 = _interopRequireDefault(_privacy3);
	
	__webpack_require__(928);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyComponent = {
	  bindings: {},
	  template: _privacy2.default,
	  controller: _privacy4.default
	};
	
	exports.default = privacyComponent;

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n<div class=\"privacy container-fluid\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"info col-xs-12 col-md-8\" ng-if=\"$ctrl.language === 'EN'\">\n        <h2 class=\"head\">Privacy Policy</h2>\n        <p>Book of Georgia is the project created on behalf of Georgian National Tourism Administration within the framework\n            of tourism marketing campaign. It has endeavored to provide a guide book (as digital also the paperback versions).\n            This site and paperback versions are fully assembled with the public posts from social media made by the travelers\n            who had visited Georgia. Book of Georgia has acquired written permission from all the authors of the posts to\n            use them for the purpose of this project.\n        </p>\n\n        <h2 class=\"head\">How This Policy Applies</h2>\n        <p>\n            ​To provide you with a membership on Book of Georgia, we need to collect information about you. We collect and combine different\n            types of information together, and collectively refer to all of this information in this Privacy Policy as “Information”.\n            <br>Our Privacy Policy explains:\n            <ul>\n                <li>What information we collect and why we collect it.</li>\n                <li>How we use that information.</li>\n                <li>The choices we offer, including how to access and update information.\n                </li>\n            </ul>\n\n            By using the Services offered by Book of Georgia, you’re acknowledging you have agreed with our Terms of Use and that you\n            have read and understood this Privacy Policy.\n            <br>\n            <span>Definition of Terms</span>\n            <span>Site – https://www.emotionsaregeorgia.com</span>\n            <span>Service – services provided by the Book of Georgia</span>\n            <span>Local Law - Georgia</span>\n        </p>\n\n        <h2 class=\"head\">Type of information we collect</h2>\n        <p>In order for you to create an account on Book of Georgia and use our Services, we need to collect and process certain\n            information. That may include:\n            <ul>\n                <li>The email address associated with your Facebook account, if you choose to sign up using your Facebook credentials.\n                    Book of Georgia will also request permission to access your name, location, likes, gender, birthday and\n                    hometown (these permissions are governed by Facebook’s privacy policies and can be managed through your\n                    Facebook privacy settings). We never post anything to your Facebook, Twitter, Instagram or other third-party\n                    accounts without your permission.</li>\n            </ul>\n            You may decline to provide us with your information. However, this will limit your ability to register for an account or\n            use our Services.\n        </p>\n\n        <h2 class=\"head\" id=\"cookies\">Cookies and other similar technologies</h2>\n        <p>We use cookies or similar technologies to identify your browser or device. Like many services, Book of Georgia uses\n            these technologies for all registered and unregistered users to track your movements around the Site, administer\n            the Site, identify your preferences according to Site content and to help the Site work better for you.\n        </p>\n\n        <h2 class=\"head\">Third party integration on our site</h2>\n        <p>\n            When you use third-party apps, websites or other services that use, or are integrated with, our Site, they may receive information\n            about what you post or share. For example, when you share via Facebook or Twitter, these services receive the\n            information that you share through this functionality, and information that you are sharing from our Site. Information\n            collected by these apps, websites or integrated services is subject to their own terms and policies.\n        </p>\n\n        <h2 class=\"head\">Information from Other Sources</h2>\n        <p>We may also obtain information, including personal information, from third- party sources to update or supplement\n            the information you provided or we collected automatically. Local Law may require you authorize the third-party\n            to share your information with us before we can acquire it. This may include aggregated anonymous information\n            or certain personal information that may be provided to us. If we receive personal information from third parties\n            we will handle it in accordance with this Privacy Policy.\n        </p>\n\n        <h2 class=\"head\">How We Use This Information</h2>\n        <p>\n            We use the information we collect for the following purposes:\n            <ul>\n                <li>To keep your account secure and protect our Services (including to verify the identities of creators and\n                    prevent fraud and abuse).</li>\n                <li>To enable us to provide you with the custom generated book.</li>\n                <li>To create your account, contact you, and customize your experience on book of Georgia.</li>\n                <li>To track and analyze use of the Services so that we can improve how Book of Georgia is performing and provide\n                    users with the best experience possible.</li>\n                <li>Personalize Book of Georgia, services, content and experiences.</li>\n                <li>Provide you with the information about events, announcements, offers, promotions, products, and services\n                    we think will be of interest to you. and</li>\n                <li>For any other purpose for which the information was collected and which is lawful under the local law.</li>\n            </ul>\n            Book of Georgia will not use or disclose personal information for a purpose other than that for which it was collected unless:\n            <ul>\n                <li>Your consent is obtained.</li>\n                <li>Tourism Georgia is required to, or authorized by the Local Law or a court or tribunal order.</li>\n            </ul>\n\n            We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required\n            by law to do so.\n        </p>\n\n        <h2 class=\"head\">How you can access your information</h2>\n        <p>Under certain conditions, you have the right to ask us for a copy of your Information, to correct it, erase it or\n            restrict its processing from the website. You have the right to object to the processing of personal information\n            on the basis of our legitimate interests.\n        </p>\n\n        <h2 class=\"head\">International Users</h2>\n        <p>This Site is hosted and operated in Georgia. If you access or use the Site from the European Union, or any other\n            region, the personal information you submit to our Site will be transferred to and stored in Ireland and other\n            countries to be processed by us so we can provide this Site to you as set forth in this Privacy Policy and the\n            Terms of Use Agreement.\n            <br> By using the Site, you consent to the transfer of your personal information outside your home jurisdiction,\n            including Georgia, and to the storage of your personal information Georgia, for the purpose of hosting, using\n            and processing the personal information in accordance with this Privacy Policy. You further acknowledge that\n            these countries may not have the same data protection laws as the country from which you provided your personal\n            information. You have the right to withdraw your consent at any time by contacting us.\n        </p>\n\n        <h2 class=\"head\">Security</h2>\n        <p>\n            We use information to help improve the safety and reliability of our services. This includes detecting, preventing, and responding\n            to fraud, abuse, security risks, and technical issues that could harm Book of Georgia, our users and public.\n            <br> We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure,\n            we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information\n            we collect online.\n            <br> In keeping with our commitment to privacy, we have put in place appropriate technical and organizational measures\n            to help ensure that personal data we collect is protected and properly handled. While we cannot guarantee that\n            loss, misuse or alteration to information will not occur. we make good faith efforts to prevent such occurrences.\n            We do not warrant or represent that your account or any of your information will be protected against, loss,\n            misuse, or alteration by third parties.\n        </p>\n\n        <h2 class=\"head\">Children’s privacy rights</h2>\n        <p>This Site is not directed toward individuals under the age of 13 and we request that such individuals do not provide\n            personal information. Additionally, we do not knowingly collect or maintain personal information from anyone\n            under the age of 13. If we become aware that a child under 13 has provided us with personal information, then\n            we will delete this information from our files.</p>\n\n        <h2 class=\"head\">Notification regarding updates</h2>\n        <p>From time to time, we can update this Privacy Policy. We will notify you about changes to this Privacy Policy by\n            placing a notice on our sites. We encourage you to periodically check back and review this policy so that you\n            always know our current privacy practices.</p>\n\n        <h2>How to contact us:</h2>\n        <p>If you have any queries or comments about this Policy, please contact us by email at: office@windfors.ge</p>\n\n        <p>\n            <strong>Last updated:</strong> 29.06.2018</p>\n    </div>\n\n    <div class=\"info col-xs-12 col-md-8\" ng-if=\"$ctrl.language === 'GE'\">\n        <h2 class=\"head\">კონფიდენციალურობის პოლიტიკა</h2>\n        <p>საქართველოს წიგნი არის საქართველოს ტურიზმის ეროვნული ადმინისტრაციის სახელით ტურიზმის მარკეტინგის კამპანიის ფარგლებში\n            შექმნილი პროექტი. იგი ცდილობს წარმოადგინოს გზამკვლევი (როგორც ციფრული ასევე ბეჭდური ვერსიები). ეს ვებ-გვერდი\n            და ბეჭდური ვერსიები სრულად შედგენილია მოგზაურების მიერ გაზიარებული სოციალურ მედიაში საჯარო პოსტებისგან, რომლებიც\n            ეწვივნენ საქართველოს. საქართველოს წიგნმა მიიღო წერილობითი ნებართვა პოსტების ყველა ავტორისგან, რათა გამოყენებული\n            იქნეს ამ პროექტის მიზნებისთვის.\n        </p>\n\n        <h2 class=\"head\">როგორ გამოიყენება ეს პოლიტიკა</h2>\n        <p>\n            ​საქართველოს წიგნში გაწევრიანების მიზნით ჩვენ უნდა შევაგროვოთ ინფორმაცია თქვენს შესახებ. ჩვენ ვაგროვებთ და ვაერთიანებთ სხვადასხვა\n            ტიპის ინფორმაციას და ყველა ეს ინფორმაცია ამ კონფიდენციალურობის პოლიტიკაში ერთობლივად მოიხსენება როგორც „ინფორმაცია“.\n            ჩვენი ​\n            <br>კონფიდენციალურობის პოლიტიკა განმარტავს:\n            <ul>\n                <li>რა ინფორმაციას ვაგროვებთ და რატომ ვაგროვებთ.</li>\n                <li>როგორ ვიყენებთ ინფორმაციას.</li>\n                <li>რა არჩევანს გთავაზობთ, ინფორმაციის წვდომისა და განახლების ჩათვლით.\n                </li>\n            </ul>\n\n            საქართველოს წიგნის მიერ შემოთავაზებული მომსახურების გამოყენებით, თქვენ ადასტურებთ, რომ ეთანხმებით ჩვენი გამოყენების პირობებს\n            და რომ წაიკითხეთ და გაიგეთ ჩვენი კონფიდენციალურობის პოლიტიკა.\n            <br> ტერმინების განმარტება ვებ-გვერდი – https://www.emotionsaregeorgia.com მომსახურება – საქართველოს წიგნის მიერ\n            განხორცილებული მომსახურება ადგილობრივი კანონი - საქართველო\n        </p>\n\n        <h2 class=\"head\">ჩვენ მიერ შეგროვებული ინფორმაციის ტიპი</h2>\n        <p>საქართველოს წიგნში ანგარიშის შესაქმნელად და ჩვენი მომსახურების გამოსაყენებლად, ჩვენ გვჭირდება გარკვეული ინფორმაციის\n            შეგროვება და გადამუშავება. ეს შეიძლება შეიცავდეს:\n            <ul>\n                <li>\n                    თქვენს Facebook ანგარიშთან ასოცირებული ელ. ფოსტას, თუ თქვენ აირჩევთ რეგისტრაციას Facebook-ის რეკვიზიტებით. საქართველოს წიგნი\n                    ასევე მოგთხოვთ ნებართვას თქვენს სახელზე, ადგილმდებარეობაზე, მოწონებაზე, სქესზე, დაბადების თარიღზე და\n                    მშობლიურ ქალაქზე წვდომაზე (ამ ნებართვებს მართავს Facebook-ის კონფიდენციალურობის პოლიტიკა და მათი მართვა\n                    შეიძლება თქვენი Facebook კონფიდენციალურობის პარამეტრებით) ჩვენ არასოდეს არ გამოვაქვეყნებთ პოსტს თქვენს\n                    Facebook, Twitter, Instagram ან სხვა მესამე მხარის ანგარიშებზე თქვენი ნებართვის გარეშე\n                </li>\n            </ul>\n            თქვენ შეგიძლიათ უარი განაცხადოთ თქვენი ინფორმაციის მოწოდებაზე. თუმცა, ეს შეზღუდავს თქვენი ანგარიშის დარეგისტრირებას ან ჩვენი\n            მომსახურების გამოყენებას.\n        </p>\n\n        <h2 class=\"head\" id=\"cookies\">ქუქები და სხვა მსგავსი ტექნოლოგიები</h2>\n        <p>\n            ჩვენ ვიყენებთ ქუქებს და მსგავს ტექნოლოგიებს თქვენი ბრაუზერის ან მოწყობილობის იდენტიფიცირებისათვის. სხვა მომსახურების მსგავსად,\n            საქართველოს წიგნი იყენებს ამ ტექნოლოგიებს ყველა რეგისტრირებული და არარეგისტრირებული მომხმარებლებისთვის, რათა\n            ვაკონტროლოთ თქვენი მოქმედებები ვებ-გვერდთან დაკავშირებით, რათა ვმართოთ ვებ-გვერდი, განვსაზღვროთ თქვენი უპირატესობები\n            ჩვენი ვებ-გვერდის კონტენტის შესაბამისად და დაგეხმაროთ, რომ ჩვენმა ვებ-გვერდმა თქვენთვის უკეთ იფუნქციონიროს.\n        </p>\n\n        <h2 class=\"head\">მესამე მხარის ინტეგრაცია ჩვენს ვებ-გვერდზე</h2>\n        <p>\n            როდესაც თქვენ იყენებთ მესამე მხარის აპლიკაციებს, ვებ-გვერდებსა და სხვა სერვისებს, რომლებიც იყენებენ ჩვენს საიტს ან ინტეგრირებულია\n            მასთან, მათ შესაძლოა მიიღონ ინფორმაცია იმის შესახებ, თუ რას დაპოსტავთ ან გაზიარებთ. მაგალითად, თუ თქვენ Facebook-ის\n            ან Twitter-ის საშუალებით გააზიარებთ, ეს სერვისები მიიღებს ინფორმაციას, რომ თქვენ ამ საშუალებით აზიარებთ და რომ\n            ინფორმაციას აზიარებთ ჩვენი ვებ-გვერდიდან. ამ აპლიკაციების, ვებ-გვერდებისა ან ინტეგრირებული სერვისების მიერ შეგროვებული\n            ინფორმაცია დამოკიდებულია საკუთარ პირობებსა და პოლიტიკაზე.\n        </p>\n\n        <h2 class=\"head\">ინფორმაცია სხვა წყაროებიდან</h2>\n        <p>\n            ჩვენ ასევე შეიძლება მოვიპოვოთ ინფორმაცია, მათ შორის პირადი ინფორმაცია, მესამე მხარის წყაროებიდან, რათა განვაახლოთ ან შევავსოთ\n            თქვენ მიერ მოწოდებული ან ჩვენ მიერ ავტომატურად შეგროვებული ინფორმაცია. ადგილობრივმა კანონმა შეიძლება მოითხოვოს\n            მესამე მხარის ავტორიზაცია, რათა გაგვიზიაროთ ინფორმაცია, სანამ მივიღებთ მას. ეს შეიძლება მოიცავდეს სტატისტიკურ\n            ანონიმურ ინფორმაციას ან გარკვეულ პირად ინფორმაციას, რომელიც შეიძლება მოგვაწოდოთ. მესამე პირებისგან პირადი ინფორმაციის\n            მიღების შემთხვევაში ჩვენ განვიხილავთ მას კონფიდენციალურობის პოლიტიკასთან შესაბამისობაში.\n        </p>\n\n        <h2 class=\"head\">როგორ ვიყენებთ ამ ინფორმაციას</h2>\n        <p>\n            ჩვენ ვიყენებთ ინფორმაციას, რომელსაც ვაგროვებთ შემდეგი მიზნებისთვის:\n            <ul>\n                <li>\n                    რათა საიმედოდ დავიცვათ თქვენი ანგარიში და ჩვენი მომსახურება (შემქმნელების იდენტურობის დასადგენად და თაღლითობისა და ბოროტად\n                    გამოყენების თავიდან ასაცილებლად)\n                </li>\n                <li>\n                    რათა შევძლოთ თქვენთვის სპეციალურად გენერირებული წიგნი\n                </li>\n                <li>\n                    რათა შევქმნათ თქვენი ანგარიში, დაგიკავშირდეთ და შევუსაბამოთ თქვენი გამოცდილება საქართველოს წიგნში\n                </li>\n                <li>\n                    რათა თვალყური ვადევნოთ და გავაანალიზოთ მომსახურების გამოყენებას ისე, რომ ჩვენ შევძლოთ გავაუმჯობესოთ საქართველოს წიგნის ფუნქციონირება\n                    და უზრუნველვყოთ მომხმარებლები საუკეთესო გამოცდილებით\n                </li>\n                <li>\n                    რათა შევძლოთ საქართველოს წიგნის, სერვისების, კონტენტისა და გამოცდილების ინდივიდუალიზირება\n                </li>\n                <li>\n                    რათა მოგაწოდოთ ინფორმაცია მოვლენების, განცხადებების, შეთავაზებების, აქციების, პროდუქტებისა და სერვისების შესახებ, რომელიც\n                    ჩვენი აზრით თქვენთვის ინტერესს წარმოადგენს და\n                </li>\n                <li>\n                    ნებისმიერი სხვა მიზნებისთვის, რომლისთვისაც ინფორმაციის შეგროვება მოხდა და რომელიც ადგილობრივი კანონმდებლობით კანონიერია\n                </li>\n            </ul>\n            საქართველოს წიგნი არ გამოიყენებს და არ გაამჟღავნებს პირად ინფორმაციას გარდა იმ მიზნისა, რომლის გამოც ის შეგროვდება:\n            <ul>\n                <li>თუ არ მიგვიღია თქვენი თანხმობა</li>\n                <li>თუ საქართველოს ტურიზმს მოეთხოვება ან ავტორიზებულია ადგილობრივი კანონმდებლობით ან სასამართლოთი ან ტრიბუნალის\n                    ბრძანებით\n                </li>\n            </ul>\n            ჩვენ არ გავყიდით, არ გავავრცელებთ ან იჯარით გავცემთ თქვენს პირად ინფორმაციას მესამე პირზე, თუ ჩვენ არ გვექნება თქვენი თანხმობა\n            ან ამას არ მოითხოვს კანონი.\n        </p>\n\n        <h2 class=\"head\">როგორ გახდეს თქვენი ინფორმაცია ხელმისაწვდომი</h2>\n        <p>\n            გარკვეულ პირობებში თქვენ უფლება გაქვთ მოგთხოვოთ თქვენი ინფორმაციის ასლი, შეასწოროთ, წაშალოთ ან შეწყვიტოთ მისი დამუშავება\n            ვებგვერდიდან. თქვენ გაქვთ უფლება, პერსონალური ინფორმაციის დამუშავების წინააღმდეგი იყოთ ჩვენი კანონიერი ინტერესების\n            საფუძველზე.\n        </p>\n\n        <h2 class=\"head\">საერთაშორისო მომხმარებლები</h2>\n        <p>ეს ვებ-გვერდი მდებარეობს და იმართება საქართველოში. თუ თქვენ შედიხართ ჩვენს ვებ-გვერდზე ან იყენებთ მას ევროკავშირიდან\n            ან სხვა ნებისმიერი რეგიონიდან, თქვენ მიერ წარდგენილი ინფორმაცია ჩვენს ვებ-გვერდზე გადამისამართდება და შეინახება\n            ირლანდიაში და სხვა ქვეყნებში, რათა მოხდეს ჩვენ მიერ დამუშავება რათა შევძლოთ მოგაწოდოთ ეს ვებ-გვერდი, როგორც ეს\n            განსაზღვრულია ამ კონფიდენციალურობის პოლიტიკაში და გამოყენების წესების შესახებ შეთანხმებაში.\n\n            <br> ვებ-გვერდის გამოყენებით თქვენ ეთანხმებით თქვენი ინფორმაციის გადაცემას თქვენი იურისდიქციის ფარგლებს გარეთ, საქართველოს\n            ჩათვლით, და თქვენი პირადი ინფორმაციის შენახვას საქართველოში, პირადი ინფორმაციის ჰოსთინგის, გამოყენების და დამუშავების\n            მიზნებისთვის ამ კონფიდენციალურობის პოლიტიკის შესაბამისად. თქვენ ასევე აღიარებთ, რომ ამ ქვეყნებს შეიძლება არ ჰქონდეს\n            მონაცემთა დაცვის იგივე კანონები. თქვენ უფლება გაქვთ ნებისმიერ დროს უკან წაიღოთ თქვენი თანხმობა, რისთვისაც შეგიძლიათ\n            დაგვიკავშირდეთ.\n        </p>\n\n        <h2 class=\"head\">უსაფრთხოება</h2>\n        <p>\n            ჩვენ ვიყენებთ ინფორმაციას, რომელიც დაგეხმარებათ ჩვენი მომსახურების უსაფრთხოებისა და საიმედოობის გაუმჯობესებაში. ეს მოიცავს\n            თაღლითობის, ბოროტად გამოყენების, უსაფრთხოების რისკებისა და ტექნიკური საკითხების გამოვლენას, თავიდან აცილებასა\n            და რეაგირებას, რამაც შესაძლოა ზიანი მიაყენოს საქართველოს წიგნს, ჩვენს წევრებსა და საზოგადოებას.\n            <br> ჩვენ დაუღალავად ვისწრაფვით, გარანტია მოგცეთ, რომ თქვენი ინფორმაცია დაცულია. არასანქცირებული წვდომისა და გამჟღავნების\n            თავიდან ასაცილებლად, ჩვენ გამოვიყენეთ შესაბამისი ფიზიკური, ელექტრონული და საორგანიზაციო პროცედურები, რათა უზრუნველვყოთ\n            ჩვენ მიერ ონლაინ შეგროვებული ინფორმაციის დაცვა და უსაფრთხოება.\n            <br> კონფიდენციალურობისადმი ჩვენი ვალდებულების შესაბამისად, ჩვენ გამოვიყენეთ შესაბამისი ტექნიკური და ორგანიზაციული\n            ზომები, რაც დაგვეხმარება, მოგცეთ გარანტია, რომ ჩვენ მიერ შეგროვებული პირადი მონაცემები დაცულია და სათანადოდ გამოყენებული.\n            <br> რადგან ჩვენ არ შეგვიძლია მოგცეთ გარანტია, რომ არ მოხდება ინფორმაციის დაკარგვა, ბოროტად გამოყენება ან შეცვლა\n            ჩვენ ვცდილობთ თავიდან ავიცილოთ ასეთი შემთხვევები. ჩვენ არ გაძლევთ გარანტიას არც ვაცხადებთ, რომ თქვენი ანგარიში\n            ან თქვენი ინფორმაცია დაცული იქნება დაკარგვის, მესამე პირის მიერ ბოროტად გამოყენების ან შეცვლის წინააღმდეგ.\n        </p>\n\n        <h2 class=\"head\">ბავშვთა კონფიდენციალურობის უფლებები</h2>\n        <p>\n            ეს ვებ-გვერდი არ არის 13 წლამდე ინდივიდუალური პირებისთვის და ჩვენ მოვითხოვთ, რომ ასეთმა პირებმა არ მოგვაწოდოს პირადი ინფორმაცია.\n            დამატებით, ჩვენ შეგნებულად არ ვაგროვებთ და არც ვინახავთ 13 წლამდე ნებისმიერი პირის მიერ მოწოდებულ პირად ინფორმაციას.\n            თუ გავაცნობიერებთ, რომ 13 წლამდე ბავშვმა მოგვაწოდა პირადი ინფორმაცია, ჩვენ წავშლით ამ ინფორმაციას ჩვენი ფაილებიდან.\n        </p>\n        <h2 class=\"head\">\n            განახლებასთან დაკავშირებული შეტყობინება\n        </h2>\n        <p>\n            დროდადრო, ჩვენ ვანახლებთ ამ კონფიდენციალურობის პოლიტიკას. ჩვენ შეგატყობინებთ ამ კონფიდენციალურობის პოლიტიკაში ცვლილებების\n            შესახებ ჩვენს ვებ-გვერდზე შეტყობინების განთავსებით. ჩვენ გირჩევთ, პერიოდულად შეამოწმოთ და გადახედოთ ამ პოლიტიკას,\n            რათა თქვენ ყოველთვის იცოდეთ ჩვენი ამჟამინდელი მონაცემთა დაცვის პრაქტიკას.\n        </p>\n\n        <h2>როგორ დაგვიკავშირდეთ:</h2>\n        <p>\n            თუ გაქვთ რამე შეკითხვები ან კომენტარები ამ პოლიტიკის შესახებ, გთხოვთ დაგვიკავშირდეთ ელექტრონული ფოსტით მისამართზე: office@windfors.ge\n        </p>\n\n        <p>\n            <strong>ბოლო განახლება: </strong>29.06.2018\n        </p>\n    </div>\n</div>\n<about-footer />\n"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyController = function () {
	    function PrivacyController($scope, $window) {
	        (0, _classCallCheck3.default)(this, PrivacyController);
	
	        this.name = 'privacy';
	
	        this.$scope = $scope;
	        this.$window = $window;
	    }
	
	    (0, _createClass3.default)(PrivacyController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$window.scrollTo(0, 0);
	
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.language = localStorage.getItem('tourists_lang') || 'EN';
	                }
	            });
	        }
	    }]);
	    return PrivacyController;
	}();
	
	PrivacyController.$inject = ['$scope', '$window'];
	
	exports.default = PrivacyController;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(929);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./privacy.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./privacy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".privacy{display:flex;align-items:center;justify-content:center;padding-bottom:90px}.privacy .info{font-family:Graphik-Regular;width:350px;overflow-y:scroll;padding-top:25px;padding-bottom:25px;text-align:justify}.privacy .info::-webkit-scrollbar{display:none}.privacy .info h2{font-size:21px;margin:20px 0}.privacy .info p{font-size:15px}.privacy .info ul{margin:10px 18px}.privacy.geo .info{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _terms = __webpack_require__(931);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var termsModule = _angular2.default.module('terms', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	    "ngInject";
	
	    $stateProvider.state('terms', {
	        url: '/terms',
	        component: 'terms'
	    });
	}]).component('terms', _terms2.default).name;
	
	exports.default = termsModule;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _terms = __webpack_require__(932);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _terms3 = __webpack_require__(933);
	
	var _terms4 = _interopRequireDefault(_terms3);
	
	__webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var termsComponent = {
	    bindings: {},
	    template: _terms2.default,
	    controller: _terms4.default
	};
	
	exports.default = termsComponent;

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports = "<navbar></navbar>\n<div class=\"terms container-fluid\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <div class=\"info col-xs-12 col-md-8\" ng-if=\"$ctrl.language === 'EN'\">\n        <p>\n            Please, read these terms of use (hereinafter “terms”, “terms of use” or “Agreement”) carefully. They affect your legal rights\n            and obligations and include waivers of rights, limitations of liability and your indemnity to us.\n        </p>\n        <h2>Terms of Use</h2>\n        <p>\n            This website is operated on the behalf of Georgian National Tourism Administration and contains information about Georgia\n            by using tourist’s public posts, which expresses impressions about Georgian wine and food, nature and adventure,\n            history and culture.\n        </p>\n        <h2>About Us</h2>\n        <p>\n            The Content can be used for general information, discussion and entertainment purposes only. The term “Content” includes,\n            without limitation, information, data, text, photographs,, written posts and interactive features generated,\n            provided, or otherwise made available through or in connection with the website. We agree to provide you with\n            the Digital Service (the “Service”). The Service includes all of the Book of Georgia’s products, features we\n            provide to advance Book of Georgia’s mission - to bring you closer to Georgia. In connection with your access\n            to use the Digital Services, we may obtain information from or about you. We will use your information in accordance\n            with our Privacy Policy, which describes our privacy practices as well as choices you may have with respect to\n            the collection and processing of some of your information. Please take a moment to review our Privacy Policy.\n            The Privacy Policy is incorporated into this Agreement and forms part of the Agreement.\n        </p>\n        <h2>Your Representations</h2>\n        <p>\n            You represent and warrant that you have read, understand, and agree to abide by these Terms and that you have read, understand,\n            and agree to the data collection and use practices set forth in our Privacy Policy.\n        </p>\n        <h2>Offering Personalized Opportunities to Discover</h2>\n        <p>We want to strengthen your relationships through shared experiences you actually care about. So we made the digital\n            book of Georgia to help you find, join and share in experiences that matter to you.\n        </p>\n        <h2>The Data Policy</h2>\n        <p>\n            Providing our Service requires collecting and using your information. The Privacy Policy explains how we collect, use and\n            share information. It also explains the many ways you can control your information. You shall agree to the Privacy\n            Policy to use Book of Georgia’s digital service.\n        </p>\n        <h2>Your Commitments</h2>\n        <p>In return for our commitment to provide the Service, we require you to acknowledge the commitments below. </p>\n\n        <h2>Who Can Use Book of Georgia’s Service</h2>\n        <p>\n            We want our Service to be as open and inclusive as possible, but we also want it to be safe, secure and in accordance with\n            the Georgian legislation. Therefore, we need you to follow few restrictions in order to be part of the Book of\n            Georgia’s community:\n            <ul>\n                <li>You must be at least 13 years old.</li>\n                <li>You must not be prohibited to receive any aspect of our Service under Georgian law.</li>\n                <li>You must not be a convicted sex offender.</li>\n            </ul>\n        </p>\n        <h2>Fees</h2>\n        <p>\n            There are NO minimum fees to use Book of Georgia’s content for visitors or contributors.\n        </p>\n        <h2>Fraud</h2>\n        <p>\n            Book of Georgia may suspend or terminate your account if We suspect that you have engaged in fraudulent activity in connection\n            with our Site, as determined in our sole discretion. Fraudulent acts include, but are not limited to, the manipulation\n            of the Rating System.\n        </p>\n        <h2>How You Can't Use Book of Georgia’s Digital Service</h2>\n        <p>\n            Your access and use of the Digital Services and Content is for personal and noncommercial purposes only. The rights granted\n            to you in this Agreement are subject to the following restrictions:\n            <ul>\n                <li>You may not either directly or through the use of any computer, tablet, phone or other device (each a “Device”)\n                    or other means (including the use of a browser, software, program or code), remove, alter, interfere\n                    with or circumvent (i) any copyright, trademark, or other proprietary notices marked on the Digital Services\n                    or Content, or (ii) any digital rights management mechanism, device, or other content protection or access\n                    control measure associated with the Digital Services or Content. You may not modify, make derivative\n                    works of, disassemble, reverse compile or reverse engineer any part of the Digital Services (including\n                    any code used in any software) or Content.\n                </li>\n                <li>\n                    You may not either directly or through the use of a Device or other means copy, download, stream, reproduce, duplicate, archive,\n                    distribute, upload, publish, modify, translate, broadcast, perform, display, sell, transmit or retransmit\n                    the Digital Services or Content unless expressly permitted by us in writing. You may not incorporate\n                    the Digital Services or Content into, or stream or retransmit the Digital Services or Content via, any\n                    hardware or software application or make the Digital Services or any Content available via frames or\n                    in-line links, and you may not otherwise surround or obfuscate the Digital Services or Content with any\n                    third-party content, materials or branding. You may also not use any software robots, spider, crawlers,\n                    or other data gathering or extraction tools, whether automated or manual, to access, acquire, copy, monitor,\n                    scrape or aggregate the Digital Services, Content or any portion thereof. You may not knowingly or intentionally\n                    take any action that may impose an unreasonable burden or load on the Digital Services or its servers\n                    and infrastructures.\n\n                </li>\n                <li>\n                    You may not build a business, in whole or in part, resell, redistribute, recirculate or make any other commercial use of,\n                    or create derivative works or materials utilizing any portion of the Digital Services (Including any\n                    code used in any software) or Content, whether or not for profit.\n                </li>\n                <li>\n                    You can't impersonate others or provide inaccurate information. You don't have to disclose your identity, but you must provide\n                    us with accurate and up to date information (including registration information). Also, you may not impersonate\n                    someone you aren't, and you can't create an account for someone else unless you have express permission.\n                </li>\n                <li>\n                    You can't do anything unlawful, misleading, or fraudulent or for an illegal or unauthorized purpose.\n\n                </li>\n                <li>\n                    You can't violate (or help or encourage others to violate) these Terms or our privacy policy.\n                </li>\n                <li>\n                    You can't do anything to interfere with or impair the intended operation of the Service.\n\n                </li>\n                <li>\n                    You can't attempt to create accounts or access or collect information in unauthorized ways. This includes creating accounts\n                    or collecting information in an automated way without our express permission.\n                </li>\n            </ul>\n        </p>\n        <h2>License and Ownership</h2>\n        <p>Any and all intellectual property rights (\"Intellectual Property\") associated with the website and its Contents (the\n            \"Content\") are the sole property of Book of Georgia the Content is protected by copyright and other laws in both\n            the Georgia and other countries. Elements of the website are also protected by trademark, trade secret, unfair\n            competition, and other laws and may not be copied or imitated in whole or in part. All custom graphics, icons,\n            and other items that appear on the Website are trademarks, service marks or trade dress (\"Marks\") of book of\n            Georgia, its affiliates or other entities that have granted book of Georgia the right and license to use such\n            Marks and may not be used or interfered with in any manner without the express written consent of book of Georgia.\n        </p>\n        <h2>Who Is Responsible If Something Happens</h2>\n        <p>\n            Our responsibility for anything that happens on the Service (also called \"liability\") is limited as much as the law will\n            allow. If there is an issue with our Service, we can't know what all the possible impacts might be. You agree\n            that we won't be responsible (\"liable\") for any lost profits, revenues, information, or data, or consequential,\n            special, indirect, exemplary, punitive, or incidental damages arising out of or related to these Terms, even\n            if we know they are possible. This includes when we delete your content, Information, or account.\n        </p>\n        <h2>Validity of These Terms</h2>\n        <p>\n            If any part or provision of these Terms is found to be unlawful or unenforceable, this shall not affect the validity of any\n            other part or provision.\n        </p>\n        <h2>How We will Handle Disputes</h2>\n        <p>\n            Relations are regulated in accordance to the active Georgian legislation. In case of occurrence of any dispute, consideration\n            of disputes is carried out by the Tbilisi City Court.\n        </p>\n        <h2>Updating These Terms</h2>\n        <p>\n            We may change our Service and we may need to make changes to these Terms so that they accurately reflect our Service and\n            policies. Unless otherwise required by law, we will notify you (for example, through our Service) about the changes\n            to these Terms, which will enter into force without your prior confirmation. We advise you to review these Terms\n            from time to time and if you do not want to use our Service on the basis of any updated Terms. We can remove\n            images from the website if they (contributors/owners) email us at office@windfors.ge\n        </p>\n    </div>\n\n    <div class=\"info col-xs-12 col-md-8\" ng-if=\"$ctrl.language === 'GE'\">\n        <p>\n            გთხოვთ, ყურადღებით წაიკითხოთ გამოყენების პირობები (შემდგომში „პირობები“, „გამოყენების პირობები“ ან „ხელშეკრულება“). ისინი\n            მოქმედებს იურიდიულ უფლებებსა და ვალდებულებებს და მოიცავს უფლებებზე უარის თქმას, ვალდებულებების შეზღუდვასა და\n            თქვენს გარანტიას ჩვენს მიმართ.\n        </p>\n        <h2>გამოყენების პირობები</h2>\n        <p>\n            ვებ-გვერდის მართვა ხდება საქართველოს ტურიზმის ეროვნული ადმინისტრაციის სახელით და შეიცავს ინფორმაციას საქართველოს შესახებ,\n            ტურისტების სახალხო პოსტების გამოყენებით, რომელიც გამოხატავს შთაბეჭდილებებს ქართული ღვინისა და საკვების, ბუნებისა\n            და თავგადასავლის, ისტორიისა და კულტურის შესახებ.\n        </p>\n        <h2>ჩვენ შესახებ</h2>\n        <p>\n            კონტენტის გამოყენება შეიძლება ზოგადი ინფორმაციის, განხილვისა და გართობის მიზნებისთვის. ტერმინი „კონტენტი“ მოიცავს, შეზღუდვის\n            გარეშე, ინფორმაციას, მონაცემებს, ტექსტებს, ფოტოსურათებს, წერილობით პოსტებსა და ინტერაქტიულ ფუნქციებს, რომელიც\n            წარმოშობილია, მოწოდებულია ან სხვაგვარად არის ხელმისაწვდომი ვებ-გვერდის მეშვეობით ან მასთან დაკავშირებით. ჩვენ\n            თანახმა ვართ, გაგიწიოთ ციფრული მომსახურება („მომსახურება“). მომსახურება მოიცავს საქართველოს გზამკვლევის ყველა\n            პროდუქტს, ფუნქციას, რომელსაც ჩვენ წინასწარ მოგაწვდით საქართველოს წიგნის მისიისთვის - რათა უფრო დაგაახლოვოთ საქართველოს.\n            თქვენს ციფრულ მომსახურების გამოყენების ხელმისაწვდომობასთან დაკავშირებით, ჩვენ შეგვიძლია მოვიპოვოთ ინფორმაცია\n            თქვენგან და თქვენს შეახებ. ჩვენ გამოვიყენებთ თქვენს ინფორმაციას ჩვენი კონფიდენციალურობის პოლიტიკის შესაბამისად,\n            რომელიც გულისხმობს ჩვენი კონფიდენციალურობის დაცვის პრაქტიკას, ასევე არჩევანს, რომელიც შეიძლება გქონდეთ გარკვეული\n            ინფორმაციის შეგროვებასთან და დამუშავებასთან მიმართებაში. გთხოვთ, გამოყავით დრო ჩვენი კონფიდენციალურობის პოლიტიკის\n            გადასახედად. კონფიდენციალურობის პოლიტიკა შედის წინამდებარე ხელშეკრულებაში და შეადგენს წინამდებარე ხელშეკრულების\n            ნაწილს.\n        </p>\n        <h2>თქვენი პრეზენტაციები</h2>\n        <p>\n            თქვენ წარმოადგენთ და გარანტიას გვაძლევთ, რომ წაიკითხეთ, გაიგეთ და ეთანხმებით დაიცვათ ეს პირობები და რომ თქვენ წაიკითხეთ,\n            გაიგეთ და ეთანხმებით მონაცემების შეგროვებას და გამოყენების პრაქტიკას, რაც დადგენილია ჩვენს კონფიდენციალურობის\n            პოლიტიკაში.\n        </p>\n        <h2>პერსონალური შესაძლებლობების შეთავაზება აღმოჩენებისთვის</h2>\n        <p>\n            ჩვენ გვსურს გავაძლიეროთ თქვენი ურთიერთობები გაზიარებული გამოცდილების მეშვეობით, რომლის მიმართ არ ხართ გულგრილი. ამიტომ ჩვენ\n            შევადგინეთ საქართველოს ციფრული წიგნი, რომელიც დაგეხმარებათ გამოცდილებების მოძიებაში, გაწევრიანებასა და გაზიარებაში,\n            რომელიც თქვენთვის მნიშვნელოვანია.\n        </p>\n        <h2>მონაცემთა მართვის პოლიტიკა.</h2>\n        <p>\n            ჩვენი მომსახურების მოწოდება მოითხოვს თქვენი ინფორმაციის შეგროვებასა და გამოყენებას. კონფიდენციალურობის პოლიტიკა განმარტავს,\n            თუ როგორ ვაგროვებთ, ვიყენებთ და ვაზიარებთ ინფორმაციას. ის ასევე განმარტავს მრავალ გზას, თუ როგორ შეგიძლიათ თქვენი\n            ინფორმაციის კონტროლი. თქვენ უნდა დაეთანხმოთ ჩვენს კონფიდენციალურობის პოლიტიკას, რათა შეძლოთ საქართველოს წიგნის\n            ციფრული მომსახურებით სარგებლობა.\n        </p>\n        <h2>თქვენი ვალდებულებები</h2>\n        <p>\n            ჩვენი ვალდებულების სანაცვლოდ, გაგიწიოთ მომსახურება, ჩვენ გთხოვთ, გაითვალისწინოთ ქვემოთ მოცემული ვალდებულებები.\n        </p>\n\n        <h2>ვის შეუძლია საქართველოს წიგნის გამოყენება</h2>\n        <p>\n            ჩვენ გვსურს, რომ ჩვენი მომსახურება იყოს რამდენადაც შესაძლებელია ღია და ინკლუზიური, მაგრამ ჩვენ ასევე გვსურს, რომ ის იყოს\n            უსაფრთხო, დაცული და შეესაბამებოდეს საქართველოს კანონმდებლობას. ამიტომ, თქვენ უნდა დაიცვათ რამდენიმე შეზღუდვა,\n            რათა გახდეთ საქართველოს წიგნის თემის ნაწილი:\n            <ul>\n                <li>თქვენ უნდა იყოთ სულ მცირე 13 წლის.</li>\n                <li>თქვენთვის არ უნდა იყოს აკრძალული მომსახურების მიღება ნებისმიერ ასპექტში საქართველოს კანონის შესაბამისად.</li>\n                <li>თქვენ არ უნდა იყოთ ნასამართლევი სექსუალური ძალადობისთვის.</li>\n            </ul>\n        </p>\n        <h2>მოსაკრებელი</h2>\n        <p>\n            საქართველოს წიგნის მონაწილეებისა და სტუმრებისათვის არ არის დაწესებული მოსაკრებელი.\n        </p>\n        <h2>თაღლითობა</h2>\n        <p>\n            საქართველოს წიგნს შეუძლია შეაჩეროს ან გააუქმოს თქვენი ანგარიში, თუ ეჭვს ავიღებთ, რომ თქვენ ჩართული ხართ თაღლითურ საქმიანობაში\n            ჩვენს ვებ-გვერდთან დაკავშირებით, ჩვენი შეხედულებისამებრ. თაღლითური ქმედება მოიცავს, მაგრამ არ არის შეზღუდული,\n            რეიტინგის სისტემის მანიპულაციას.\n        </p>\n        <h2>როგორ ვერ გამოიყენებთ საქართველოს წიგნის ციფრულ მომსახურებას</h2>\n        <p>\n            თქვენ გაქვთ წვდომა და იყენებთ ციფრულ მომსახურებასა და კონტენტს მხოლოდ პირადი და არაკომერციული მიზნებისთვის. წინამდებარე ხელშეკრულებით\n            თქვენთვის მინიჭებული უფლებები ექვემდებარება შემდეგ შეზღუდვებს:\n            <ul>\n                <li>\n                    თქვენ არ შეგიძლიათ პირდაპირ ან ნებისმიერი კომპიუტერის, ტაბლეტის, ტელეფონის ან სხვა მოწყობილობის მეშვეობით (თითოეული „მოწყობილობა“)\n                    ან სხვა საშუალებით (ბრაუზერის, პროგრამული უზრუნველყოფის, პროგრამის ან კოდის ჩათვლით) წაშალოთ (i) ნებისმიერი\n                    საავტორო უფლება, სავაჭრო ნიშანი ან სხვა საკუთრების შენიშვნა, რომელიც დატანებულია ციფრულ მომსახურებაზე\n                    ან კონტენტზე, ან (ii) ნებისმიერი ციფრული უფლებების მართვის მექანიზმი, მოწყობილობა, ან სხვა კონტენტის\n                    დაცვა ან წვდომა რეგულაციის ღონისძიებებზე, რომელიც ასოცირებულია ციფრულ მომსახურებასთან ან კონტენტთან,\n                    შეცვალოთ, ჩაერიოთ ან გვერდი აუაროთ. თქვენ არ შეგიძლიათ შეცვალოთ ციფრული მომსახურების ნებისმიერი ნაწილი\n                    (ნებისმიერ პროგრამაში ნებისმიერი გამოყენებული კოდის ჩათვლით), აწარმოოთ სამუშაოები მასზე, განახორციელოთ\n                    მისი დაშლა, დეკომპილირება ან დემონტაჟი.\n                </li>\n                <li>\n                    თქვენ არ შეგიძლიათ პირდაპირ ან მოწყობილობის გამოყენებით ან სხვა საშუალებით გააკეთოთ ასლი, ჩამოტვირთოთ, პირდაპირ გადასცეთ,\n                    აღადგინოთ, გააკეთოთ ასლი, დააარქივოთ, გაავრცელოთ, ატვირთოთ, გამოაქვეყნოთ, შეცვალოთ, თარგმნოთ, განახორციელოთ\n                    ტრანსლაცია, შეასრულოთ, აჩვენოთ, გაყიდოთ, გადასცეთ რადიოთი ან განმეორებით გადასცეთ ციფრული მომსახურება\n                    ან კონტენტი, თუ პირდაპირ არ არის ნებადართული ჩვენ მიერ წერილობით. თქვენ არ შეგიძლიათ გააერთიანოთ ციფრული\n                    მომსახურება ან კონტენტი, ან პირდაპირ ან განმეორებით გადასცეთ ციფრული მომსახურება ან კონტენტი ნებისმიერი\n                    აპარატურული ან პროგრამული უზრუნველყოფის აპლიკაციის მეშვეობით, ან ხელმისაწვდომი გახადოთ ციფრული მომსახურება\n                    ან კონტენტი მონაცემთა ბლოკის ან მიერთებული ბმულების მეშვეობით, და თქვენ არ შეგიძლიათ სხვაგვარად მოაწყოთ\n                    ან გაართულოთ ციფრული მომსახურება ან კონტენტი მესამე მხარის კონტენტით, მასალით ან ბრენდინგით. თქვენ ასევე\n                    არ შეგიძლიათ გამოიყენოთ ნებისმიერი გადაპროგრამირების რობოტები, ობობა-რობოტები, საძიებო რობოტები, ან სხვა\n                    მონაცემების შემგროვებელი და მომპოვებელი ხელსაწყოები, ავტომატური თუ მექანიკური, რათა წვდომა გქონდეთ ციფრულ\n                    მომსახურებაზე, კონტენტზე ან ნებისმიერ მათ ნაწილზე, შეიძინოთ, გააკეთოთ მათი ასლი, განახორციელოთ მონიტორინგი,\n                    გაწმინდოთ ან გააერთიანოთ ისინი. თქვენ არ შეგიძლიათ განზრახ ან შეგნებულად შეასრულოთ მოქმედება, რამაც შეიძლება\n                    გამოიწვიოს არამიზანშეწონილი ტვირთი ან დატვირთვა ციფრულ მომსახურებაზე ან მის სერვერებსა და ინფრასტრუქტურაზე.\n                </li>\n                <li>\n                    თქვენ არ შეგიძლიათ შექმნათ ბიზნესი, მთლიანადz ან ნაწილობრივ, ხელახლა გაყიდოთ, გაავრცელოთ, ჩაწეროთ ან გამოიყენოთ სხვა კომერციული\n                    მიზნებისთვის, ან შექმნათ საწარმოო სამუშაოები ან მასალები ციფრული მომსახურების (პროგრამულ უზრუნველყოფაში\n                    გამოყენებული ნებისმიერი კოდის ჩათვლით) ან კონტენტის რომელიმე ნაწილის გამოყენებით, იმის მიუხედავად სარგებლისთვის\n                    თუ არა.\n                </li>\n                <li>\n                    თქვენ არ შეგიძლიათ სხვების იმიტაცია ან არასწორი ინფორმაციის მიწოდება. თქვენ არ უნდა გაამჟღავნოთ თქვენი პიროვნება, მაგრამ\n                    უნდა მოგვაწოდოთ ზუსტი და უახლესი ინფორმაცია (რეგისტრაციის ინფორმაციის ჩათვლით). აგრეთვე, თქვენ გეკრძალებათ\n                    თავის წარმოდგენა იმ პირად, ვინც არ ბრძანდებით, და თქვენ ვერ შექმნით ანგარიშს სხვისთვის, თუ არ გაქვთ ოფიციალური\n                    ნებართვა.\n                </li>\n                <li>\n                    თქვენ გეკრძალებათ რამე კანონსაწინააღმდეგო, შეცდომაში შემყვანი ან თაღლითური ქმედება ან არალეგალური ან არაავტორიზებული მიზნებისთვის.\n                </li>\n                <li>\n                    თქვენ ვერ დაარღვევთ (ვერ დაეხმარებით, ვერ წააქეზებთ სხვებს დაარღვიონ) წინამდებარე პირობებს ან ჩვენი კონფიდენციალურობის პოლიტიკა.\n                </li>\n                <li>\n                    თქვენ ვერ გააკეთებთ ვერაფერს, რათა ჩაერიოთ ან ჩაშალოთ მომსახურების დაგეგმილი ოპერაცია.\n                </li>\n                <li>\n                    თქვენ ვერ შექმნით ანგარიშებს ან გქონდეთ წვდომა ან შეაგროვოთ ინფორმაცია არაავტორიზებული გზებით. ეს მოიცავს ანგარიშების შექმნას\n                    ან ინფორმაციის შეგროვებას ავტომატური გზით ჩვენი ოფიციალური ნებართვის გარეშე.\n                </li>\n            </ul>\n        </p>\n        <h2>ლიცენზია და საკუთრება</h2>\n        <p>\n            ნებისმიერი ინტელექტუალური საკუთრების უფლებები („ინტელექტუალური საკუთრება“), რომელიც ასოცირებულია ვებ-გვერდთან და მის კონტენტთან\n            („კონტენტი“) არის საქართველოს წიგნის საკუთრება. კონტენტი დაცულია საავტორო უფლებით და როგორც საქართველოში, ასევე\n            საზღვარგარეთ მოქმედი კანონებით. ვებ-გვერდის ელემენტები დაცულია სავაჭრო ნიშნით, სავაჭრო საიდუმლოთი, უსამართლო\n            შეჯიბრებით და სხვა კანონებით, და შეიძლება არ მოხდეს მათი კოპირება ან იმიტაცია მთლიანად ან ნაწილობრივ. ყველა პირადი\n            ნახატი, პიქტოგრამა, და სხვები, რომელიც ჩანს ვებ-გვერდზე არის საქართველოს წიგნის სავაჭრო ნიშნები, მომსახურების\n            ნიშნები ან სავაჭრო გაფორმება („ნიშნები“), მისი ფილიალები ან სხვა ერთეულები, რომელსაც საქართველოს წიგნმა მიანიჭა\n            უფლება და ლიცენზია, გამოიყენოს ამგვარი ნიშნები და არ შეიძლება გამოიყენოთ ან ხელი შეუშალოთ ნებისმიერი გზით საქართველოს\n            წიგნის წერილობითი ოფიციალური თანხმობის გარეშე.\n        </p>\n        <h2>ვინ არის პასუხისმგებელი, თუ რამე მოხდება</h2>\n        <p>\n            ჩვენი პასუხისმგებლობა, თუ რამე მოხდება მომსახურებაზე (ასევე „ვალდებულება“) შეზღუდულია იმდენად, რამდენადაც კანონი ამას ნებას\n            რთავს. თუ არის რამე საკითხი ჩვენს მომსახურებასთან დაკავშირებით, ჩვენ არ ვიცით, რა შესაძლო ზემოქმედება შეიძლება\n            ჰქონდეს მას. თქვენ თანახმა ხართ, რომ ჩვენ ვერ ვიქნებით პასუხისმგებელი („ვალდებული“) ნებისმიერი დაკარგული მოგებისთვის,\n            შემოსავლებისთვის, ინფორმაციისთვის ან მონაცემებისთვის ან თანმიმდევრული, სპეციალური, არაპირდაპირი, დამსჯელი, საჯარიმო\n            ან შემთხვევითი ზარალისთვის, რომელიც წარმოიშობა ამ პირობების გამო ან დაკავშირებულია მათთან, მაშინაც თუ ჩვენ ვიცით,\n            რომ ისინი შესაძლებელია. ეს ასევე გულისხმობს, რომ ჩვენ ვშლით თქვენს კონტენტს, ინფორმაციას ან ანგარიშს.\n        </p>\n        <h2>ამ პირობების ვადა</h2>\n        <p>\n            თუ ამ პირობების რომელიმე დებულება არაკანონიერია ან არ აქვს იურიდიული ძალა, ამან შეიძლება არ იმოქმედოს ნებისმიერი სხვა ნაწილის\n            ან დებულების კანონიერებაზე.\n        </p>\n        <h2>როგორ მოვაგვარებთ დავებს</h2>\n        <p>\n            ურთიერთობები რეგულირდება საქართველოს კანონმდებლობის შესაბამისად. ნებისმიერი დავის წარმოშობის შემთხვევაში დავის განხილვა ხდება\n            თბილისის საქალაქო სასამართლოს მიერ.\n        </p>\n        <h2>ამ პირობების განახლება</h2>\n        <p>\n            ჩვენ შეიძლება შევცვალოთ ჩვენი მომსახურება და შეიძლება დაგვჭირდეს ამ პირობების ცვლილება ისე, რომ ისინი ზუსტად ასახავდეს ჩვენი\n            მომსახურებასა და პოლიტიკას. თუ კანონით სხვაგვარად არ არის დადგენილი, ჩვენ შეგატყობინებთ (მაგალითად, ჩვენი მომსახურების\n            მეშვეობით) ამ პირობების ცვლილებების შესახებ, რომელიც ძალაში შევა თქვენი წინასწარი დადასტურების გარეშე. ჩვენ გირჩევთ\n            დროდადრო გადახედოთ ამ პირობებს და თუ თქვენ არ გსურთ ჩვენი მომსახურების გამოყენება განახლებული პირობების საფუძველზე,\n            ჩვენ შეგვიძლია წავშალოთ სურათები ვებ-გვერდიდან, თუ ისინი (მონაწილეები/მფლობელები) მოგვწერენ ელ. ფოსტაზე office@windfors.ge\n        </p>\n    </div>\n</div>\n<about-footer />\n"

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsController = function () {
	    function TermsController($scope, $window) {
	        (0, _classCallCheck3.default)(this, TermsController);
	
	        this.name = 'terms';
	
	        this.$scope = $scope;
	        this.$window = $window;
	    }
	
	    (0, _createClass3.default)(TermsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.$window.scrollTo(0, 0);
	
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.language = localStorage.getItem('tourists_lang') || 'EN';
	                }
	            });
	        }
	    }]);
	    return TermsController;
	}();
	
	TermsController.$inject = ['$scope', '$window'];
	
	exports.default = TermsController;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(935);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./terms.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./terms.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".terms{display:flex;align-items:center;justify-content:center}.terms .info{font-family:Graphik-Regular;width:350px;overflow-y:scroll;padding-top:25px;padding-bottom:25px;text-align:justify}.terms .info::-webkit-scrollbar{display:none}.terms .info h2{font-size:21px;margin:20px 0}.terms .info p{font-size:15px}.terms .info ul{margin:10px 18px}.terms.geo .info{font-family:Georgian-Regular}", ""]);
	
	// exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(333);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(345);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _cookies = __webpack_require__(937);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookiesModule = _angular2.default.module('cookies', [_angularUiRouter2.default]).component('cookies', _cookies2.default).name;
	
	exports.default = cookiesModule;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookies = __webpack_require__(938);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _cookies3 = __webpack_require__(939);
	
	var _cookies4 = _interopRequireDefault(_cookies3);
	
	__webpack_require__(941);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookiesComponent = {
	  bindings: {},
	  template: _cookies2.default,
	  controller: _cookies4.default
	};
	
	exports.default = cookiesComponent;

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"cookies\" ng-if=\"$ctrl.showMessage\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <span>{{$ctrl.DESCRIPTIONS[0]}}\n        <a href=\"/privacy-policy#cookies\">{{$ctrl.DESCRIPTIONS[1]}}</a>\n    </span>\n    <button ng-click=\"$ctrl.gotIt()\">\n        <span>{{$ctrl.BUTTON}}</span>\n    </button>\n</div>\n"

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(431);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(432);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cookies = __webpack_require__(940);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CookiesController = function () {
	    function CookiesController($scope) {
	        (0, _classCallCheck3.default)(this, CookiesController);
	
	        this.name = 'cookies';
	
	        this.$scope = $scope;
	    }
	
	    (0, _createClass3.default)(CookiesController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (!localStorage.getItem('agreed_cookies')) {
	                this.showMessage = true;
	            }
	
	            this.render();
	
	            this.watchLanguage();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            this.language = localStorage.getItem('tourists_lang') || 'EN';
	
	            var _texts$language = _cookies2.default[this.language],
	                BUTTON = _texts$language.BUTTON,
	                DESCRIPTIONS = _texts$language.DESCRIPTIONS;
	
	
	            this.BUTTON = BUTTON;
	            this.DESCRIPTIONS = DESCRIPTIONS;
	        }
	    }, {
	        key: 'gotIt',
	        value: function gotIt() {
	            localStorage.setItem('agreed_cookies', true);
	            this.showMessage = false;
	        }
	    }, {
	        key: 'watchLanguage',
	        value: function watchLanguage() {
	            var _this = this;
	
	            this.$scope.$watch(function () {
	                return localStorage.getItem('tourists_lang');
	            }, function (newValue, oldValue) {
	                if (newValue && newValue !== oldValue) {
	                    _this.render();
	                }
	            });
	        }
	    }]);
	    return CookiesController;
	}();
	
	CookiesController.$inject = ['$scope'];
	
	exports.default = CookiesController;

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        BUTTON: 'გაგრძელება',
	        DESCRIPTIONS: ['ეს ვებ გვერდი იყენებს Cookies-ს. ამ საიტზე ყოფნით თქვენ ეთანხმებით ჩვენ მიერ', 'Cookies გამოყენებას.']
	    },
	    EN: {
	        BUTTON: 'Got it',
	        DESCRIPTIONS: ['This site uses cookies. By continuing to browse the site, you are agreeing to our', 'use of cookies']
	    }
	};
	
	exports.default = json;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(942);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cookies.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cookies.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, ".cookies{position:fixed;width:calc(100% - 20px);bottom:0;padding:10px;z-index:15;font-size:13px;font-family:Graphik;font-weight:700;color:#fff;background-color:rgba(30,30,30,.8);display:flex;justify-content:center;align-items:center}.cookies span a{display:inline-block;color:#fff}.cookies button{margin-left:10px;min-width:95px;height:30px;background-color:#90dc19;border:0;border-radius:7px;font-family:Graphik-Regular;font-size:13px;color:#fff;outline:0}.cookies button:hover{background-color:#72ae14}.cookies.geo,.cookies.geo button{font-family:Georgian-Regular}.cookies.geo button span{position:relative;top:-1px}", ""]);
	
	// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(944);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(945);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <div ui-view></div>\n</div>\n"

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(946);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(340)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(339)();
	// imports
	
	
	// module
	exports.push([module.id, "p,ul{margin:0;padding:0}ul{list-style:none}body{height:100%}@media only screen and (min-width:1500px){.hidden-custom-xl{display:none!important}.visible-custom-xl{display:block!important}.row.visible-custom-xl{display:-ms-flexbox!important;display:flex!important}.col-custom-xl{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.col-custom-xl-1{-ms-flex-preferred-size:8.333%;flex-basis:8.333%;max-width:8.333%}.col-custom-xl-2{-ms-flex-preferred-size:16.667%;flex-basis:16.667%;max-width:16.667%}.col-custom-xl-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-custom-xl-4{-ms-flex-preferred-size:33.333%!important;flex-basis:33.333%!important;max-width:33.333%!important}.col-custom-xl-5{-ms-flex-preferred-size:41.667%;flex-basis:41.667%;max-width:41.667%}.col-custom-xl-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-custom-xl-7{-ms-flex-preferred-size:58.333%;flex-basis:58.333%;max-width:58.333%}.col-custom-xl-8{-ms-flex-preferred-size:66.667%;flex-basis:66.667%;max-width:66.667%}.col-custom-xl-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-custom-xl-10{-ms-flex-preferred-size:83.333%;flex-basis:83.333%;max-width:83.333%}.col-custom-xl-11{-ms-flex-preferred-size:91.667%;flex-basis:91.667%;max-width:91.667%}.col-custom-xl-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-custom-xl-offset-1{margin-left:8.333%}.col-custom-xl-offset-2{margin-left:16.667%}.col-custom-xl-offset-3{margin-left:25%}.col-custom-xl-offset-4{margin-left:33.333%}.col-custom-xl-offset-5{margin-left:41.667%}.col-custom-xl-offset-6{margin-left:50%}.col-custom-xl-offset-7{margin-left:58.333%}.col-custom-xl-offset-8{margin-left:66.667%}.col-custom-xl-offset-9{margin-left:75%}.col-custom-xl-offset-10{margin-left:83.333%}.col-custom-xl-offset-11{margin-left:91.667%}}.visible-lg,.visible-md,.visible-sm,.visible-xs{display:none!important}@media (max-width:49em){.visible-xs{display:block!important}.row.visible-xs{display:-ms-flexbox!important;display:flex!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (min-width:49em) and (max-width:62em){.visible-sm{display:block!important}.row.visible-sm{display:-ms-flexbox!important;display:flex!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:62em) and (max-width:75em){.visible-md{display:block!important}.row.visible-md{display:-ms-flexbox!important;display:flex!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:75em){.visible-lg{display:block!important}.row.visible-lg{display:-ms-flexbox!important;display:flex!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (max-width:49em){.hidden-xs{display:none!important}}@media (min-width:49em) and (max-width:62em){.hidden-sm{display:none!important}}@media (min-width:62em) and (max-width:75em){.hidden-md{display:none!important}}@media (min-width:75em){.hidden-lg{display:none!important}}@font-face{font-family:Graphik-Black;src:url(\"/assets/fonts/Graphik-Black.otf\")}@font-face{font-family:Graphik-Bold;src:url(\"/assets/fonts/Graphik-Bold.otf\")}@font-face{font-family:Graphik;src:url(\"/assets/fonts/Graphik-Extralight.otf\")}@font-face{font-family:Graphik-Medium;src:url(\"/assets/fonts/Graphik-Medium.otf\")}@font-face{font-family:Graphik-Light;src:url(\"/assets/fonts/ueno-font.ttf\")}@font-face{font-family:Graphik-Regular;src:url(\"/assets/fonts/ueno-font2.ttf\")}@font-face{font-family:Graphik-Semibold;src:url(\"/assets/fonts/ueno-font3.ttf\")}@font-face{font-family:Nickainley-Normal;src:url(\"/assets/fonts/Nickainley-Normal.otf\")}@font-face{font-family:Myriad-Pro;src:url(\"/assets/fonts/Myriad-Pro.ttf\")}@font-face{font-family:Georgian-Black;src:url(\"/assets/fonts/NotoSansGeorgian-Black.ttf\")}@font-face{font-family:Georgian-Bold;src:url(\"/assets/fonts/NotoSansGeorgian-Bold.ttf\")}@font-face{font-family:Georgian;src:url(\"/assets/fonts/NotoSansGeorgian-ExtraCondensedExtraLight.ttf\")}@font-face{font-family:Georgian-Medium;src:url(\"/assets/fonts/NotoSansGeorgian-ExtraCondensedMedium.ttf\")}@font-face{font-family:Georgian-Light;src:url(\"/assets/fonts/NotoSansGeorgian-Light.ttf\")}@font-face{font-family:Georgian-Regular;src:url(\"/assets/fonts/NotoSansGeorgian-SemiCondensed.ttf\")}@font-face{font-family:Georgian-Semibold;src:url(\"/assets/fonts/NotoSansGeorgian-SemiCondensedBold.ttf\")}@font-face{font-family:Georgian-Pro;src:url(\"/assets/fonts/NotoSansGeorgian-SemiCondensedMedium.ttf\")}NotoSansGeorgian-Black.ttf *{margin:0;padding:0}.app{background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 947 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var json = {
	    GE: {
	        home: 'გაზიარებული ემოციები ',
	        about: 'კამპანიის შესახებ',
	        statistics: 'რიცხვები და ემოციები',
	        privacy: 'Privacy Policy',
	        terms: 'Terms of Use',
	        'home.contributor.step2': 'სერთიფიკატი',
	        'home.book.bookStep3': 'გზამკვლევი'
	    },
	    EN: {
	        home: 'Shared Emotions',
	        about: 'About',
	        statistics: 'Figures & Feelings',
	        privacy: 'Privacy Policy',
	        terms: 'Terms of Use',
	        'home.contributor.step2': 'Certificate of Graditute',
	        'home.book.bookStep3': 'Guidebook'
	    }
	};
	
	exports.default = json;

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js